/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../client";
import type {
  DeleteApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
  DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema,
  DeleteApiProjectsProjectIdContractsContractIdFilesId401Schema,
  DeleteApiProjectsProjectIdContractsContractIdFilesId403Schema,
  DeleteApiProjectsProjectIdContractsContractIdFilesId404Schema,
} from "../types/deleteApiProjectsProjectIdContractsContractIdFilesIdSchema";
import type {
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId401Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId403Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId404Schema,
} from "../types/deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdSchema";
import type {
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema,
} from "../types/deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdSchema";
import type {
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationResponseSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId401Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId403Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId404Schema,
} from "../types/deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdSchema";
import type {
  DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
  DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema,
  DeleteApiProjectsProjectIdCustomFieldsCustomFieldId401Schema,
  DeleteApiProjectsProjectIdCustomFieldsCustomFieldId403Schema,
  DeleteApiProjectsProjectIdCustomFieldsCustomFieldId404Schema,
} from "../types/deleteApiProjectsProjectIdCustomFieldsCustomFieldIdSchema";
import type {
  DeleteApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
  DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema,
  DeleteApiProjectsProjectIdDisciplinesDisciplineId401Schema,
  DeleteApiProjectsProjectIdDisciplinesDisciplineId403Schema,
  DeleteApiProjectsProjectIdDisciplinesDisciplineId404Schema,
  DeleteApiProjectsProjectIdDisciplinesDisciplineId422Schema,
} from "../types/deleteApiProjectsProjectIdDisciplinesDisciplineIdSchema";
import type {
  DeleteApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
  DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema,
  DeleteApiProjectsProjectIdDocumentsDocumentId401Schema,
  DeleteApiProjectsProjectIdDocumentsDocumentId403Schema,
  DeleteApiProjectsProjectIdDocumentsDocumentId404Schema,
} from "../types/deleteApiProjectsProjectIdDocumentsDocumentIdSchema";
import type {
  DeleteApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
  DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema,
  DeleteApiProjectsProjectIdGroupsGroupId401Schema,
  DeleteApiProjectsProjectIdGroupsGroupId403Schema,
  DeleteApiProjectsProjectIdGroupsGroupId404Schema,
} from "../types/deleteApiProjectsProjectIdGroupsGroupIdSchema";
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId401Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId403Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId404Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId422Schema,
} from "../types/deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdSchema";
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId401Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId403Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId404Schema,
} from "../types/deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdSchema";
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema,
} from "../types/deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdSchema";
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueId400Schema,
  DeleteApiProjectsProjectIdIssuesIssueId401Schema,
  DeleteApiProjectsProjectIdIssuesIssueId403Schema,
  DeleteApiProjectsProjectIdIssuesIssueId404Schema,
} from "../types/deleteApiProjectsProjectIdIssuesIssueIdSchema";
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId401Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId403Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId404Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId422Schema,
} from "../types/deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdSchema";
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdWatchings401Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdWatchings404Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdWatchings422Schema,
} from "../types/deleteApiProjectsProjectIdIssuesIssueIdWatchingsSchema";
import type {
  DeleteApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssueViewsIssueViewId401Schema,
  DeleteApiProjectsProjectIdIssueViewsIssueViewId403Schema,
  DeleteApiProjectsProjectIdIssueViewsIssueViewId404Schema,
  DeleteApiProjectsProjectIdIssueViewsIssueViewId422Schema,
} from "../types/deleteApiProjectsProjectIdIssueViewsIssueViewIdSchema";
import type {
  DeleteApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
  DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema,
  DeleteApiProjectsProjectIdLocationsLocationId401Schema,
  DeleteApiProjectsProjectIdLocationsLocationId403Schema,
  DeleteApiProjectsProjectIdLocationsLocationId404Schema,
  DeleteApiProjectsProjectIdLocationsLocationId422Schema,
} from "../types/deleteApiProjectsProjectIdLocationsLocationIdSchema";
import type {
  DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
  DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema,
  DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId401Schema,
  DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId403Schema,
  DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId404Schema,
} from "../types/deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdSchema";
import type {
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId401Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId403Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId404Schema,
} from "../types/deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdSchema";
import type {
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema,
} from "../types/deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionSchema";
import type {
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema,
} from "../types/deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdSchema";
import type {
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId401Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId403Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId404Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId422Schema,
} from "../types/deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdSchema";
import type {
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId401Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId403Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId404Schema,
} from "../types/deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdSchema";
import type {
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId401Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId403Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId404Schema,
} from "../types/deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdSchema";
import type {
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportId400Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportId401Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportId403Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportId404Schema,
} from "../types/deleteApiProjectsProjectIdShiftReportsShiftReportIdSchema";
import type {
  DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
  DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema,
  DeleteApiProjectsProjectIdTeamsTeamIdJoinToken401Schema,
  DeleteApiProjectsProjectIdTeamsTeamIdJoinToken403Schema,
  DeleteApiProjectsProjectIdTeamsTeamIdJoinToken404Schema,
} from "../types/deleteApiProjectsProjectIdTeamsTeamIdJoinTokenSchema";
import type {
  DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
  DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema,
  DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema,
  DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema,
  DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema,
} from "../types/deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdSchema";
import type {
  DeleteApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
  DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema,
  DeleteApiProjectsProjectIdTeamsTeamId401Schema,
  DeleteApiProjectsProjectIdTeamsTeamId403Schema,
  DeleteApiProjectsProjectIdTeamsTeamId404Schema,
} from "../types/deleteApiProjectsProjectIdTeamsTeamIdSchema";
import type {
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationResponseSchema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate401Schema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate403Schema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate404Schema,
} from "../types/deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateSchema";
import type {
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema,
} from "../types/deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSchema";
import type { GetApiConfigEnvironmentQueryResponseSchema } from "../types/getApiConfigEnvironmentSchema";
import type {
  GetApiConstructionRolesQueryResponseSchema,
  GetApiConstructionRoles401Schema,
} from "../types/getApiConstructionRolesSchema";
import type {
  GetApiNotificationsOverviewQueryResponseSchema,
  GetApiNotificationsOverview401Schema,
} from "../types/getApiNotificationsOverviewSchema";
import type {
  GetApiOrgsOrgIdQueryResponseSchema,
  GetApiOrgsOrgIdPathParamsSchema,
  GetApiOrgsOrgId401Schema,
  GetApiOrgsOrgId403Schema,
  GetApiOrgsOrgId404Schema,
} from "../types/getApiOrgsOrgIdSchema";
import type {
  GetApiOrgsQueryResponseSchema,
  GetApiOrgs401Schema,
} from "../types/getApiOrgsSchema";
import type {
  GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
  GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema,
  GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId401Schema,
  GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId403Schema,
  GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId404Schema,
} from "../types/getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSchema";
import type {
  GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
  GetApiProjectsProjectIdAccessRequestsPathParamsSchema,
  GetApiProjectsProjectIdAccessRequestsQueryParamsSchema,
  GetApiProjectsProjectIdAccessRequests400Schema,
  GetApiProjectsProjectIdAccessRequests401Schema,
  GetApiProjectsProjectIdAccessRequests403Schema,
  GetApiProjectsProjectIdAccessRequests404Schema,
} from "../types/getApiProjectsProjectIdAccessRequestsSchema";
import type {
  GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
  GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema,
  GetApiProjectsProjectIdContractsContractIdFiles401Schema,
  GetApiProjectsProjectIdContractsContractIdFiles403Schema,
  GetApiProjectsProjectIdContractsContractIdFiles404Schema,
} from "../types/getApiProjectsProjectIdContractsContractIdFilesSchema";
import type {
  GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
  GetApiProjectsProjectIdContractsContractIdPathParamsSchema,
  GetApiProjectsProjectIdContractsContractId401Schema,
  GetApiProjectsProjectIdContractsContractId403Schema,
  GetApiProjectsProjectIdContractsContractId404Schema,
} from "../types/getApiProjectsProjectIdContractsContractIdSchema";
import type {
  GetApiProjectsProjectIdContractsQueryResponseSchema,
  GetApiProjectsProjectIdContractsPathParamsSchema,
  GetApiProjectsProjectIdContracts401Schema,
  GetApiProjectsProjectIdContracts403Schema,
  GetApiProjectsProjectIdContracts404Schema,
} from "../types/getApiProjectsProjectIdContractsSchema";
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsCountersPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsCounters401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsCounters403Schema,
} from "../types/getApiProjectsProjectIdControlCenterChangeSignalsCountersSchema";
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes403Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes404Schema,
} from "../types/getApiProjectsProjectIdControlCenterChangeSignalsDowntimesSchema";
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsId401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsId403Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsId404Schema,
} from "../types/getApiProjectsProjectIdControlCenterChangeSignalsIdSchema";
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIssuesPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIssues401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIssues403Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIssues404Schema,
} from "../types/getApiProjectsProjectIdControlCenterChangeSignalsIssuesSchema";
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs403Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs404Schema,
} from "../types/getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSchema";
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema,
} from "../types/getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSchema";
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema,
} from "../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSchema";
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed404Schema,
} from "../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSchema";
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema,
} from "../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSchema";
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate400Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate404Schema,
} from "../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSchema";
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView400Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView404Schema,
} from "../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSchema";
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema,
} from "../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSchema";
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChanges401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChanges403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChanges404Schema,
} from "../types/getApiProjectsProjectIdControlCenterPotentialChangesSchema";
import type {
  GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema,
  GetApiProjectsProjectIdControlCenterTeamPersonalization401Schema,
  GetApiProjectsProjectIdControlCenterTeamPersonalization403Schema,
  GetApiProjectsProjectIdControlCenterTeamPersonalization404Schema,
} from "../types/getApiProjectsProjectIdControlCenterTeamPersonalizationSchema";
import type {
  GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
  GetApiProjectsProjectIdCustomFieldsPathParamsSchema,
  GetApiProjectsProjectIdCustomFields401Schema,
  GetApiProjectsProjectIdCustomFields403Schema,
  GetApiProjectsProjectIdCustomFields404Schema,
} from "../types/getApiProjectsProjectIdCustomFieldsSchema";
import type {
  GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema,
  GetApiProjectsProjectIdDashboardsDashboardIdEmbedding401Schema,
  GetApiProjectsProjectIdDashboardsDashboardIdEmbedding403Schema,
  GetApiProjectsProjectIdDashboardsDashboardIdEmbedding404Schema,
  GetApiProjectsProjectIdDashboardsDashboardIdEmbedding503Schema,
} from "../types/getApiProjectsProjectIdDashboardsDashboardIdEmbeddingSchema";
import type {
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesPathParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues401Schema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues403Schema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues404Schema,
} from "../types/getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSchema";
import type {
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsPathParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports401Schema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports403Schema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports404Schema,
} from "../types/getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSchema";
import type {
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType401Schema,
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType403Schema,
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType404Schema,
} from "../types/getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSchema";
import type {
  GetApiProjectsProjectIdDashboardsQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsPathParamsSchema,
  GetApiProjectsProjectIdDashboards401Schema,
  GetApiProjectsProjectIdDashboards403Schema,
  GetApiProjectsProjectIdDashboards404Schema,
} from "../types/getApiProjectsProjectIdDashboardsSchema";
import type {
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate400Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate401Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate403Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate404Schema,
} from "../types/getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSchema";
import type {
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesPathParamsSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryParamsSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities400Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities401Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities403Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities404Schema,
} from "../types/getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSchema";
import type {
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelinePathParamsSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryParamsSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline400Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline401Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline403Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline404Schema,
} from "../types/getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSchema";
import type {
  GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
  GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema,
  GetApiProjectsProjectIdDisciplinesDisciplineId401Schema,
  GetApiProjectsProjectIdDisciplinesDisciplineId403Schema,
  GetApiProjectsProjectIdDisciplinesDisciplineId404Schema,
} from "../types/getApiProjectsProjectIdDisciplinesDisciplineIdSchema";
import type {
  GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
  GetApiProjectsProjectIdDisciplinesPathParamsSchema,
  GetApiProjectsProjectIdDisciplinesQueryParamsSchema,
  GetApiProjectsProjectIdDisciplines401Schema,
  GetApiProjectsProjectIdDisciplines403Schema,
  GetApiProjectsProjectIdDisciplines404Schema,
} from "../types/getApiProjectsProjectIdDisciplinesSchema";
import type {
  GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
  GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema,
  GetApiProjectsProjectIdDocumentsDocumentIdReferences401Schema,
  GetApiProjectsProjectIdDocumentsDocumentIdReferences403Schema,
  GetApiProjectsProjectIdDocumentsDocumentIdReferences404Schema,
} from "../types/getApiProjectsProjectIdDocumentsDocumentIdReferencesSchema";
import type {
  GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
  GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema,
  GetApiProjectsProjectIdDocumentsDocumentId401Schema,
  GetApiProjectsProjectIdDocumentsDocumentId403Schema,
  GetApiProjectsProjectIdDocumentsDocumentId404Schema,
} from "../types/getApiProjectsProjectIdDocumentsDocumentIdSchema";
import type {
  GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
  GetApiProjectsProjectIdDocumentsImageUrlsPathParamsSchema,
  GetApiProjectsProjectIdDocumentsImageUrlsQueryParamsSchema,
  GetApiProjectsProjectIdDocumentsImageUrls401Schema,
  GetApiProjectsProjectIdDocumentsImageUrls403Schema,
} from "../types/getApiProjectsProjectIdDocumentsImageUrlsSchema";
import type {
  GetApiProjectsProjectIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdDocuments400Schema,
  GetApiProjectsProjectIdDocuments401Schema,
  GetApiProjectsProjectIdDocuments403Schema,
  GetApiProjectsProjectIdDocuments404Schema,
} from "../types/getApiProjectsProjectIdDocumentsSchema";
import type {
  GetApiProjectsProjectIdFilesIdQueryResponseSchema,
  GetApiProjectsProjectIdFilesIdPathParamsSchema,
  GetApiProjectsProjectIdFilesId401Schema,
  GetApiProjectsProjectIdFilesId403Schema,
  GetApiProjectsProjectIdFilesId404Schema,
} from "../types/getApiProjectsProjectIdFilesIdSchema";
import type {
  GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
  GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema,
  GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema,
  GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema,
  GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema,
} from "../types/getApiProjectsProjectIdGroupsGroupIdChannelConfigurationSchema";
import type {
  GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
  GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema,
  GetApiProjectsProjectIdGroupsGroupId401Schema,
  GetApiProjectsProjectIdGroupsGroupId403Schema,
  GetApiProjectsProjectIdGroupsGroupId404Schema,
} from "../types/getApiProjectsProjectIdGroupsGroupIdSchema";
import type {
  GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
  GetApiProjectsProjectIdIssuesGroupCountPathParamsSchema,
  GetApiProjectsProjectIdIssuesGroupCountQueryParamsSchema,
  GetApiProjectsProjectIdIssuesGroupCount400Schema,
  GetApiProjectsProjectIdIssuesGroupCount401Schema,
  GetApiProjectsProjectIdIssuesGroupCount403Schema,
  GetApiProjectsProjectIdIssuesGroupCount404Schema,
} from "../types/getApiProjectsProjectIdIssuesGroupCountSchema";
import type {
  GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdDocuments400Schema,
  GetApiProjectsProjectIdIssuesIssueIdDocuments401Schema,
  GetApiProjectsProjectIdIssuesIssueIdDocuments403Schema,
  GetApiProjectsProjectIdIssuesIssueIdDocuments404Schema,
} from "../types/getApiProjectsProjectIdIssuesIssueIdDocumentsSchema";
import type {
  GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublic400Schema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublic401Schema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublic404Schema,
} from "../types/getApiProjectsProjectIdIssuesIssueIdFeedPublicSchema";
import type {
  GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeam400Schema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeam401Schema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeam404Schema,
} from "../types/getApiProjectsProjectIdIssuesIssueIdFeedTeamSchema";
import type {
  GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdIssueImages401Schema,
  GetApiProjectsProjectIdIssuesIssueIdIssueImages403Schema,
  GetApiProjectsProjectIdIssuesIssueIdIssueImages404Schema,
} from "../types/getApiProjectsProjectIdIssuesIssueIdIssueImagesSchema";
import type {
  GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdQualityIndicators401Schema,
  GetApiProjectsProjectIdIssuesIssueIdQualityIndicators403Schema,
  GetApiProjectsProjectIdIssuesIssueIdQualityIndicators404Schema,
} from "../types/getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSchema";
import type {
  GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueId401Schema,
  GetApiProjectsProjectIdIssuesIssueId403Schema,
  GetApiProjectsProjectIdIssuesIssueId404Schema,
} from "../types/getApiProjectsProjectIdIssuesIssueIdSchema";
import type {
  GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema,
  GetApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema,
  GetApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema,
} from "../types/getApiProjectsProjectIdIssuesIssueIdStatusStatementsSchema";
import type {
  GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdVisit401Schema,
  GetApiProjectsProjectIdIssuesIssueIdVisit403Schema,
  GetApiProjectsProjectIdIssuesIssueIdVisit404Schema,
} from "../types/getApiProjectsProjectIdIssuesIssueIdVisitSchema";
import type {
  GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdWatchings401Schema,
  GetApiProjectsProjectIdIssuesIssueIdWatchings404Schema,
} from "../types/getApiProjectsProjectIdIssuesIssueIdWatchingsSchema";
import type {
  GetApiProjectsProjectIdIssuesQueryResponseSchema,
  GetApiProjectsProjectIdIssuesPathParamsSchema,
  GetApiProjectsProjectIdIssuesQueryParamsSchema,
  GetApiProjectsProjectIdIssues400Schema,
  GetApiProjectsProjectIdIssues401Schema,
  GetApiProjectsProjectIdIssues403Schema,
  GetApiProjectsProjectIdIssues404Schema,
} from "../types/getApiProjectsProjectIdIssuesSchema";
import type {
  GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
  GetApiProjectsProjectIdIssueViewsPathParamsSchema,
  GetApiProjectsProjectIdIssueViews401Schema,
  GetApiProjectsProjectIdIssueViews403Schema,
  GetApiProjectsProjectIdIssueViews404Schema,
} from "../types/getApiProjectsProjectIdIssueViewsSchema";
import type {
  GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
  GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema,
  GetApiProjectsProjectIdLocationsLocationId401Schema,
  GetApiProjectsProjectIdLocationsLocationId403Schema,
  GetApiProjectsProjectIdLocationsLocationId404Schema,
} from "../types/getApiProjectsProjectIdLocationsLocationIdSchema";
import type {
  GetApiProjectsProjectIdLocationsQueryResponseSchema,
  GetApiProjectsProjectIdLocationsPathParamsSchema,
  GetApiProjectsProjectIdLocationsQueryParamsSchema,
  GetApiProjectsProjectIdLocations401Schema,
  GetApiProjectsProjectIdLocations403Schema,
  GetApiProjectsProjectIdLocations404Schema,
} from "../types/getApiProjectsProjectIdLocationsSchema";
import type {
  GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations401Schema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations404Schema,
} from "../types/getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSchema";
import type {
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments400Schema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments401Schema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments404Schema,
} from "../types/getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSchema";
import type {
  GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
  GetApiProjectsProjectIdLogsPeoplePathParamsSchema,
  GetApiProjectsProjectIdLogsPeopleQueryParamsSchema,
  GetApiProjectsProjectIdLogsPeople401Schema,
  GetApiProjectsProjectIdLogsPeople403Schema,
  GetApiProjectsProjectIdLogsPeople404Schema,
} from "../types/getApiProjectsProjectIdLogsPeopleSchema";
import type {
  GetApiProjectsProjectIdNotificationsQueryResponseSchema,
  GetApiProjectsProjectIdNotificationsPathParamsSchema,
  GetApiProjectsProjectIdNotificationsQueryParamsSchema,
  GetApiProjectsProjectIdNotifications400Schema,
  GetApiProjectsProjectIdNotifications401Schema,
  GetApiProjectsProjectIdNotifications404Schema,
} from "../types/getApiProjectsProjectIdNotificationsSchema";
import type {
  GetApiProjectsProjectIdPeopleQueryResponseSchema,
  GetApiProjectsProjectIdPeoplePathParamsSchema,
  GetApiProjectsProjectIdPeopleQueryParamsSchema,
  GetApiProjectsProjectIdPeople400Schema,
  GetApiProjectsProjectIdPeople401Schema,
  GetApiProjectsProjectIdPeople404Schema,
} from "../types/getApiProjectsProjectIdPeopleSchema";
import type {
  GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
  GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema,
  GetApiProjectsProjectIdPeopleTeamMemberId401Schema,
  GetApiProjectsProjectIdPeopleTeamMemberId403Schema,
  GetApiProjectsProjectIdPeopleTeamMemberId404Schema,
} from "../types/getApiProjectsProjectIdPeopleTeamMemberIdSchema";
import type {
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema,
} from "../types/getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSchema";
import type {
  GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema,
  GetApiProjectsProjectIdProgressLogsProgressLogId401Schema,
  GetApiProjectsProjectIdProgressLogsProgressLogId404Schema,
} from "../types/getApiProjectsProjectIdProgressLogsProgressLogIdSchema";
import type {
  GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
  GetApiProjectsProjectIdProgressLogsPathParamsSchema,
  GetApiProjectsProjectIdProgressLogsQueryParamsSchema,
  GetApiProjectsProjectIdProgressLogs401Schema,
  GetApiProjectsProjectIdProgressLogs403Schema,
  GetApiProjectsProjectIdProgressLogs404Schema,
} from "../types/getApiProjectsProjectIdProgressLogsSchema";
import type {
  GetApiProjectsProjectIdQueryResponseSchema,
  GetApiProjectsProjectIdPathParamsSchema,
  GetApiProjectsProjectId401Schema,
  GetApiProjectsProjectId403Schema,
  GetApiProjectsProjectId404Schema,
} from "../types/getApiProjectsProjectIdSchema";
import type {
  GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesQueryParamsSchema,
  GetApiProjectsProjectIdShiftActivities400Schema,
  GetApiProjectsProjectIdShiftActivities401Schema,
  GetApiProjectsProjectIdShiftActivities403Schema,
  GetApiProjectsProjectIdShiftActivities404Schema,
} from "../types/getApiProjectsProjectIdShiftActivitiesSchema";
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers404Schema,
} from "../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSchema";
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress404Schema,
} from "../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSchema";
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments404Schema,
} from "../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSchema";
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema,
} from "../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSchema";
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage404Schema,
} from "../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSchema";
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats404Schema,
} from "../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSchema";
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema,
} from "../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdSchema";
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning404Schema,
} from "../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSchema";
import type {
  GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsArchivedPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsArchivedQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsArchived400Schema,
  GetApiProjectsProjectIdShiftReportsArchived401Schema,
  GetApiProjectsProjectIdShiftReportsArchived403Schema,
  GetApiProjectsProjectIdShiftReportsArchived404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsArchivedSchema";
import type {
  GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsCompletionsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsCompletions401Schema,
  GetApiProjectsProjectIdShiftReportsCompletions403Schema,
} from "../types/getApiProjectsProjectIdShiftReportsCompletionsSchema";
import type {
  GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsDraftPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsDraftQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsDraft400Schema,
  GetApiProjectsProjectIdShiftReportsDraft401Schema,
  GetApiProjectsProjectIdShiftReportsDraft403Schema,
  GetApiProjectsProjectIdShiftReportsDraft404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsDraftSchema";
import type {
  GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsInReviewPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsInReviewQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsInReview400Schema,
  GetApiProjectsProjectIdShiftReportsInReview401Schema,
  GetApiProjectsProjectIdShiftReportsInReview403Schema,
  GetApiProjectsProjectIdShiftReportsInReview404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsInReviewSchema";
import type {
  GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsQueryParamsSchema,
  GetApiProjectsProjectIdShiftReports400Schema,
  GetApiProjectsProjectIdShiftReports401Schema,
  GetApiProjectsProjectIdShiftReports403Schema,
  GetApiProjectsProjectIdShiftReports404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsSchema";
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSchema";
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSchema";
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSchema";
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeople401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeople403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeople404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsShiftReportIdPeopleSchema";
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSchema";
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSchema";
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSchema";
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSchema";
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportId401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportId403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportId404Schema,
} from "../types/getApiProjectsProjectIdShiftReportsShiftReportIdSchema";
import type {
  GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
  GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema,
  GetApiProjectsProjectIdTeamJoinTokensToken404Schema,
} from "../types/getApiProjectsProjectIdTeamJoinTokensTokenSchema";
import type {
  GetApiProjectsProjectIdTeamsQueryResponseSchema,
  GetApiProjectsProjectIdTeamsPathParamsSchema,
  GetApiProjectsProjectIdTeams401Schema,
  GetApiProjectsProjectIdTeams403Schema,
  GetApiProjectsProjectIdTeams404Schema,
} from "../types/getApiProjectsProjectIdTeamsSchema";
import type {
  GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema,
  GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema,
  GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema,
} from "../types/getApiProjectsProjectIdTeamsTeamIdChannelConfigurationSchema";
import type {
  GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdJoinToken401Schema,
  GetApiProjectsProjectIdTeamsTeamIdJoinToken403Schema,
  GetApiProjectsProjectIdTeamsTeamIdJoinToken404Schema,
} from "../types/getApiProjectsProjectIdTeamsTeamIdJoinTokenSchema";
import type {
  GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies401Schema,
  GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies403Schema,
  GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies404Schema,
} from "../types/getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSchema";
import type {
  GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema,
  GetApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema,
  GetApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema,
} from "../types/getApiProjectsProjectIdTeamsTeamIdResourcesKindSchema";
import type {
  GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamId401Schema,
  GetApiProjectsProjectIdTeamsTeamId403Schema,
  GetApiProjectsProjectIdTeamsTeamId404Schema,
} from "../types/getApiProjectsProjectIdTeamsTeamIdSchema";
import type {
  GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan401Schema,
  GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan403Schema,
  GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan404Schema,
} from "../types/getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSchema";
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansQueryParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlans400Schema,
  GetApiProjectsProjectIdWeeklyWorkPlans401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlans403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlans404Schema,
} from "../types/getApiProjectsProjectIdWeeklyWorkPlansSchema";
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema,
} from "../types/getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSchema";
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema,
} from "../types/getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSchema";
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema,
} from "../types/getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSchema";
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs404Schema,
} from "../types/getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSchema";
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema,
} from "../types/getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSchema";
import type {
  GetApiProjectsQueryResponseSchema,
  GetApiProjects401Schema,
  GetApiProjects403Schema,
} from "../types/getApiProjectsSchema";
import type {
  GetApiQueuedTasksQueryResponseSchema,
  GetApiQueuedTasksQueryParamsSchema,
  GetApiQueuedTasks400Schema,
  GetApiQueuedTasks401Schema,
} from "../types/getApiQueuedTasksSchema";
import type {
  GetWellKnownJwksJsonQueryResponseSchema,
  GetWellKnownJwksJson503Schema,
} from "../types/getWellKnownJwksJsonSchema";
import type {
  PatchApiOrgsOrgIdMutationRequestSchema,
  PatchApiOrgsOrgIdMutationResponseSchema,
  PatchApiOrgsOrgIdPathParamsSchema,
  PatchApiOrgsOrgId401Schema,
} from "../types/patchApiOrgsOrgIdSchema";
import type {
  PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema,
  PatchApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
  PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema,
  PatchApiProjectsProjectIdContractsContractIdFilesId401Schema,
  PatchApiProjectsProjectIdContractsContractIdFilesId403Schema,
  PatchApiProjectsProjectIdContractsContractIdFilesId404Schema,
  PatchApiProjectsProjectIdContractsContractIdFilesId422Schema,
} from "../types/patchApiProjectsProjectIdContractsContractIdFilesIdSchema";
import type {
  PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema,
  PatchApiProjectsProjectIdContractsContractIdMutationResponseSchema,
  PatchApiProjectsProjectIdContractsContractIdPathParamsSchema,
  PatchApiProjectsProjectIdContractsContractId401Schema,
  PatchApiProjectsProjectIdContractsContractId403Schema,
  PatchApiProjectsProjectIdContractsContractId422Schema,
} from "../types/patchApiProjectsProjectIdContractsContractIdSchema";
import type {
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationResponseSchema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter422Schema,
} from "../types/patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSchema";
import type {
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationResponseSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative400Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema,
} from "../types/patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSchema";
import type {
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId400Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId422Schema,
} from "../types/patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdSchema";
import type {
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationResponseSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId422Schema,
} from "../types/patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSchema";
import type {
  PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationResponseSchema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalization401Schema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalization403Schema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalization404Schema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalization422Schema,
} from "../types/patchApiProjectsProjectIdControlCenterTeamPersonalizationSchema";
import type {
  PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldId401Schema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldId403Schema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldId404Schema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldId422Schema,
} from "../types/patchApiProjectsProjectIdCustomFieldsCustomFieldIdSchema";
import type {
  PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema,
  PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
  PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema,
  PatchApiProjectsProjectIdDisciplinesDisciplineId401Schema,
  PatchApiProjectsProjectIdDisciplinesDisciplineId403Schema,
  PatchApiProjectsProjectIdDisciplinesDisciplineId404Schema,
  PatchApiProjectsProjectIdDisciplinesDisciplineId422Schema,
} from "../types/patchApiProjectsProjectIdDisciplinesDisciplineIdSchema";
import type {
  PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema,
  PatchApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
  PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema,
  PatchApiProjectsProjectIdDocumentsDocumentId401Schema,
  PatchApiProjectsProjectIdDocumentsDocumentId403Schema,
  PatchApiProjectsProjectIdDocumentsDocumentId404Schema,
  PatchApiProjectsProjectIdDocumentsDocumentId422Schema,
} from "../types/patchApiProjectsProjectIdDocumentsDocumentIdSchema";
import type {
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationResponseSchema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration422Schema,
} from "../types/patchApiProjectsProjectIdGroupsGroupIdChannelConfigurationSchema";
import type {
  PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema,
  PatchApiProjectsProjectIdGroupsGroupIdMembersMutationResponseSchema,
  PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema,
  PatchApiProjectsProjectIdGroupsGroupIdMembers401Schema,
  PatchApiProjectsProjectIdGroupsGroupIdMembers403Schema,
  PatchApiProjectsProjectIdGroupsGroupIdMembers404Schema,
  PatchApiProjectsProjectIdGroupsGroupIdMembers422Schema,
} from "../types/patchApiProjectsProjectIdGroupsGroupIdMembersSchema";
import type {
  PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema,
  PatchApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
  PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema,
  PatchApiProjectsProjectIdGroupsGroupId400Schema,
  PatchApiProjectsProjectIdGroupsGroupId401Schema,
  PatchApiProjectsProjectIdGroupsGroupId403Schema,
  PatchApiProjectsProjectIdGroupsGroupId404Schema,
  PatchApiProjectsProjectIdGroupsGroupId422Schema,
} from "../types/patchApiProjectsProjectIdGroupsGroupIdSchema";
import type {
  PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationResponseSchema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFields401Schema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFields403Schema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFields404Schema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFields422Schema,
} from "../types/patchApiProjectsProjectIdIssuesIssueIdCustomFieldsSchema";
import type {
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema,
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema,
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema,
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema,
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema,
} from "../types/patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdSchema";
import type {
  PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema,
  PatchApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
  PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema,
  PatchApiProjectsProjectIdIssuesIssueId401Schema,
  PatchApiProjectsProjectIdIssuesIssueId403Schema,
  PatchApiProjectsProjectIdIssuesIssueId404Schema,
  PatchApiProjectsProjectIdIssuesIssueId422Schema,
} from "../types/patchApiProjectsProjectIdIssuesIssueIdSchema";
import type {
  PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema,
  PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
  PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema,
  PatchApiProjectsProjectIdIssueViewsIssueViewId401Schema,
  PatchApiProjectsProjectIdIssueViewsIssueViewId404Schema,
  PatchApiProjectsProjectIdIssueViewsIssueViewId422Schema,
} from "../types/patchApiProjectsProjectIdIssueViewsIssueViewIdSchema";
import type {
  PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema,
  PatchApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
  PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema,
  PatchApiProjectsProjectIdLocationsLocationId401Schema,
  PatchApiProjectsProjectIdLocationsLocationId403Schema,
  PatchApiProjectsProjectIdLocationsLocationId404Schema,
  PatchApiProjectsProjectIdLocationsLocationId422Schema,
} from "../types/patchApiProjectsProjectIdLocationsLocationIdSchema";
import type {
  PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema,
  PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationResponseSchema,
  PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema,
  PatchApiProjectsProjectIdProgressLogsProgressLogId401Schema,
  PatchApiProjectsProjectIdProgressLogsProgressLogId403Schema,
  PatchApiProjectsProjectIdProgressLogsProgressLogId404Schema,
  PatchApiProjectsProjectIdProgressLogsProgressLogId422Schema,
} from "../types/patchApiProjectsProjectIdProgressLogsProgressLogIdSchema";
import type {
  PatchApiProjectsProjectIdMutationRequestSchema,
  PatchApiProjectsProjectIdMutationResponseSchema,
  PatchApiProjectsProjectIdPathParamsSchema,
  PatchApiProjectsProjectId401Schema,
  PatchApiProjectsProjectId403Schema,
  PatchApiProjectsProjectId404Schema,
  PatchApiProjectsProjectId422Schema,
} from "../types/patchApiProjectsProjectIdSchema";
import type {
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationResponseSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness400Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness401Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness403Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness404Schema,
} from "../types/patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessSchema";
import type {
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId422Schema,
} from "../types/patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdSchema";
import type {
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationResponseSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityId403Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityId422Schema,
} from "../types/patchApiProjectsProjectIdShiftActivitiesShiftActivityIdSchema";
import type {
  PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema,
  PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
  PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema,
  PatchApiProjectsProjectIdShiftReportsShiftReportId400Schema,
  PatchApiProjectsProjectIdShiftReportsShiftReportId401Schema,
  PatchApiProjectsProjectIdShiftReportsShiftReportId403Schema,
  PatchApiProjectsProjectIdShiftReportsShiftReportId404Schema,
  PatchApiProjectsProjectIdShiftReportsShiftReportId422Schema,
} from "../types/patchApiProjectsProjectIdShiftReportsShiftReportIdSchema";
import type {
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationResponseSchema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration422Schema,
} from "../types/patchApiProjectsProjectIdTeamsTeamIdChannelConfigurationSchema";
import type {
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId422Schema,
} from "../types/patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdSchema";
import type {
  PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema,
  PatchApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
  PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema,
  PatchApiProjectsProjectIdTeamsTeamId401Schema,
  PatchApiProjectsProjectIdTeamsTeamId403Schema,
  PatchApiProjectsProjectIdTeamsTeamId404Schema,
} from "../types/patchApiProjectsProjectIdTeamsTeamIdSchema";
import type {
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationResponseSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder422Schema,
} from "../types/patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSchema";
import type {
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId422Schema,
} from "../types/patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSchema";
import type {
  PostApiChannelsTokenMutationResponseSchema,
  PostApiChannelsToken401Schema,
  PostApiChannelsToken422Schema,
  PostApiChannelsToken503Schema,
} from "../types/postApiChannelsTokenSchema";
import type {
  PostApiDirectUploadsTypeMutationRequestSchema,
  PostApiDirectUploadsTypeMutationResponseSchema,
  PostApiDirectUploadsTypePathParamsSchema,
  PostApiDirectUploadsType400Schema,
  PostApiDirectUploadsType401Schema,
  PostApiDirectUploadsType404Schema,
} from "../types/postApiDirectUploadsTypeSchema";
import type {
  PostApiOrgsCheckDomainMutationRequestSchema,
  PostApiOrgsCheckDomainMutationResponseSchema,
  PostApiOrgsCheckDomain401Schema,
} from "../types/postApiOrgsCheckDomainSchema";
import type {
  PostApiOrgsOrgIdResendVerificationEmailMutationResponseSchema,
  PostApiOrgsOrgIdResendVerificationEmailPathParamsSchema,
  PostApiOrgsOrgIdResendVerificationEmail401Schema,
  PostApiOrgsOrgIdResendVerificationEmail403Schema,
  PostApiOrgsOrgIdResendVerificationEmail404Schema,
} from "../types/postApiOrgsOrgIdResendVerificationEmailSchema";
import type {
  PostApiOrgsMutationRequestSchema,
  PostApiOrgsMutationResponseSchema,
  PostApiOrgs400Schema,
  PostApiOrgs401Schema,
  PostApiOrgs422Schema,
} from "../types/postApiOrgsSchema";
import type {
  PostApiPowerSyncTokenMutationResponseSchema,
  PostApiPowerSyncToken401Schema,
} from "../types/postApiPowerSyncTokenSchema";
import type {
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationResponseSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept401Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept403Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept404Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept422Schema,
} from "../types/postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptSchema";
import type {
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationResponseSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect400Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect401Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect403Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect404Schema,
} from "../types/postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectSchema";
import type {
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationResponseSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject401Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject403Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject404Schema,
} from "../types/postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectSchema";
import type {
  PostApiProjectsProjectIdAccessRequestsMutationRequestSchema,
  PostApiProjectsProjectIdAccessRequestsMutationResponseSchema,
  PostApiProjectsProjectIdAccessRequestsPathParamsSchema,
  PostApiProjectsProjectIdAccessRequests400Schema,
  PostApiProjectsProjectIdAccessRequests401Schema,
  PostApiProjectsProjectIdAccessRequests404Schema,
  PostApiProjectsProjectIdAccessRequests422Schema,
} from "../types/postApiProjectsProjectIdAccessRequestsSchema";
import type {
  PostApiProjectsProjectIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdArchivePathParamsSchema,
  PostApiProjectsProjectIdArchive401Schema,
  PostApiProjectsProjectIdArchive403Schema,
  PostApiProjectsProjectIdArchive404Schema,
} from "../types/postApiProjectsProjectIdArchiveSchema";
import type {
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationResponseSchema,
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema,
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments401Schema,
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments403Schema,
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments404Schema,
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments422Schema,
} from "../types/postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsSchema";
import type {
  PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema,
  PostApiProjectsProjectIdChannelsMessagingMutationResponseSchema,
  PostApiProjectsProjectIdChannelsMessagingPathParamsSchema,
  PostApiProjectsProjectIdChannelsMessaging400Schema,
  PostApiProjectsProjectIdChannelsMessaging401Schema,
  PostApiProjectsProjectIdChannelsMessaging403Schema,
  PostApiProjectsProjectIdChannelsMessaging404Schema,
  PostApiProjectsProjectIdChannelsMessaging422Schema,
} from "../types/postApiProjectsProjectIdChannelsMessagingSchema";
import type {
  PostApiProjectsProjectIdChannelsPersonalMutationResponseSchema,
  PostApiProjectsProjectIdChannelsPersonalPathParamsSchema,
  PostApiProjectsProjectIdChannelsPersonal401Schema,
  PostApiProjectsProjectIdChannelsPersonal403Schema,
  PostApiProjectsProjectIdChannelsPersonal404Schema,
  PostApiProjectsProjectIdChannelsPersonal422Schema,
} from "../types/postApiProjectsProjectIdChannelsPersonalSchema";
import type {
  PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema,
  PostApiProjectsProjectIdContractsContractIdFilesMutationResponseSchema,
  PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema,
  PostApiProjectsProjectIdContractsContractIdFiles400Schema,
  PostApiProjectsProjectIdContractsContractIdFiles401Schema,
  PostApiProjectsProjectIdContractsContractIdFiles403Schema,
  PostApiProjectsProjectIdContractsContractIdFiles404Schema,
  PostApiProjectsProjectIdContractsContractIdFiles422Schema,
} from "../types/postApiProjectsProjectIdContractsContractIdFilesSchema";
import type {
  PostApiProjectsProjectIdContractsMutationRequestSchema,
  PostApiProjectsProjectIdContractsMutationResponseSchema,
  PostApiProjectsProjectIdContractsPathParamsSchema,
  PostApiProjectsProjectIdContracts401Schema,
  PostApiProjectsProjectIdContracts403Schema,
  PostApiProjectsProjectIdContracts422Schema,
} from "../types/postApiProjectsProjectIdContractsSchema";
import type {
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissPathParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss401Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss403Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss404Schema,
} from "../types/postApiProjectsProjectIdControlCenterChangeSignalsBatchDismissSchema";
import type {
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals401Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals403Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals404Schema,
} from "../types/postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsSchema";
import type {
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchPathParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch401Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch403Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch404Schema,
} from "../types/postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchSchema";
import type {
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchPathParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch401Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch403Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch404Schema,
} from "../types/postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchSchema";
import type {
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchPathParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch401Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch403Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch404Schema,
} from "../types/postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchSchema";
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive404Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive422Schema,
} from "../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveSchema";
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate403Schema,
} from "../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateSchema";
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete403Schema,
} from "../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteSchema";
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments422Schema,
} from "../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSchema";
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport404Schema,
} from "../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportSchema";
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile400Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile404Schema,
} from "../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileSchema";
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries400Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries404Schema,
} from "../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesSchema";
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows404Schema,
} from "../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsSchema";
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChanges401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChanges403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChanges404Schema,
  PostApiProjectsProjectIdControlCenterPotentialChanges422Schema,
} from "../types/postApiProjectsProjectIdControlCenterPotentialChangesSchema";
import type {
  PostApiProjectsProjectIdCustomFieldsMutationRequestSchema,
  PostApiProjectsProjectIdCustomFieldsMutationResponseSchema,
  PostApiProjectsProjectIdCustomFieldsPathParamsSchema,
  PostApiProjectsProjectIdCustomFields401Schema,
  PostApiProjectsProjectIdCustomFields403Schema,
  PostApiProjectsProjectIdCustomFields404Schema,
  PostApiProjectsProjectIdCustomFields422Schema,
} from "../types/postApiProjectsProjectIdCustomFieldsSchema";
import type {
  PostApiProjectsProjectIdDisciplinesMutationRequestSchema,
  PostApiProjectsProjectIdDisciplinesMutationResponseSchema,
  PostApiProjectsProjectIdDisciplinesPathParamsSchema,
  PostApiProjectsProjectIdDisciplines401Schema,
  PostApiProjectsProjectIdDisciplines403Schema,
  PostApiProjectsProjectIdDisciplines404Schema,
  PostApiProjectsProjectIdDisciplines422Schema,
} from "../types/postApiProjectsProjectIdDisciplinesSchema";
import type {
  PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema,
  PostApiProjectsProjectIdDisciplinesSortMutationResponseSchema,
  PostApiProjectsProjectIdDisciplinesSortPathParamsSchema,
  PostApiProjectsProjectIdDisciplinesSort401Schema,
  PostApiProjectsProjectIdDisciplinesSort403Schema,
  PostApiProjectsProjectIdDisciplinesSort404Schema,
} from "../types/postApiProjectsProjectIdDisciplinesSortSchema";
import type {
  PostApiProjectsProjectIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdDocuments400Schema,
  PostApiProjectsProjectIdDocuments401Schema,
  PostApiProjectsProjectIdDocuments403Schema,
  PostApiProjectsProjectIdDocuments404Schema,
  PostApiProjectsProjectIdDocuments422Schema,
} from "../types/postApiProjectsProjectIdDocumentsSchema";
import type {
  PostApiProjectsProjectIdGroupsMutationRequestSchema,
  PostApiProjectsProjectIdGroupsMutationResponseSchema,
  PostApiProjectsProjectIdGroupsPathParamsSchema,
  PostApiProjectsProjectIdGroups400Schema,
  PostApiProjectsProjectIdGroups401Schema,
  PostApiProjectsProjectIdGroups403Schema,
  PostApiProjectsProjectIdGroups404Schema,
  PostApiProjectsProjectIdGroups422Schema,
} from "../types/postApiProjectsProjectIdGroupsSchema";
import type {
  PostApiProjectsProjectIdIssuesExportMutationResponseSchema,
  PostApiProjectsProjectIdIssuesExportPathParamsSchema,
  PostApiProjectsProjectIdIssuesExportQueryParamsSchema,
  PostApiProjectsProjectIdIssuesExport400Schema,
  PostApiProjectsProjectIdIssuesExport401Schema,
  PostApiProjectsProjectIdIssuesExport403Schema,
  PostApiProjectsProjectIdIssuesExport404Schema,
} from "../types/postApiProjectsProjectIdIssuesExportSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdApproveMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdApprove400Schema,
  PostApiProjectsProjectIdIssuesIssueIdApprove401Schema,
  PostApiProjectsProjectIdIssuesIssueIdApprove403Schema,
  PostApiProjectsProjectIdIssuesIssueIdApprove404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdApproveSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdArchive401Schema,
  PostApiProjectsProjectIdIssuesIssueIdArchive403Schema,
  PostApiProjectsProjectIdIssuesIssueIdArchive404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdArchiveSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept401Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept403Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject401Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject403Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignments400Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignments401Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignments403Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignments404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdAssignmentsSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdCommentsMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdComments401Schema,
  PostApiProjectsProjectIdIssuesIssueIdComments404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdCommentsSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdCompleteMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdComplete400Schema,
  PostApiProjectsProjectIdIssuesIssueIdComplete401Schema,
  PostApiProjectsProjectIdIssuesIssueIdComplete403Schema,
  PostApiProjectsProjectIdIssuesIssueIdComplete404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdCompleteSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdDocuments400Schema,
  PostApiProjectsProjectIdIssuesIssueIdDocuments401Schema,
  PostApiProjectsProjectIdIssuesIssueIdDocuments403Schema,
  PostApiProjectsProjectIdIssuesIssueIdDocuments422Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdDocumentsSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdExportMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdExport401Schema,
  PostApiProjectsProjectIdIssuesIssueIdExport403Schema,
  PostApiProjectsProjectIdIssuesIssueIdExport404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdExportSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImages400Schema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImages401Schema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImages403Schema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImages422Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdIssueImagesSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdRejectMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdReject400Schema,
  PostApiProjectsProjectIdIssuesIssueIdReject401Schema,
  PostApiProjectsProjectIdIssuesIssueIdReject404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdRejectSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdReopenMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdReopen400Schema,
  PostApiProjectsProjectIdIssuesIssueIdReopen401Schema,
  PostApiProjectsProjectIdIssuesIssueIdReopen404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdReopenSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdRestoreMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdRestore401Schema,
  PostApiProjectsProjectIdIssuesIssueIdRestore403Schema,
  PostApiProjectsProjectIdIssuesIssueIdRestore404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdRestoreSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdStartMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdStart400Schema,
  PostApiProjectsProjectIdIssuesIssueIdStart401Schema,
  PostApiProjectsProjectIdIssuesIssueIdStart404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdStartSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema,
  PostApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema,
  PostApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdStatusStatementsSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdStopMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdStop400Schema,
  PostApiProjectsProjectIdIssuesIssueIdStop401Schema,
  PostApiProjectsProjectIdIssuesIssueIdStop404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdStopSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdSubmitMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdSubmit401Schema,
  PostApiProjectsProjectIdIssuesIssueIdSubmit403Schema,
  PostApiProjectsProjectIdIssuesIssueIdSubmit404Schema,
  PostApiProjectsProjectIdIssuesIssueIdSubmit422Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdSubmitSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpact401Schema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpact403Schema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpact404Schema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpact422Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdUpdateImpactSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdVisitMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdVisit401Schema,
  PostApiProjectsProjectIdIssuesIssueIdVisit403Schema,
  PostApiProjectsProjectIdIssuesIssueIdVisit404Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdVisitSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate401Schema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate403Schema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate422Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateSchema";
import type {
  PostApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdWatchings401Schema,
  PostApiProjectsProjectIdIssuesIssueIdWatchings403Schema,
  PostApiProjectsProjectIdIssuesIssueIdWatchings404Schema,
  PostApiProjectsProjectIdIssuesIssueIdWatchings422Schema,
} from "../types/postApiProjectsProjectIdIssuesIssueIdWatchingsSchema";
import type {
  PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema,
  PostApiProjectsProjectIdIssuesQuickIssuesMutationResponseSchema,
  PostApiProjectsProjectIdIssuesQuickIssuesPathParamsSchema,
  PostApiProjectsProjectIdIssuesQuickIssuesHeaderParamsSchema,
  PostApiProjectsProjectIdIssuesQuickIssues400Schema,
  PostApiProjectsProjectIdIssuesQuickIssues401Schema,
  PostApiProjectsProjectIdIssuesQuickIssues403Schema,
  PostApiProjectsProjectIdIssuesQuickIssues404Schema,
  PostApiProjectsProjectIdIssuesQuickIssues422Schema,
} from "../types/postApiProjectsProjectIdIssuesQuickIssuesSchema";
import type {
  PostApiProjectsProjectIdIssuesMutationRequestSchema,
  PostApiProjectsProjectIdIssuesMutationResponseSchema,
  PostApiProjectsProjectIdIssuesPathParamsSchema,
  PostApiProjectsProjectIdIssuesHeaderParamsSchema,
  PostApiProjectsProjectIdIssues401Schema,
  PostApiProjectsProjectIdIssues403Schema,
  PostApiProjectsProjectIdIssues404Schema,
} from "../types/postApiProjectsProjectIdIssuesSchema";
import type {
  PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema,
  PostApiProjectsProjectIdIssuesSmartIssuesMutationResponseSchema,
  PostApiProjectsProjectIdIssuesSmartIssuesPathParamsSchema,
  PostApiProjectsProjectIdIssuesSmartIssues401Schema,
  PostApiProjectsProjectIdIssuesSmartIssues403Schema,
  PostApiProjectsProjectIdIssuesSmartIssues404Schema,
} from "../types/postApiProjectsProjectIdIssuesSmartIssuesSchema";
import type {
  PostApiProjectsProjectIdIssueViewsMutationRequestSchema,
  PostApiProjectsProjectIdIssueViewsMutationResponseSchema,
  PostApiProjectsProjectIdIssueViewsPathParamsSchema,
  PostApiProjectsProjectIdIssueViews401Schema,
  PostApiProjectsProjectIdIssueViews403Schema,
  PostApiProjectsProjectIdIssueViews404Schema,
  PostApiProjectsProjectIdIssueViews422Schema,
} from "../types/postApiProjectsProjectIdIssueViewsSchema";
import type {
  PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema,
  PostApiProjectsProjectIdLocationsLocationIdSortMutationResponseSchema,
  PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema,
  PostApiProjectsProjectIdLocationsLocationIdSort401Schema,
  PostApiProjectsProjectIdLocationsLocationIdSort403Schema,
  PostApiProjectsProjectIdLocationsLocationIdSort404Schema,
} from "../types/postApiProjectsProjectIdLocationsLocationIdSortSchema";
import type {
  PostApiProjectsProjectIdLocationsMutationRequestSchema,
  PostApiProjectsProjectIdLocationsMutationResponseSchema,
  PostApiProjectsProjectIdLocationsPathParamsSchema,
  PostApiProjectsProjectIdLocations401Schema,
  PostApiProjectsProjectIdLocations403Schema,
  PostApiProjectsProjectIdLocations404Schema,
  PostApiProjectsProjectIdLocations422Schema,
} from "../types/postApiProjectsProjectIdLocationsSchema";
import type {
  PostApiProjectsProjectIdNotificationsMarkAllReadMutationResponseSchema,
  PostApiProjectsProjectIdNotificationsMarkAllReadPathParamsSchema,
  PostApiProjectsProjectIdNotificationsMarkAllRead401Schema,
} from "../types/postApiProjectsProjectIdNotificationsMarkAllReadSchema";
import type {
  PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema,
  PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationResponseSchema,
  PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema,
  PostApiProjectsProjectIdNotificationsNotificationIdMarkRead401Schema,
  PostApiProjectsProjectIdNotificationsNotificationIdMarkRead404Schema,
} from "../types/postApiProjectsProjectIdNotificationsNotificationIdMarkReadSchema";
import type {
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments422Schema,
} from "../types/postApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSchema";
import type {
  PostApiProjectsProjectIdProgressLogsMutationRequestSchema,
  PostApiProjectsProjectIdProgressLogsMutationResponseSchema,
  PostApiProjectsProjectIdProgressLogsPathParamsSchema,
  PostApiProjectsProjectIdProgressLogs401Schema,
  PostApiProjectsProjectIdProgressLogs404Schema,
  PostApiProjectsProjectIdProgressLogs422Schema,
} from "../types/postApiProjectsProjectIdProgressLogsSchema";
import type {
  PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesExportMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesExportPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesExport401Schema,
  PostApiProjectsProjectIdShiftActivitiesExport403Schema,
  PostApiProjectsProjectIdShiftActivitiesExport404Schema,
} from "../types/postApiProjectsProjectIdShiftActivitiesExportSchema";
import type {
  PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesImportsMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesImportsPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesImports401Schema,
  PostApiProjectsProjectIdShiftActivitiesImports403Schema,
  PostApiProjectsProjectIdShiftActivitiesImports404Schema,
  PostApiProjectsProjectIdShiftActivitiesImports422Schema,
} from "../types/postApiProjectsProjectIdShiftActivitiesImportsSchema";
import type {
  PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesPathParamsSchema,
  PostApiProjectsProjectIdShiftActivities401Schema,
  PostApiProjectsProjectIdShiftActivities403Schema,
  PostApiProjectsProjectIdShiftActivities404Schema,
  PostApiProjectsProjectIdShiftActivities422Schema,
} from "../types/postApiProjectsProjectIdShiftActivitiesSchema";
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive404Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive422Schema,
} from "../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveSchema";
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch400Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch404Schema,
} from "../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchSchema";
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema,
} from "../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionSchema";
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements422Schema,
} from "../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSchema";
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort400Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort404Schema,
} from "../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortSchema";
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore404Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore422Schema,
} from "../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreSchema";
import type {
  PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsExportMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsExportPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsExport400Schema,
  PostApiProjectsProjectIdShiftReportsExport401Schema,
  PostApiProjectsProjectIdShiftReportsExport403Schema,
  PostApiProjectsProjectIdShiftReportsExport404Schema,
} from "../types/postApiProjectsProjectIdShiftReportsExportSchema";
import type {
  PostApiProjectsProjectIdShiftReportsMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsPathParamsSchema,
  PostApiProjectsProjectIdShiftReports401Schema,
  PostApiProjectsProjectIdShiftReports403Schema,
  PostApiProjectsProjectIdShiftReports404Schema,
  PostApiProjectsProjectIdShiftReports422Schema,
} from "../types/postApiProjectsProjectIdShiftReportsSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate422Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchive401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchive403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchive404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchive422Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdArchiveSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators422Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments422Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdExportMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExportQueryParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExport400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExport401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExport403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExport404Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdExportSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImport400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImport401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImport403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImport404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImport422Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdImportSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublishQueryParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublish400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublish401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublish403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublish404Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdPublishSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionQueryParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection401Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdResetSectionSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind422Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments422Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestore401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestore403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestore404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestore422Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdRestoreSchema";
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview404Schema,
} from "../types/postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewSchema";
import type {
  PostApiProjectsProjectIdTeamJoinTokensTokenJoinMutationResponseSchema,
  PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema,
  PostApiProjectsProjectIdTeamJoinTokensTokenJoin401Schema,
  PostApiProjectsProjectIdTeamJoinTokensTokenJoin404Schema,
  PostApiProjectsProjectIdTeamJoinTokensTokenJoin422Schema,
} from "../types/postApiProjectsProjectIdTeamJoinTokensTokenJoinSchema";
import type {
  PostApiProjectsProjectIdTeamsMutationRequestSchema,
  PostApiProjectsProjectIdTeamsMutationResponseSchema,
  PostApiProjectsProjectIdTeamsPathParamsSchema,
  PostApiProjectsProjectIdTeams401Schema,
  PostApiProjectsProjectIdTeams403Schema,
  PostApiProjectsProjectIdTeams404Schema,
  PostApiProjectsProjectIdTeams422Schema,
} from "../types/postApiProjectsProjectIdTeamsSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdJoinToken401Schema,
  PostApiProjectsProjectIdTeamsTeamIdJoinToken403Schema,
  PostApiProjectsProjectIdTeamsTeamIdJoinToken404Schema,
  PostApiProjectsProjectIdTeamsTeamIdJoinToken422Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdJoinTokenSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembers401Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembers403Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembers404Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembers422Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdMembersSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive401Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive403Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive404Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive422Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail401Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail403Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail404Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites401Schema,
  PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites404Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdResendMembersInvitesSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKind422Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdResourcesKindSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable401Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable403Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable404Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable401Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable403Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable404Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal401Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal403Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal404Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal422Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm401Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm403Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm404Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm422Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmSchema";
import type {
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscription401Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscription403Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscription404Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscription422Schema,
} from "../types/postApiProjectsProjectIdTeamsTeamIdSubscriptionSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlans400Schema,
  PostApiProjectsProjectIdWeeklyWorkPlans401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlans403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlans404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlans422Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays422Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch404Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities400Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities422Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort400Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort404Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive422Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose422Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate400Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate422Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport404Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport404Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill400Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill422Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish422Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishSchema";
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore422Schema,
} from "../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreSchema";
import type {
  PostApiProjectsMutationRequestSchema,
  PostApiProjectsMutationResponseSchema,
  PostApiProjects401Schema,
  PostApiProjects403Schema,
} from "../types/postApiProjectsSchema";
import type {
  PostApiProjectsShowcasesMutationRequestSchema,
  PostApiProjectsShowcasesMutationResponseSchema,
  PostApiProjectsShowcases401Schema,
  PostApiProjectsShowcases403Schema,
} from "../types/postApiProjectsShowcasesSchema";
import type {
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationResponseSchema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId400Schema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId422Schema,
} from "../types/putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSchema";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import {
  getApiConfigEnvironment,
  getApiConstructionRoles,
  getApiProjectsProjectIdContractsContractIdFiles,
  getApiProjectsProjectIdContracts,
  getApiProjectsProjectIdContractsContractId,
  getApiProjectsProjectIdControlCenterChangeSignalsSearchFilter,
  getApiProjectsProjectIdControlCenterChangeSignalsIssues,
  getApiProjectsProjectIdControlCenterChangeSignalsDowntimes,
  getApiProjectsProjectIdControlCenterChangeSignalsProgressLogs,
  getApiProjectsProjectIdControlCenterChangeSignalsCounters,
  getApiProjectsProjectIdControlCenterChangeSignalsId,
  getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments,
  getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed,
  getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative,
  getApiProjectsProjectIdControlCenterPotentialChanges,
  getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId,
  getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView,
  getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate,
  getApiProjectsProjectIdControlCenterTeamPersonalization,
  getApiProjectsProjectIdCustomFields,
  getApiProjectsProjectIdDashboards,
  getApiProjectsProjectIdDashboardsDataHealthRecordsIssues,
  getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports,
  getApiProjectsProjectIdDashboardsDataHealthScoresRecordType,
  getApiProjectsProjectIdDashboardsDashboardIdEmbedding,
  getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities,
  getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate,
  getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline,
  getApiProjectsProjectIdDisciplines,
  getApiProjectsProjectIdDisciplinesDisciplineId,
  getApiProjectsProjectIdDocumentsDocumentIdReferences,
  getApiProjectsProjectIdDocuments,
  getApiProjectsProjectIdDocumentsImageUrls,
  getApiProjectsProjectIdDocumentsDocumentId,
  getApiProjectsProjectIdGroupsGroupIdChannelConfiguration,
  getApiProjectsProjectIdGroupsGroupId,
  getApiProjectsProjectIdIssuesIssueIdDocuments,
  getApiProjectsProjectIdIssuesIssueIdFeedTeam,
  getApiProjectsProjectIdIssuesIssueIdFeedPublic,
  getApiProjectsProjectIdIssuesIssueIdIssueImages,
  getApiProjectsProjectIdIssuesIssueIdStatusStatements,
  getApiProjectsProjectIdIssueViews,
  getApiProjectsProjectIdIssuesIssueIdVisit,
  getApiProjectsProjectIdIssuesIssueIdQualityIndicators,
  getApiProjectsProjectIdIssues,
  getApiProjectsProjectIdIssuesGroupCount,
  getApiProjectsProjectIdIssuesIssueId,
  getApiProjectsProjectIdLocations,
  getApiProjectsProjectIdLocationsLocationId,
  getApiProjectsProjectIdLogsPeopleLogPersonIdAllocations,
  getApiProjectsProjectIdLogsPeopleLogPersonIdDocuments,
  getApiProjectsProjectIdLogsPeople,
  getApiOrgs,
  getApiOrgsOrgId,
  getWellKnownJwksJson,
  getApiProjectsProjectIdProgressLogsProgressLogIdDocuments,
  getApiProjectsProjectIdProgressLogs,
  getApiProjectsProjectIdProgressLogsProgressLogId,
  getApiProjectsProjectIdAccessRequests,
  getApiProjectsProjectIdAccessRequestsProjectAccessRequestId,
  getApiProjectsProjectIdPeople,
  getApiProjectsProjectIdPeopleTeamMemberId,
  getApiProjectsProjectIdFilesId,
  getApiNotificationsOverview,
  getApiProjectsProjectIdNotifications,
  getApiProjects,
  getApiProjectsProjectId,
  getApiQueuedTasks,
  getApiProjectsProjectIdShiftActivities,
  getApiProjectsProjectIdShiftActivitiesShiftActivityId,
  getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers,
  getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress,
  getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments,
  getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements,
  getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage,
  getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats,
  getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning,
  getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators,
  getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic,
  getApiProjectsProjectIdShiftReportsShiftReportIdDocuments,
  getApiProjectsProjectIdShiftReportsShiftReportIdPeople,
  getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments,
  getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind,
  getApiProjectsProjectIdShiftReportsCompletions,
  getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators,
  getApiProjectsProjectIdShiftReports,
  getApiProjectsProjectIdShiftReportsArchived,
  getApiProjectsProjectIdShiftReportsDraft,
  getApiProjectsProjectIdShiftReportsInReview,
  getApiProjectsProjectIdShiftReportsShiftReportId,
  getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters,
  getApiProjectsProjectIdTeamsTeamIdChannelConfiguration,
  getApiProjectsProjectIdTeamsTeamIdJoinToken,
  getApiProjectsProjectIdTeamJoinTokensToken,
  getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies,
  getApiProjectsProjectIdTeamsTeamIdResourcesKind,
  getApiProjectsProjectIdTeamsTeamIdSubscriptionPlan,
  getApiProjectsProjectIdTeams,
  getApiProjectsProjectIdTeamsTeamId,
  getApiProjectsProjectIdIssuesIssueIdWatchings,
  getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities,
  getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId,
  getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs,
  getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder,
  getApiProjectsProjectIdWeeklyWorkPlans,
  getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId,
  postApiChannelsToken,
  postApiProjectsProjectIdChannelsPersonal,
  postApiProjectsProjectIdChannelsMessaging,
  postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments,
  postApiProjectsProjectIdIssuesIssueIdComments,
  deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId,
  postApiProjectsProjectIdContractsContractIdFiles,
  patchApiProjectsProjectIdContractsContractIdFilesId,
  deleteApiProjectsProjectIdContractsContractIdFilesId,
  postApiProjectsProjectIdContracts,
  patchApiProjectsProjectIdContractsContractId,
  postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals,
  patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter,
  postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch,
  postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch,
  postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch,
  postApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss,
  deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId,
  postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments,
  postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport,
  postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete,
  postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate,
  patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative,
  postApiProjectsProjectIdControlCenterPotentialChanges,
  patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId,
  postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive,
  postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile,
  postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries,
  deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId,
  postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows,
  patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId,
  deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId,
  patchApiProjectsProjectIdControlCenterTeamPersonalization,
  postApiProjectsProjectIdCustomFields,
  patchApiProjectsProjectIdCustomFieldsCustomFieldId,
  deleteApiProjectsProjectIdCustomFieldsCustomFieldId,
  patchApiProjectsProjectIdIssuesIssueIdCustomFields,
  postApiDirectUploadsType,
  postApiProjectsProjectIdDisciplines,
  patchApiProjectsProjectIdDisciplinesDisciplineId,
  deleteApiProjectsProjectIdDisciplinesDisciplineId,
  postApiProjectsProjectIdDisciplinesSort,
  postApiProjectsProjectIdDocuments,
  patchApiProjectsProjectIdDocumentsDocumentId,
  deleteApiProjectsProjectIdDocumentsDocumentId,
  patchApiProjectsProjectIdGroupsGroupIdChannelConfiguration,
  postApiProjectsProjectIdGroups,
  patchApiProjectsProjectIdGroupsGroupId,
  deleteApiProjectsProjectIdGroupsGroupId,
  patchApiProjectsProjectIdGroupsGroupIdMembers,
  postApiProjectsProjectIdIssuesIssueIdAssignments,
  postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept,
  postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject,
  deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId,
  postApiProjectsProjectIdIssuesIssueIdDocuments,
  postApiProjectsProjectIdIssuesIssueIdIssueImages,
  deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId,
  patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId,
  postApiProjectsProjectIdIssuesSmartIssues,
  postApiProjectsProjectIdIssuesIssueIdApprove,
  postApiProjectsProjectIdIssuesIssueIdComplete,
  postApiProjectsProjectIdIssuesIssueIdReject,
  postApiProjectsProjectIdIssuesIssueIdReopen,
  postApiProjectsProjectIdIssuesIssueIdStart,
  postApiProjectsProjectIdIssuesIssueIdStop,
  postApiProjectsProjectIdIssuesIssueIdSubmit,
  postApiProjectsProjectIdIssuesIssueIdStatusStatements,
  deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId,
  postApiProjectsProjectIdIssueViews,
  patchApiProjectsProjectIdIssueViewsIssueViewId,
  deleteApiProjectsProjectIdIssueViewsIssueViewId,
  postApiProjectsProjectIdIssuesIssueIdVisit,
  postApiProjectsProjectIdIssues,
  postApiProjectsProjectIdIssuesExport,
  postApiProjectsProjectIdIssuesQuickIssues,
  patchApiProjectsProjectIdIssuesIssueId,
  deleteApiProjectsProjectIdIssuesIssueId,
  postApiProjectsProjectIdIssuesIssueIdArchive,
  postApiProjectsProjectIdIssuesIssueIdExport,
  postApiProjectsProjectIdIssuesIssueIdRestore,
  postApiProjectsProjectIdIssuesIssueIdUpdateImpact,
  postApiProjectsProjectIdLocations,
  patchApiProjectsProjectIdLocationsLocationId,
  deleteApiProjectsProjectIdLocationsLocationId,
  postApiProjectsProjectIdLocationsLocationIdSort,
  postApiOrgs,
  patchApiOrgsOrgId,
  postApiOrgsCheckDomain,
  postApiOrgsOrgIdResendVerificationEmail,
  postApiPowerSyncToken,
  deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId,
  postApiProjectsProjectIdProgressLogsProgressLogIdDocuments,
  postApiProjectsProjectIdProgressLogs,
  patchApiProjectsProjectIdProgressLogsProgressLogId,
  postApiProjectsProjectIdAccessRequests,
  postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept,
  postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject,
  postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect,
  postApiProjectsProjectIdNotificationsNotificationIdMarkRead,
  postApiProjectsProjectIdNotificationsMarkAllRead,
  postApiProjects,
  patchApiProjectsProjectId,
  postApiProjectsProjectIdArchive,
  postApiProjectsProjectIdShiftActivities,
  patchApiProjectsProjectIdShiftActivitiesShiftActivityId,
  postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive,
  postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore,
  postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch,
  deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId,
  postApiProjectsProjectIdShiftActivitiesExport,
  postApiProjectsProjectIdShiftActivitiesImports,
  patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness,
  postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements,
  postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort,
  patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId,
  deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId,
  postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion,
  deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion,
  postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate,
  postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators,
  postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic,
  deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId,
  deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId,
  postApiProjectsProjectIdShiftReportsShiftReportIdDocuments,
  postApiProjectsProjectIdShiftReportsExport,
  postApiProjectsProjectIdShiftReportsShiftReportIdExport,
  postApiProjectsProjectIdShiftReportsShiftReportIdImport,
  postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments,
  deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId,
  postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind,
  postApiProjectsProjectIdShiftReports,
  patchApiProjectsProjectIdShiftReportsShiftReportId,
  deleteApiProjectsProjectIdShiftReportsShiftReportId,
  postApiProjectsProjectIdShiftReportsShiftReportIdArchive,
  postApiProjectsProjectIdShiftReportsShiftReportIdPublish,
  postApiProjectsProjectIdShiftReportsShiftReportIdResetSection,
  postApiProjectsProjectIdShiftReportsShiftReportIdRestore,
  postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview,
  postApiProjectsShowcases,
  patchApiProjectsProjectIdTeamsTeamIdChannelConfiguration,
  postApiProjectsProjectIdTeamsTeamIdJoinToken,
  deleteApiProjectsProjectIdTeamsTeamIdJoinToken,
  postApiProjectsProjectIdTeamJoinTokensTokenJoin,
  postApiProjectsProjectIdTeamsTeamIdMembers,
  patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId,
  deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId,
  postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive,
  postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail,
  postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable,
  postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable,
  postApiProjectsProjectIdTeamsTeamIdResourcesKind,
  postApiProjectsProjectIdTeamsTeamIdSubscription,
  postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm,
  postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal,
  postApiProjectsProjectIdTeams,
  patchApiProjectsProjectIdTeamsTeamId,
  deleteApiProjectsProjectIdTeamsTeamId,
  postApiProjectsProjectIdTeamsTeamIdResendMembersInvites,
  postApiProjectsProjectIdIssuesIssueIdWatchings,
  deleteApiProjectsProjectIdIssuesIssueIdWatchings,
  postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch,
  patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId,
  deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays,
  deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate,
  patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder,
  postApiProjectsProjectIdWeeklyWorkPlans,
  putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive,
  postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore,
} from "../api/index";
import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
  mutationOptions,
  useMutation,
} from "@tanstack/react-query";

export const getApiConfigEnvironmentQueryKey = () =>
  [{ url: "/api/config/environment" }] as const;

export type GetApiConfigEnvironmentQueryKey = ReturnType<
  typeof getApiConfigEnvironmentQueryKey
>;

export function getApiConfigEnvironmentQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiConfigEnvironmentQueryKey();
  return queryOptions<
    GetApiConfigEnvironmentQueryResponseSchema,
    ResponseErrorConfig<Error>,
    GetApiConfigEnvironmentQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiConfigEnvironment(config);
    },
  });
}

/**
 * @summary Return environment configuration
 * {@link /api/config/environment}
 */
export function useGetApiConfigEnvironment<
  TData = GetApiConfigEnvironmentQueryResponseSchema,
  TQueryData = GetApiConfigEnvironmentQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiConfigEnvironmentQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiConfigEnvironmentQueryResponseSchema,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiConfigEnvironmentQueryKey();

  const query = useQuery(
    {
      ...getApiConfigEnvironmentQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiConstructionRolesQueryKey = () =>
  [{ url: "/api/construction_roles" }] as const;

export type GetApiConstructionRolesQueryKey = ReturnType<
  typeof getApiConstructionRolesQueryKey
>;

export function getApiConstructionRolesQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiConstructionRolesQueryKey();
  return queryOptions<
    GetApiConstructionRolesQueryResponseSchema,
    ResponseErrorConfig<GetApiConstructionRoles401Schema>,
    GetApiConstructionRolesQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiConstructionRoles(config);
    },
  });
}

/**
 * @summary Retrieves construction roles
 * {@link /api/construction_roles}
 */
export function useGetApiConstructionRoles<
  TData = GetApiConstructionRolesQueryResponseSchema,
  TQueryData = GetApiConstructionRolesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiConstructionRolesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiConstructionRolesQueryResponseSchema,
        ResponseErrorConfig<GetApiConstructionRoles401Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiConstructionRolesQueryKey();

  const query = useQuery(
    {
      ...getApiConstructionRolesQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiConstructionRoles401Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdContractsContractIdFilesQueryKey = (
  projectId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/contracts/:contract_id/files",
      params: { projectId: projectId, contractId: contractId },
    },
  ] as const;

export type GetApiProjectsProjectIdContractsContractIdFilesQueryKey =
  ReturnType<typeof getApiProjectsProjectIdContractsContractIdFilesQueryKey>;

export function getApiProjectsProjectIdContractsContractIdFilesQueryOptions(
  projectId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdContractsContractIdFilesQueryKey(
    projectId,
    contractId,
  );
  return queryOptions<
    GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContractsContractIdFiles401Schema
      | GetApiProjectsProjectIdContractsContractIdFiles403Schema
      | GetApiProjectsProjectIdContractsContractIdFiles404Schema
    >,
    GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && contractId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdContractsContractIdFiles(
        projectId,
        contractId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves contract files
 * {@link /api/projects/:project_id/contracts/:contract_id/files}
 */
export function useGetApiProjectsProjectIdContractsContractIdFiles<
  TData = GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdContractsContractIdFilesQueryKey,
>(
  projectId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdContractsContractIdFiles401Schema
          | GetApiProjectsProjectIdContractsContractIdFiles403Schema
          | GetApiProjectsProjectIdContractsContractIdFiles404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdContractsContractIdFilesQueryKey(
      projectId,
      contractId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdContractsContractIdFilesQueryOptions(
        projectId,
        contractId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContractsContractIdFiles401Schema
      | GetApiProjectsProjectIdContractsContractIdFiles403Schema
      | GetApiProjectsProjectIdContractsContractIdFiles404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdContractsQueryKey = (
  projectId: GetApiProjectsProjectIdContractsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/contracts",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdContractsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdContractsQueryKey
>;

export function getApiProjectsProjectIdContractsQueryOptions(
  projectId: GetApiProjectsProjectIdContractsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdContractsQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdContractsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContracts401Schema
      | GetApiProjectsProjectIdContracts403Schema
      | GetApiProjectsProjectIdContracts404Schema
    >,
    GetApiProjectsProjectIdContractsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdContracts(projectId, config);
    },
  });
}

/**
 * @summary Retrieves contracts
 * {@link /api/projects/:project_id/contracts}
 */
export function useGetApiProjectsProjectIdContracts<
  TData = GetApiProjectsProjectIdContractsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdContractsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdContractsQueryKey,
>(
  projectId: GetApiProjectsProjectIdContractsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdContractsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdContracts401Schema
          | GetApiProjectsProjectIdContracts403Schema
          | GetApiProjectsProjectIdContracts404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdContractsQueryKey(projectId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdContractsQueryOptions(projectId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContracts401Schema
      | GetApiProjectsProjectIdContracts403Schema
      | GetApiProjectsProjectIdContracts404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdContractsContractIdQueryKey = (
  projectId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/contracts/:contract_id",
      params: { projectId: projectId, contractId: contractId },
    },
  ] as const;

export type GetApiProjectsProjectIdContractsContractIdQueryKey = ReturnType<
  typeof getApiProjectsProjectIdContractsContractIdQueryKey
>;

export function getApiProjectsProjectIdContractsContractIdQueryOptions(
  projectId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdContractsContractIdQueryKey(
    projectId,
    contractId,
  );
  return queryOptions<
    GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContractsContractId401Schema
      | GetApiProjectsProjectIdContractsContractId403Schema
      | GetApiProjectsProjectIdContractsContractId404Schema
    >,
    GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && contractId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdContractsContractId(
        projectId,
        contractId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a contract
 * {@link /api/projects/:project_id/contracts/:contract_id}
 */
export function useGetApiProjectsProjectIdContractsContractId<
  TData = GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdContractsContractIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdContractsContractId401Schema
          | GetApiProjectsProjectIdContractsContractId403Schema
          | GetApiProjectsProjectIdContractsContractId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdContractsContractIdQueryKey(projectId, contractId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdContractsContractIdQueryOptions(
        projectId,
        contractId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContractsContractId401Schema
      | GetApiProjectsProjectIdContractsContractId403Schema
      | GetApiProjectsProjectIdContractsContractId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/search_filter",
        params: { projectId: projectId },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryKey(
      projectId,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsSearchFilter(
        projectId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the search filter for change signals assigned to the current team member
 * {@link /api/projects/:project_id/control_center/change_signals/search_filter}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryKey(
      projectId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryKey = (
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/control_center/change_signals/issues",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues404Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsIssues(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves issue change signals
 * {@link /api/projects/:project_id/control_center/change_signals/issues}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsIssues<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsIssues401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsIssues403Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsIssues404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryKey(
      projectId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/downtimes",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes404Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsDowntimes(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves downtime change signals
 * {@link /api/projects/:project_id/control_center/change_signals/downtimes}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsDowntimes<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes403Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryKey(
      projectId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/progress_logs",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs404Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsProgressLogs(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves progress log change signals
 * {@link /api/projects/:project_id/control_center/change_signals/progress_logs}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs403Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryKey(
      projectId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsCountersQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterChangeSignalsCountersPathParamsSchema["project_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/counters",
        params: { projectId: projectId },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsCountersQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsCountersQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsCountersPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsCountersQueryKey(
      projectId,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsCounters401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsCounters403Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsCounters(
        projectId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves change signals counters
 * {@link /api/projects/:project_id/control_center/change_signals/counters}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsCounters<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsCountersPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsCounters401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsCounters403Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsCountersQueryKey(
      projectId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsCountersQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsCounters401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsCounters403Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsIdQueryKey = (
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["id"],
) =>
  [
    {
      url: "/api/projects/:project_id/control_center/change_signals/:id",
      params: { projectId: projectId, id: id },
    },
  ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsIdQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsIdQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdControlCenterChangeSignalsIdQueryKey(
    projectId,
    id,
  );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsId401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsId403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsId404Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && id),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsId(
        projectId,
        id,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a change signal
 * {@link /api/projects/:project_id/control_center/change_signals/:id}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsId<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsId401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsId403Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsIdQueryKey(projectId, id);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsIdQueryOptions(
        projectId,
        id,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsId401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsId403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"],
    params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/documents",
        params: { projectId: projectId, potentialChangeId: potentialChangeId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryKey(
      projectId,
      potentialChangeId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments(
        projectId,
        potentialChangeId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves potential change documents, including documents attached to its linked signalables
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/documents}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryKey(
      projectId,
      potentialChangeId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryOptions(
        projectId,
        potentialChangeId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["potential_change_id"],
    params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/feed",
        params: { projectId: projectId, potentialChangeId: potentialChangeId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["potential_change_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryKey(
      projectId,
      potentialChangeId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed(
        projectId,
        potentialChangeId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the feed of the PotentialChange events
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/feed}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["potential_change_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryKey(
      projectId,
      potentialChangeId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryOptions(
        projectId,
        potentialChangeId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/narrative",
        params: { projectId: projectId, potentialChangeId: potentialChangeId },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryKey(
      projectId,
      potentialChangeId,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative(
        projectId,
        potentialChangeId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves potential change narrative
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/narrative}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryKey(
      projectId,
      potentialChangeId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryOptions(
        projectId,
        potentialChangeId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesQueryKey = (
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/control_center/potential_changes",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdControlCenterPotentialChangesQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChanges401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChanges403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChanges404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChanges(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves potential changes
 * {@link /api/projects/:project_id/control_center/potential_changes}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChanges<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChanges401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChanges403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChanges404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesQueryKey(
      projectId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChanges401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChanges403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChanges404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id",
        params: { projectId: projectId, potentialChangeId: potentialChangeId },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryKey(
      projectId,
      potentialChangeId,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId(
        projectId,
        potentialChangeId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryKey(
      projectId,
      potentialChangeId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryOptions(
        projectId,
        potentialChangeId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["potential_change_id"],
    params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryParamsSchema,
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view",
        params: { projectId: projectId, potentialChangeId: potentialChangeId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["potential_change_id"],
  params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryKey(
      projectId,
      potentialChangeId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView(
        projectId,
        potentialChangeId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the schedule view for a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["potential_change_id"],
  params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView400Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryKey(
      projectId,
      potentialChangeId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryOptions(
        projectId,
        potentialChangeId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["potential_change_id"],
    rowId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["row_id"],
    date: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["date"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/days/:date",
        params: {
          projectId: projectId,
          potentialChangeId: potentialChangeId,
          rowId: rowId,
          date: date,
        },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["potential_change_id"],
  rowId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["row_id"],
  date: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["date"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryKey(
      projectId,
      potentialChangeId,
      rowId,
      date,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId && rowId && date),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate(
        projectId,
        potentialChangeId,
        rowId,
        date,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves day details for a schedule view row
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/days/:date}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["potential_change_id"],
  rowId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["row_id"],
  date: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["date"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate400Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryKey(
      projectId,
      potentialChangeId,
      rowId,
      date,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryOptions(
        projectId,
        potentialChangeId,
        rowId,
        date,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterTeamPersonalizationQueryKey = (
  projectId: GetApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/control_center/team_personalization",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterTeamPersonalizationQueryKey
  >;

export function getApiProjectsProjectIdControlCenterTeamPersonalizationQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterTeamPersonalizationQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterTeamPersonalization401Schema
      | GetApiProjectsProjectIdControlCenterTeamPersonalization403Schema
      | GetApiProjectsProjectIdControlCenterTeamPersonalization404Schema
    >,
    GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterTeamPersonalization(
        projectId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves team personalization for the control center
 * {@link /api/projects/:project_id/control_center/team_personalization}
 */
export function useGetApiProjectsProjectIdControlCenterTeamPersonalization<
  TData =
    GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterTeamPersonalization401Schema
          | GetApiProjectsProjectIdControlCenterTeamPersonalization403Schema
          | GetApiProjectsProjectIdControlCenterTeamPersonalization404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterTeamPersonalizationQueryKey(projectId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdControlCenterTeamPersonalizationQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterTeamPersonalization401Schema
      | GetApiProjectsProjectIdControlCenterTeamPersonalization403Schema
      | GetApiProjectsProjectIdControlCenterTeamPersonalization404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdCustomFieldsQueryKey = (
  projectId: GetApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/custom_fields",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdCustomFieldsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdCustomFieldsQueryKey
>;

export function getApiProjectsProjectIdCustomFieldsQueryOptions(
  projectId: GetApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdCustomFieldsQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdCustomFields401Schema
      | GetApiProjectsProjectIdCustomFields403Schema
      | GetApiProjectsProjectIdCustomFields404Schema
    >,
    GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdCustomFields(projectId, config);
    },
  });
}

/**
 * @summary Retrieves project custom fields
 * {@link /api/projects/:project_id/custom_fields}
 */
export function useGetApiProjectsProjectIdCustomFields<
  TData = GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdCustomFieldsQueryKey,
>(
  projectId: GetApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdCustomFields401Schema
          | GetApiProjectsProjectIdCustomFields403Schema
          | GetApiProjectsProjectIdCustomFields404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdCustomFieldsQueryKey(projectId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdCustomFieldsQueryOptions(projectId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdCustomFields401Schema
      | GetApiProjectsProjectIdCustomFields403Schema
      | GetApiProjectsProjectIdCustomFields404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsQueryKey = (
  projectId: GetApiProjectsProjectIdDashboardsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/dashboards",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdDashboardsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdDashboardsQueryKey
>;

export function getApiProjectsProjectIdDashboardsQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDashboardsQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdDashboardsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboards401Schema
      | GetApiProjectsProjectIdDashboards403Schema
      | GetApiProjectsProjectIdDashboards404Schema
    >,
    GetApiProjectsProjectIdDashboardsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboards(projectId, config);
    },
  });
}

/**
 * @summary Retrieve dashboards
 * {@link /api/projects/:project_id/dashboards}
 */
export function useGetApiProjectsProjectIdDashboards<
  TData = GetApiProjectsProjectIdDashboardsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdDashboardsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdDashboardsQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDashboardsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboards401Schema
          | GetApiProjectsProjectIdDashboards403Schema
          | GetApiProjectsProjectIdDashboards404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsQueryKey(projectId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDashboardsQueryOptions(projectId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboards401Schema
      | GetApiProjectsProjectIdDashboards403Schema
      | GetApiProjectsProjectIdDashboards404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/data_health_records/issues",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryKey
  >;

export function getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues404Schema
    >,
    GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsDataHealthRecordsIssues(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves data health issues
 * {@link /api/projects/:project_id/dashboards/data_health_records/issues}
 */
export function useGetApiProjectsProjectIdDashboardsDataHealthRecordsIssues<
  TData =
    GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues401Schema
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues403Schema
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryKey(
      projectId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/data_health_records/shift_reports",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryKey
  >;

export function getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports404Schema
    >,
    GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves data health shift reports
 * {@link /api/projects/:project_id/dashboards/data_health_records/shift_reports}
 */
export function useGetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports<
  TData =
    GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports401Schema
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports403Schema
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryKey(
      projectId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["project_id"],
    recordType: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["record_type"],
    params: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/data_health_scores/:record_type",
        params: { projectId: projectId, recordType: recordType },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryKey
  >;

export function getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["project_id"],
  recordType: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["record_type"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryKey(
      projectId,
      recordType,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType404Schema
    >,
    GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && recordType),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsDataHealthScoresRecordType(
        projectId,
        recordType,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves data health scores
 * {@link /api/projects/:project_id/dashboards/data_health_scores/:record_type}
 */
export function useGetApiProjectsProjectIdDashboardsDataHealthScoresRecordType<
  TData =
    GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["project_id"],
  recordType: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["record_type"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType401Schema
          | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType403Schema
          | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryKey(
      projectId,
      recordType,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryOptions(
        projectId,
        recordType,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryKey = (
  projectId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["project_id"],
  dashboardId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["dashboard_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/dashboards/:dashboard_id/embedding",
      params: { projectId: projectId, dashboardId: dashboardId },
    },
  ] as const;

export type GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryKey
  >;

export function getApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["project_id"],
  dashboardId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["dashboard_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryKey(
      projectId,
      dashboardId,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding401Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding403Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding404Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding503Schema
    >,
    GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && dashboardId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsDashboardIdEmbedding(
        projectId,
        dashboardId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieve embedding information
 * {@link /api/projects/:project_id/dashboards/:dashboard_id/embedding}
 */
export function useGetApiProjectsProjectIdDashboardsDashboardIdEmbedding<
  TData =
    GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["project_id"],
  dashboardId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["dashboard_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding401Schema
          | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding403Schema
          | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding404Schema
          | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding503Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryKey(
      projectId,
      dashboardId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryOptions(
        projectId,
        dashboardId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding401Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding403Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding404Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding503Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/shift_activities/gantt/activities",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryKey
  >;

export function getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities404Schema
    >,
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift activities for Gantt view
 * {@link /api/projects/:project_id/dashboards/shift_activities/gantt/activities}
 */
export function useGetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities<
  TData =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities400Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities401Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities403Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryKey(
      projectId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["project_id"],
    activityId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["activity_id"],
    date: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["date"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/shift_activities/gantt/activities/:activity_id/days/:date",
        params: { projectId: projectId, activityId: activityId, date: date },
      },
    ] as const;

export type GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryKey
  >;

export function getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["project_id"],
  activityId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["activity_id"],
  date: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["date"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryKey(
      projectId,
      activityId,
      date,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate404Schema
    >,
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && activityId && date),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate(
        projectId,
        activityId,
        date,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves Gantt dashboard day details for a shift activity
 * {@link /api/projects/:project_id/dashboards/shift_activities/gantt/activities/:activity_id/days/:date}
 */
export function useGetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate<
  TData =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["project_id"],
  activityId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["activity_id"],
  date: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["date"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate400Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate401Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate403Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryKey(
      projectId,
      activityId,
      date,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryOptions(
        projectId,
        activityId,
        date,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelinePathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryParamsSchema,
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/shift_activities/gantt/timeline",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryKey
  >;

export function getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelinePathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline404Schema
    >,
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves Gantt dashboard timeline for shift activities
 * {@link /api/projects/:project_id/dashboards/shift_activities/gantt/timeline}
 */
export function useGetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline<
  TData =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelinePathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline400Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline401Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline403Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryKey(
      projectId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDisciplinesQueryKey = (
  projectId: GetApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDisciplinesQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/disciplines",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdDisciplinesQueryKey = ReturnType<
  typeof getApiProjectsProjectIdDisciplinesQueryKey
>;

export function getApiProjectsProjectIdDisciplinesQueryOptions(
  projectId: GetApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDisciplinesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDisciplinesQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDisciplines401Schema
      | GetApiProjectsProjectIdDisciplines403Schema
      | GetApiProjectsProjectIdDisciplines404Schema
    >,
    GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDisciplines(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves disciplines
 * {@link /api/projects/:project_id/disciplines}
 */
export function useGetApiProjectsProjectIdDisciplines<
  TData = GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdDisciplinesQueryKey,
>(
  projectId: GetApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDisciplinesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDisciplines401Schema
          | GetApiProjectsProjectIdDisciplines403Schema
          | GetApiProjectsProjectIdDisciplines404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDisciplinesQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDisciplinesQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDisciplines401Schema
      | GetApiProjectsProjectIdDisciplines403Schema
      | GetApiProjectsProjectIdDisciplines404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDisciplinesDisciplineIdQueryKey = (
  projectId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"],
  disciplineId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/disciplines/:discipline_id",
      params: { projectId: projectId, disciplineId: disciplineId },
    },
  ] as const;

export type GetApiProjectsProjectIdDisciplinesDisciplineIdQueryKey = ReturnType<
  typeof getApiProjectsProjectIdDisciplinesDisciplineIdQueryKey
>;

export function getApiProjectsProjectIdDisciplinesDisciplineIdQueryOptions(
  projectId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"],
  disciplineId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDisciplinesDisciplineIdQueryKey(
    projectId,
    disciplineId,
  );
  return queryOptions<
    GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | GetApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | GetApiProjectsProjectIdDisciplinesDisciplineId404Schema
    >,
    GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && disciplineId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDisciplinesDisciplineId(
        projectId,
        disciplineId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a discipline
 * {@link /api/projects/:project_id/disciplines/:discipline_id}
 */
export function useGetApiProjectsProjectIdDisciplinesDisciplineId<
  TData = GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDisciplinesDisciplineIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"],
  disciplineId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDisciplinesDisciplineId401Schema
          | GetApiProjectsProjectIdDisciplinesDisciplineId403Schema
          | GetApiProjectsProjectIdDisciplinesDisciplineId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDisciplinesDisciplineIdQueryKey(
      projectId,
      disciplineId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDisciplinesDisciplineIdQueryOptions(
        projectId,
        disciplineId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | GetApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | GetApiProjectsProjectIdDisciplinesDisciplineId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDocumentsDocumentIdReferencesQueryKey = (
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["document_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/documents/:document_id/references",
      params: { projectId: projectId, documentId: documentId },
    },
  ] as const;

export type GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDocumentsDocumentIdReferencesQueryKey
  >;

export function getApiProjectsProjectIdDocumentsDocumentIdReferencesQueryOptions(
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["document_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDocumentsDocumentIdReferencesQueryKey(
    projectId,
    documentId,
  );
  return queryOptions<
    GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences401Schema
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences403Schema
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences404Schema
    >,
    GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && documentId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDocumentsDocumentIdReferences(
        projectId,
        documentId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves document references
 * {@link /api/projects/:project_id/documents/:document_id/references}
 */
export function useGetApiProjectsProjectIdDocumentsDocumentIdReferences<
  TData =
    GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryKey,
>(
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["document_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDocumentsDocumentIdReferences401Schema
          | GetApiProjectsProjectIdDocumentsDocumentIdReferences403Schema
          | GetApiProjectsProjectIdDocumentsDocumentIdReferences404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDocumentsDocumentIdReferencesQueryKey(
      projectId,
      documentId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDocumentsDocumentIdReferencesQueryOptions(
        projectId,
        documentId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences401Schema
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences403Schema
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDocumentsQueryKey = (
  projectId: GetApiProjectsProjectIdDocumentsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDocumentsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/documents",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdDocumentsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdDocumentsQueryKey
>;

export function getApiProjectsProjectIdDocumentsQueryOptions(
  projectId: GetApiProjectsProjectIdDocumentsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDocumentsQueryKey(projectId, params);
  return queryOptions<
    GetApiProjectsProjectIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocuments400Schema
      | GetApiProjectsProjectIdDocuments401Schema
      | GetApiProjectsProjectIdDocuments403Schema
      | GetApiProjectsProjectIdDocuments404Schema
    >,
    GetApiProjectsProjectIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDocuments(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves documents
 * {@link /api/projects/:project_id/documents}
 */
export function useGetApiProjectsProjectIdDocuments<
  TData = GetApiProjectsProjectIdDocumentsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdDocumentsQueryKey,
>(
  projectId: GetApiProjectsProjectIdDocumentsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDocuments400Schema
          | GetApiProjectsProjectIdDocuments401Schema
          | GetApiProjectsProjectIdDocuments403Schema
          | GetApiProjectsProjectIdDocuments404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDocumentsQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDocumentsQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocuments400Schema
      | GetApiProjectsProjectIdDocuments401Schema
      | GetApiProjectsProjectIdDocuments403Schema
      | GetApiProjectsProjectIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDocumentsImageUrlsQueryKey = (
  projectId: GetApiProjectsProjectIdDocumentsImageUrlsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDocumentsImageUrlsQueryParamsSchema,
) =>
  [
    {
      url: "/api/projects/:project_id/documents/image_urls",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdDocumentsImageUrlsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdDocumentsImageUrlsQueryKey
>;

export function getApiProjectsProjectIdDocumentsImageUrlsQueryOptions(
  projectId: GetApiProjectsProjectIdDocumentsImageUrlsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDocumentsImageUrlsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDocumentsImageUrlsQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsImageUrls401Schema
      | GetApiProjectsProjectIdDocumentsImageUrls403Schema
    >,
    GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDocumentsImageUrls(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves documents image URLs
 * {@link /api/projects/:project_id/documents/image_urls}
 */
export function useGetApiProjectsProjectIdDocumentsImageUrls<
  TData = GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDocumentsImageUrlsQueryKey,
>(
  projectId: GetApiProjectsProjectIdDocumentsImageUrlsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDocumentsImageUrlsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDocumentsImageUrls401Schema
          | GetApiProjectsProjectIdDocumentsImageUrls403Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDocumentsImageUrlsQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDocumentsImageUrlsQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsImageUrls401Schema
      | GetApiProjectsProjectIdDocumentsImageUrls403Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDocumentsDocumentIdQueryKey = (
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/documents/:document_id",
      params: { projectId: projectId, documentId: documentId },
    },
  ] as const;

export type GetApiProjectsProjectIdDocumentsDocumentIdQueryKey = ReturnType<
  typeof getApiProjectsProjectIdDocumentsDocumentIdQueryKey
>;

export function getApiProjectsProjectIdDocumentsDocumentIdQueryOptions(
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDocumentsDocumentIdQueryKey(
    projectId,
    documentId,
  );
  return queryOptions<
    GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsDocumentId401Schema
      | GetApiProjectsProjectIdDocumentsDocumentId403Schema
      | GetApiProjectsProjectIdDocumentsDocumentId404Schema
    >,
    GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && documentId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDocumentsDocumentId(
        projectId,
        documentId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a document
 * {@link /api/projects/:project_id/documents/:document_id}
 */
export function useGetApiProjectsProjectIdDocumentsDocumentId<
  TData = GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDocumentsDocumentIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDocumentsDocumentId401Schema
          | GetApiProjectsProjectIdDocumentsDocumentId403Schema
          | GetApiProjectsProjectIdDocumentsDocumentId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDocumentsDocumentIdQueryKey(projectId, documentId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdDocumentsDocumentIdQueryOptions(
        projectId,
        documentId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsDocumentId401Schema
      | GetApiProjectsProjectIdDocumentsDocumentId403Schema
      | GetApiProjectsProjectIdDocumentsDocumentId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryKey =
  (
    projectId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"],
    groupId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/groups/:group_id/channel_configuration",
        params: { projectId: projectId, groupId: groupId },
      },
    ] as const;

export type GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryKey
  >;

export function getApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryOptions(
  projectId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"],
  groupId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryKey(
      projectId,
      groupId,
    );
  return queryOptions<
    GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
    >,
    GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && groupId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdGroupsGroupIdChannelConfiguration(
        projectId,
        groupId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the group channel configuration
 * {@link /api/projects/:project_id/groups/:group_id/channel_configuration}
 */
export function useGetApiProjectsProjectIdGroupsGroupIdChannelConfiguration<
  TData =
    GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryKey,
>(
  projectId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"],
  groupId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
          | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
          | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryKey(
      projectId,
      groupId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryOptions(
        projectId,
        groupId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdGroupsGroupIdQueryKey = (
  projectId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"],
  groupId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/groups/:group_id",
      params: { projectId: projectId, groupId: groupId },
    },
  ] as const;

export type GetApiProjectsProjectIdGroupsGroupIdQueryKey = ReturnType<
  typeof getApiProjectsProjectIdGroupsGroupIdQueryKey
>;

export function getApiProjectsProjectIdGroupsGroupIdQueryOptions(
  projectId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"],
  groupId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdGroupsGroupIdQueryKey(
    projectId,
    groupId,
  );
  return queryOptions<
    GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdGroupsGroupId401Schema
      | GetApiProjectsProjectIdGroupsGroupId403Schema
      | GetApiProjectsProjectIdGroupsGroupId404Schema
    >,
    GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && groupId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdGroupsGroupId(projectId, groupId, config);
    },
  });
}

/**
 * @summary Retrieves a group
 * {@link /api/projects/:project_id/groups/:group_id}
 */
export function useGetApiProjectsProjectIdGroupsGroupId<
  TData = GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdGroupsGroupIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"],
  groupId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdGroupsGroupId401Schema
          | GetApiProjectsProjectIdGroupsGroupId403Schema
          | GetApiProjectsProjectIdGroupsGroupId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdGroupsGroupIdQueryKey(projectId, groupId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdGroupsGroupIdQueryOptions(
        projectId,
        groupId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdGroupsGroupId401Schema
      | GetApiProjectsProjectIdGroupsGroupId403Schema
      | GetApiProjectsProjectIdGroupsGroupId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdDocumentsQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"],
  params: GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/documents",
      params: { projectId: projectId, issueId: issueId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssuesIssueIdDocumentsQueryKey
>;

export function getApiProjectsProjectIdIssuesIssueIdDocumentsQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdDocumentsQueryKey(
    projectId,
    issueId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdDocuments400Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments401Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments403Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdDocuments(
        projectId,
        issueId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves issue documents
 * {@link /api/projects/:project_id/issues/:issue_id/documents}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdDocuments<
  TData = GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdDocuments400Schema
          | GetApiProjectsProjectIdIssuesIssueIdDocuments401Schema
          | GetApiProjectsProjectIdIssuesIssueIdDocuments403Schema
          | GetApiProjectsProjectIdIssuesIssueIdDocuments404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdDocumentsQueryKey(
      projectId,
      issueId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdDocumentsQueryOptions(
        projectId,
        issueId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdDocuments400Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments401Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments403Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdFeedTeamQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["issue_id"],
  params: GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/feed/team",
      params: { projectId: projectId, issueId: issueId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssuesIssueIdFeedTeamQueryKey
>;

export function getApiProjectsProjectIdIssuesIssueIdFeedTeamQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdFeedTeamQueryKey(
    projectId,
    issueId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam400Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam401Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdFeedTeam(
        projectId,
        issueId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves team only issue events
 * {@link /api/projects/:project_id/issues/:issue_id/feed/team}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdFeedTeam<
  TData = GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdFeedTeam400Schema
          | GetApiProjectsProjectIdIssuesIssueIdFeedTeam401Schema
          | GetApiProjectsProjectIdIssuesIssueIdFeedTeam404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdFeedTeamQueryKey(
      projectId,
      issueId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdFeedTeamQueryOptions(
        projectId,
        issueId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam400Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam401Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdFeedPublicQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["issue_id"],
  params: GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/feed/public",
      params: { projectId: projectId, issueId: issueId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssuesIssueIdFeedPublicQueryKey
>;

export function getApiProjectsProjectIdIssuesIssueIdFeedPublicQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdFeedPublicQueryKey(
    projectId,
    issueId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic400Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic401Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdFeedPublic(
        projectId,
        issueId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves public issue events
 * {@link /api/projects/:project_id/issues/:issue_id/feed/public}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdFeedPublic<
  TData = GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdFeedPublic400Schema
          | GetApiProjectsProjectIdIssuesIssueIdFeedPublic401Schema
          | GetApiProjectsProjectIdIssuesIssueIdFeedPublic404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdFeedPublicQueryKey(
      projectId,
      issueId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdFeedPublicQueryOptions(
        projectId,
        issueId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic400Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic401Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdIssueImagesQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"],
  params: GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/issue_images",
      params: { projectId: projectId, issueId: issueId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryKey =
  ReturnType<typeof getApiProjectsProjectIdIssuesIssueIdIssueImagesQueryKey>;

export function getApiProjectsProjectIdIssuesIssueIdIssueImagesQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdIssueImagesQueryKey(
    projectId,
    issueId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdIssueImages(
        projectId,
        issueId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Deprecated: use /api/projects/{project_id}/issues/{issue_id}/documents
 * @summary Retrieves issue images and evidence images
 * {@link /api/projects/:project_id/issues/:issue_id/issue_images}
 * @deprecated
 */
export function useGetApiProjectsProjectIdIssuesIssueIdIssueImages<
  TData = GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
          | GetApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
          | GetApiProjectsProjectIdIssuesIssueIdIssueImages404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdIssueImagesQueryKey(
      projectId,
      issueId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdIssueImagesQueryOptions(
        projectId,
        issueId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/status_statements",
      params: { projectId: projectId, issueId: issueId },
    },
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryKey
  >;

export function getApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryKey(
    projectId,
    issueId,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdStatusStatements(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves issue status statements
 * {@link /api/projects/:project_id/issues/:issue_id/status_statements}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdStatusStatements<
  TData =
    GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
          | GetApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
          | GetApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryKey(
      projectId,
      issueId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryOptions(
        projectId,
        issueId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssueViewsQueryKey = (
  projectId: GetApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/issue_views",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdIssueViewsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssueViewsQueryKey
>;

export function getApiProjectsProjectIdIssueViewsQueryOptions(
  projectId: GetApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssueViewsQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssueViews401Schema
      | GetApiProjectsProjectIdIssueViews403Schema
      | GetApiProjectsProjectIdIssueViews404Schema
    >,
    GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssueViews(projectId, config);
    },
  });
}

/**
 * @summary Retrieves issue views
 * {@link /api/projects/:project_id/issue_views}
 */
export function useGetApiProjectsProjectIdIssueViews<
  TData = GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdIssueViewsQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssueViews401Schema
          | GetApiProjectsProjectIdIssueViews403Schema
          | GetApiProjectsProjectIdIssueViews404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssueViewsQueryKey(projectId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssueViewsQueryOptions(projectId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssueViews401Schema
      | GetApiProjectsProjectIdIssueViews403Schema
      | GetApiProjectsProjectIdIssueViews404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdVisitQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/visit",
      params: { projectId: projectId, issueId: issueId },
    },
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdVisitQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssuesIssueIdVisitQueryKey
>;

export function getApiProjectsProjectIdIssuesIssueIdVisitQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdVisitQueryKey(
    projectId,
    issueId,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdVisit401Schema
      | GetApiProjectsProjectIdIssuesIssueIdVisit403Schema
      | GetApiProjectsProjectIdIssuesIssueIdVisit404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdVisit(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieve issue visit status
 * {@link /api/projects/:project_id/issues/:issue_id/visit}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdVisit<
  TData = GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdVisitQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdVisit401Schema
          | GetApiProjectsProjectIdIssuesIssueIdVisit403Schema
          | GetApiProjectsProjectIdIssuesIssueIdVisit404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdVisitQueryKey(projectId, issueId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdVisitQueryOptions(
        projectId,
        issueId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdVisit401Schema
      | GetApiProjectsProjectIdIssuesIssueIdVisit403Schema
      | GetApiProjectsProjectIdIssuesIssueIdVisit404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["issue_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/quality_indicators",
      params: { projectId: projectId, issueId: issueId },
    },
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryKey
  >;

export function getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["issue_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryKey(
      projectId,
      issueId,
    );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators401Schema
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators403Schema
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdQualityIndicators(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves all quality indicators for a issue
 * {@link /api/projects/:project_id/issues/:issue_id/quality_indicators}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdQualityIndicators<
  TData =
    GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["issue_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators401Schema
          | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators403Schema
          | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryKey(
      projectId,
      issueId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryOptions(
        projectId,
        issueId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators401Schema
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators403Schema
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdIssuesQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssuesQueryKey
>;

export function getApiProjectsProjectIdIssuesQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdIssuesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesQueryKey(projectId, params);
  return queryOptions<
    GetApiProjectsProjectIdIssuesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssues400Schema
      | GetApiProjectsProjectIdIssues401Schema
      | GetApiProjectsProjectIdIssues403Schema
      | GetApiProjectsProjectIdIssues404Schema
    >,
    GetApiProjectsProjectIdIssuesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssues(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves issues
 * {@link /api/projects/:project_id/issues}
 */
export function useGetApiProjectsProjectIdIssues<
  TData = GetApiProjectsProjectIdIssuesQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdIssuesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdIssuesQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdIssuesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssues400Schema
          | GetApiProjectsProjectIdIssues401Schema
          | GetApiProjectsProjectIdIssues403Schema
          | GetApiProjectsProjectIdIssues404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesQueryOptions(projectId, params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssues400Schema
      | GetApiProjectsProjectIdIssues401Schema
      | GetApiProjectsProjectIdIssues403Schema
      | GetApiProjectsProjectIdIssues404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesGroupCountQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesGroupCountPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdIssuesGroupCountQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues/group_count",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesGroupCountQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssuesGroupCountQueryKey
>;

export function getApiProjectsProjectIdIssuesGroupCountQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesGroupCountPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdIssuesGroupCountQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesGroupCountQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesGroupCount400Schema
      | GetApiProjectsProjectIdIssuesGroupCount401Schema
      | GetApiProjectsProjectIdIssuesGroupCount403Schema
      | GetApiProjectsProjectIdIssuesGroupCount404Schema
    >,
    GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesGroupCount(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves issues group count
 * {@link /api/projects/:project_id/issues/group_count}
 */
export function useGetApiProjectsProjectIdIssuesGroupCount<
  TData = GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdIssuesGroupCountQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesGroupCountPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdIssuesGroupCountQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesGroupCount400Schema
          | GetApiProjectsProjectIdIssuesGroupCount401Schema
          | GetApiProjectsProjectIdIssuesGroupCount403Schema
          | GetApiProjectsProjectIdIssuesGroupCount404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesGroupCountQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesGroupCountQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesGroupCount400Schema
      | GetApiProjectsProjectIdIssuesGroupCount401Schema
      | GetApiProjectsProjectIdIssuesGroupCount403Schema
      | GetApiProjectsProjectIdIssuesGroupCount404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id",
      params: { projectId: projectId, issueId: issueId },
    },
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssuesIssueIdQueryKey
>;

export function getApiProjectsProjectIdIssuesIssueIdQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdQueryKey(
    projectId,
    issueId,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueId401Schema
      | GetApiProjectsProjectIdIssuesIssueId403Schema
      | GetApiProjectsProjectIdIssuesIssueId404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueId(projectId, issueId, config);
    },
  });
}

/**
 * @summary Retrieves an issue
 * {@link /api/projects/:project_id/issues/:issue_id}
 */
export function useGetApiProjectsProjectIdIssuesIssueId<
  TData = GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdIssuesIssueIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueId401Schema
          | GetApiProjectsProjectIdIssuesIssueId403Schema
          | GetApiProjectsProjectIdIssuesIssueId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdQueryKey(projectId, issueId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdQueryOptions(
        projectId,
        issueId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueId401Schema
      | GetApiProjectsProjectIdIssuesIssueId403Schema
      | GetApiProjectsProjectIdIssuesIssueId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdLocationsQueryKey = (
  projectId: GetApiProjectsProjectIdLocationsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdLocationsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/locations",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdLocationsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdLocationsQueryKey
>;

export function getApiProjectsProjectIdLocationsQueryOptions(
  projectId: GetApiProjectsProjectIdLocationsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdLocationsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdLocationsQueryKey(projectId, params);
  return queryOptions<
    GetApiProjectsProjectIdLocationsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLocations401Schema
      | GetApiProjectsProjectIdLocations403Schema
      | GetApiProjectsProjectIdLocations404Schema
    >,
    GetApiProjectsProjectIdLocationsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdLocations(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves locations
 * {@link /api/projects/:project_id/locations}
 */
export function useGetApiProjectsProjectIdLocations<
  TData = GetApiProjectsProjectIdLocationsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdLocationsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdLocationsQueryKey,
>(
  projectId: GetApiProjectsProjectIdLocationsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdLocationsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdLocationsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdLocations401Schema
          | GetApiProjectsProjectIdLocations403Schema
          | GetApiProjectsProjectIdLocations404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdLocationsQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdLocationsQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLocations401Schema
      | GetApiProjectsProjectIdLocations403Schema
      | GetApiProjectsProjectIdLocations404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdLocationsLocationIdQueryKey = (
  projectId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"],
  locationId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/locations/:location_id",
      params: { projectId: projectId, locationId: locationId },
    },
  ] as const;

export type GetApiProjectsProjectIdLocationsLocationIdQueryKey = ReturnType<
  typeof getApiProjectsProjectIdLocationsLocationIdQueryKey
>;

export function getApiProjectsProjectIdLocationsLocationIdQueryOptions(
  projectId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"],
  locationId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdLocationsLocationIdQueryKey(
    projectId,
    locationId,
  );
  return queryOptions<
    GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLocationsLocationId401Schema
      | GetApiProjectsProjectIdLocationsLocationId403Schema
      | GetApiProjectsProjectIdLocationsLocationId404Schema
    >,
    GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && locationId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdLocationsLocationId(
        projectId,
        locationId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a location
 * {@link /api/projects/:project_id/locations/:location_id}
 */
export function useGetApiProjectsProjectIdLocationsLocationId<
  TData = GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdLocationsLocationIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"],
  locationId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdLocationsLocationId401Schema
          | GetApiProjectsProjectIdLocationsLocationId403Schema
          | GetApiProjectsProjectIdLocationsLocationId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdLocationsLocationIdQueryKey(projectId, locationId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdLocationsLocationIdQueryOptions(
        projectId,
        locationId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLocationsLocationId401Schema
      | GetApiProjectsProjectIdLocationsLocationId403Schema
      | GetApiProjectsProjectIdLocationsLocationId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryKey = (
  projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["project_id"],
  logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["log_person_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/logs/people/:log_person_id/allocations",
      params: { projectId: projectId, logPersonId: logPersonId },
    },
  ] as const;

export type GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryKey
  >;

export function getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryOptions(
  projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["project_id"],
  logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["log_person_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryKey(
      projectId,
      logPersonId,
    );
  return queryOptions<
    GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations401Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations404Schema
    >,
    GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && logPersonId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdLogsPeopleLogPersonIdAllocations(
        projectId,
        logPersonId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves allocations for a person log
 * {@link /api/projects/:project_id/logs/people/:log_person_id/allocations}
 */
export function useGetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations<
  TData =
    GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryKey,
>(
  projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["project_id"],
  logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["log_person_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations401Schema
          | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryKey(
      projectId,
      logPersonId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryOptions(
        projectId,
        logPersonId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations401Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryKey = (
  projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["project_id"],
  logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["log_person_id"],
  params: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/logs/people/:log_person_id/documents",
      params: { projectId: projectId, logPersonId: logPersonId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryKey
  >;

export function getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryOptions(
  projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["project_id"],
  logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["log_person_id"],
  params?: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryKey(
      projectId,
      logPersonId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments400Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments401Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments404Schema
    >,
    GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && logPersonId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdLogsPeopleLogPersonIdDocuments(
        projectId,
        logPersonId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves person log documents
 * {@link /api/projects/:project_id/logs/people/:log_person_id/documents}
 */
export function useGetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments<
  TData =
    GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryKey,
>(
  projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["project_id"],
  logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["log_person_id"],
  params?: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments400Schema
          | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments401Schema
          | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryKey(
      projectId,
      logPersonId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryOptions(
        projectId,
        logPersonId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments400Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments401Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdLogsPeopleQueryKey = (
  projectId: GetApiProjectsProjectIdLogsPeoplePathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdLogsPeopleQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/logs/people",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdLogsPeopleQueryKey = ReturnType<
  typeof getApiProjectsProjectIdLogsPeopleQueryKey
>;

export function getApiProjectsProjectIdLogsPeopleQueryOptions(
  projectId: GetApiProjectsProjectIdLogsPeoplePathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdLogsPeopleQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdLogsPeopleQueryKey(projectId, params);
  return queryOptions<
    GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeople401Schema
      | GetApiProjectsProjectIdLogsPeople403Schema
      | GetApiProjectsProjectIdLogsPeople404Schema
    >,
    GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdLogsPeople(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves people logs
 * {@link /api/projects/:project_id/logs/people}
 */
export function useGetApiProjectsProjectIdLogsPeople<
  TData = GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdLogsPeopleQueryKey,
>(
  projectId: GetApiProjectsProjectIdLogsPeoplePathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdLogsPeopleQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdLogsPeople401Schema
          | GetApiProjectsProjectIdLogsPeople403Schema
          | GetApiProjectsProjectIdLogsPeople404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdLogsPeopleQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdLogsPeopleQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeople401Schema
      | GetApiProjectsProjectIdLogsPeople403Schema
      | GetApiProjectsProjectIdLogsPeople404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiOrgsQueryKey = () => [{ url: "/api/orgs" }] as const;

export type GetApiOrgsQueryKey = ReturnType<typeof getApiOrgsQueryKey>;

export function getApiOrgsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiOrgsQueryKey();
  return queryOptions<
    GetApiOrgsQueryResponseSchema,
    ResponseErrorConfig<GetApiOrgs401Schema>,
    GetApiOrgsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiOrgs(config);
    },
  });
}

/**
 * @summary Retrieves orgs
 * {@link /api/orgs}
 */
export function useGetApiOrgs<
  TData = GetApiOrgsQueryResponseSchema,
  TQueryData = GetApiOrgsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiOrgsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiOrgsQueryResponseSchema,
        ResponseErrorConfig<GetApiOrgs401Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiOrgsQueryKey();

  const query = useQuery(
    {
      ...getApiOrgsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetApiOrgs401Schema>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiOrgsOrgIdQueryKey = (
  orgId: GetApiOrgsOrgIdPathParamsSchema["org_id"],
) => [{ url: "/api/orgs/:org_id", params: { orgId: orgId } }] as const;

export type GetApiOrgsOrgIdQueryKey = ReturnType<
  typeof getApiOrgsOrgIdQueryKey
>;

export function getApiOrgsOrgIdQueryOptions(
  orgId: GetApiOrgsOrgIdPathParamsSchema["org_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiOrgsOrgIdQueryKey(orgId);
  return queryOptions<
    GetApiOrgsOrgIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiOrgsOrgId401Schema
      | GetApiOrgsOrgId403Schema
      | GetApiOrgsOrgId404Schema
    >,
    GetApiOrgsOrgIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!orgId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiOrgsOrgId(orgId, config);
    },
  });
}

/**
 * @summary Retrieves an org
 * {@link /api/orgs/:org_id}
 */
export function useGetApiOrgsOrgId<
  TData = GetApiOrgsOrgIdQueryResponseSchema,
  TQueryData = GetApiOrgsOrgIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiOrgsOrgIdQueryKey,
>(
  orgId: GetApiOrgsOrgIdPathParamsSchema["org_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiOrgsOrgIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiOrgsOrgId401Schema
          | GetApiOrgsOrgId403Schema
          | GetApiOrgsOrgId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiOrgsOrgIdQueryKey(orgId);

  const query = useQuery(
    {
      ...getApiOrgsOrgIdQueryOptions(orgId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiOrgsOrgId401Schema
      | GetApiOrgsOrgId403Schema
      | GetApiOrgsOrgId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getWellKnownJwksJsonQueryKey = () =>
  [{ url: "/.well-known/jwks.json" }] as const;

export type GetWellKnownJwksJsonQueryKey = ReturnType<
  typeof getWellKnownJwksJsonQueryKey
>;

export function getWellKnownJwksJsonQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getWellKnownJwksJsonQueryKey();
  return queryOptions<
    GetWellKnownJwksJsonQueryResponseSchema,
    ResponseErrorConfig<GetWellKnownJwksJson503Schema>,
    GetWellKnownJwksJsonQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getWellKnownJwksJson(config);
    },
  });
}

/**
 * @summary Retrieves the JWKS for PowerSync token verification
 * {@link /.well-known/jwks.json}
 */
export function useGetWellKnownJwksJson<
  TData = GetWellKnownJwksJsonQueryResponseSchema,
  TQueryData = GetWellKnownJwksJsonQueryResponseSchema,
  TQueryKey extends QueryKey = GetWellKnownJwksJsonQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetWellKnownJwksJsonQueryResponseSchema,
        ResponseErrorConfig<GetWellKnownJwksJson503Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getWellKnownJwksJsonQueryKey();

  const query = useQuery(
    {
      ...getWellKnownJwksJsonQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetWellKnownJwksJson503Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryKey =
  (
    projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"],
    progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"],
    params: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/progress_logs/:progress_log_id/documents",
        params: { projectId: projectId, progressLogId: progressLogId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryKey
  >;

export function getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryOptions(
  projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"],
  progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"],
  params?: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryKey(
      projectId,
      progressLogId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
    >,
    GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && progressLogId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdProgressLogsProgressLogIdDocuments(
        projectId,
        progressLogId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves progress log documents
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id/documents}
 */
export function useGetApiProjectsProjectIdProgressLogsProgressLogIdDocuments<
  TData =
    GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryKey,
>(
  projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"],
  progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"],
  params?: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
          | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
          | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryKey(
      projectId,
      progressLogId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryOptions(
        projectId,
        progressLogId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdProgressLogsQueryKey = (
  projectId: GetApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdProgressLogsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/progress_logs",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdProgressLogsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdProgressLogsQueryKey
>;

export function getApiProjectsProjectIdProgressLogsQueryOptions(
  projectId: GetApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdProgressLogsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdProgressLogsQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogs401Schema
      | GetApiProjectsProjectIdProgressLogs403Schema
      | GetApiProjectsProjectIdProgressLogs404Schema
    >,
    GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdProgressLogs(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves progress logs
 * {@link /api/projects/:project_id/progress_logs}
 */
export function useGetApiProjectsProjectIdProgressLogs<
  TData = GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdProgressLogsQueryKey,
>(
  projectId: GetApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdProgressLogsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdProgressLogs401Schema
          | GetApiProjectsProjectIdProgressLogs403Schema
          | GetApiProjectsProjectIdProgressLogs404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdProgressLogsQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdProgressLogsQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogs401Schema
      | GetApiProjectsProjectIdProgressLogs403Schema
      | GetApiProjectsProjectIdProgressLogs404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdProgressLogsProgressLogIdQueryKey = (
  projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"],
  progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/progress_logs/:progress_log_id",
      params: { projectId: projectId, progressLogId: progressLogId },
    },
  ] as const;

export type GetApiProjectsProjectIdProgressLogsProgressLogIdQueryKey =
  ReturnType<typeof getApiProjectsProjectIdProgressLogsProgressLogIdQueryKey>;

export function getApiProjectsProjectIdProgressLogsProgressLogIdQueryOptions(
  projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"],
  progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdProgressLogsProgressLogIdQueryKey(
    projectId,
    progressLogId,
  );
  return queryOptions<
    GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogsProgressLogId401Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogId404Schema
    >,
    GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && progressLogId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdProgressLogsProgressLogId(
        projectId,
        progressLogId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a progress log
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id}
 */
export function useGetApiProjectsProjectIdProgressLogsProgressLogId<
  TData = GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdProgressLogsProgressLogIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"],
  progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdProgressLogsProgressLogId401Schema
          | GetApiProjectsProjectIdProgressLogsProgressLogId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdProgressLogsProgressLogIdQueryKey(
      projectId,
      progressLogId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdProgressLogsProgressLogIdQueryOptions(
        projectId,
        progressLogId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogsProgressLogId401Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdAccessRequestsQueryKey = (
  projectId: GetApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdAccessRequestsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/access_requests",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdAccessRequestsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdAccessRequestsQueryKey
>;

export function getApiProjectsProjectIdAccessRequestsQueryOptions(
  projectId: GetApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdAccessRequestsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdAccessRequestsQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdAccessRequests400Schema
      | GetApiProjectsProjectIdAccessRequests401Schema
      | GetApiProjectsProjectIdAccessRequests403Schema
      | GetApiProjectsProjectIdAccessRequests404Schema
    >,
    GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdAccessRequests(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves project pending access requests
 * {@link /api/projects/:project_id/access_requests}
 */
export function useGetApiProjectsProjectIdAccessRequests<
  TData = GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdAccessRequestsQueryKey,
>(
  projectId: GetApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdAccessRequestsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdAccessRequests400Schema
          | GetApiProjectsProjectIdAccessRequests401Schema
          | GetApiProjectsProjectIdAccessRequests403Schema
          | GetApiProjectsProjectIdAccessRequests404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdAccessRequestsQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdAccessRequestsQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdAccessRequests400Schema
      | GetApiProjectsProjectIdAccessRequests401Schema
      | GetApiProjectsProjectIdAccessRequests403Schema
      | GetApiProjectsProjectIdAccessRequests404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryKey =
  (
    projectId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_id"],
    projectAccessRequestId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_access_request_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/access_requests/:project_access_request_id",
        params: {
          projectId: projectId,
          projectAccessRequestId: projectAccessRequestId,
        },
      },
    ] as const;

export type GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryKey
  >;

export function getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryOptions(
  projectId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_id"],
  projectAccessRequestId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_access_request_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryKey(
      projectId,
      projectAccessRequestId,
    );
  return queryOptions<
    GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId401Schema
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId403Schema
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId404Schema
    >,
    GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && projectAccessRequestId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdAccessRequestsProjectAccessRequestId(
        projectId,
        projectAccessRequestId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a project access request
 * {@link /api/projects/:project_id/access_requests/:project_access_request_id}
 */
export function useGetApiProjectsProjectIdAccessRequestsProjectAccessRequestId<
  TData =
    GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_id"],
  projectAccessRequestId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_access_request_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId401Schema
          | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId403Schema
          | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryKey(
      projectId,
      projectAccessRequestId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryOptions(
        projectId,
        projectAccessRequestId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId401Schema
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId403Schema
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdPeopleQueryKey = (
  projectId: GetApiProjectsProjectIdPeoplePathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdPeopleQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/people",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdPeopleQueryKey = ReturnType<
  typeof getApiProjectsProjectIdPeopleQueryKey
>;

export function getApiProjectsProjectIdPeopleQueryOptions(
  projectId: GetApiProjectsProjectIdPeoplePathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdPeopleQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdPeopleQueryKey(projectId, params);
  return queryOptions<
    GetApiProjectsProjectIdPeopleQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdPeople400Schema
      | GetApiProjectsProjectIdPeople401Schema
      | GetApiProjectsProjectIdPeople404Schema
    >,
    GetApiProjectsProjectIdPeopleQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdPeople(projectId, params, config);
    },
  });
}

/**
 * @description Excludes archived team members by default, unless status is given
 * @summary Retrieves project people
 * {@link /api/projects/:project_id/people}
 */
export function useGetApiProjectsProjectIdPeople<
  TData = GetApiProjectsProjectIdPeopleQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdPeopleQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdPeopleQueryKey,
>(
  projectId: GetApiProjectsProjectIdPeoplePathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdPeopleQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdPeopleQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdPeople400Schema
          | GetApiProjectsProjectIdPeople401Schema
          | GetApiProjectsProjectIdPeople404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdPeopleQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdPeopleQueryOptions(projectId, params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdPeople400Schema
      | GetApiProjectsProjectIdPeople401Schema
      | GetApiProjectsProjectIdPeople404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdPeopleTeamMemberIdQueryKey = (
  projectId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["project_id"],
  teamMemberId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["team_member_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/people/:team_member_id",
      params: { projectId: projectId, teamMemberId: teamMemberId },
    },
  ] as const;

export type GetApiProjectsProjectIdPeopleTeamMemberIdQueryKey = ReturnType<
  typeof getApiProjectsProjectIdPeopleTeamMemberIdQueryKey
>;

export function getApiProjectsProjectIdPeopleTeamMemberIdQueryOptions(
  projectId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["project_id"],
  teamMemberId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["team_member_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdPeopleTeamMemberIdQueryKey(
    projectId,
    teamMemberId,
  );
  return queryOptions<
    GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdPeopleTeamMemberId401Schema
      | GetApiProjectsProjectIdPeopleTeamMemberId403Schema
      | GetApiProjectsProjectIdPeopleTeamMemberId404Schema
    >,
    GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamMemberId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdPeopleTeamMemberId(
        projectId,
        teamMemberId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a team member
 * {@link /api/projects/:project_id/people/:team_member_id}
 */
export function useGetApiProjectsProjectIdPeopleTeamMemberId<
  TData = GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdPeopleTeamMemberIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["project_id"],
  teamMemberId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["team_member_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdPeopleTeamMemberId401Schema
          | GetApiProjectsProjectIdPeopleTeamMemberId403Schema
          | GetApiProjectsProjectIdPeopleTeamMemberId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdPeopleTeamMemberIdQueryKey(projectId, teamMemberId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdPeopleTeamMemberIdQueryOptions(
        projectId,
        teamMemberId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdPeopleTeamMemberId401Schema
      | GetApiProjectsProjectIdPeopleTeamMemberId403Schema
      | GetApiProjectsProjectIdPeopleTeamMemberId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdFilesIdQueryKey = (
  projectId: GetApiProjectsProjectIdFilesIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdFilesIdPathParamsSchema["id"],
) =>
  [
    {
      url: "/api/projects/:project_id/files/:id",
      params: { projectId: projectId, id: id },
    },
  ] as const;

export type GetApiProjectsProjectIdFilesIdQueryKey = ReturnType<
  typeof getApiProjectsProjectIdFilesIdQueryKey
>;

export function getApiProjectsProjectIdFilesIdQueryOptions(
  projectId: GetApiProjectsProjectIdFilesIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdFilesIdPathParamsSchema["id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdFilesIdQueryKey(projectId, id);
  return queryOptions<
    GetApiProjectsProjectIdFilesIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdFilesId401Schema
      | GetApiProjectsProjectIdFilesId403Schema
      | GetApiProjectsProjectIdFilesId404Schema
    >,
    GetApiProjectsProjectIdFilesIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && id),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdFilesId(projectId, id, config);
    },
  });
}

/**
 * @summary Retrieves a file download URL
 * {@link /api/projects/:project_id/files/:id}
 */
export function useGetApiProjectsProjectIdFilesId<
  TData = GetApiProjectsProjectIdFilesIdQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdFilesIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdFilesIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdFilesIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdFilesIdPathParamsSchema["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdFilesIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdFilesId401Schema
          | GetApiProjectsProjectIdFilesId403Schema
          | GetApiProjectsProjectIdFilesId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdFilesIdQueryKey(projectId, id);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdFilesIdQueryOptions(projectId, id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdFilesId401Schema
      | GetApiProjectsProjectIdFilesId403Schema
      | GetApiProjectsProjectIdFilesId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiNotificationsOverviewQueryKey = () =>
  [{ url: "/api/notifications/overview" }] as const;

export type GetApiNotificationsOverviewQueryKey = ReturnType<
  typeof getApiNotificationsOverviewQueryKey
>;

export function getApiNotificationsOverviewQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiNotificationsOverviewQueryKey();
  return queryOptions<
    GetApiNotificationsOverviewQueryResponseSchema,
    ResponseErrorConfig<GetApiNotificationsOverview401Schema>,
    GetApiNotificationsOverviewQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiNotificationsOverview(config);
    },
  });
}

/**
 * @summary Retrieves notifications overview
 * {@link /api/notifications/overview}
 */
export function useGetApiNotificationsOverview<
  TData = GetApiNotificationsOverviewQueryResponseSchema,
  TQueryData = GetApiNotificationsOverviewQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiNotificationsOverviewQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiNotificationsOverviewQueryResponseSchema,
        ResponseErrorConfig<GetApiNotificationsOverview401Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiNotificationsOverviewQueryKey();

  const query = useQuery(
    {
      ...getApiNotificationsOverviewQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiNotificationsOverview401Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdNotificationsQueryKey = (
  projectId: GetApiProjectsProjectIdNotificationsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdNotificationsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/notifications",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdNotificationsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdNotificationsQueryKey
>;

export function getApiProjectsProjectIdNotificationsQueryOptions(
  projectId: GetApiProjectsProjectIdNotificationsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdNotificationsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdNotificationsQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdNotificationsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdNotifications400Schema
      | GetApiProjectsProjectIdNotifications401Schema
      | GetApiProjectsProjectIdNotifications404Schema
    >,
    GetApiProjectsProjectIdNotificationsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdNotifications(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves notifications
 * {@link /api/projects/:project_id/notifications}
 */
export function useGetApiProjectsProjectIdNotifications<
  TData = GetApiProjectsProjectIdNotificationsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdNotificationsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdNotificationsQueryKey,
>(
  projectId: GetApiProjectsProjectIdNotificationsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdNotificationsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdNotificationsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdNotifications400Schema
          | GetApiProjectsProjectIdNotifications401Schema
          | GetApiProjectsProjectIdNotifications404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdNotificationsQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdNotificationsQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdNotifications400Schema
      | GetApiProjectsProjectIdNotifications401Schema
      | GetApiProjectsProjectIdNotifications404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsQueryKey = () => [{ url: "/api/projects" }] as const;

export type GetApiProjectsQueryKey = ReturnType<typeof getApiProjectsQueryKey>;

export function getApiProjectsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsQueryKey();
  return queryOptions<
    GetApiProjectsQueryResponseSchema,
    ResponseErrorConfig<GetApiProjects401Schema | GetApiProjects403Schema>,
    GetApiProjectsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjects(config);
    },
  });
}

/**
 * @summary Retrieves projects
 * {@link /api/projects}
 */
export function useGetApiProjects<
  TData = GetApiProjectsQueryResponseSchema,
  TQueryData = GetApiProjectsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsQueryResponseSchema,
        ResponseErrorConfig<GetApiProjects401Schema | GetApiProjects403Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiProjectsQueryKey();

  const query = useQuery(
    {
      ...getApiProjectsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiProjects401Schema | GetApiProjects403Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdQueryKey = (
  projectId: GetApiProjectsProjectIdPathParamsSchema["project_id"],
) =>
  [
    { url: "/api/projects/:project_id", params: { projectId: projectId } },
  ] as const;

export type GetApiProjectsProjectIdQueryKey = ReturnType<
  typeof getApiProjectsProjectIdQueryKey
>;

export function getApiProjectsProjectIdQueryOptions(
  projectId: GetApiProjectsProjectIdPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectId401Schema
      | GetApiProjectsProjectId403Schema
      | GetApiProjectsProjectId404Schema
    >,
    GetApiProjectsProjectIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectId(projectId, config);
    },
  });
}

/**
 * @summary Retrieves a project
 * {@link /api/projects/:project_id}
 */
export function useGetApiProjectsProjectId<
  TData = GetApiProjectsProjectIdQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectId401Schema
          | GetApiProjectsProjectId403Schema
          | GetApiProjectsProjectId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiProjectsProjectIdQueryKey(projectId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdQueryOptions(projectId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectId401Schema
      | GetApiProjectsProjectId403Schema
      | GetApiProjectsProjectId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiQueuedTasksQueryKey = (
  params: GetApiQueuedTasksQueryParamsSchema,
) => [{ url: "/api/queued_tasks" }, ...(params ? [params] : [])] as const;

export type GetApiQueuedTasksQueryKey = ReturnType<
  typeof getApiQueuedTasksQueryKey
>;

export function getApiQueuedTasksQueryOptions(
  params: GetApiQueuedTasksQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiQueuedTasksQueryKey(params);
  return queryOptions<
    GetApiQueuedTasksQueryResponseSchema,
    ResponseErrorConfig<
      GetApiQueuedTasks400Schema | GetApiQueuedTasks401Schema
    >,
    GetApiQueuedTasksQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiQueuedTasks(params, config);
    },
  });
}

/**
 * @summary Retrieves queued tasks
 * {@link /api/queued_tasks}
 */
export function useGetApiQueuedTasks<
  TData = GetApiQueuedTasksQueryResponseSchema,
  TQueryData = GetApiQueuedTasksQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiQueuedTasksQueryKey,
>(
  params: GetApiQueuedTasksQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiQueuedTasksQueryResponseSchema,
        ResponseErrorConfig<
          GetApiQueuedTasks400Schema | GetApiQueuedTasks401Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiQueuedTasksQueryKey(params);

  const query = useQuery(
    {
      ...getApiQueuedTasksQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiQueuedTasks400Schema | GetApiQueuedTasks401Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesQueryKey = (
  projectId: GetApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdShiftActivitiesQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_activities",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftActivitiesQueryKey = ReturnType<
  typeof getApiProjectsProjectIdShiftActivitiesQueryKey
>;

export function getApiProjectsProjectIdShiftActivitiesQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftActivitiesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftActivitiesQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivities400Schema
      | GetApiProjectsProjectIdShiftActivities401Schema
      | GetApiProjectsProjectIdShiftActivities403Schema
      | GetApiProjectsProjectIdShiftActivities404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivities(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves shift activities
 * {@link /api/projects/:project_id/shift_activities}
 */
export function useGetApiProjectsProjectIdShiftActivities<
  TData = GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdShiftActivitiesQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftActivitiesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivities400Schema
          | GetApiProjectsProjectIdShiftActivities401Schema
          | GetApiProjectsProjectIdShiftActivities403Schema
          | GetApiProjectsProjectIdShiftActivities404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivities400Schema
      | GetApiProjectsProjectIdShiftActivities401Schema
      | GetApiProjectsProjectIdShiftActivities403Schema
      | GetApiProjectsProjectIdShiftActivities404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryKey = (
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/shift_activities/:shift_activity_id",
      params: { projectId: projectId, shiftActivityId: shiftActivityId },
    },
  ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityId(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityId<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/blockers",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift activity blockers
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/blockers}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/daily_progress",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift activity weekly work plans
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/daily_progress}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["shift_activity_id"],
    params: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/documents",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["shift_activity_id"],
  params?: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryKey(
      projectId,
      shiftActivityId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments(
        projectId,
        shiftActivityId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift activity documents
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/documents}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["shift_activity_id"],
  params?: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryKey(
      projectId,
      shiftActivityId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryOptions(
        projectId,
        shiftActivityId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/requirements",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the shift activity requirements
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/resources_usage",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift activity resources usage material list
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/resources_usage}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/resources_usage/stats",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift activity resources usage stats
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/resources_usage/stats}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/weekly_planning",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the weekly planning items of an activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/weekly_planning}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/comments/collaborators",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryKey(
      projectId,
      shiftReportId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift report collaborators comments
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/collaborators}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryKey(
      projectId,
      shiftReportId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryOptions(
        projectId,
        shiftReportId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/comments/public",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryKey(
      projectId,
      shiftReportId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift report public comments
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/public}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryKey(
      projectId,
      shiftReportId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryOptions(
        projectId,
        shiftReportId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/documents",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryKey(
      projectId,
      shiftReportId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdDocuments(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift report documents
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/documents}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdDocuments<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryKey(
      projectId,
      shiftReportId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryOptions(
        projectId,
        shiftReportId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["shift_report_id"],
  params: GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports/:shift_report_id/people",
      params: { projectId: projectId, shiftReportId: shiftReportId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryKey(
      projectId,
      shiftReportId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdPeople(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves team members with access to shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/people}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdPeople<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryKey(
      projectId,
      shiftReportId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryOptions(
        projectId,
        shiftReportId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"],
    resourceType: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"],
    resourceId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents",
        params: {
          projectId: projectId,
          shiftReportId: shiftReportId,
          resourceType: resourceType,
          resourceId: resourceId,
        },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"],
  resourceType: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"],
  resourceId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryKey(
      projectId,
      shiftReportId,
      resourceType,
      resourceId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId && resourceType && resourceId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments(
        projectId,
        shiftReportId,
        resourceType,
        resourceId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift report resource documents
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"],
  resourceType: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"],
  resourceId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryKey(
      projectId,
      shiftReportId,
      resourceType,
      resourceId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryOptions(
        projectId,
        shiftReportId,
        resourceType,
        resourceId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"],
    kind: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/resources/:kind",
        params: {
          projectId: projectId,
          shiftReportId: shiftReportId,
          kind: kind,
        },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"],
  kind: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryKey(
      projectId,
      shiftReportId,
      kind,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId && kind),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind(
        projectId,
        shiftReportId,
        kind,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves resources
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/resources/:kind}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"],
  kind: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryKey(
      projectId,
      shiftReportId,
      kind,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryOptions(
        projectId,
        shiftReportId,
        kind,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsCompletionsQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsCompletionsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports/completions",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdShiftReportsCompletionsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdShiftReportsCompletionsQueryKey
>;

export function getApiProjectsProjectIdShiftReportsCompletionsQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsCompletionsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsCompletionsQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsCompletions401Schema
      | GetApiProjectsProjectIdShiftReportsCompletions403Schema
    >,
    GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsCompletions(projectId, config);
    },
  });
}

/**
 * @summary Retrieves published shift reports
 * {@link /api/projects/:project_id/shift_reports/completions}
 */
export function useGetApiProjectsProjectIdShiftReportsCompletions<
  TData = GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsCompletionsQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsCompletionsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsCompletions401Schema
          | GetApiProjectsProjectIdShiftReportsCompletions403Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsCompletionsQueryKey(projectId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsCompletionsQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsCompletions401Schema
      | GetApiProjectsProjectIdShiftReportsCompletions403Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["shift_report_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/quality_indicators",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["shift_report_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryKey(
      projectId,
      shiftReportId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators(
        projectId,
        shiftReportId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves all quality indicators for a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/quality_indicators}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["shift_report_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryKey(
      projectId,
      shiftReportId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryOptions(
        projectId,
        shiftReportId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdShiftReportsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftReportsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdShiftReportsQueryKey
>;

export function getApiProjectsProjectIdShiftReportsQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftReportsQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReports400Schema
      | GetApiProjectsProjectIdShiftReports401Schema
      | GetApiProjectsProjectIdShiftReports403Schema
      | GetApiProjectsProjectIdShiftReports404Schema
    >,
    GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReports(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves published shift reports
 * {@link /api/projects/:project_id/shift_reports}
 */
export function useGetApiProjectsProjectIdShiftReports<
  TData = GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdShiftReportsQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReports400Schema
          | GetApiProjectsProjectIdShiftReports401Schema
          | GetApiProjectsProjectIdShiftReports403Schema
          | GetApiProjectsProjectIdShiftReports404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReports400Schema
      | GetApiProjectsProjectIdShiftReports401Schema
      | GetApiProjectsProjectIdShiftReports403Schema
      | GetApiProjectsProjectIdShiftReports404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsArchivedQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsArchivedPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdShiftReportsArchivedQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports/archived",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftReportsArchivedQueryKey = ReturnType<
  typeof getApiProjectsProjectIdShiftReportsArchivedQueryKey
>;

export function getApiProjectsProjectIdShiftReportsArchivedQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsArchivedPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsArchivedQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftReportsArchivedQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsArchived400Schema
      | GetApiProjectsProjectIdShiftReportsArchived401Schema
      | GetApiProjectsProjectIdShiftReportsArchived403Schema
      | GetApiProjectsProjectIdShiftReportsArchived404Schema
    >,
    GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsArchived(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves archived shift reports
 * {@link /api/projects/:project_id/shift_reports/archived}
 */
export function useGetApiProjectsProjectIdShiftReportsArchived<
  TData = GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsArchivedQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsArchivedPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsArchivedQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsArchived400Schema
          | GetApiProjectsProjectIdShiftReportsArchived401Schema
          | GetApiProjectsProjectIdShiftReportsArchived403Schema
          | GetApiProjectsProjectIdShiftReportsArchived404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsArchivedQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsArchivedQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsArchived400Schema
      | GetApiProjectsProjectIdShiftReportsArchived401Schema
      | GetApiProjectsProjectIdShiftReportsArchived403Schema
      | GetApiProjectsProjectIdShiftReportsArchived404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsDraftQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsDraftPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdShiftReportsDraftQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports/draft",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftReportsDraftQueryKey = ReturnType<
  typeof getApiProjectsProjectIdShiftReportsDraftQueryKey
>;

export function getApiProjectsProjectIdShiftReportsDraftQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsDraftPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsDraftQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftReportsDraftQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsDraft400Schema
      | GetApiProjectsProjectIdShiftReportsDraft401Schema
      | GetApiProjectsProjectIdShiftReportsDraft403Schema
      | GetApiProjectsProjectIdShiftReportsDraft404Schema
    >,
    GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsDraft(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves draft shift reports where the user is an owner or a collaborator
 * {@link /api/projects/:project_id/shift_reports/draft}
 */
export function useGetApiProjectsProjectIdShiftReportsDraft<
  TData = GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdShiftReportsDraftQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsDraftPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsDraftQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsDraft400Schema
          | GetApiProjectsProjectIdShiftReportsDraft401Schema
          | GetApiProjectsProjectIdShiftReportsDraft403Schema
          | GetApiProjectsProjectIdShiftReportsDraft404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsDraftQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsDraftQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsDraft400Schema
      | GetApiProjectsProjectIdShiftReportsDraft401Schema
      | GetApiProjectsProjectIdShiftReportsDraft403Schema
      | GetApiProjectsProjectIdShiftReportsDraft404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsInReviewQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsInReviewPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdShiftReportsInReviewQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports/in_review",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftReportsInReviewQueryKey = ReturnType<
  typeof getApiProjectsProjectIdShiftReportsInReviewQueryKey
>;

export function getApiProjectsProjectIdShiftReportsInReviewQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsInReviewPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsInReviewQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftReportsInReviewQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsInReview400Schema
      | GetApiProjectsProjectIdShiftReportsInReview401Schema
      | GetApiProjectsProjectIdShiftReportsInReview403Schema
      | GetApiProjectsProjectIdShiftReportsInReview404Schema
    >,
    GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsInReview(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves in_review shift reports where the user is an owner, approver, or a collaborator
 * {@link /api/projects/:project_id/shift_reports/in_review}
 */
export function useGetApiProjectsProjectIdShiftReportsInReview<
  TData = GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsInReviewQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsInReviewPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsInReviewQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsInReview400Schema
          | GetApiProjectsProjectIdShiftReportsInReview401Schema
          | GetApiProjectsProjectIdShiftReportsInReview403Schema
          | GetApiProjectsProjectIdShiftReportsInReview404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsInReviewQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsInReviewQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsInReview400Schema
      | GetApiProjectsProjectIdShiftReportsInReview401Schema
      | GetApiProjectsProjectIdShiftReportsInReview403Schema
      | GetApiProjectsProjectIdShiftReportsInReview404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports/:shift_report_id",
      params: { projectId: projectId, shiftReportId: shiftReportId },
    },
  ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdQueryKey =
  ReturnType<typeof getApiProjectsProjectIdShiftReportsShiftReportIdQueryKey>;

export function getApiProjectsProjectIdShiftReportsShiftReportIdQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftReportsShiftReportIdQueryKey(
    projectId,
    shiftReportId,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportId404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportId(
        projectId,
        shiftReportId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportId<
  TData = GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportId401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportId403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdQueryKey(
      projectId,
      shiftReportId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdQueryOptions(
        projectId,
        shiftReportId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["shift_report_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/progress_logs/counters",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryKey(
      projectId,
      shiftReportId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves progress log counters for a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/progress_logs/counters}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryKey(
      projectId,
      shiftReportId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryOptions(
        projectId,
        shiftReportId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryKey = (
  projectId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/teams/:team_id/channel_configuration",
      params: { projectId: projectId, teamId: teamId },
    },
  ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryKey
  >;

export function getApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryKey(
      projectId,
      teamId,
    );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamIdChannelConfiguration(
        projectId,
        teamId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the team channel configuration
 * {@link /api/projects/:project_id/teams/:team_id/channel_configuration}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdChannelConfiguration<
  TData =
    GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
          | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
          | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryKey(
      projectId,
      teamId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryOptions(
        projectId,
        teamId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdJoinTokenQueryKey = (
  projectId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/teams/:team_id/join_token",
      params: { projectId: projectId, teamId: teamId },
    },
  ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryKey = ReturnType<
  typeof getApiProjectsProjectIdTeamsTeamIdJoinTokenQueryKey
>;

export function getApiProjectsProjectIdTeamsTeamIdJoinTokenQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdTeamsTeamIdJoinTokenQueryKey(
    projectId,
    teamId,
  );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamIdJoinToken(
        projectId,
        teamId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a team join token
 * {@link /api/projects/:project_id/teams/:team_id/join_token}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdJoinToken<
  TData = GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
          | GetApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
          | GetApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdJoinTokenQueryKey(projectId, teamId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdJoinTokenQueryOptions(
        projectId,
        teamId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamJoinTokensTokenQueryKey = (
  projectId: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["project_id"],
  token: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["token"],
) =>
  [
    {
      url: "/api/projects/:project_id/team_join_tokens/:token",
      params: { projectId: projectId, token: token },
    },
  ] as const;

export type GetApiProjectsProjectIdTeamJoinTokensTokenQueryKey = ReturnType<
  typeof getApiProjectsProjectIdTeamJoinTokensTokenQueryKey
>;

export function getApiProjectsProjectIdTeamJoinTokensTokenQueryOptions(
  projectId: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["project_id"],
  token: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["token"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdTeamJoinTokensTokenQueryKey(
    projectId,
    token,
  );
  return queryOptions<
    GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
    ResponseErrorConfig<GetApiProjectsProjectIdTeamJoinTokensToken404Schema>,
    GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && token),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamJoinTokensToken(
        projectId,
        token,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves public team join token
 * {@link /api/projects/:project_id/team_join_tokens/:token}
 */
export function useGetApiProjectsProjectIdTeamJoinTokensToken<
  TData = GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamJoinTokensTokenQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["project_id"],
  token: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["token"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
        ResponseErrorConfig<GetApiProjectsProjectIdTeamJoinTokensToken404Schema>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamJoinTokensTokenQueryKey(projectId, token);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdTeamJoinTokensTokenQueryOptions(
        projectId,
        token,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiProjectsProjectIdTeamJoinTokensToken404Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryKey =
  (
    projectId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["project_id"],
    teamId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_id"],
    teamMemberId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_member_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/members/:team_member_id/issue_dependencies",
        params: {
          projectId: projectId,
          teamId: teamId,
          teamMemberId: teamMemberId,
        },
      },
    ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryKey
  >;

export function getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_id"],
  teamMemberId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_member_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryKey(
      projectId,
      teamId,
      teamMemberId,
    );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies401Schema
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies403Schema
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId && teamMemberId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies(
        projectId,
        teamId,
        teamMemberId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves team member issue dependencies
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id/issue_dependencies}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies<
  TData =
    GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_id"],
  teamMemberId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_member_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies401Schema
          | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies403Schema
          | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryKey(
      projectId,
      teamId,
      teamMemberId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryOptions(
        projectId,
        teamId,
        teamMemberId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies401Schema
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies403Schema
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdResourcesKindQueryKey = (
  projectId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"],
  kind: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"],
  params: GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/teams/:team_id/resources/:kind",
      params: { projectId: projectId, teamId: teamId, kind: kind },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryKey =
  ReturnType<typeof getApiProjectsProjectIdTeamsTeamIdResourcesKindQueryKey>;

export function getApiProjectsProjectIdTeamsTeamIdResourcesKindQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"],
  kind: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"],
  params?: GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdTeamsTeamIdResourcesKindQueryKey(
    projectId,
    teamId,
    kind,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId && kind),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamIdResourcesKind(
        projectId,
        teamId,
        kind,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves resources
 * {@link /api/projects/:project_id/teams/:team_id/resources/:kind}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdResourcesKind<
  TData = GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"],
  kind: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"],
  params?: GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
          | GetApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
          | GetApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdResourcesKindQueryKey(
      projectId,
      teamId,
      kind,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdResourcesKindQueryOptions(
        projectId,
        teamId,
        kind,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryKey = (
  projectId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["team_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/teams/:team_id/subscription_plan",
      params: { projectId: projectId, teamId: teamId },
    },
  ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryKey =
  ReturnType<typeof getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryKey>;

export function getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["team_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryKey(
    projectId,
    teamId,
  );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan401Schema
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan403Schema
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamIdSubscriptionPlan(
        projectId,
        teamId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves team current subscription plan
 * {@link /api/projects/:project_id/teams/:team_id/subscription_plan}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan<
  TData = GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["team_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan401Schema
          | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan403Schema
          | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryKey(
      projectId,
      teamId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryOptions(
        projectId,
        teamId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan401Schema
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan403Schema
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsQueryKey = (
  projectId: GetApiProjectsProjectIdTeamsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/teams",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdTeamsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdTeamsQueryKey
>;

export function getApiProjectsProjectIdTeamsQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdTeamsQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdTeamsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeams401Schema
      | GetApiProjectsProjectIdTeams403Schema
      | GetApiProjectsProjectIdTeams404Schema
    >,
    GetApiProjectsProjectIdTeamsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeams(projectId, config);
    },
  });
}

/**
 * @summary Retrieves teams
 * {@link /api/projects/:project_id/teams}
 */
export function useGetApiProjectsProjectIdTeams<
  TData = GetApiProjectsProjectIdTeamsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdTeamsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdTeamsQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdTeamsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeams401Schema
          | GetApiProjectsProjectIdTeams403Schema
          | GetApiProjectsProjectIdTeams404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiProjectsProjectIdTeamsQueryKey(projectId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdTeamsQueryOptions(projectId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeams401Schema
      | GetApiProjectsProjectIdTeams403Schema
      | GetApiProjectsProjectIdTeams404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdQueryKey = (
  projectId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/teams/:team_id",
      params: { projectId: projectId, teamId: teamId },
    },
  ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdQueryKey = ReturnType<
  typeof getApiProjectsProjectIdTeamsTeamIdQueryKey
>;

export function getApiProjectsProjectIdTeamsTeamIdQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdTeamsTeamIdQueryKey(
    projectId,
    teamId,
  );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamId401Schema
      | GetApiProjectsProjectIdTeamsTeamId403Schema
      | GetApiProjectsProjectIdTeamsTeamId404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamId(projectId, teamId, config);
    },
  });
}

/**
 * @summary Retrieves a team
 * {@link /api/projects/:project_id/teams/:team_id}
 */
export function useGetApiProjectsProjectIdTeamsTeamId<
  TData = GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdTeamsTeamIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamId401Schema
          | GetApiProjectsProjectIdTeamsTeamId403Schema
          | GetApiProjectsProjectIdTeamsTeamId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdQueryKey(projectId, teamId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdQueryOptions(
        projectId,
        teamId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamId401Schema
      | GetApiProjectsProjectIdTeamsTeamId403Schema
      | GetApiProjectsProjectIdTeamsTeamId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdWatchingsQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/watchings",
      params: { projectId: projectId, issueId: issueId },
    },
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssuesIssueIdWatchingsQueryKey
>;

export function getApiProjectsProjectIdIssuesIssueIdWatchingsQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdWatchingsQueryKey(
    projectId,
    issueId,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | GetApiProjectsProjectIdIssuesIssueIdWatchings404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdWatchings(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves issue watchings
 * {@link /api/projects/:project_id/issues/:issue_id/watchings}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdWatchings<
  TData = GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdWatchings401Schema
          | GetApiProjectsProjectIdIssuesIssueIdWatchings404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdWatchingsQueryKey(projectId, issueId);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdWatchingsQueryOptions(
        projectId,
        issueId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | GetApiProjectsProjectIdIssuesIssueIdWatchings404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryKey =
  (
    projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"],
    weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"],
    params: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities",
        params: { projectId: projectId, weeklyWorkPlanId: weeklyWorkPlanId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryKey
  >;

export function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryKey(
      projectId,
      weeklyWorkPlanId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && weeklyWorkPlanId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities(
        projectId,
        weeklyWorkPlanId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a weekly work plan activities
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities<
  TData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryKey(
      projectId,
      weeklyWorkPlanId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryOptions(
        projectId,
        weeklyWorkPlanId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryKey =
  (
    projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"],
    weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"],
    activityId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id",
        params: {
          projectId: projectId,
          weeklyWorkPlanId: weeklyWorkPlanId,
          activityId: activityId,
        },
      },
    ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryKey
  >;

export function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"],
  activityId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryKey(
      projectId,
      weeklyWorkPlanId,
      activityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && weeklyWorkPlanId && activityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId(
        projectId,
        weeklyWorkPlanId,
        activityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a weekly work plan activity
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId<
  TData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"],
  activityId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryKey(
      projectId,
      weeklyWorkPlanId,
      activityId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryOptions(
        projectId,
        weeklyWorkPlanId,
        activityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryKey =
  (
    projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["project_id"],
    weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["weekly_work_plan_id"],
    params: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/progress_logs",
        params: { projectId: projectId, weeklyWorkPlanId: weeklyWorkPlanId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryKey
  >;

export function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["weekly_work_plan_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryKey(
      projectId,
      weeklyWorkPlanId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && weeklyWorkPlanId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs(
        projectId,
        weeklyWorkPlanId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a weekly work plan progress logs
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/progress_logs}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs<
  TData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["weekly_work_plan_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryKey(
      projectId,
      weeklyWorkPlanId,
      params,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryOptions(
        projectId,
        weeklyWorkPlanId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryKey =
  (
    projectId: GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/shift_activities_finder",
        params: { projectId: projectId },
      },
    ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryKey
  >;

export function getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryKey(
      projectId,
    );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder(
        projectId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift activities finder options for weekly work plans
 * {@link /api/projects/:project_id/weekly_work_plans/shift_activities_finder}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder<
  TData =
    GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryKey(
      projectId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansQueryKey = (
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdWeeklyWorkPlansQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/weekly_work_plans",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansQueryKey = ReturnType<
  typeof getApiProjectsProjectIdWeeklyWorkPlansQueryKey
>;

export function getApiProjectsProjectIdWeeklyWorkPlansQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdWeeklyWorkPlansQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlans400Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlans(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves all team weekly work plans
 * {@link /api/projects/:project_id/weekly_work_plans}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlans<
  TData = GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
  TQueryData = GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdWeeklyWorkPlansQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansQueryParamsSchema,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlans400Schema
          | GetApiProjectsProjectIdWeeklyWorkPlans401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlans403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlans404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansQueryKey(projectId, params);

  const query = useQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlans400Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryKey = (
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id",
      params: { projectId: projectId, weeklyWorkPlanId: weeklyWorkPlanId },
    },
  ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryKey
  >;

export function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryKey(
      projectId,
      weeklyWorkPlanId,
    );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && weeklyWorkPlanId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId(
        projectId,
        weeklyWorkPlanId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId<
  TData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
  TQueryData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryKey(
      projectId,
      weeklyWorkPlanId,
    );

  const query = useQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryOptions(
        projectId,
        weeklyWorkPlanId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiConfigEnvironmentSuspenseQueryKey = () =>
  [{ url: "/api/config/environment" }] as const;

export type GetApiConfigEnvironmentSuspenseQueryKey = ReturnType<
  typeof getApiConfigEnvironmentSuspenseQueryKey
>;

export function getApiConfigEnvironmentSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiConfigEnvironmentSuspenseQueryKey();
  return queryOptions<
    GetApiConfigEnvironmentQueryResponseSchema,
    ResponseErrorConfig<Error>,
    GetApiConfigEnvironmentQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiConfigEnvironment(config);
    },
  });
}

/**
 * @summary Return environment configuration
 * {@link /api/config/environment}
 */
export function useGetApiConfigEnvironmentSuspense<
  TData = GetApiConfigEnvironmentQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiConfigEnvironmentSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiConfigEnvironmentQueryResponseSchema,
        ResponseErrorConfig<Error>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiConfigEnvironmentSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiConfigEnvironmentSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiConstructionRolesSuspenseQueryKey = () =>
  [{ url: "/api/construction_roles" }] as const;

export type GetApiConstructionRolesSuspenseQueryKey = ReturnType<
  typeof getApiConstructionRolesSuspenseQueryKey
>;

export function getApiConstructionRolesSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiConstructionRolesSuspenseQueryKey();
  return queryOptions<
    GetApiConstructionRolesQueryResponseSchema,
    ResponseErrorConfig<GetApiConstructionRoles401Schema>,
    GetApiConstructionRolesQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiConstructionRoles(config);
    },
  });
}

/**
 * @summary Retrieves construction roles
 * {@link /api/construction_roles}
 */
export function useGetApiConstructionRolesSuspense<
  TData = GetApiConstructionRolesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiConstructionRolesSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiConstructionRolesQueryResponseSchema,
        ResponseErrorConfig<GetApiConstructionRoles401Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiConstructionRolesSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiConstructionRolesSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetApiConstructionRoles401Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdContractsContractIdFilesSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/contracts/:contract_id/files",
      params: { projectId: projectId, contractId: contractId },
    },
  ] as const;

export type GetApiProjectsProjectIdContractsContractIdFilesSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdContractsContractIdFilesSuspenseQueryKey
  >;

export function getApiProjectsProjectIdContractsContractIdFilesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdContractsContractIdFilesSuspenseQueryKey(
      projectId,
      contractId,
    );
  return queryOptions<
    GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContractsContractIdFiles401Schema
      | GetApiProjectsProjectIdContractsContractIdFiles403Schema
      | GetApiProjectsProjectIdContractsContractIdFiles404Schema
    >,
    GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && contractId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdContractsContractIdFiles(
        projectId,
        contractId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves contract files
 * {@link /api/projects/:project_id/contracts/:contract_id/files}
 */
export function useGetApiProjectsProjectIdContractsContractIdFilesSuspense<
  TData = GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdContractsContractIdFilesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdContractsContractIdFiles401Schema
          | GetApiProjectsProjectIdContractsContractIdFiles403Schema
          | GetApiProjectsProjectIdContractsContractIdFiles404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdContractsContractIdFilesSuspenseQueryKey(
      projectId,
      contractId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdContractsContractIdFilesSuspenseQueryOptions(
        projectId,
        contractId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContractsContractIdFiles401Schema
      | GetApiProjectsProjectIdContractsContractIdFiles403Schema
      | GetApiProjectsProjectIdContractsContractIdFiles404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdContractsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdContractsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/contracts",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdContractsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdContractsSuspenseQueryKey
>;

export function getApiProjectsProjectIdContractsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdContractsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdContractsSuspenseQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdContractsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContracts401Schema
      | GetApiProjectsProjectIdContracts403Schema
      | GetApiProjectsProjectIdContracts404Schema
    >,
    GetApiProjectsProjectIdContractsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdContracts(projectId, config);
    },
  });
}

/**
 * @summary Retrieves contracts
 * {@link /api/projects/:project_id/contracts}
 */
export function useGetApiProjectsProjectIdContractsSuspense<
  TData = GetApiProjectsProjectIdContractsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdContractsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdContractsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdContractsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdContracts401Schema
          | GetApiProjectsProjectIdContracts403Schema
          | GetApiProjectsProjectIdContracts404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdContractsSuspenseQueryKey(projectId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdContractsSuspenseQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContracts401Schema
      | GetApiProjectsProjectIdContracts403Schema
      | GetApiProjectsProjectIdContracts404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdContractsContractIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/contracts/:contract_id",
      params: { projectId: projectId, contractId: contractId },
    },
  ] as const;

export type GetApiProjectsProjectIdContractsContractIdSuspenseQueryKey =
  ReturnType<typeof getApiProjectsProjectIdContractsContractIdSuspenseQueryKey>;

export function getApiProjectsProjectIdContractsContractIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdContractsContractIdSuspenseQueryKey(
    projectId,
    contractId,
  );
  return queryOptions<
    GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContractsContractId401Schema
      | GetApiProjectsProjectIdContractsContractId403Schema
      | GetApiProjectsProjectIdContractsContractId404Schema
    >,
    GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && contractId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdContractsContractId(
        projectId,
        contractId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a contract
 * {@link /api/projects/:project_id/contracts/:contract_id}
 */
export function useGetApiProjectsProjectIdContractsContractIdSuspense<
  TData = GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdContractsContractIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"],
  contractId: GetApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdContractsContractId401Schema
          | GetApiProjectsProjectIdContractsContractId403Schema
          | GetApiProjectsProjectIdContractsContractId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdContractsContractIdSuspenseQueryKey(
      projectId,
      contractId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdContractsContractIdSuspenseQueryOptions(
        projectId,
        contractId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContractsContractId401Schema
      | GetApiProjectsProjectIdContractsContractId403Schema
      | GetApiProjectsProjectIdContractsContractId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/search_filter",
        params: { projectId: projectId },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSuspenseQueryKey(
      projectId,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsSearchFilter(
        projectId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the search filter for change signals assigned to the current team member
 * {@link /api/projects/:project_id/control_center/change_signals/search_filter}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSuspenseQueryKey(
      projectId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSuspenseQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsIssuesSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/issues",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsIssuesSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsIssuesSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsIssuesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsIssuesSuspenseQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues404Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsIssues(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves issue change signals
 * {@link /api/projects/:project_id/control_center/change_signals/issues}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsIssuesSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsIssuesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsIssues401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsIssues403Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsIssues404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsIssuesSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsIssuesSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsDowntimesSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/downtimes",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsDowntimesSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsDowntimesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsDowntimesSuspenseQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes404Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsDowntimes(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves downtime change signals
 * {@link /api/projects/:project_id/control_center/change_signals/downtimes}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsDowntimesSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes403Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsDowntimesSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsDowntimesSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/progress_logs",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSuspenseQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs404Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsProgressLogs(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves progress log change signals
 * {@link /api/projects/:project_id/control_center/change_signals/progress_logs}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs403Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsCountersSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterChangeSignalsCountersPathParamsSchema["project_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/counters",
        params: { projectId: projectId },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsCountersSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsCountersSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsCountersSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsCountersPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsCountersSuspenseQueryKey(
      projectId,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsCounters401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsCounters403Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsCounters(
        projectId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves change signals counters
 * {@link /api/projects/:project_id/control_center/change_signals/counters}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsCountersSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsCountersSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsCountersPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsCounters401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsCounters403Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsCountersSuspenseQueryKey(
      projectId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsCountersSuspenseQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsCounters401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsCounters403Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterChangeSignalsIdSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["project_id"],
    id: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/:id",
        params: { projectId: projectId, id: id },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterChangeSignalsIdSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterChangeSignalsIdSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterChangeSignalsIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterChangeSignalsIdSuspenseQueryKey(
      projectId,
      id,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsId401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsId403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsId404Schema
    >,
    GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && id),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterChangeSignalsId(
        projectId,
        id,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a change signal
 * {@link /api/projects/:project_id/control_center/change_signals/:id}
 */
export function useGetApiProjectsProjectIdControlCenterChangeSignalsIdSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterChangeSignalsIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema["id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterChangeSignalsId401Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsId403Schema
          | GetApiProjectsProjectIdControlCenterChangeSignalsId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterChangeSignalsIdSuspenseQueryKey(
      projectId,
      id,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterChangeSignalsIdSuspenseQueryOptions(
        projectId,
        id,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsId401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsId403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"],
    params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/documents",
        params: { projectId: projectId, potentialChangeId: potentialChangeId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSuspenseQueryKey(
      projectId,
      potentialChangeId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments(
        projectId,
        potentialChangeId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves potential change documents, including documents attached to its linked signalables
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/documents}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSuspenseQueryKey(
      projectId,
      potentialChangeId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSuspenseQueryOptions(
        projectId,
        potentialChangeId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["potential_change_id"],
    params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/feed",
        params: { projectId: projectId, potentialChangeId: potentialChangeId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["potential_change_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSuspenseQueryKey(
      projectId,
      potentialChangeId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed(
        projectId,
        potentialChangeId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the feed of the PotentialChange events
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/feed}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema["potential_change_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSuspenseQueryKey(
      projectId,
      potentialChangeId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSuspenseQueryOptions(
        projectId,
        potentialChangeId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/narrative",
        params: { projectId: projectId, potentialChangeId: potentialChangeId },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSuspenseQueryKey(
      projectId,
      potentialChangeId,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative(
        projectId,
        potentialChangeId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves potential change narrative
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/narrative}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSuspenseQueryKey(
      projectId,
      potentialChangeId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSuspenseQueryOptions(
        projectId,
        potentialChangeId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesSuspenseQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChanges401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChanges403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChanges404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChanges(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves potential changes
 * {@link /api/projects/:project_id/control_center/potential_changes}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChanges401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChanges403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChanges404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChanges401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChanges403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChanges404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id",
        params: { projectId: projectId, potentialChangeId: potentialChangeId },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSuspenseQueryKey(
      projectId,
      potentialChangeId,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId(
        projectId,
        potentialChangeId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSuspenseQueryKey(
      projectId,
      potentialChangeId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSuspenseQueryOptions(
        projectId,
        potentialChangeId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["potential_change_id"],
    params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryParamsSchema,
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view",
        params: { projectId: projectId, potentialChangeId: potentialChangeId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["potential_change_id"],
  params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSuspenseQueryKey(
      projectId,
      potentialChangeId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView(
        projectId,
        potentialChangeId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the schedule view for a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema["potential_change_id"],
  params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView400Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSuspenseQueryKey(
      projectId,
      potentialChangeId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSuspenseQueryOptions(
        projectId,
        potentialChangeId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["project_id"],
    potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["potential_change_id"],
    rowId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["row_id"],
    date: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["date"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/days/:date",
        params: {
          projectId: projectId,
          potentialChangeId: potentialChangeId,
          rowId: rowId,
          date: date,
        },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["potential_change_id"],
  rowId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["row_id"],
  date: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["date"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSuspenseQueryKey(
      projectId,
      potentialChangeId,
      rowId,
      date,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate404Schema
    >,
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && potentialChangeId && rowId && date),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate(
        projectId,
        potentialChangeId,
        rowId,
        date,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves day details for a schedule view row
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/days/:date}
 */
export function useGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["project_id"],
  potentialChangeId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["potential_change_id"],
  rowId: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["row_id"],
  date: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema["date"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate400Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate401Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate403Schema
          | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSuspenseQueryKey(
      projectId,
      potentialChangeId,
      rowId,
      date,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSuspenseQueryOptions(
        projectId,
        potentialChangeId,
        rowId,
        date,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdControlCenterTeamPersonalizationSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/control_center/team_personalization",
        params: { projectId: projectId },
      },
    ] as const;

export type GetApiProjectsProjectIdControlCenterTeamPersonalizationSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdControlCenterTeamPersonalizationSuspenseQueryKey
  >;

export function getApiProjectsProjectIdControlCenterTeamPersonalizationSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdControlCenterTeamPersonalizationSuspenseQueryKey(
      projectId,
    );
  return queryOptions<
    GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterTeamPersonalization401Schema
      | GetApiProjectsProjectIdControlCenterTeamPersonalization403Schema
      | GetApiProjectsProjectIdControlCenterTeamPersonalization404Schema
    >,
    GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdControlCenterTeamPersonalization(
        projectId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves team personalization for the control center
 * {@link /api/projects/:project_id/control_center/team_personalization}
 */
export function useGetApiProjectsProjectIdControlCenterTeamPersonalizationSuspense<
  TData =
    GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdControlCenterTeamPersonalizationSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdControlCenterTeamPersonalization401Schema
          | GetApiProjectsProjectIdControlCenterTeamPersonalization403Schema
          | GetApiProjectsProjectIdControlCenterTeamPersonalization404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdControlCenterTeamPersonalizationSuspenseQueryKey(
      projectId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdControlCenterTeamPersonalizationSuspenseQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterTeamPersonalization401Schema
      | GetApiProjectsProjectIdControlCenterTeamPersonalization403Schema
      | GetApiProjectsProjectIdControlCenterTeamPersonalization404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdCustomFieldsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/custom_fields",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdCustomFieldsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdCustomFieldsSuspenseQueryKey
>;

export function getApiProjectsProjectIdCustomFieldsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdCustomFieldsSuspenseQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdCustomFields401Schema
      | GetApiProjectsProjectIdCustomFields403Schema
      | GetApiProjectsProjectIdCustomFields404Schema
    >,
    GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdCustomFields(projectId, config);
    },
  });
}

/**
 * @summary Retrieves project custom fields
 * {@link /api/projects/:project_id/custom_fields}
 */
export function useGetApiProjectsProjectIdCustomFieldsSuspense<
  TData = GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdCustomFieldsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdCustomFields401Schema
          | GetApiProjectsProjectIdCustomFields403Schema
          | GetApiProjectsProjectIdCustomFields404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdCustomFieldsSuspenseQueryKey(projectId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdCustomFieldsSuspenseQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdCustomFields401Schema
      | GetApiProjectsProjectIdCustomFields403Schema
      | GetApiProjectsProjectIdCustomFields404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdDashboardsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/dashboards",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdDashboardsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdDashboardsSuspenseQueryKey
>;

export function getApiProjectsProjectIdDashboardsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDashboardsSuspenseQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdDashboardsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboards401Schema
      | GetApiProjectsProjectIdDashboards403Schema
      | GetApiProjectsProjectIdDashboards404Schema
    >,
    GetApiProjectsProjectIdDashboardsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboards(projectId, config);
    },
  });
}

/**
 * @summary Retrieve dashboards
 * {@link /api/projects/:project_id/dashboards}
 */
export function useGetApiProjectsProjectIdDashboardsSuspense<
  TData = GetApiProjectsProjectIdDashboardsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDashboardsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboards401Schema
          | GetApiProjectsProjectIdDashboards403Schema
          | GetApiProjectsProjectIdDashboards404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsSuspenseQueryKey(projectId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDashboardsSuspenseQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboards401Schema
      | GetApiProjectsProjectIdDashboards403Schema
      | GetApiProjectsProjectIdDashboards404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/data_health_records/issues",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSuspenseQueryKey
  >;

export function getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSuspenseQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues404Schema
    >,
    GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsDataHealthRecordsIssues(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves data health issues
 * {@link /api/projects/:project_id/dashboards/data_health_records/issues}
 */
export function useGetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSuspense<
  TData =
    GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues401Schema
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues403Schema
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/data_health_records/shift_reports",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSuspenseQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports404Schema
    >,
    GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves data health shift reports
 * {@link /api/projects/:project_id/dashboards/data_health_records/shift_reports}
 */
export function useGetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSuspense<
  TData =
    GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports401Schema
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports403Schema
          | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["project_id"],
    recordType: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["record_type"],
    params: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/data_health_scores/:record_type",
        params: { projectId: projectId, recordType: recordType },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSuspenseQueryKey
  >;

export function getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["project_id"],
  recordType: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["record_type"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSuspenseQueryKey(
      projectId,
      recordType,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType404Schema
    >,
    GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && recordType),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsDataHealthScoresRecordType(
        projectId,
        recordType,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves data health scores
 * {@link /api/projects/:project_id/dashboards/data_health_scores/:record_type}
 */
export function useGetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSuspense<
  TData =
    GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["project_id"],
  recordType: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema["record_type"],
  params?: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType401Schema
          | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType403Schema
          | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSuspenseQueryKey(
      projectId,
      recordType,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSuspenseQueryOptions(
        projectId,
        recordType,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsDashboardIdEmbeddingSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["project_id"],
    dashboardId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["dashboard_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/:dashboard_id/embedding",
        params: { projectId: projectId, dashboardId: dashboardId },
      },
    ] as const;

export type GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsDashboardIdEmbeddingSuspenseQueryKey
  >;

export function getApiProjectsProjectIdDashboardsDashboardIdEmbeddingSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["project_id"],
  dashboardId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["dashboard_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsDashboardIdEmbeddingSuspenseQueryKey(
      projectId,
      dashboardId,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding401Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding403Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding404Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding503Schema
    >,
    GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && dashboardId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsDashboardIdEmbedding(
        projectId,
        dashboardId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieve embedding information
 * {@link /api/projects/:project_id/dashboards/:dashboard_id/embedding}
 */
export function useGetApiProjectsProjectIdDashboardsDashboardIdEmbeddingSuspense<
  TData =
    GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["project_id"],
  dashboardId: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema["dashboard_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding401Schema
          | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding403Schema
          | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding404Schema
          | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding503Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsDashboardIdEmbeddingSuspenseQueryKey(
      projectId,
      dashboardId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDashboardsDashboardIdEmbeddingSuspenseQueryOptions(
        projectId,
        dashboardId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding401Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding403Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding404Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding503Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesPathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/shift_activities/gantt/activities",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSuspenseQueryKey
  >;

export function getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSuspenseQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities404Schema
    >,
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift activities for Gantt view
 * {@link /api/projects/:project_id/dashboards/shift_activities/gantt/activities}
 */
export function useGetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSuspense<
  TData =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities400Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities401Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities403Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["project_id"],
    activityId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["activity_id"],
    date: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["date"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/shift_activities/gantt/activities/:activity_id/days/:date",
        params: { projectId: projectId, activityId: activityId, date: date },
      },
    ] as const;

export type GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSuspenseQueryKey
  >;

export function getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["project_id"],
  activityId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["activity_id"],
  date: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["date"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSuspenseQueryKey(
      projectId,
      activityId,
      date,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate404Schema
    >,
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && activityId && date),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate(
        projectId,
        activityId,
        date,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves Gantt dashboard day details for a shift activity
 * {@link /api/projects/:project_id/dashboards/shift_activities/gantt/activities/:activity_id/days/:date}
 */
export function useGetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSuspense<
  TData =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["project_id"],
  activityId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["activity_id"],
  date: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema["date"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate400Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate401Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate403Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSuspenseQueryKey(
      projectId,
      activityId,
      date,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSuspenseQueryOptions(
        projectId,
        activityId,
        date,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelinePathParamsSchema["project_id"],
    params: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryParamsSchema,
  ) =>
    [
      {
        url: "/api/projects/:project_id/dashboards/shift_activities/gantt/timeline",
        params: { projectId: projectId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSuspenseQueryKey
  >;

export function getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelinePathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSuspenseQueryKey(
      projectId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline404Schema
    >,
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves Gantt dashboard timeline for shift activities
 * {@link /api/projects/:project_id/dashboards/shift_activities/gantt/timeline}
 */
export function useGetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSuspense<
  TData =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelinePathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline400Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline401Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline403Schema
          | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDisciplinesSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDisciplinesQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/disciplines",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdDisciplinesSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdDisciplinesSuspenseQueryKey
>;

export function getApiProjectsProjectIdDisciplinesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDisciplinesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDisciplinesSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDisciplines401Schema
      | GetApiProjectsProjectIdDisciplines403Schema
      | GetApiProjectsProjectIdDisciplines404Schema
    >,
    GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDisciplines(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves disciplines
 * {@link /api/projects/:project_id/disciplines}
 */
export function useGetApiProjectsProjectIdDisciplinesSuspense<
  TData = GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDisciplinesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDisciplinesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDisciplines401Schema
          | GetApiProjectsProjectIdDisciplines403Schema
          | GetApiProjectsProjectIdDisciplines404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDisciplinesSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDisciplinesSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDisciplines401Schema
      | GetApiProjectsProjectIdDisciplines403Schema
      | GetApiProjectsProjectIdDisciplines404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDisciplinesDisciplineIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"],
  disciplineId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/disciplines/:discipline_id",
      params: { projectId: projectId, disciplineId: disciplineId },
    },
  ] as const;

export type GetApiProjectsProjectIdDisciplinesDisciplineIdSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDisciplinesDisciplineIdSuspenseQueryKey
  >;

export function getApiProjectsProjectIdDisciplinesDisciplineIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"],
  disciplineId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDisciplinesDisciplineIdSuspenseQueryKey(
      projectId,
      disciplineId,
    );
  return queryOptions<
    GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | GetApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | GetApiProjectsProjectIdDisciplinesDisciplineId404Schema
    >,
    GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && disciplineId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDisciplinesDisciplineId(
        projectId,
        disciplineId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a discipline
 * {@link /api/projects/:project_id/disciplines/:discipline_id}
 */
export function useGetApiProjectsProjectIdDisciplinesDisciplineIdSuspense<
  TData = GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDisciplinesDisciplineIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"],
  disciplineId: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDisciplinesDisciplineId401Schema
          | GetApiProjectsProjectIdDisciplinesDisciplineId403Schema
          | GetApiProjectsProjectIdDisciplinesDisciplineId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDisciplinesDisciplineIdSuspenseQueryKey(
      projectId,
      disciplineId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDisciplinesDisciplineIdSuspenseQueryOptions(
        projectId,
        disciplineId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | GetApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | GetApiProjectsProjectIdDisciplinesDisciplineId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDocumentsDocumentIdReferencesSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["project_id"],
    documentId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["document_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/documents/:document_id/references",
        params: { projectId: projectId, documentId: documentId },
      },
    ] as const;

export type GetApiProjectsProjectIdDocumentsDocumentIdReferencesSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdDocumentsDocumentIdReferencesSuspenseQueryKey
  >;

export function getApiProjectsProjectIdDocumentsDocumentIdReferencesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["document_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdDocumentsDocumentIdReferencesSuspenseQueryKey(
      projectId,
      documentId,
    );
  return queryOptions<
    GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences401Schema
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences403Schema
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences404Schema
    >,
    GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && documentId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDocumentsDocumentIdReferences(
        projectId,
        documentId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves document references
 * {@link /api/projects/:project_id/documents/:document_id/references}
 */
export function useGetApiProjectsProjectIdDocumentsDocumentIdReferencesSuspense<
  TData =
    GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDocumentsDocumentIdReferencesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema["document_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDocumentsDocumentIdReferences401Schema
          | GetApiProjectsProjectIdDocumentsDocumentIdReferences403Schema
          | GetApiProjectsProjectIdDocumentsDocumentIdReferences404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDocumentsDocumentIdReferencesSuspenseQueryKey(
      projectId,
      documentId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDocumentsDocumentIdReferencesSuspenseQueryOptions(
        projectId,
        documentId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences401Schema
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences403Schema
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDocumentsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdDocumentsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDocumentsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/documents",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdDocumentsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdDocumentsSuspenseQueryKey
>;

export function getApiProjectsProjectIdDocumentsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDocumentsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDocumentsSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocuments400Schema
      | GetApiProjectsProjectIdDocuments401Schema
      | GetApiProjectsProjectIdDocuments403Schema
      | GetApiProjectsProjectIdDocuments404Schema
    >,
    GetApiProjectsProjectIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDocuments(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves documents
 * {@link /api/projects/:project_id/documents}
 */
export function useGetApiProjectsProjectIdDocumentsSuspense<
  TData = GetApiProjectsProjectIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdDocumentsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDocumentsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDocuments400Schema
          | GetApiProjectsProjectIdDocuments401Schema
          | GetApiProjectsProjectIdDocuments403Schema
          | GetApiProjectsProjectIdDocuments404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDocumentsSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDocumentsSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocuments400Schema
      | GetApiProjectsProjectIdDocuments401Schema
      | GetApiProjectsProjectIdDocuments403Schema
      | GetApiProjectsProjectIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDocumentsImageUrlsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdDocumentsImageUrlsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDocumentsImageUrlsQueryParamsSchema,
) =>
  [
    {
      url: "/api/projects/:project_id/documents/image_urls",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdDocumentsImageUrlsSuspenseQueryKey =
  ReturnType<typeof getApiProjectsProjectIdDocumentsImageUrlsSuspenseQueryKey>;

export function getApiProjectsProjectIdDocumentsImageUrlsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDocumentsImageUrlsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDocumentsImageUrlsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDocumentsImageUrlsSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsImageUrls401Schema
      | GetApiProjectsProjectIdDocumentsImageUrls403Schema
    >,
    GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDocumentsImageUrls(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves documents image URLs
 * {@link /api/projects/:project_id/documents/image_urls}
 */
export function useGetApiProjectsProjectIdDocumentsImageUrlsSuspense<
  TData = GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDocumentsImageUrlsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDocumentsImageUrlsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdDocumentsImageUrlsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDocumentsImageUrls401Schema
          | GetApiProjectsProjectIdDocumentsImageUrls403Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDocumentsImageUrlsSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDocumentsImageUrlsSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsImageUrls401Schema
      | GetApiProjectsProjectIdDocumentsImageUrls403Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdDocumentsDocumentIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/documents/:document_id",
      params: { projectId: projectId, documentId: documentId },
    },
  ] as const;

export type GetApiProjectsProjectIdDocumentsDocumentIdSuspenseQueryKey =
  ReturnType<typeof getApiProjectsProjectIdDocumentsDocumentIdSuspenseQueryKey>;

export function getApiProjectsProjectIdDocumentsDocumentIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdDocumentsDocumentIdSuspenseQueryKey(
    projectId,
    documentId,
  );
  return queryOptions<
    GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsDocumentId401Schema
      | GetApiProjectsProjectIdDocumentsDocumentId403Schema
      | GetApiProjectsProjectIdDocumentsDocumentId404Schema
    >,
    GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && documentId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdDocumentsDocumentId(
        projectId,
        documentId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a document
 * {@link /api/projects/:project_id/documents/:document_id}
 */
export function useGetApiProjectsProjectIdDocumentsDocumentIdSuspense<
  TData = GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdDocumentsDocumentIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"],
  documentId: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdDocumentsDocumentId401Schema
          | GetApiProjectsProjectIdDocumentsDocumentId403Schema
          | GetApiProjectsProjectIdDocumentsDocumentId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdDocumentsDocumentIdSuspenseQueryKey(
      projectId,
      documentId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdDocumentsDocumentIdSuspenseQueryOptions(
        projectId,
        documentId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsDocumentId401Schema
      | GetApiProjectsProjectIdDocumentsDocumentId403Schema
      | GetApiProjectsProjectIdDocumentsDocumentId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdGroupsGroupIdChannelConfigurationSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"],
    groupId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/groups/:group_id/channel_configuration",
        params: { projectId: projectId, groupId: groupId },
      },
    ] as const;

export type GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdGroupsGroupIdChannelConfigurationSuspenseQueryKey
  >;

export function getApiProjectsProjectIdGroupsGroupIdChannelConfigurationSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"],
  groupId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdGroupsGroupIdChannelConfigurationSuspenseQueryKey(
      projectId,
      groupId,
    );
  return queryOptions<
    GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
    >,
    GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && groupId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdGroupsGroupIdChannelConfiguration(
        projectId,
        groupId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the group channel configuration
 * {@link /api/projects/:project_id/groups/:group_id/channel_configuration}
 */
export function useGetApiProjectsProjectIdGroupsGroupIdChannelConfigurationSuspense<
  TData =
    GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"],
  groupId: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
          | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
          | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdGroupsGroupIdChannelConfigurationSuspenseQueryKey(
      projectId,
      groupId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdGroupsGroupIdChannelConfigurationSuspenseQueryOptions(
        projectId,
        groupId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdGroupsGroupIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"],
  groupId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/groups/:group_id",
      params: { projectId: projectId, groupId: groupId },
    },
  ] as const;

export type GetApiProjectsProjectIdGroupsGroupIdSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdGroupsGroupIdSuspenseQueryKey
>;

export function getApiProjectsProjectIdGroupsGroupIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"],
  groupId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdGroupsGroupIdSuspenseQueryKey(
    projectId,
    groupId,
  );
  return queryOptions<
    GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdGroupsGroupId401Schema
      | GetApiProjectsProjectIdGroupsGroupId403Schema
      | GetApiProjectsProjectIdGroupsGroupId404Schema
    >,
    GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && groupId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdGroupsGroupId(projectId, groupId, config);
    },
  });
}

/**
 * @summary Retrieves a group
 * {@link /api/projects/:project_id/groups/:group_id}
 */
export function useGetApiProjectsProjectIdGroupsGroupIdSuspense<
  TData = GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdGroupsGroupIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"],
  groupId: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdGroupsGroupId401Schema
          | GetApiProjectsProjectIdGroupsGroupId403Schema
          | GetApiProjectsProjectIdGroupsGroupId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdGroupsGroupIdSuspenseQueryKey(projectId, groupId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdGroupsGroupIdSuspenseQueryOptions(
        projectId,
        groupId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdGroupsGroupId401Schema
      | GetApiProjectsProjectIdGroupsGroupId403Schema
      | GetApiProjectsProjectIdGroupsGroupId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdDocumentsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"],
  params: GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/documents",
      params: { projectId: projectId, issueId: issueId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdDocumentsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdIssuesIssueIdDocumentsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdIssuesIssueIdDocumentsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdIssuesIssueIdDocumentsSuspenseQueryKey(
      projectId,
      issueId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdDocuments400Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments401Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments403Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdDocuments(
        projectId,
        issueId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves issue documents
 * {@link /api/projects/:project_id/issues/:issue_id/documents}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdDocumentsSuspense<
  TData = GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdDocumentsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdDocuments400Schema
          | GetApiProjectsProjectIdIssuesIssueIdDocuments401Schema
          | GetApiProjectsProjectIdIssuesIssueIdDocuments403Schema
          | GetApiProjectsProjectIdIssuesIssueIdDocuments404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdDocumentsSuspenseQueryKey(
      projectId,
      issueId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdDocumentsSuspenseQueryOptions(
        projectId,
        issueId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdDocuments400Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments401Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments403Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdFeedTeamSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["issue_id"],
  params: GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/feed/team",
      params: { projectId: projectId, issueId: issueId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdFeedTeamSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdIssuesIssueIdFeedTeamSuspenseQueryKey
  >;

export function getApiProjectsProjectIdIssuesIssueIdFeedTeamSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdFeedTeamSuspenseQueryKey(
    projectId,
    issueId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam400Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam401Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdFeedTeam(
        projectId,
        issueId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves team only issue events
 * {@link /api/projects/:project_id/issues/:issue_id/feed/team}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdFeedTeamSuspense<
  TData = GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdFeedTeamSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdFeedTeam400Schema
          | GetApiProjectsProjectIdIssuesIssueIdFeedTeam401Schema
          | GetApiProjectsProjectIdIssuesIssueIdFeedTeam404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdFeedTeamSuspenseQueryKey(
      projectId,
      issueId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdFeedTeamSuspenseQueryOptions(
        projectId,
        issueId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam400Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam401Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdFeedPublicSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["issue_id"],
  params: GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/feed/public",
      params: { projectId: projectId, issueId: issueId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdFeedPublicSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdIssuesIssueIdFeedPublicSuspenseQueryKey
  >;

export function getApiProjectsProjectIdIssuesIssueIdFeedPublicSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdIssuesIssueIdFeedPublicSuspenseQueryKey(
      projectId,
      issueId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic400Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic401Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdFeedPublic(
        projectId,
        issueId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves public issue events
 * {@link /api/projects/:project_id/issues/:issue_id/feed/public}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdFeedPublicSuspense<
  TData = GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdFeedPublicSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdFeedPublic400Schema
          | GetApiProjectsProjectIdIssuesIssueIdFeedPublic401Schema
          | GetApiProjectsProjectIdIssuesIssueIdFeedPublic404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdFeedPublicSuspenseQueryKey(
      projectId,
      issueId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdFeedPublicSuspenseQueryOptions(
        projectId,
        issueId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic400Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic401Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdIssueImagesSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"],
  params: GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/issue_images",
      params: { projectId: projectId, issueId: issueId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdIssueImagesSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdIssuesIssueIdIssueImagesSuspenseQueryKey
  >;

export function getApiProjectsProjectIdIssuesIssueIdIssueImagesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdIssuesIssueIdIssueImagesSuspenseQueryKey(
      projectId,
      issueId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdIssueImages(
        projectId,
        issueId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Deprecated: use /api/projects/{project_id}/issues/{issue_id}/documents
 * @summary Retrieves issue images and evidence images
 * {@link /api/projects/:project_id/issues/:issue_id/issue_images}
 * @deprecated
 */
export function useGetApiProjectsProjectIdIssuesIssueIdIssueImagesSuspense<
  TData = GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdIssueImagesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"],
  params?: GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
          | GetApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
          | GetApiProjectsProjectIdIssuesIssueIdIssueImages404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdIssueImagesSuspenseQueryKey(
      projectId,
      issueId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdIssueImagesSuspenseQueryOptions(
        projectId,
        issueId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdStatusStatementsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"],
    issueId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/issues/:issue_id/status_statements",
        params: { projectId: projectId, issueId: issueId },
      },
    ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdStatusStatementsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdIssuesIssueIdStatusStatementsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdIssuesIssueIdStatusStatementsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdIssuesIssueIdStatusStatementsSuspenseQueryKey(
      projectId,
      issueId,
    );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdStatusStatements(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves issue status statements
 * {@link /api/projects/:project_id/issues/:issue_id/status_statements}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdStatusStatementsSuspense<
  TData =
    GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdStatusStatementsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
          | GetApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
          | GetApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdStatusStatementsSuspenseQueryKey(
      projectId,
      issueId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdStatusStatementsSuspenseQueryOptions(
        projectId,
        issueId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssueViewsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/issue_views",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdIssueViewsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssueViewsSuspenseQueryKey
>;

export function getApiProjectsProjectIdIssueViewsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssueViewsSuspenseQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssueViews401Schema
      | GetApiProjectsProjectIdIssueViews403Schema
      | GetApiProjectsProjectIdIssueViews404Schema
    >,
    GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssueViews(projectId, config);
    },
  });
}

/**
 * @summary Retrieves issue views
 * {@link /api/projects/:project_id/issue_views}
 */
export function useGetApiProjectsProjectIdIssueViewsSuspense<
  TData = GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssueViewsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssueViews401Schema
          | GetApiProjectsProjectIdIssueViews403Schema
          | GetApiProjectsProjectIdIssueViews404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssueViewsSuspenseQueryKey(projectId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssueViewsSuspenseQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssueViews401Schema
      | GetApiProjectsProjectIdIssueViews403Schema
      | GetApiProjectsProjectIdIssueViews404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdVisitSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/visit",
      params: { projectId: projectId, issueId: issueId },
    },
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdVisitSuspenseQueryKey =
  ReturnType<typeof getApiProjectsProjectIdIssuesIssueIdVisitSuspenseQueryKey>;

export function getApiProjectsProjectIdIssuesIssueIdVisitSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdVisitSuspenseQueryKey(
    projectId,
    issueId,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdVisit401Schema
      | GetApiProjectsProjectIdIssuesIssueIdVisit403Schema
      | GetApiProjectsProjectIdIssuesIssueIdVisit404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdVisit(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieve issue visit status
 * {@link /api/projects/:project_id/issues/:issue_id/visit}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdVisitSuspense<
  TData = GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdVisitSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdVisit401Schema
          | GetApiProjectsProjectIdIssuesIssueIdVisit403Schema
          | GetApiProjectsProjectIdIssuesIssueIdVisit404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdVisitSuspenseQueryKey(
      projectId,
      issueId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdVisitSuspenseQueryOptions(
        projectId,
        issueId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdVisit401Schema
      | GetApiProjectsProjectIdIssuesIssueIdVisit403Schema
      | GetApiProjectsProjectIdIssuesIssueIdVisit404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["project_id"],
    issueId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["issue_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/issues/:issue_id/quality_indicators",
        params: { projectId: projectId, issueId: issueId },
      },
    ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["issue_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSuspenseQueryKey(
      projectId,
      issueId,
    );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators401Schema
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators403Schema
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdQualityIndicators(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves all quality indicators for a issue
 * {@link /api/projects/:project_id/issues/:issue_id/quality_indicators}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSuspense<
  TData =
    GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema["issue_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators401Schema
          | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators403Schema
          | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSuspenseQueryKey(
      projectId,
      issueId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSuspenseQueryOptions(
        projectId,
        issueId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators401Schema
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators403Schema
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdIssuesQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssuesSuspenseQueryKey
>;

export function getApiProjectsProjectIdIssuesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdIssuesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssues400Schema
      | GetApiProjectsProjectIdIssues401Schema
      | GetApiProjectsProjectIdIssues403Schema
      | GetApiProjectsProjectIdIssues404Schema
    >,
    GetApiProjectsProjectIdIssuesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssues(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves issues
 * {@link /api/projects/:project_id/issues}
 */
export function useGetApiProjectsProjectIdIssuesSuspense<
  TData = GetApiProjectsProjectIdIssuesQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdIssuesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdIssuesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssues400Schema
          | GetApiProjectsProjectIdIssues401Schema
          | GetApiProjectsProjectIdIssues403Schema
          | GetApiProjectsProjectIdIssues404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssues400Schema
      | GetApiProjectsProjectIdIssues401Schema
      | GetApiProjectsProjectIdIssues403Schema
      | GetApiProjectsProjectIdIssues404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesGroupCountSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesGroupCountPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdIssuesGroupCountQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/issues/group_count",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdIssuesGroupCountSuspenseQueryKey =
  ReturnType<typeof getApiProjectsProjectIdIssuesGroupCountSuspenseQueryKey>;

export function getApiProjectsProjectIdIssuesGroupCountSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesGroupCountPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdIssuesGroupCountQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesGroupCountSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesGroupCount400Schema
      | GetApiProjectsProjectIdIssuesGroupCount401Schema
      | GetApiProjectsProjectIdIssuesGroupCount403Schema
      | GetApiProjectsProjectIdIssuesGroupCount404Schema
    >,
    GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesGroupCount(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves issues group count
 * {@link /api/projects/:project_id/issues/group_count}
 */
export function useGetApiProjectsProjectIdIssuesGroupCountSuspense<
  TData = GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesGroupCountSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesGroupCountPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdIssuesGroupCountQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesGroupCount400Schema
          | GetApiProjectsProjectIdIssuesGroupCount401Schema
          | GetApiProjectsProjectIdIssuesGroupCount403Schema
          | GetApiProjectsProjectIdIssuesGroupCount404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesGroupCountSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesGroupCountSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesGroupCount400Schema
      | GetApiProjectsProjectIdIssuesGroupCount401Schema
      | GetApiProjectsProjectIdIssuesGroupCount403Schema
      | GetApiProjectsProjectIdIssuesGroupCount404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id",
      params: { projectId: projectId, issueId: issueId },
    },
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdIssuesIssueIdSuspenseQueryKey
>;

export function getApiProjectsProjectIdIssuesIssueIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdIssuesIssueIdSuspenseQueryKey(
    projectId,
    issueId,
  );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueId401Schema
      | GetApiProjectsProjectIdIssuesIssueId403Schema
      | GetApiProjectsProjectIdIssuesIssueId404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueId(projectId, issueId, config);
    },
  });
}

/**
 * @summary Retrieves an issue
 * {@link /api/projects/:project_id/issues/:issue_id}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdSuspense<
  TData = GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueId401Schema
          | GetApiProjectsProjectIdIssuesIssueId403Schema
          | GetApiProjectsProjectIdIssuesIssueId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdSuspenseQueryKey(projectId, issueId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdSuspenseQueryOptions(
        projectId,
        issueId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueId401Schema
      | GetApiProjectsProjectIdIssuesIssueId403Schema
      | GetApiProjectsProjectIdIssuesIssueId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdLocationsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdLocationsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdLocationsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/locations",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdLocationsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdLocationsSuspenseQueryKey
>;

export function getApiProjectsProjectIdLocationsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdLocationsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdLocationsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdLocationsSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdLocationsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLocations401Schema
      | GetApiProjectsProjectIdLocations403Schema
      | GetApiProjectsProjectIdLocations404Schema
    >,
    GetApiProjectsProjectIdLocationsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdLocations(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves locations
 * {@link /api/projects/:project_id/locations}
 */
export function useGetApiProjectsProjectIdLocationsSuspense<
  TData = GetApiProjectsProjectIdLocationsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdLocationsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdLocationsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdLocationsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdLocationsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdLocations401Schema
          | GetApiProjectsProjectIdLocations403Schema
          | GetApiProjectsProjectIdLocations404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdLocationsSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdLocationsSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLocations401Schema
      | GetApiProjectsProjectIdLocations403Schema
      | GetApiProjectsProjectIdLocations404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdLocationsLocationIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"],
  locationId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/locations/:location_id",
      params: { projectId: projectId, locationId: locationId },
    },
  ] as const;

export type GetApiProjectsProjectIdLocationsLocationIdSuspenseQueryKey =
  ReturnType<typeof getApiProjectsProjectIdLocationsLocationIdSuspenseQueryKey>;

export function getApiProjectsProjectIdLocationsLocationIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"],
  locationId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdLocationsLocationIdSuspenseQueryKey(
    projectId,
    locationId,
  );
  return queryOptions<
    GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLocationsLocationId401Schema
      | GetApiProjectsProjectIdLocationsLocationId403Schema
      | GetApiProjectsProjectIdLocationsLocationId404Schema
    >,
    GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && locationId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdLocationsLocationId(
        projectId,
        locationId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a location
 * {@link /api/projects/:project_id/locations/:location_id}
 */
export function useGetApiProjectsProjectIdLocationsLocationIdSuspense<
  TData = GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdLocationsLocationIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"],
  locationId: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdLocationsLocationId401Schema
          | GetApiProjectsProjectIdLocationsLocationId403Schema
          | GetApiProjectsProjectIdLocationsLocationId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdLocationsLocationIdSuspenseQueryKey(
      projectId,
      locationId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdLocationsLocationIdSuspenseQueryOptions(
        projectId,
        locationId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLocationsLocationId401Schema
      | GetApiProjectsProjectIdLocationsLocationId403Schema
      | GetApiProjectsProjectIdLocationsLocationId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["project_id"],
    logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["log_person_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/logs/people/:log_person_id/allocations",
        params: { projectId: projectId, logPersonId: logPersonId },
      },
    ] as const;

export type GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["project_id"],
  logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["log_person_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSuspenseQueryKey(
      projectId,
      logPersonId,
    );
  return queryOptions<
    GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations401Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations404Schema
    >,
    GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && logPersonId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdLogsPeopleLogPersonIdAllocations(
        projectId,
        logPersonId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves allocations for a person log
 * {@link /api/projects/:project_id/logs/people/:log_person_id/allocations}
 */
export function useGetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSuspense<
  TData =
    GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["project_id"],
  logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema["log_person_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations401Schema
          | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSuspenseQueryKey(
      projectId,
      logPersonId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSuspenseQueryOptions(
        projectId,
        logPersonId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations401Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["project_id"],
    logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["log_person_id"],
    params: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/logs/people/:log_person_id/documents",
        params: { projectId: projectId, logPersonId: logPersonId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["project_id"],
  logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["log_person_id"],
  params?: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSuspenseQueryKey(
      projectId,
      logPersonId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments400Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments401Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments404Schema
    >,
    GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && logPersonId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdLogsPeopleLogPersonIdDocuments(
        projectId,
        logPersonId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves person log documents
 * {@link /api/projects/:project_id/logs/people/:log_person_id/documents}
 */
export function useGetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSuspense<
  TData =
    GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["project_id"],
  logPersonId: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema["log_person_id"],
  params?: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments400Schema
          | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments401Schema
          | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSuspenseQueryKey(
      projectId,
      logPersonId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSuspenseQueryOptions(
        projectId,
        logPersonId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments400Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments401Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdLogsPeopleSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdLogsPeoplePathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdLogsPeopleQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/logs/people",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdLogsPeopleSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdLogsPeopleSuspenseQueryKey
>;

export function getApiProjectsProjectIdLogsPeopleSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdLogsPeoplePathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdLogsPeopleQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdLogsPeopleSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeople401Schema
      | GetApiProjectsProjectIdLogsPeople403Schema
      | GetApiProjectsProjectIdLogsPeople404Schema
    >,
    GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdLogsPeople(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves people logs
 * {@link /api/projects/:project_id/logs/people}
 */
export function useGetApiProjectsProjectIdLogsPeopleSuspense<
  TData = GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdLogsPeopleSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdLogsPeoplePathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdLogsPeopleQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdLogsPeople401Schema
          | GetApiProjectsProjectIdLogsPeople403Schema
          | GetApiProjectsProjectIdLogsPeople404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdLogsPeopleSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdLogsPeopleSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeople401Schema
      | GetApiProjectsProjectIdLogsPeople403Schema
      | GetApiProjectsProjectIdLogsPeople404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiOrgsSuspenseQueryKey = () => [{ url: "/api/orgs" }] as const;

export type GetApiOrgsSuspenseQueryKey = ReturnType<
  typeof getApiOrgsSuspenseQueryKey
>;

export function getApiOrgsSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiOrgsSuspenseQueryKey();
  return queryOptions<
    GetApiOrgsQueryResponseSchema,
    ResponseErrorConfig<GetApiOrgs401Schema>,
    GetApiOrgsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiOrgs(config);
    },
  });
}

/**
 * @summary Retrieves orgs
 * {@link /api/orgs}
 */
export function useGetApiOrgsSuspense<
  TData = GetApiOrgsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiOrgsSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiOrgsQueryResponseSchema,
        ResponseErrorConfig<GetApiOrgs401Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiOrgsSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiOrgsSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetApiOrgs401Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiOrgsOrgIdSuspenseQueryKey = (
  orgId: GetApiOrgsOrgIdPathParamsSchema["org_id"],
) => [{ url: "/api/orgs/:org_id", params: { orgId: orgId } }] as const;

export type GetApiOrgsOrgIdSuspenseQueryKey = ReturnType<
  typeof getApiOrgsOrgIdSuspenseQueryKey
>;

export function getApiOrgsOrgIdSuspenseQueryOptions(
  orgId: GetApiOrgsOrgIdPathParamsSchema["org_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiOrgsOrgIdSuspenseQueryKey(orgId);
  return queryOptions<
    GetApiOrgsOrgIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiOrgsOrgId401Schema
      | GetApiOrgsOrgId403Schema
      | GetApiOrgsOrgId404Schema
    >,
    GetApiOrgsOrgIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!orgId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiOrgsOrgId(orgId, config);
    },
  });
}

/**
 * @summary Retrieves an org
 * {@link /api/orgs/:org_id}
 */
export function useGetApiOrgsOrgIdSuspense<
  TData = GetApiOrgsOrgIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiOrgsOrgIdSuspenseQueryKey,
>(
  orgId: GetApiOrgsOrgIdPathParamsSchema["org_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiOrgsOrgIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiOrgsOrgId401Schema
          | GetApiOrgsOrgId403Schema
          | GetApiOrgsOrgId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiOrgsOrgIdSuspenseQueryKey(orgId);

  const query = useSuspenseQuery(
    {
      ...getApiOrgsOrgIdSuspenseQueryOptions(orgId, config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiOrgsOrgId401Schema
      | GetApiOrgsOrgId403Schema
      | GetApiOrgsOrgId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getWellKnownJwksJsonSuspenseQueryKey = () =>
  [{ url: "/.well-known/jwks.json" }] as const;

export type GetWellKnownJwksJsonSuspenseQueryKey = ReturnType<
  typeof getWellKnownJwksJsonSuspenseQueryKey
>;

export function getWellKnownJwksJsonSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getWellKnownJwksJsonSuspenseQueryKey();
  return queryOptions<
    GetWellKnownJwksJsonQueryResponseSchema,
    ResponseErrorConfig<GetWellKnownJwksJson503Schema>,
    GetWellKnownJwksJsonQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getWellKnownJwksJson(config);
    },
  });
}

/**
 * @summary Retrieves the JWKS for PowerSync token verification
 * {@link /.well-known/jwks.json}
 */
export function useGetWellKnownJwksJsonSuspense<
  TData = GetWellKnownJwksJsonQueryResponseSchema,
  TQueryKey extends QueryKey = GetWellKnownJwksJsonSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetWellKnownJwksJsonQueryResponseSchema,
        ResponseErrorConfig<GetWellKnownJwksJson503Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getWellKnownJwksJsonSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getWellKnownJwksJsonSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetWellKnownJwksJson503Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"],
    progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"],
    params: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/progress_logs/:progress_log_id/documents",
        params: { projectId: projectId, progressLogId: progressLogId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"],
  progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"],
  params?: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSuspenseQueryKey(
      projectId,
      progressLogId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
    >,
    GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && progressLogId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdProgressLogsProgressLogIdDocuments(
        projectId,
        progressLogId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves progress log documents
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id/documents}
 */
export function useGetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSuspense<
  TData =
    GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"],
  progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"],
  params?: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
          | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
          | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSuspenseQueryKey(
      projectId,
      progressLogId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSuspenseQueryOptions(
        projectId,
        progressLogId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdProgressLogsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdProgressLogsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/progress_logs",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdProgressLogsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdProgressLogsSuspenseQueryKey
>;

export function getApiProjectsProjectIdProgressLogsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdProgressLogsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdProgressLogsSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogs401Schema
      | GetApiProjectsProjectIdProgressLogs403Schema
      | GetApiProjectsProjectIdProgressLogs404Schema
    >,
    GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdProgressLogs(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves progress logs
 * {@link /api/projects/:project_id/progress_logs}
 */
export function useGetApiProjectsProjectIdProgressLogsSuspense<
  TData = GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdProgressLogsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdProgressLogsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdProgressLogs401Schema
          | GetApiProjectsProjectIdProgressLogs403Schema
          | GetApiProjectsProjectIdProgressLogs404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdProgressLogsSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdProgressLogsSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogs401Schema
      | GetApiProjectsProjectIdProgressLogs403Schema
      | GetApiProjectsProjectIdProgressLogs404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdProgressLogsProgressLogIdSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"],
    progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/progress_logs/:progress_log_id",
        params: { projectId: projectId, progressLogId: progressLogId },
      },
    ] as const;

export type GetApiProjectsProjectIdProgressLogsProgressLogIdSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdProgressLogsProgressLogIdSuspenseQueryKey
  >;

export function getApiProjectsProjectIdProgressLogsProgressLogIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"],
  progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdProgressLogsProgressLogIdSuspenseQueryKey(
      projectId,
      progressLogId,
    );
  return queryOptions<
    GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogsProgressLogId401Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogId404Schema
    >,
    GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && progressLogId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdProgressLogsProgressLogId(
        projectId,
        progressLogId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a progress log
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id}
 */
export function useGetApiProjectsProjectIdProgressLogsProgressLogIdSuspense<
  TData = GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdProgressLogsProgressLogIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"],
  progressLogId: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdProgressLogsProgressLogId401Schema
          | GetApiProjectsProjectIdProgressLogsProgressLogId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdProgressLogsProgressLogIdSuspenseQueryKey(
      projectId,
      progressLogId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdProgressLogsProgressLogIdSuspenseQueryOptions(
        projectId,
        progressLogId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogsProgressLogId401Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdAccessRequestsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdAccessRequestsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/access_requests",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdAccessRequestsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdAccessRequestsSuspenseQueryKey
>;

export function getApiProjectsProjectIdAccessRequestsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdAccessRequestsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdAccessRequestsSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdAccessRequests400Schema
      | GetApiProjectsProjectIdAccessRequests401Schema
      | GetApiProjectsProjectIdAccessRequests403Schema
      | GetApiProjectsProjectIdAccessRequests404Schema
    >,
    GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdAccessRequests(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves project pending access requests
 * {@link /api/projects/:project_id/access_requests}
 */
export function useGetApiProjectsProjectIdAccessRequestsSuspense<
  TData = GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdAccessRequestsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdAccessRequestsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdAccessRequests400Schema
          | GetApiProjectsProjectIdAccessRequests401Schema
          | GetApiProjectsProjectIdAccessRequests403Schema
          | GetApiProjectsProjectIdAccessRequests404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdAccessRequestsSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdAccessRequestsSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdAccessRequests400Schema
      | GetApiProjectsProjectIdAccessRequests401Schema
      | GetApiProjectsProjectIdAccessRequests403Schema
      | GetApiProjectsProjectIdAccessRequests404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_id"],
    projectAccessRequestId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_access_request_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/access_requests/:project_access_request_id",
        params: {
          projectId: projectId,
          projectAccessRequestId: projectAccessRequestId,
        },
      },
    ] as const;

export type GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSuspenseQueryKey
  >;

export function getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_id"],
  projectAccessRequestId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_access_request_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSuspenseQueryKey(
      projectId,
      projectAccessRequestId,
    );
  return queryOptions<
    GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId401Schema
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId403Schema
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId404Schema
    >,
    GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && projectAccessRequestId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdAccessRequestsProjectAccessRequestId(
        projectId,
        projectAccessRequestId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a project access request
 * {@link /api/projects/:project_id/access_requests/:project_access_request_id}
 */
export function useGetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSuspense<
  TData =
    GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_id"],
  projectAccessRequestId: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema["project_access_request_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId401Schema
          | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId403Schema
          | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSuspenseQueryKey(
      projectId,
      projectAccessRequestId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSuspenseQueryOptions(
        projectId,
        projectAccessRequestId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId401Schema
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId403Schema
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdPeopleSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdPeoplePathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdPeopleQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/people",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdPeopleSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdPeopleSuspenseQueryKey
>;

export function getApiProjectsProjectIdPeopleSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdPeoplePathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdPeopleQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdPeopleSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdPeopleQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdPeople400Schema
      | GetApiProjectsProjectIdPeople401Schema
      | GetApiProjectsProjectIdPeople404Schema
    >,
    GetApiProjectsProjectIdPeopleQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdPeople(projectId, params, config);
    },
  });
}

/**
 * @description Excludes archived team members by default, unless status is given
 * @summary Retrieves project people
 * {@link /api/projects/:project_id/people}
 */
export function useGetApiProjectsProjectIdPeopleSuspense<
  TData = GetApiProjectsProjectIdPeopleQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdPeopleSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdPeoplePathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdPeopleQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdPeopleQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdPeople400Schema
          | GetApiProjectsProjectIdPeople401Schema
          | GetApiProjectsProjectIdPeople404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdPeopleSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdPeopleSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdPeople400Schema
      | GetApiProjectsProjectIdPeople401Schema
      | GetApiProjectsProjectIdPeople404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdPeopleTeamMemberIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["project_id"],
  teamMemberId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["team_member_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/people/:team_member_id",
      params: { projectId: projectId, teamMemberId: teamMemberId },
    },
  ] as const;

export type GetApiProjectsProjectIdPeopleTeamMemberIdSuspenseQueryKey =
  ReturnType<typeof getApiProjectsProjectIdPeopleTeamMemberIdSuspenseQueryKey>;

export function getApiProjectsProjectIdPeopleTeamMemberIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["project_id"],
  teamMemberId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["team_member_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdPeopleTeamMemberIdSuspenseQueryKey(
    projectId,
    teamMemberId,
  );
  return queryOptions<
    GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdPeopleTeamMemberId401Schema
      | GetApiProjectsProjectIdPeopleTeamMemberId403Schema
      | GetApiProjectsProjectIdPeopleTeamMemberId404Schema
    >,
    GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamMemberId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdPeopleTeamMemberId(
        projectId,
        teamMemberId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a team member
 * {@link /api/projects/:project_id/people/:team_member_id}
 */
export function useGetApiProjectsProjectIdPeopleTeamMemberIdSuspense<
  TData = GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdPeopleTeamMemberIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["project_id"],
  teamMemberId: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema["team_member_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdPeopleTeamMemberId401Schema
          | GetApiProjectsProjectIdPeopleTeamMemberId403Schema
          | GetApiProjectsProjectIdPeopleTeamMemberId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdPeopleTeamMemberIdSuspenseQueryKey(
      projectId,
      teamMemberId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdPeopleTeamMemberIdSuspenseQueryOptions(
        projectId,
        teamMemberId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdPeopleTeamMemberId401Schema
      | GetApiProjectsProjectIdPeopleTeamMemberId403Schema
      | GetApiProjectsProjectIdPeopleTeamMemberId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdFilesIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdFilesIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdFilesIdPathParamsSchema["id"],
) =>
  [
    {
      url: "/api/projects/:project_id/files/:id",
      params: { projectId: projectId, id: id },
    },
  ] as const;

export type GetApiProjectsProjectIdFilesIdSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdFilesIdSuspenseQueryKey
>;

export function getApiProjectsProjectIdFilesIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdFilesIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdFilesIdPathParamsSchema["id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdFilesIdSuspenseQueryKey(
    projectId,
    id,
  );
  return queryOptions<
    GetApiProjectsProjectIdFilesIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdFilesId401Schema
      | GetApiProjectsProjectIdFilesId403Schema
      | GetApiProjectsProjectIdFilesId404Schema
    >,
    GetApiProjectsProjectIdFilesIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && id),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdFilesId(projectId, id, config);
    },
  });
}

/**
 * @summary Retrieves a file download URL
 * {@link /api/projects/:project_id/files/:id}
 */
export function useGetApiProjectsProjectIdFilesIdSuspense<
  TData = GetApiProjectsProjectIdFilesIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdFilesIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdFilesIdPathParamsSchema["project_id"],
  id: GetApiProjectsProjectIdFilesIdPathParamsSchema["id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdFilesIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdFilesId401Schema
          | GetApiProjectsProjectIdFilesId403Schema
          | GetApiProjectsProjectIdFilesId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdFilesIdSuspenseQueryKey(projectId, id);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdFilesIdSuspenseQueryOptions(
        projectId,
        id,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdFilesId401Schema
      | GetApiProjectsProjectIdFilesId403Schema
      | GetApiProjectsProjectIdFilesId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiNotificationsOverviewSuspenseQueryKey = () =>
  [{ url: "/api/notifications/overview" }] as const;

export type GetApiNotificationsOverviewSuspenseQueryKey = ReturnType<
  typeof getApiNotificationsOverviewSuspenseQueryKey
>;

export function getApiNotificationsOverviewSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiNotificationsOverviewSuspenseQueryKey();
  return queryOptions<
    GetApiNotificationsOverviewQueryResponseSchema,
    ResponseErrorConfig<GetApiNotificationsOverview401Schema>,
    GetApiNotificationsOverviewQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiNotificationsOverview(config);
    },
  });
}

/**
 * @summary Retrieves notifications overview
 * {@link /api/notifications/overview}
 */
export function useGetApiNotificationsOverviewSuspense<
  TData = GetApiNotificationsOverviewQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiNotificationsOverviewSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiNotificationsOverviewQueryResponseSchema,
        ResponseErrorConfig<GetApiNotificationsOverview401Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiNotificationsOverviewSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiNotificationsOverviewSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetApiNotificationsOverview401Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdNotificationsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdNotificationsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdNotificationsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/notifications",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdNotificationsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdNotificationsSuspenseQueryKey
>;

export function getApiProjectsProjectIdNotificationsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdNotificationsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdNotificationsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdNotificationsSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdNotificationsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdNotifications400Schema
      | GetApiProjectsProjectIdNotifications401Schema
      | GetApiProjectsProjectIdNotifications404Schema
    >,
    GetApiProjectsProjectIdNotificationsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdNotifications(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves notifications
 * {@link /api/projects/:project_id/notifications}
 */
export function useGetApiProjectsProjectIdNotificationsSuspense<
  TData = GetApiProjectsProjectIdNotificationsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdNotificationsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdNotificationsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdNotificationsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdNotificationsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdNotifications400Schema
          | GetApiProjectsProjectIdNotifications401Schema
          | GetApiProjectsProjectIdNotifications404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdNotificationsSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdNotificationsSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdNotifications400Schema
      | GetApiProjectsProjectIdNotifications401Schema
      | GetApiProjectsProjectIdNotifications404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsSuspenseQueryKey = () =>
  [{ url: "/api/projects" }] as const;

export type GetApiProjectsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsSuspenseQueryKey
>;

export function getApiProjectsSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsSuspenseQueryKey();
  return queryOptions<
    GetApiProjectsQueryResponseSchema,
    ResponseErrorConfig<GetApiProjects401Schema | GetApiProjects403Schema>,
    GetApiProjectsQueryResponseSchema,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjects(config);
    },
  });
}

/**
 * @summary Retrieves projects
 * {@link /api/projects}
 */
export function useGetApiProjectsSuspense<
  TData = GetApiProjectsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsQueryResponseSchema,
        ResponseErrorConfig<GetApiProjects401Schema | GetApiProjects403Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiProjectsSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getApiProjectsSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetApiProjects401Schema | GetApiProjects403Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdPathParamsSchema["project_id"],
) =>
  [
    { url: "/api/projects/:project_id", params: { projectId: projectId } },
  ] as const;

export type GetApiProjectsProjectIdSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdSuspenseQueryKey
>;

export function getApiProjectsProjectIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdSuspenseQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectId401Schema
      | GetApiProjectsProjectId403Schema
      | GetApiProjectsProjectId404Schema
    >,
    GetApiProjectsProjectIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectId(projectId, config);
    },
  });
}

/**
 * @summary Retrieves a project
 * {@link /api/projects/:project_id}
 */
export function useGetApiProjectsProjectIdSuspense<
  TData = GetApiProjectsProjectIdQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectId401Schema
          | GetApiProjectsProjectId403Schema
          | GetApiProjectsProjectId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdSuspenseQueryKey(projectId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdSuspenseQueryOptions(projectId, config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectId401Schema
      | GetApiProjectsProjectId403Schema
      | GetApiProjectsProjectId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiQueuedTasksSuspenseQueryKey = (
  params: GetApiQueuedTasksQueryParamsSchema,
) => [{ url: "/api/queued_tasks" }, ...(params ? [params] : [])] as const;

export type GetApiQueuedTasksSuspenseQueryKey = ReturnType<
  typeof getApiQueuedTasksSuspenseQueryKey
>;

export function getApiQueuedTasksSuspenseQueryOptions(
  params: GetApiQueuedTasksQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiQueuedTasksSuspenseQueryKey(params);
  return queryOptions<
    GetApiQueuedTasksQueryResponseSchema,
    ResponseErrorConfig<
      GetApiQueuedTasks400Schema | GetApiQueuedTasks401Schema
    >,
    GetApiQueuedTasksQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiQueuedTasks(params, config);
    },
  });
}

/**
 * @summary Retrieves queued tasks
 * {@link /api/queued_tasks}
 */
export function useGetApiQueuedTasksSuspense<
  TData = GetApiQueuedTasksQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiQueuedTasksSuspenseQueryKey,
>(
  params: GetApiQueuedTasksQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiQueuedTasksQueryResponseSchema,
        ResponseErrorConfig<
          GetApiQueuedTasks400Schema | GetApiQueuedTasks401Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiQueuedTasksSuspenseQueryKey(params);

  const query = useSuspenseQuery(
    {
      ...getApiQueuedTasksSuspenseQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetApiQueuedTasks400Schema | GetApiQueuedTasks401Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdShiftActivitiesQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_activities",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftActivitiesSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdShiftActivitiesSuspenseQueryKey
>;

export function getApiProjectsProjectIdShiftActivitiesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftActivitiesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftActivitiesSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivities400Schema
      | GetApiProjectsProjectIdShiftActivities401Schema
      | GetApiProjectsProjectIdShiftActivities403Schema
      | GetApiProjectsProjectIdShiftActivities404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivities(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves shift activities
 * {@link /api/projects/:project_id/shift_activities}
 */
export function useGetApiProjectsProjectIdShiftActivitiesSuspense<
  TData = GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftActivitiesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivities400Schema
          | GetApiProjectsProjectIdShiftActivities401Schema
          | GetApiProjectsProjectIdShiftActivities403Schema
          | GetApiProjectsProjectIdShiftActivities404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivities400Schema
      | GetApiProjectsProjectIdShiftActivities401Schema
      | GetApiProjectsProjectIdShiftActivities403Schema
      | GetApiProjectsProjectIdShiftActivities404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityId(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdSuspense<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdSuspenseQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/blockers",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift activity blockers
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/blockers}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSuspense<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSuspenseQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/daily_progress",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift activity weekly work plans
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/daily_progress}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSuspense<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSuspenseQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["shift_activity_id"],
    params: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/documents",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["shift_activity_id"],
  params?: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSuspenseQueryKey(
      projectId,
      shiftActivityId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments(
        projectId,
        shiftActivityId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift activity documents
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/documents}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSuspense<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema["shift_activity_id"],
  params?: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSuspenseQueryKey(
      projectId,
      shiftActivityId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSuspenseQueryOptions(
        projectId,
        shiftActivityId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/requirements",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the shift activity requirements
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSuspense<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSuspenseQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/resources_usage",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift activity resources usage material list
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/resources_usage}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSuspense<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSuspenseQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/resources_usage/stats",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift activity resources usage stats
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/resources_usage/stats}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSuspense<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSuspenseQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["project_id"],
    shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["shift_activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/weekly_planning",
        params: { projectId: projectId, shiftActivityId: shiftActivityId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["shift_activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning404Schema
    >,
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftActivityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the weekly planning items of an activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/weekly_planning}
 */
export function useGetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSuspense<
  TData =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["project_id"],
  shiftActivityId: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema["shift_activity_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning401Schema
          | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSuspenseQueryKey(
      projectId,
      shiftActivityId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSuspenseQueryOptions(
        projectId,
        shiftActivityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/comments/collaborators",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSuspenseQueryKey(
      projectId,
      shiftReportId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift report collaborators comments
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/collaborators}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSuspense<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSuspenseQueryKey(
      projectId,
      shiftReportId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSuspenseQueryOptions(
        projectId,
        shiftReportId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/comments/public",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSuspenseQueryKey(
      projectId,
      shiftReportId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift report public comments
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/public}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSuspense<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSuspenseQueryKey(
      projectId,
      shiftReportId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSuspenseQueryOptions(
        projectId,
        shiftReportId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/documents",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSuspenseQueryKey(
      projectId,
      shiftReportId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdDocuments(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift report documents
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/documents}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSuspense<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSuspenseQueryKey(
      projectId,
      shiftReportId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSuspenseQueryOptions(
        projectId,
        shiftReportId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdPeopleSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["shift_report_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/people",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdPeopleSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdPeopleSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdPeopleSuspenseQueryKey(
      projectId,
      shiftReportId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdPeople(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves team members with access to shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/people}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdPeopleSuspense<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdPeopleSuspenseQueryKey(
      projectId,
      shiftReportId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdPeopleSuspenseQueryOptions(
        projectId,
        shiftReportId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"],
    resourceType: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"],
    resourceId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents",
        params: {
          projectId: projectId,
          shiftReportId: shiftReportId,
          resourceType: resourceType,
          resourceId: resourceId,
        },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"],
  resourceType: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"],
  resourceId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSuspenseQueryKey(
      projectId,
      shiftReportId,
      resourceType,
      resourceId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId && resourceType && resourceId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments(
        projectId,
        shiftReportId,
        resourceType,
        resourceId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift report resource documents
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSuspense<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"],
  resourceType: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"],
  resourceId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSuspenseQueryKey(
      projectId,
      shiftReportId,
      resourceType,
      resourceId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSuspenseQueryOptions(
        projectId,
        shiftReportId,
        resourceType,
        resourceId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"],
    kind: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/resources/:kind",
        params: {
          projectId: projectId,
          shiftReportId: shiftReportId,
          kind: kind,
        },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"],
  kind: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSuspenseQueryKey(
      projectId,
      shiftReportId,
      kind,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId && kind),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind(
        projectId,
        shiftReportId,
        kind,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves resources
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/resources/:kind}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSuspense<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"],
  kind: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSuspenseQueryKey(
      projectId,
      shiftReportId,
      kind,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSuspenseQueryOptions(
        projectId,
        shiftReportId,
        kind,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsCompletionsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsCompletionsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports/completions",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdShiftReportsCompletionsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsCompletionsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsCompletionsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsCompletionsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsCompletionsSuspenseQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsCompletions401Schema
      | GetApiProjectsProjectIdShiftReportsCompletions403Schema
    >,
    GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsCompletions(projectId, config);
    },
  });
}

/**
 * @summary Retrieves published shift reports
 * {@link /api/projects/:project_id/shift_reports/completions}
 */
export function useGetApiProjectsProjectIdShiftReportsCompletionsSuspense<
  TData = GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsCompletionsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsCompletionsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsCompletions401Schema
          | GetApiProjectsProjectIdShiftReportsCompletions403Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsCompletionsSuspenseQueryKey(projectId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsCompletionsSuspenseQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsCompletions401Schema
      | GetApiProjectsProjectIdShiftReportsCompletions403Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["shift_report_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/quality_indicators",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["shift_report_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSuspenseQueryKey(
      projectId,
      shiftReportId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators(
        projectId,
        shiftReportId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves all quality indicators for a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/quality_indicators}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSuspense<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema["shift_report_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSuspenseQueryKey(
      projectId,
      shiftReportId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSuspenseQueryOptions(
        projectId,
        shiftReportId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdShiftReportsQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftReportsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdShiftReportsSuspenseQueryKey
>;

export function getApiProjectsProjectIdShiftReportsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftReportsSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReports400Schema
      | GetApiProjectsProjectIdShiftReports401Schema
      | GetApiProjectsProjectIdShiftReports403Schema
      | GetApiProjectsProjectIdShiftReports404Schema
    >,
    GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReports(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves published shift reports
 * {@link /api/projects/:project_id/shift_reports}
 */
export function useGetApiProjectsProjectIdShiftReportsSuspense<
  TData = GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReports400Schema
          | GetApiProjectsProjectIdShiftReports401Schema
          | GetApiProjectsProjectIdShiftReports403Schema
          | GetApiProjectsProjectIdShiftReports404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReports400Schema
      | GetApiProjectsProjectIdShiftReports401Schema
      | GetApiProjectsProjectIdShiftReports403Schema
      | GetApiProjectsProjectIdShiftReports404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsArchivedSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsArchivedPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdShiftReportsArchivedQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports/archived",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftReportsArchivedSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsArchivedSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsArchivedSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsArchivedPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsArchivedQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftReportsArchivedSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsArchived400Schema
      | GetApiProjectsProjectIdShiftReportsArchived401Schema
      | GetApiProjectsProjectIdShiftReportsArchived403Schema
      | GetApiProjectsProjectIdShiftReportsArchived404Schema
    >,
    GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsArchived(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves archived shift reports
 * {@link /api/projects/:project_id/shift_reports/archived}
 */
export function useGetApiProjectsProjectIdShiftReportsArchivedSuspense<
  TData = GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsArchivedSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsArchivedPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsArchivedQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsArchived400Schema
          | GetApiProjectsProjectIdShiftReportsArchived401Schema
          | GetApiProjectsProjectIdShiftReportsArchived403Schema
          | GetApiProjectsProjectIdShiftReportsArchived404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsArchivedSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsArchivedSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsArchived400Schema
      | GetApiProjectsProjectIdShiftReportsArchived401Schema
      | GetApiProjectsProjectIdShiftReportsArchived403Schema
      | GetApiProjectsProjectIdShiftReportsArchived404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsDraftSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsDraftPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdShiftReportsDraftQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports/draft",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftReportsDraftSuspenseQueryKey =
  ReturnType<typeof getApiProjectsProjectIdShiftReportsDraftSuspenseQueryKey>;

export function getApiProjectsProjectIdShiftReportsDraftSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsDraftPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsDraftQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftReportsDraftSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsDraft400Schema
      | GetApiProjectsProjectIdShiftReportsDraft401Schema
      | GetApiProjectsProjectIdShiftReportsDraft403Schema
      | GetApiProjectsProjectIdShiftReportsDraft404Schema
    >,
    GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsDraft(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves draft shift reports where the user is an owner or a collaborator
 * {@link /api/projects/:project_id/shift_reports/draft}
 */
export function useGetApiProjectsProjectIdShiftReportsDraftSuspense<
  TData = GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsDraftSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsDraftPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsDraftQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsDraft400Schema
          | GetApiProjectsProjectIdShiftReportsDraft401Schema
          | GetApiProjectsProjectIdShiftReportsDraft403Schema
          | GetApiProjectsProjectIdShiftReportsDraft404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsDraftSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsDraftSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsDraft400Schema
      | GetApiProjectsProjectIdShiftReportsDraft401Schema
      | GetApiProjectsProjectIdShiftReportsDraft403Schema
      | GetApiProjectsProjectIdShiftReportsDraft404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsInReviewSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdShiftReportsInReviewPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdShiftReportsInReviewQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/shift_reports/in_review",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdShiftReportsInReviewSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsInReviewSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsInReviewSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsInReviewPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsInReviewQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdShiftReportsInReviewSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsInReview400Schema
      | GetApiProjectsProjectIdShiftReportsInReview401Schema
      | GetApiProjectsProjectIdShiftReportsInReview403Schema
      | GetApiProjectsProjectIdShiftReportsInReview404Schema
    >,
    GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsInReview(
        projectId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves in_review shift reports where the user is an owner, approver, or a collaborator
 * {@link /api/projects/:project_id/shift_reports/in_review}
 */
export function useGetApiProjectsProjectIdShiftReportsInReviewSuspense<
  TData = GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsInReviewSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsInReviewPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdShiftReportsInReviewQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsInReview400Schema
          | GetApiProjectsProjectIdShiftReportsInReview401Schema
          | GetApiProjectsProjectIdShiftReportsInReview403Schema
          | GetApiProjectsProjectIdShiftReportsInReview404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsInReviewSuspenseQueryKey(
      projectId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsInReviewSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsInReview400Schema
      | GetApiProjectsProjectIdShiftReportsInReview401Schema
      | GetApiProjectsProjectIdShiftReportsInReview403Schema
      | GetApiProjectsProjectIdShiftReportsInReview404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdSuspenseQueryKey(
      projectId,
      shiftReportId,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportId404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportId(
        projectId,
        shiftReportId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdSuspense<
  TData = GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportId401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportId403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdSuspenseQueryKey(
      projectId,
      shiftReportId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdSuspenseQueryOptions(
        projectId,
        shiftReportId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["project_id"],
    shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["shift_report_id"],
    params: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/progress_logs/counters",
        params: { projectId: projectId, shiftReportId: shiftReportId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSuspenseQueryKey
  >;

export function getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSuspenseQueryKey(
      projectId,
      shiftReportId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters404Schema
    >,
    GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && shiftReportId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves progress log counters for a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/progress_logs/counters}
 */
export function useGetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSuspense<
  TData =
    GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["project_id"],
  shiftReportId: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema["shift_report_id"],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters401Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters403Schema
          | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSuspenseQueryKey(
      projectId,
      shiftReportId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSuspenseQueryOptions(
        projectId,
        shiftReportId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdChannelConfigurationSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"],
    teamId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/channel_configuration",
        params: { projectId: projectId, teamId: teamId },
      },
    ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdTeamsTeamIdChannelConfigurationSuspenseQueryKey
  >;

export function getApiProjectsProjectIdTeamsTeamIdChannelConfigurationSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdTeamsTeamIdChannelConfigurationSuspenseQueryKey(
      projectId,
      teamId,
    );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamIdChannelConfiguration(
        projectId,
        teamId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves the team channel configuration
 * {@link /api/projects/:project_id/teams/:team_id/channel_configuration}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdChannelConfigurationSuspense<
  TData =
    GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
          | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
          | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdChannelConfigurationSuspenseQueryKey(
      projectId,
      teamId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdChannelConfigurationSuspenseQueryOptions(
        projectId,
        teamId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdJoinTokenSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/teams/:team_id/join_token",
      params: { projectId: projectId, teamId: teamId },
    },
  ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdJoinTokenSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdTeamsTeamIdJoinTokenSuspenseQueryKey
  >;

export function getApiProjectsProjectIdTeamsTeamIdJoinTokenSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdTeamsTeamIdJoinTokenSuspenseQueryKey(
    projectId,
    teamId,
  );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamIdJoinToken(
        projectId,
        teamId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a team join token
 * {@link /api/projects/:project_id/teams/:team_id/join_token}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdJoinTokenSuspense<
  TData = GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdJoinTokenSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
          | GetApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
          | GetApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdJoinTokenSuspenseQueryKey(
      projectId,
      teamId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdJoinTokenSuspenseQueryOptions(
        projectId,
        teamId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamJoinTokensTokenSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["project_id"],
  token: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["token"],
) =>
  [
    {
      url: "/api/projects/:project_id/team_join_tokens/:token",
      params: { projectId: projectId, token: token },
    },
  ] as const;

export type GetApiProjectsProjectIdTeamJoinTokensTokenSuspenseQueryKey =
  ReturnType<typeof getApiProjectsProjectIdTeamJoinTokensTokenSuspenseQueryKey>;

export function getApiProjectsProjectIdTeamJoinTokensTokenSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["project_id"],
  token: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["token"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdTeamJoinTokensTokenSuspenseQueryKey(
    projectId,
    token,
  );
  return queryOptions<
    GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
    ResponseErrorConfig<GetApiProjectsProjectIdTeamJoinTokensToken404Schema>,
    GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && token),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamJoinTokensToken(
        projectId,
        token,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves public team join token
 * {@link /api/projects/:project_id/team_join_tokens/:token}
 */
export function useGetApiProjectsProjectIdTeamJoinTokensTokenSuspense<
  TData = GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamJoinTokensTokenSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["project_id"],
  token: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema["token"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
        ResponseErrorConfig<GetApiProjectsProjectIdTeamJoinTokensToken404Schema>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamJoinTokensTokenSuspenseQueryKey(
      projectId,
      token,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdTeamJoinTokensTokenSuspenseQueryOptions(
        projectId,
        token,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<GetApiProjectsProjectIdTeamJoinTokensToken404Schema>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["project_id"],
    teamId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_id"],
    teamMemberId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_member_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/members/:team_member_id/issue_dependencies",
        params: {
          projectId: projectId,
          teamId: teamId,
          teamMemberId: teamMemberId,
        },
      },
    ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSuspenseQueryKey
  >;

export function getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_id"],
  teamMemberId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_member_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSuspenseQueryKey(
      projectId,
      teamId,
      teamMemberId,
    );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies401Schema
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies403Schema
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId && teamMemberId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies(
        projectId,
        teamId,
        teamMemberId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves team member issue dependencies
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id/issue_dependencies}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSuspense<
  TData =
    GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_id"],
  teamMemberId: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema["team_member_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies401Schema
          | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies403Schema
          | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSuspenseQueryKey(
      projectId,
      teamId,
      teamMemberId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSuspenseQueryOptions(
        projectId,
        teamId,
        teamMemberId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies401Schema
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies403Schema
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdResourcesKindSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"],
  kind: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"],
  params: GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/teams/:team_id/resources/:kind",
      params: { projectId: projectId, teamId: teamId, kind: kind },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdResourcesKindSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdTeamsTeamIdResourcesKindSuspenseQueryKey
  >;

export function getApiProjectsProjectIdTeamsTeamIdResourcesKindSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"],
  kind: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"],
  params?: GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdTeamsTeamIdResourcesKindSuspenseQueryKey(
      projectId,
      teamId,
      kind,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId && kind),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamIdResourcesKind(
        projectId,
        teamId,
        kind,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves resources
 * {@link /api/projects/:project_id/teams/:team_id/resources/:kind}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdResourcesKindSuspense<
  TData = GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdResourcesKindSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"],
  kind: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"],
  params?: GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
          | GetApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
          | GetApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdResourcesKindSuspenseQueryKey(
      projectId,
      teamId,
      kind,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdResourcesKindSuspenseQueryOptions(
        projectId,
        teamId,
        kind,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["project_id"],
    teamId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["team_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/subscription_plan",
        params: { projectId: projectId, teamId: teamId },
      },
    ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSuspenseQueryKey
  >;

export function getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["team_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSuspenseQueryKey(
      projectId,
      teamId,
    );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan401Schema
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan403Schema
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamIdSubscriptionPlan(
        projectId,
        teamId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves team current subscription plan
 * {@link /api/projects/:project_id/teams/:team_id/subscription_plan}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSuspense<
  TData = GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema["team_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan401Schema
          | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan403Schema
          | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSuspenseQueryKey(
      projectId,
      teamId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSuspenseQueryOptions(
        projectId,
        teamId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan401Schema
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan403Schema
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdTeamsPathParamsSchema["project_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/teams",
      params: { projectId: projectId },
    },
  ] as const;

export type GetApiProjectsProjectIdTeamsSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdTeamsSuspenseQueryKey
>;

export function getApiProjectsProjectIdTeamsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdTeamsSuspenseQueryKey(projectId);
  return queryOptions<
    GetApiProjectsProjectIdTeamsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeams401Schema
      | GetApiProjectsProjectIdTeams403Schema
      | GetApiProjectsProjectIdTeams404Schema
    >,
    GetApiProjectsProjectIdTeamsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeams(projectId, config);
    },
  });
}

/**
 * @summary Retrieves teams
 * {@link /api/projects/:project_id/teams}
 */
export function useGetApiProjectsProjectIdTeamsSuspense<
  TData = GetApiProjectsProjectIdTeamsQueryResponseSchema,
  TQueryKey extends QueryKey = GetApiProjectsProjectIdTeamsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdTeamsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeams401Schema
          | GetApiProjectsProjectIdTeams403Schema
          | GetApiProjectsProjectIdTeams404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsSuspenseQueryKey(projectId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdTeamsSuspenseQueryOptions(projectId, config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeams401Schema
      | GetApiProjectsProjectIdTeams403Schema
      | GetApiProjectsProjectIdTeams404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdTeamsTeamIdSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/teams/:team_id",
      params: { projectId: projectId, teamId: teamId },
    },
  ] as const;

export type GetApiProjectsProjectIdTeamsTeamIdSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdTeamsTeamIdSuspenseQueryKey
>;

export function getApiProjectsProjectIdTeamsTeamIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdTeamsTeamIdSuspenseQueryKey(
    projectId,
    teamId,
  );
  return queryOptions<
    GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamId401Schema
      | GetApiProjectsProjectIdTeamsTeamId403Schema
      | GetApiProjectsProjectIdTeamsTeamId404Schema
    >,
    GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && teamId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdTeamsTeamId(projectId, teamId, config);
    },
  });
}

/**
 * @summary Retrieves a team
 * {@link /api/projects/:project_id/teams/:team_id}
 */
export function useGetApiProjectsProjectIdTeamsTeamIdSuspense<
  TData = GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdTeamsTeamIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"],
  teamId: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdTeamsTeamId401Schema
          | GetApiProjectsProjectIdTeamsTeamId403Schema
          | GetApiProjectsProjectIdTeamsTeamId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdTeamsTeamIdSuspenseQueryKey(projectId, teamId);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdTeamsTeamIdSuspenseQueryOptions(
        projectId,
        teamId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamId401Schema
      | GetApiProjectsProjectIdTeamsTeamId403Schema
      | GetApiProjectsProjectIdTeamsTeamId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdIssuesIssueIdWatchingsSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"],
) =>
  [
    {
      url: "/api/projects/:project_id/issues/:issue_id/watchings",
      params: { projectId: projectId, issueId: issueId },
    },
  ] as const;

export type GetApiProjectsProjectIdIssuesIssueIdWatchingsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdIssuesIssueIdWatchingsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdIssuesIssueIdWatchingsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdIssuesIssueIdWatchingsSuspenseQueryKey(
      projectId,
      issueId,
    );
  return queryOptions<
    GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | GetApiProjectsProjectIdIssuesIssueIdWatchings404Schema
    >,
    GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && issueId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdIssuesIssueIdWatchings(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves issue watchings
 * {@link /api/projects/:project_id/issues/:issue_id/watchings}
 */
export function useGetApiProjectsProjectIdIssuesIssueIdWatchingsSuspense<
  TData = GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdIssuesIssueIdWatchingsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"],
  issueId: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdIssuesIssueIdWatchings401Schema
          | GetApiProjectsProjectIdIssuesIssueIdWatchings404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdIssuesIssueIdWatchingsSuspenseQueryKey(
      projectId,
      issueId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdIssuesIssueIdWatchingsSuspenseQueryOptions(
        projectId,
        issueId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | GetApiProjectsProjectIdIssuesIssueIdWatchings404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"],
    weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"],
    params: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities",
        params: { projectId: projectId, weeklyWorkPlanId: weeklyWorkPlanId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSuspenseQueryKey
  >;

export function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSuspenseQueryKey(
      projectId,
      weeklyWorkPlanId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && weeklyWorkPlanId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities(
        projectId,
        weeklyWorkPlanId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a weekly work plan activities
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSuspense<
  TData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSuspenseQueryKey(
      projectId,
      weeklyWorkPlanId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSuspenseQueryOptions(
        projectId,
        weeklyWorkPlanId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"],
    weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"],
    activityId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id",
        params: {
          projectId: projectId,
          weeklyWorkPlanId: weeklyWorkPlanId,
          activityId: activityId,
        },
      },
    ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSuspenseQueryKey
  >;

export function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"],
  activityId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSuspenseQueryKey(
      projectId,
      weeklyWorkPlanId,
      activityId,
    );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && weeklyWorkPlanId && activityId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId(
        projectId,
        weeklyWorkPlanId,
        activityId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a weekly work plan activity
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSuspense<
  TData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"],
  activityId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSuspenseQueryKey(
      projectId,
      weeklyWorkPlanId,
      activityId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSuspenseQueryOptions(
        projectId,
        weeklyWorkPlanId,
        activityId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["project_id"],
    weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["weekly_work_plan_id"],
    params: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryParamsSchema = {},
  ) =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/progress_logs",
        params: { projectId: projectId, weeklyWorkPlanId: weeklyWorkPlanId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSuspenseQueryKey
  >;

export function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["weekly_work_plan_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSuspenseQueryKey(
      projectId,
      weeklyWorkPlanId,
      params,
    );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && weeklyWorkPlanId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs(
        projectId,
        weeklyWorkPlanId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a weekly work plan progress logs
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/progress_logs}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSuspense<
  TData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema["weekly_work_plan_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSuspenseQueryKey(
      projectId,
      weeklyWorkPlanId,
      params,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSuspenseQueryOptions(
        projectId,
        weeklyWorkPlanId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/shift_activities_finder",
        params: { projectId: projectId },
      },
    ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSuspenseQueryKey
  >;

export function getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSuspenseQueryKey(
      projectId,
    );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder(
        projectId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves shift activities finder options for weekly work plans
 * {@link /api/projects/:project_id/weekly_work_plans/shift_activities_finder}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSuspense<
  TData =
    GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSuspenseQueryKey(
      projectId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSuspenseQueryOptions(
        projectId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansSuspenseQueryKey = (
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"],
  params: GetApiProjectsProjectIdWeeklyWorkPlansQueryParamsSchema = {},
) =>
  [
    {
      url: "/api/projects/:project_id/weekly_work_plans",
      params: { projectId: projectId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansSuspenseQueryKey = ReturnType<
  typeof getApiProjectsProjectIdWeeklyWorkPlansSuspenseQueryKey
>;

export function getApiProjectsProjectIdWeeklyWorkPlansSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsProjectIdWeeklyWorkPlansSuspenseQueryKey(
    projectId,
    params,
  );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlans400Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlans(projectId, params, config);
    },
  });
}

/**
 * @summary Retrieves all team weekly work plans
 * {@link /api/projects/:project_id/weekly_work_plans}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansSuspense<
  TData = GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansQueryParamsSchema,
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlans400Schema
          | GetApiProjectsProjectIdWeeklyWorkPlans401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlans403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlans404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansSuspenseQueryKey(projectId, params);

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansSuspenseQueryOptions(
        projectId,
        params,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlans400Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSuspenseQueryKey =
  (
    projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"],
    weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"],
  ) =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id",
        params: { projectId: projectId, weeklyWorkPlanId: weeklyWorkPlanId },
      },
    ] as const;

export type GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSuspenseQueryKey =
  ReturnType<
    typeof getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSuspenseQueryKey
  >;

export function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSuspenseQueryOptions(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey =
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSuspenseQueryKey(
      projectId,
      weeklyWorkPlanId,
    );
  return queryOptions<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
    >,
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
    typeof queryKey
  >({
    enabled: !!(projectId && weeklyWorkPlanId),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId(
        projectId,
        weeklyWorkPlanId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id}
 */
export function useGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSuspense<
  TData =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
  TQueryKey extends QueryKey =
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSuspenseQueryKey,
>(
  projectId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"],
  weeklyWorkPlanId: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"],
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
        ResponseErrorConfig<
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
          | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
        >,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ??
    getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSuspenseQueryKey(
      projectId,
      weeklyWorkPlanId,
    );

  const query = useSuspenseQuery(
    {
      ...getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSuspenseQueryOptions(
        projectId,
        weeklyWorkPlanId,
        config,
      ),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}

export const postApiChannelsTokenMutationKey = () =>
  [{ url: "/api/channels/token" }] as const;

export type PostApiChannelsTokenMutationKey = ReturnType<
  typeof postApiChannelsTokenMutationKey
>;

export function postApiChannelsTokenMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiChannelsTokenMutationKey();
  return mutationOptions<
    PostApiChannelsTokenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiChannelsToken401Schema
      | PostApiChannelsToken422Schema
      | PostApiChannelsToken503Schema
    >,
    void,
    TContext
  >({
    mutationKey,
    mutationFn: async () => {
      return postApiChannelsToken(config);
    },
  });
}

/**
 * @summary Requests a new Channels token
 * {@link /api/channels/token}
 */
export function usePostApiChannelsToken<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiChannelsTokenMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiChannelsToken401Schema
        | PostApiChannelsToken422Schema
        | PostApiChannelsToken503Schema
      >,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiChannelsTokenMutationKey();

  const baseOptions = postApiChannelsTokenMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiChannelsTokenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiChannelsToken401Schema
      | PostApiChannelsToken422Schema
      | PostApiChannelsToken503Schema
    >,
    void,
    TContext
  >;

  return useMutation<
    PostApiChannelsTokenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiChannelsToken401Schema
      | PostApiChannelsToken422Schema
      | PostApiChannelsToken503Schema
    >,
    void,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiChannelsTokenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiChannelsToken401Schema
      | PostApiChannelsToken422Schema
      | PostApiChannelsToken503Schema
    >,
    void,
    TContext
  >;
}

export const postApiProjectsProjectIdChannelsPersonalMutationKey = () =>
  [{ url: "/api/projects/:project_id/channels/personal" }] as const;

export type PostApiProjectsProjectIdChannelsPersonalMutationKey = ReturnType<
  typeof postApiProjectsProjectIdChannelsPersonalMutationKey
>;

export function postApiProjectsProjectIdChannelsPersonalMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiProjectsProjectIdChannelsPersonalMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdChannelsPersonalMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsPersonal401Schema
      | PostApiProjectsProjectIdChannelsPersonal403Schema
      | PostApiProjectsProjectIdChannelsPersonal404Schema
      | PostApiProjectsProjectIdChannelsPersonal422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsPersonalPathParamsSchema["project_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId }) => {
      return postApiProjectsProjectIdChannelsPersonal(projectId, config);
    },
  });
}

/**
 * @summary Create personal channel
 * {@link /api/projects/:project_id/channels/personal}
 */
export function usePostApiProjectsProjectIdChannelsPersonal<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdChannelsPersonalMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdChannelsPersonal401Schema
        | PostApiProjectsProjectIdChannelsPersonal403Schema
        | PostApiProjectsProjectIdChannelsPersonal404Schema
        | PostApiProjectsProjectIdChannelsPersonal422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdChannelsPersonalPathParamsSchema["project_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdChannelsPersonalMutationKey();

  const baseOptions = postApiProjectsProjectIdChannelsPersonalMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdChannelsPersonalMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsPersonal401Schema
      | PostApiProjectsProjectIdChannelsPersonal403Schema
      | PostApiProjectsProjectIdChannelsPersonal404Schema
      | PostApiProjectsProjectIdChannelsPersonal422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsPersonalPathParamsSchema["project_id"];
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdChannelsPersonalMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsPersonal401Schema
      | PostApiProjectsProjectIdChannelsPersonal403Schema
      | PostApiProjectsProjectIdChannelsPersonal404Schema
      | PostApiProjectsProjectIdChannelsPersonal422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsPersonalPathParamsSchema["project_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdChannelsPersonalMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsPersonal401Schema
      | PostApiProjectsProjectIdChannelsPersonal403Schema
      | PostApiProjectsProjectIdChannelsPersonal404Schema
      | PostApiProjectsProjectIdChannelsPersonal422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsPersonalPathParamsSchema["project_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdChannelsMessagingMutationKey = () =>
  [{ url: "/api/projects/:project_id/channels/messaging" }] as const;

export type PostApiProjectsProjectIdChannelsMessagingMutationKey = ReturnType<
  typeof postApiProjectsProjectIdChannelsMessagingMutationKey
>;

export function postApiProjectsProjectIdChannelsMessagingMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdChannelsMessagingMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdChannelsMessagingMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsMessaging400Schema
      | PostApiProjectsProjectIdChannelsMessaging401Schema
      | PostApiProjectsProjectIdChannelsMessaging403Schema
      | PostApiProjectsProjectIdChannelsMessaging404Schema
      | PostApiProjectsProjectIdChannelsMessaging422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsMessagingPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdChannelsMessaging(projectId, data, config);
    },
  });
}

/**
 * @summary Create messaging channel
 * {@link /api/projects/:project_id/channels/messaging}
 */
export function usePostApiProjectsProjectIdChannelsMessaging<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdChannelsMessagingMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdChannelsMessaging400Schema
        | PostApiProjectsProjectIdChannelsMessaging401Schema
        | PostApiProjectsProjectIdChannelsMessaging403Schema
        | PostApiProjectsProjectIdChannelsMessaging404Schema
        | PostApiProjectsProjectIdChannelsMessaging422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdChannelsMessagingPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdChannelsMessagingMutationKey();

  const baseOptions = postApiProjectsProjectIdChannelsMessagingMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdChannelsMessagingMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsMessaging400Schema
      | PostApiProjectsProjectIdChannelsMessaging401Schema
      | PostApiProjectsProjectIdChannelsMessaging403Schema
      | PostApiProjectsProjectIdChannelsMessaging404Schema
      | PostApiProjectsProjectIdChannelsMessaging422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsMessagingPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdChannelsMessagingMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsMessaging400Schema
      | PostApiProjectsProjectIdChannelsMessaging401Schema
      | PostApiProjectsProjectIdChannelsMessaging403Schema
      | PostApiProjectsProjectIdChannelsMessaging404Schema
      | PostApiProjectsProjectIdChannelsMessaging422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsMessagingPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdChannelsMessagingMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsMessaging400Schema
      | PostApiProjectsProjectIdChannelsMessaging401Schema
      | PostApiProjectsProjectIdChannelsMessaging403Schema
      | PostApiProjectsProjectIdChannelsMessaging404Schema
      | PostApiProjectsProjectIdChannelsMessaging422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsMessagingPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/channels/messages/:message_id/save_attachments",
      },
    ] as const;

export type PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationKey
  >;

export function postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments401Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments403Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments404Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema["project_id"];
      messageId: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema["message_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, messageId }) => {
      return postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments(
        projectId,
        messageId,
        config,
      );
    },
  });
}

/**
 * @summary Save message attachments to project gallery
 * {@link /api/projects/:project_id/channels/messages/:message_id/save_attachments}
 */
export function usePostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments401Schema
        | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments403Schema
        | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments404Schema
        | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema["project_id"];
        messageId: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema["message_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments401Schema
        | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments403Schema
        | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments404Schema
        | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema["project_id"];
        messageId: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema["message_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments401Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments403Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments404Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema["project_id"];
      messageId: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema["message_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments401Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments403Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments404Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema["project_id"];
      messageId: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema["message_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdCommentsMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/comments" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdCommentsMutationKey =
  ReturnType<typeof postApiProjectsProjectIdIssuesIssueIdCommentsMutationKey>;

export function postApiProjectsProjectIdIssuesIssueIdCommentsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdCommentsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdCommentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdComments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdComments404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema["issue_id"];
      data: PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdComments(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a comment
 * {@link /api/projects/:project_id/issues/:issue_id/comments}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdComments<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdCommentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdComments401Schema
        | PostApiProjectsProjectIdIssuesIssueIdComments404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema["issue_id"];
        data: PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdCommentsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdCommentsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdCommentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdComments401Schema
        | PostApiProjectsProjectIdIssuesIssueIdComments404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema["issue_id"];
        data: PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdCommentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdComments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdComments404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema["issue_id"];
      data: PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdCommentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdComments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdComments404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema["issue_id"];
      data: PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/issues/:issue_id/comments/:comment_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationKey
  >;

export function deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["issue_id"];
      commentId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["comment_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, commentId }) => {
      return deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId(
        projectId,
        issueId,
        commentId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a comment
 * {@link /api/projects/:project_id/issues/:issue_id/comments/:comment_id}
 */
export function useDeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId401Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId403Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId404Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["issue_id"];
        commentId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["comment_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId401Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId403Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId404Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["issue_id"];
        commentId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["comment_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["issue_id"];
      commentId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["comment_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["issue_id"];
      commentId: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema["comment_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdContractsContractIdFilesMutationKey = () =>
  [{ url: "/api/projects/:project_id/contracts/:contract_id/files" }] as const;

export type PostApiProjectsProjectIdContractsContractIdFilesMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdContractsContractIdFilesMutationKey
  >;

export function postApiProjectsProjectIdContractsContractIdFilesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdContractsContractIdFilesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdContractsContractIdFilesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdContractsContractIdFiles400Schema
      | PostApiProjectsProjectIdContractsContractIdFiles401Schema
      | PostApiProjectsProjectIdContractsContractIdFiles403Schema
      | PostApiProjectsProjectIdContractsContractIdFiles404Schema
      | PostApiProjectsProjectIdContractsContractIdFiles422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"];
      contractId: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"];
      data: PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, contractId, data }) => {
      return postApiProjectsProjectIdContractsContractIdFiles(
        projectId,
        contractId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a contract file
 * {@link /api/projects/:project_id/contracts/:contract_id/files}
 */
export function usePostApiProjectsProjectIdContractsContractIdFiles<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdContractsContractIdFilesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdContractsContractIdFiles400Schema
        | PostApiProjectsProjectIdContractsContractIdFiles401Schema
        | PostApiProjectsProjectIdContractsContractIdFiles403Schema
        | PostApiProjectsProjectIdContractsContractIdFiles404Schema
        | PostApiProjectsProjectIdContractsContractIdFiles422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"];
        contractId: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"];
        data: PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdContractsContractIdFilesMutationKey();

  const baseOptions =
    postApiProjectsProjectIdContractsContractIdFilesMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdContractsContractIdFilesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdContractsContractIdFiles400Schema
        | PostApiProjectsProjectIdContractsContractIdFiles401Schema
        | PostApiProjectsProjectIdContractsContractIdFiles403Schema
        | PostApiProjectsProjectIdContractsContractIdFiles404Schema
        | PostApiProjectsProjectIdContractsContractIdFiles422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"];
        contractId: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"];
        data: PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdContractsContractIdFilesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdContractsContractIdFiles400Schema
      | PostApiProjectsProjectIdContractsContractIdFiles401Schema
      | PostApiProjectsProjectIdContractsContractIdFiles403Schema
      | PostApiProjectsProjectIdContractsContractIdFiles404Schema
      | PostApiProjectsProjectIdContractsContractIdFiles422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"];
      contractId: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"];
      data: PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdContractsContractIdFilesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdContractsContractIdFiles400Schema
      | PostApiProjectsProjectIdContractsContractIdFiles401Schema
      | PostApiProjectsProjectIdContractsContractIdFiles403Schema
      | PostApiProjectsProjectIdContractsContractIdFiles404Schema
      | PostApiProjectsProjectIdContractsContractIdFiles422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["project_id"];
      contractId: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema["contract_id"];
      data: PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdContractsContractIdFilesIdMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/contracts/:contract_id/files/:id" },
    ] as const;

export type PatchApiProjectsProjectIdContractsContractIdFilesIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdContractsContractIdFilesIdMutationKey
  >;

export function patchApiProjectsProjectIdContractsContractIdFilesIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdContractsContractIdFilesIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdContractsContractIdFilesId401Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId403Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId404Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["project_id"];
      contractId: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["contract_id"];
      id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["id"];
      data?: PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, contractId, id, data }) => {
      return patchApiProjectsProjectIdContractsContractIdFilesId(
        projectId,
        contractId,
        id,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a contract file
 * {@link /api/projects/:project_id/contracts/:contract_id/files/:id}
 */
export function usePatchApiProjectsProjectIdContractsContractIdFilesId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdContractsContractIdFilesId401Schema
        | PatchApiProjectsProjectIdContractsContractIdFilesId403Schema
        | PatchApiProjectsProjectIdContractsContractIdFilesId404Schema
        | PatchApiProjectsProjectIdContractsContractIdFilesId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["project_id"];
        contractId: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["contract_id"];
        id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["id"];
        data?: PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdContractsContractIdFilesIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdContractsContractIdFilesIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdContractsContractIdFilesId401Schema
        | PatchApiProjectsProjectIdContractsContractIdFilesId403Schema
        | PatchApiProjectsProjectIdContractsContractIdFilesId404Schema
        | PatchApiProjectsProjectIdContractsContractIdFilesId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["project_id"];
        contractId: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["contract_id"];
        id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["id"];
        data?: PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdContractsContractIdFilesId401Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId403Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId404Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["project_id"];
      contractId: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["contract_id"];
      id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["id"];
      data?: PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdContractsContractIdFilesId401Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId403Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId404Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["project_id"];
      contractId: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["contract_id"];
      id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["id"];
      data?: PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdContractsContractIdFilesIdMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/contracts/:contract_id/files/:id" },
    ] as const;

export type DeleteApiProjectsProjectIdContractsContractIdFilesIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdContractsContractIdFilesIdMutationKey
  >;

export function deleteApiProjectsProjectIdContractsContractIdFilesIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdContractsContractIdFilesIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdContractsContractIdFilesId401Schema
      | DeleteApiProjectsProjectIdContractsContractIdFilesId403Schema
      | DeleteApiProjectsProjectIdContractsContractIdFilesId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["project_id"];
      contractId: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["contract_id"];
      id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, contractId, id }) => {
      return deleteApiProjectsProjectIdContractsContractIdFilesId(
        projectId,
        contractId,
        id,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a contract file
 * {@link /api/projects/:project_id/contracts/:contract_id/files/:id}
 */
export function useDeleteApiProjectsProjectIdContractsContractIdFilesId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdContractsContractIdFilesId401Schema
        | DeleteApiProjectsProjectIdContractsContractIdFilesId403Schema
        | DeleteApiProjectsProjectIdContractsContractIdFilesId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["project_id"];
        contractId: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["contract_id"];
        id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdContractsContractIdFilesIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdContractsContractIdFilesIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdContractsContractIdFilesId401Schema
        | DeleteApiProjectsProjectIdContractsContractIdFilesId403Schema
        | DeleteApiProjectsProjectIdContractsContractIdFilesId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["project_id"];
        contractId: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["contract_id"];
        id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdContractsContractIdFilesId401Schema
      | DeleteApiProjectsProjectIdContractsContractIdFilesId403Schema
      | DeleteApiProjectsProjectIdContractsContractIdFilesId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["project_id"];
      contractId: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["contract_id"];
      id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdContractsContractIdFilesId401Schema
      | DeleteApiProjectsProjectIdContractsContractIdFilesId403Schema
      | DeleteApiProjectsProjectIdContractsContractIdFilesId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["project_id"];
      contractId: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["contract_id"];
      id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema["id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdContractsMutationKey = () =>
  [{ url: "/api/projects/:project_id/contracts" }] as const;

export type PostApiProjectsProjectIdContractsMutationKey = ReturnType<
  typeof postApiProjectsProjectIdContractsMutationKey
>;

export function postApiProjectsProjectIdContractsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdContractsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdContractsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdContractsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdContracts401Schema
      | PostApiProjectsProjectIdContracts403Schema
      | PostApiProjectsProjectIdContracts422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdContractsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdContractsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdContracts(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a contract
 * {@link /api/projects/:project_id/contracts}
 */
export function usePostApiProjectsProjectIdContracts<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdContractsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdContracts401Schema
        | PostApiProjectsProjectIdContracts403Schema
        | PostApiProjectsProjectIdContracts422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdContractsPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdContractsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdContractsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdContractsMutationKey();

  const baseOptions = postApiProjectsProjectIdContractsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdContractsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdContracts401Schema
      | PostApiProjectsProjectIdContracts403Schema
      | PostApiProjectsProjectIdContracts422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdContractsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdContractsMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdContractsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdContracts401Schema
      | PostApiProjectsProjectIdContracts403Schema
      | PostApiProjectsProjectIdContracts422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdContractsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdContractsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdContractsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdContracts401Schema
      | PostApiProjectsProjectIdContracts403Schema
      | PostApiProjectsProjectIdContracts422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdContractsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdContractsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdContractsContractIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/contracts/:contract_id" }] as const;

export type PatchApiProjectsProjectIdContractsContractIdMutationKey =
  ReturnType<typeof patchApiProjectsProjectIdContractsContractIdMutationKey>;

export function patchApiProjectsProjectIdContractsContractIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = patchApiProjectsProjectIdContractsContractIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdContractsContractIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdContractsContractId401Schema
      | PatchApiProjectsProjectIdContractsContractId403Schema
      | PatchApiProjectsProjectIdContractsContractId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"];
      contractId: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"];
      data?: PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, contractId, data }) => {
      return patchApiProjectsProjectIdContractsContractId(
        projectId,
        contractId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a contract
 * {@link /api/projects/:project_id/contracts/:contract_id}
 */
export function usePatchApiProjectsProjectIdContractsContractId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdContractsContractIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdContractsContractId401Schema
        | PatchApiProjectsProjectIdContractsContractId403Schema
        | PatchApiProjectsProjectIdContractsContractId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"];
        contractId: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"];
        data?: PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdContractsContractIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdContractsContractIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdContractsContractIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdContractsContractId401Schema
        | PatchApiProjectsProjectIdContractsContractId403Schema
        | PatchApiProjectsProjectIdContractsContractId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"];
        contractId: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"];
        data?: PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdContractsContractIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdContractsContractId401Schema
      | PatchApiProjectsProjectIdContractsContractId403Schema
      | PatchApiProjectsProjectIdContractsContractId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"];
      contractId: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"];
      data?: PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdContractsContractIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdContractsContractId401Schema
      | PatchApiProjectsProjectIdContractsContractId403Schema
      | PatchApiProjectsProjectIdContractsContractId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema["project_id"];
      contractId: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema["contract_id"];
      data?: PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/:change_signal_id/contract_change_signals",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationKey
  >;

export function postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema["project_id"];
      changeSignalId: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema["change_signal_id"];
      data: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, changeSignalId, data }) => {
      return postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals(
        projectId,
        changeSignalId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Assigns a contract to a change signal
 * {@link /api/projects/:project_id/control_center/change_signals/:change_signal_id/contract_change_signals}
 */
export function usePostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals401Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals403Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema["project_id"];
        changeSignalId: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema["change_signal_id"];
        data: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals401Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals403Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema["project_id"];
        changeSignalId: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema["change_signal_id"];
        data: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema["project_id"];
      changeSignalId: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema["change_signal_id"];
      data: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema["project_id"];
      changeSignalId: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema["change_signal_id"];
      data: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/search_filter",
      },
    ] as const;

export type PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationKey
  >;

export function patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"];
      data?: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter(
        projectId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Sets the search filter for change signals assigned to the current team member
 * {@link /api/projects/:project_id/control_center/change_signals/search_filter}
 */
export function usePatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
        | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
        | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
        | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"];
        data?: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
        | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
        | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
        | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"];
        data?: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"];
      data?: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema["project_id"];
      data?: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/issues_search",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationKey
  >;

export function postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchQueryParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data, params }) => {
      return postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch(
        projectId,
        data,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Performs a issue change signals search
 * {@link /api/projects/:project_id/control_center/change_signals/issues_search}
 */
export function usePostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch401Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch403Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema;
        params?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchQueryParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch401Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch403Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema;
        params?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchQueryParamsSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchQueryParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchQueryParamsSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/downtimes_search",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationKey
  >;

export function postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchQueryParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data, params }) => {
      return postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch(
        projectId,
        data,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Performs a downtime change signals search
 * {@link /api/projects/:project_id/control_center/change_signals/downtimes_search}
 */
export function usePostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch401Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch403Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema;
        params?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchQueryParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch401Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch403Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema;
        params?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchQueryParamsSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchQueryParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchQueryParamsSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/progress_logs_search",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationKey
  >;

export function postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchQueryParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data, params }) => {
      return postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch(
        projectId,
        data,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Performs a progress log change signals search
 * {@link /api/projects/:project_id/control_center/change_signals/progress_logs_search}
 */
export function usePostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch401Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch403Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema;
        params?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchQueryParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch401Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch403Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema;
        params?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchQueryParamsSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchQueryParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchQueryParamsSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/change_signals/batch_dismiss",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationKey
  >;

export function postApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissQueryParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data, params }) => {
      return postApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss(
        projectId,
        data,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Dismisses change signals
 * {@link /api/projects/:project_id/control_center/change_signals/batch_dismiss}
 */
export function usePostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss401Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss403Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema;
        params?: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissQueryParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss401Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss403Schema
        | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema;
        params?: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissQueryParamsSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissQueryParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissQueryParamsSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/document_references/:document_reference_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationKey
  >;

export function deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["potential_change_id"];
      documentReferenceId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({
      projectId,
      potentialChangeId,
      documentReferenceId,
    }) => {
      return deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId(
        projectId,
        potentialChangeId,
        documentReferenceId,
        config,
      );
    },
  });
}

/**
 * @summary Removes a document from a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/document_references/:document_reference_id}
 */
export function useDeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId401Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId403Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
        potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["potential_change_id"];
        documentReferenceId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId401Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId403Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
        potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["potential_change_id"];
        documentReferenceId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["potential_change_id"];
      documentReferenceId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["potential_change_id"];
      documentReferenceId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/documents",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationKey
  >;

export function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"];
      data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId, data }) => {
      return postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments(
        projectId,
        potentialChangeId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Adds a document to a potential change (from an upload or an existing document)
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/documents}
 */
export function usePostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"];
        data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"];
        data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"];
      data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema["potential_change_id"];
      data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/export",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationKey
  >;

export function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema["potential_change_id"];
      data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId, data }) => {
      return postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport(
        projectId,
        potentialChangeId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a potential change export
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/export}
 */
export function usePostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema["potential_change_id"];
        data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema["potential_change_id"];
        data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema["potential_change_id"];
      data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema["potential_change_id"];
      data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/change_signal_links/batch_delete",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationKey
  >;

export function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete403Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema["potential_change_id"];
      data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId, data }) => {
      return postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete(
        projectId,
        potentialChangeId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Delete potential change change signal links
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/change_signal_links/batch_delete}
 */
export function usePostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete403Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema["potential_change_id"];
        data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete403Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema["potential_change_id"];
        data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete403Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema["potential_change_id"];
      data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete403Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema["potential_change_id"];
      data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/change_signal_links/batch_create",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationKey
  >;

export function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate403Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema["potential_change_id"];
      data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId, data }) => {
      return postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate(
        projectId,
        potentialChangeId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates potential change change signal links
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/change_signal_links/batch_create}
 */
export function usePostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate403Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema["potential_change_id"];
        data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate403Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema["potential_change_id"];
        data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate403Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema["potential_change_id"];
      data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate403Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema["potential_change_id"];
      data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/narrative",
      },
    ] as const;

export type PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationKey
  >;

export function patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative400Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"];
      potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"];
      data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId, data }) => {
      return patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative(
        projectId,
        potentialChangeId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates potential change narrative
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/narrative}
 */
export function usePatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative400Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"];
        potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"];
        data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative400Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"];
        potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"];
        data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative400Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"];
      potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"];
      data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative400Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["project_id"];
      potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema["potential_change_id"];
      data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterPotentialChangesMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/control_center/potential_changes" },
    ] as const;

export type PostApiProjectsProjectIdControlCenterPotentialChangesMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterPotentialChangesMutationKey
  >;

export function postApiProjectsProjectIdControlCenterPotentialChangesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterPotentialChangesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterPotentialChangesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChanges401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data, params }) => {
      return postApiProjectsProjectIdControlCenterPotentialChanges(
        projectId,
        data,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Creates a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes}
 */
export function usePostApiProjectsProjectIdControlCenterPotentialChanges<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChanges401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChanges403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChanges404Schema
        | PostApiProjectsProjectIdControlCenterPotentialChanges422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema;
        params?: PostApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterPotentialChangesMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterPotentialChangesMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChanges401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChanges403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChanges404Schema
        | PostApiProjectsProjectIdControlCenterPotentialChanges422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema;
        params?: PostApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterPotentialChangesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChanges401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterPotentialChangesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChanges401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema;
      params?: PostApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id",
      },
    ] as const;

export type PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationKey
  >;

export function patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"];
      potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"];
      data?: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId, data }) => {
      return patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId(
        projectId,
        potentialChangeId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id}
 */
export function usePatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"];
        potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"];
        data?: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"];
        potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"];
        data?: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"];
      potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"];
      data?: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["project_id"];
      potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema["potential_change_id"];
      data?: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/archive",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationKey
  >;

export function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema["potential_change_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId }) => {
      return postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive(
        projectId,
        potentialChangeId,
        config,
      );
    },
  });
}

/**
 * @summary Archives a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/archive}
 */
export function usePostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive404Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema["potential_change_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive404Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema["potential_change_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema["potential_change_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema["potential_change_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/reconcile",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationKey
  >;

export function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema["potential_change_id"];
      params: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileQueryParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId, params }) => {
      return postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile(
        projectId,
        potentialChangeId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Reconciles the schedule view with the change linked signals
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/reconcile}
 */
export function usePostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile400Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema["potential_change_id"];
        params: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileQueryParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile400Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema["potential_change_id"];
        params: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileQueryParamsSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema["potential_change_id"];
      params: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileQueryParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema["potential_change_id"];
      params: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileQueryParamsSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/entries",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationKey
  >;

export function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["potential_change_id"];
      rowId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["row_id"];
      data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId, rowId, data }) => {
      return postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries(
        projectId,
        potentialChangeId,
        rowId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Adds an entry to a schedule view row
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/entries}
 */
export function usePostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries400Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["potential_change_id"];
        rowId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["row_id"];
        data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries400Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["potential_change_id"];
        rowId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["row_id"];
        data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["potential_change_id"];
      rowId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["row_id"];
      data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["potential_change_id"];
      rowId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema["row_id"];
      data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/entries/:change_signal_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationKey
  >;

export function deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["project_id"];
      potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["potential_change_id"];
      rowId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["row_id"];
      changeSignalId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["change_signal_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({
      projectId,
      potentialChangeId,
      rowId,
      changeSignalId,
    }) => {
      return deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId(
        projectId,
        potentialChangeId,
        rowId,
        changeSignalId,
        config,
      );
    },
  });
}

/**
 * @summary Removes an entry from a schedule view row
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/entries/:change_signal_id}
 */
export function useDeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId401Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId403Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["project_id"];
        potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["potential_change_id"];
        rowId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["row_id"];
        changeSignalId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["change_signal_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId401Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId403Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["project_id"];
        potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["potential_change_id"];
        rowId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["row_id"];
        changeSignalId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["change_signal_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["project_id"];
      potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["potential_change_id"];
      rowId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["row_id"];
      changeSignalId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["change_signal_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["project_id"];
      potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["potential_change_id"];
      rowId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["row_id"];
      changeSignalId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema["change_signal_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows",
      },
    ] as const;

export type PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationKey
  >;

export function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema["potential_change_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId }) => {
      return postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows(
        projectId,
        potentialChangeId,
        config,
      );
    },
  });
}

/**
 * @summary Adds an empty row to the schedule view
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows}
 */
export function usePostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema["potential_change_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows401Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows403Schema
        | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema["project_id"];
        potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema["potential_change_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema["potential_change_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema["project_id"];
      potentialChangeId: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema["potential_change_id"];
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:id",
      },
    ] as const;

export type PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationKey
  >;

export function patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId400Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["project_id"];
      potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["potential_change_id"];
      id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["id"];
      data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId, id, data }) => {
      return patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId(
        projectId,
        potentialChangeId,
        id,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a schedule view row
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:id}
 */
export function usePatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId400Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["project_id"];
        potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["potential_change_id"];
        id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["id"];
        data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId400Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
        | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["project_id"];
        potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["potential_change_id"];
        id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["id"];
        data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId400Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["project_id"];
      potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["potential_change_id"];
      id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["id"];
      data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId400Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["project_id"];
      potentialChangeId: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["potential_change_id"];
      id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["id"];
      data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationKey
  >;

export function deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["project_id"];
      potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["potential_change_id"];
      id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, potentialChangeId, id }) => {
      return deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId(
        projectId,
        potentialChangeId,
        id,
        config,
      );
    },
  });
}

/**
 * @summary Removes a row from the schedule view
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:id}
 */
export function useDeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["project_id"];
        potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["potential_change_id"];
        id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
        | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["project_id"];
        potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["potential_change_id"];
        id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["project_id"];
      potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["potential_change_id"];
      id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["project_id"];
      potentialChangeId: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["potential_change_id"];
      id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema["id"];
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdControlCenterTeamPersonalizationMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/control_center/team_personalization" },
    ] as const;

export type PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdControlCenterTeamPersonalizationMutationKey
  >;

export function patchApiProjectsProjectIdControlCenterTeamPersonalizationMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdControlCenterTeamPersonalizationMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization401Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization403Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization404Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"];
      data?: PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return patchApiProjectsProjectIdControlCenterTeamPersonalization(
        projectId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates the control center team personalization
 * {@link /api/projects/:project_id/control_center/team_personalization}
 */
export function usePatchApiProjectsProjectIdControlCenterTeamPersonalization<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdControlCenterTeamPersonalization401Schema
        | PatchApiProjectsProjectIdControlCenterTeamPersonalization403Schema
        | PatchApiProjectsProjectIdControlCenterTeamPersonalization404Schema
        | PatchApiProjectsProjectIdControlCenterTeamPersonalization422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"];
        data?: PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdControlCenterTeamPersonalizationMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdControlCenterTeamPersonalizationMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdControlCenterTeamPersonalization401Schema
        | PatchApiProjectsProjectIdControlCenterTeamPersonalization403Schema
        | PatchApiProjectsProjectIdControlCenterTeamPersonalization404Schema
        | PatchApiProjectsProjectIdControlCenterTeamPersonalization422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"];
        data?: PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization401Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization403Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization404Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"];
      data?: PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization401Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization403Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization404Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema["project_id"];
      data?: PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdCustomFieldsMutationKey = () =>
  [{ url: "/api/projects/:project_id/custom_fields" }] as const;

export type PostApiProjectsProjectIdCustomFieldsMutationKey = ReturnType<
  typeof postApiProjectsProjectIdCustomFieldsMutationKey
>;

export function postApiProjectsProjectIdCustomFieldsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdCustomFieldsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdCustomFieldsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdCustomFieldsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdCustomFields401Schema
      | PostApiProjectsProjectIdCustomFields403Schema
      | PostApiProjectsProjectIdCustomFields404Schema
      | PostApiProjectsProjectIdCustomFields422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdCustomFieldsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdCustomFields(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a custom field
 * {@link /api/projects/:project_id/custom_fields}
 */
export function usePostApiProjectsProjectIdCustomFields<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdCustomFieldsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdCustomFields401Schema
        | PostApiProjectsProjectIdCustomFields403Schema
        | PostApiProjectsProjectIdCustomFields404Schema
        | PostApiProjectsProjectIdCustomFields422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdCustomFieldsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdCustomFieldsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdCustomFieldsMutationKey();

  const baseOptions = postApiProjectsProjectIdCustomFieldsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdCustomFieldsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdCustomFields401Schema
      | PostApiProjectsProjectIdCustomFields403Schema
      | PostApiProjectsProjectIdCustomFields404Schema
      | PostApiProjectsProjectIdCustomFields422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdCustomFieldsMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdCustomFieldsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdCustomFields401Schema
      | PostApiProjectsProjectIdCustomFields403Schema
      | PostApiProjectsProjectIdCustomFields404Schema
      | PostApiProjectsProjectIdCustomFields422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdCustomFieldsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdCustomFieldsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdCustomFields401Schema
      | PostApiProjectsProjectIdCustomFields403Schema
      | PostApiProjectsProjectIdCustomFields404Schema
      | PostApiProjectsProjectIdCustomFields422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdCustomFieldsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdCustomFieldsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/custom_fields/:custom_field_id" },
    ] as const;

export type PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationKey
  >;

export function patchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["project_id"];
      customFieldId: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["custom_field_id"];
      data: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, customFieldId, data }) => {
      return patchApiProjectsProjectIdCustomFieldsCustomFieldId(
        projectId,
        customFieldId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a custom field
 * {@link /api/projects/:project_id/custom_fields/:custom_field_id}
 */
export function usePatchApiProjectsProjectIdCustomFieldsCustomFieldId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
        | PatchApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
        | PatchApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
        | PatchApiProjectsProjectIdCustomFieldsCustomFieldId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["project_id"];
        customFieldId: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["custom_field_id"];
        data: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
        | PatchApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
        | PatchApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
        | PatchApiProjectsProjectIdCustomFieldsCustomFieldId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["project_id"];
        customFieldId: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["custom_field_id"];
        data: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["project_id"];
      customFieldId: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["custom_field_id"];
      data: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["project_id"];
      customFieldId: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["custom_field_id"];
      data: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/custom_fields/:custom_field_id" },
    ] as const;

export type DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationKey
  >;

export function deleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["project_id"];
      customFieldId: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["custom_field_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, customFieldId }) => {
      return deleteApiProjectsProjectIdCustomFieldsCustomFieldId(
        projectId,
        customFieldId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a custom field
 * {@link /api/projects/:project_id/custom_fields/:custom_field_id}
 */
export function useDeleteApiProjectsProjectIdCustomFieldsCustomFieldId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
        | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
        | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["project_id"];
        customFieldId: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["custom_field_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
        | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
        | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["project_id"];
        customFieldId: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["custom_field_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["project_id"];
      customFieldId: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["custom_field_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["project_id"];
      customFieldId: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema["custom_field_id"];
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/issues/:issue_id/custom_fields" },
    ] as const;

export type PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationKey
  >;

export function patchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields401Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields403Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields404Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema["project_id"];
      issueId: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema["issue_id"];
      data?: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return patchApiProjectsProjectIdIssuesIssueIdCustomFields(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates issue custom fields
 * {@link /api/projects/:project_id/issues/:issue_id/custom_fields}
 */
export function usePatchApiProjectsProjectIdIssuesIssueIdCustomFields<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdIssuesIssueIdCustomFields401Schema
        | PatchApiProjectsProjectIdIssuesIssueIdCustomFields403Schema
        | PatchApiProjectsProjectIdIssuesIssueIdCustomFields404Schema
        | PatchApiProjectsProjectIdIssuesIssueIdCustomFields422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema["project_id"];
        issueId: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema["issue_id"];
        data?: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdIssuesIssueIdCustomFields401Schema
        | PatchApiProjectsProjectIdIssuesIssueIdCustomFields403Schema
        | PatchApiProjectsProjectIdIssuesIssueIdCustomFields404Schema
        | PatchApiProjectsProjectIdIssuesIssueIdCustomFields422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema["project_id"];
        issueId: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema["issue_id"];
        data?: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields401Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields403Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields404Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema["project_id"];
      issueId: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema["issue_id"];
      data?: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields401Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields403Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields404Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema["project_id"];
      issueId: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema["issue_id"];
      data?: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiDirectUploadsTypeMutationKey = () =>
  [{ url: "/api/direct_uploads/:type" }] as const;

export type PostApiDirectUploadsTypeMutationKey = ReturnType<
  typeof postApiDirectUploadsTypeMutationKey
>;

export function postApiDirectUploadsTypeMutationOptions<TContext = unknown>(
  config: Partial<
    RequestConfig<PostApiDirectUploadsTypeMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiDirectUploadsTypeMutationKey();
  return mutationOptions<
    PostApiDirectUploadsTypeMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiDirectUploadsType400Schema
      | PostApiDirectUploadsType401Schema
      | PostApiDirectUploadsType404Schema
    >,
    {
      type: PostApiDirectUploadsTypePathParamsSchema["type"];
      data: PostApiDirectUploadsTypeMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ type, data }) => {
      return postApiDirectUploadsType(type, data, config);
    },
  });
}

/**
 * @summary Creates a direct upload
 * {@link /api/direct_uploads/:type}
 */
export function usePostApiDirectUploadsType<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiDirectUploadsTypeMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiDirectUploadsType400Schema
        | PostApiDirectUploadsType401Schema
        | PostApiDirectUploadsType404Schema
      >,
      {
        type: PostApiDirectUploadsTypePathParamsSchema["type"];
        data: PostApiDirectUploadsTypeMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiDirectUploadsTypeMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiDirectUploadsTypeMutationKey();

  const baseOptions = postApiDirectUploadsTypeMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiDirectUploadsTypeMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiDirectUploadsType400Schema
      | PostApiDirectUploadsType401Schema
      | PostApiDirectUploadsType404Schema
    >,
    {
      type: PostApiDirectUploadsTypePathParamsSchema["type"];
      data: PostApiDirectUploadsTypeMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiDirectUploadsTypeMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiDirectUploadsType400Schema
      | PostApiDirectUploadsType401Schema
      | PostApiDirectUploadsType404Schema
    >,
    {
      type: PostApiDirectUploadsTypePathParamsSchema["type"];
      data: PostApiDirectUploadsTypeMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiDirectUploadsTypeMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiDirectUploadsType400Schema
      | PostApiDirectUploadsType401Schema
      | PostApiDirectUploadsType404Schema
    >,
    {
      type: PostApiDirectUploadsTypePathParamsSchema["type"];
      data: PostApiDirectUploadsTypeMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdDisciplinesMutationKey = () =>
  [{ url: "/api/projects/:project_id/disciplines" }] as const;

export type PostApiProjectsProjectIdDisciplinesMutationKey = ReturnType<
  typeof postApiProjectsProjectIdDisciplinesMutationKey
>;

export function postApiProjectsProjectIdDisciplinesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdDisciplinesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdDisciplinesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdDisciplinesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDisciplines401Schema
      | PostApiProjectsProjectIdDisciplines403Schema
      | PostApiProjectsProjectIdDisciplines404Schema
      | PostApiProjectsProjectIdDisciplines422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdDisciplinesMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdDisciplines(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a discipline
 * {@link /api/projects/:project_id/disciplines}
 */
export function usePostApiProjectsProjectIdDisciplines<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdDisciplinesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdDisciplines401Schema
        | PostApiProjectsProjectIdDisciplines403Schema
        | PostApiProjectsProjectIdDisciplines404Schema
        | PostApiProjectsProjectIdDisciplines422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdDisciplinesMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdDisciplinesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdDisciplinesMutationKey();

  const baseOptions = postApiProjectsProjectIdDisciplinesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdDisciplinesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDisciplines401Schema
      | PostApiProjectsProjectIdDisciplines403Schema
      | PostApiProjectsProjectIdDisciplines404Schema
      | PostApiProjectsProjectIdDisciplines422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdDisciplinesMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdDisciplinesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDisciplines401Schema
      | PostApiProjectsProjectIdDisciplines403Schema
      | PostApiProjectsProjectIdDisciplines404Schema
      | PostApiProjectsProjectIdDisciplines422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdDisciplinesMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdDisciplinesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDisciplines401Schema
      | PostApiProjectsProjectIdDisciplines403Schema
      | PostApiProjectsProjectIdDisciplines404Schema
      | PostApiProjectsProjectIdDisciplines422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDisciplinesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdDisciplinesMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdDisciplinesDisciplineIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/disciplines/:discipline_id" }] as const;

export type PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdDisciplinesDisciplineIdMutationKey
  >;

export function patchApiProjectsProjectIdDisciplinesDisciplineIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdDisciplinesDisciplineIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId404Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"];
      disciplineId: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"];
      data?: PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, disciplineId, data }) => {
      return patchApiProjectsProjectIdDisciplinesDisciplineId(
        projectId,
        disciplineId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a discipline
 * {@link /api/projects/:project_id/disciplines/:discipline_id}
 */
export function usePatchApiProjectsProjectIdDisciplinesDisciplineId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdDisciplinesDisciplineId401Schema
        | PatchApiProjectsProjectIdDisciplinesDisciplineId403Schema
        | PatchApiProjectsProjectIdDisciplinesDisciplineId404Schema
        | PatchApiProjectsProjectIdDisciplinesDisciplineId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"];
        disciplineId: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"];
        data?: PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdDisciplinesDisciplineIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdDisciplinesDisciplineIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdDisciplinesDisciplineId401Schema
        | PatchApiProjectsProjectIdDisciplinesDisciplineId403Schema
        | PatchApiProjectsProjectIdDisciplinesDisciplineId404Schema
        | PatchApiProjectsProjectIdDisciplinesDisciplineId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"];
        disciplineId: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"];
        data?: PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId404Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"];
      disciplineId: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"];
      data?: PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId404Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"];
      disciplineId: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"];
      data?: PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdDisciplinesDisciplineIdMutationKey =
  () =>
    [{ url: "/api/projects/:project_id/disciplines/:discipline_id" }] as const;

export type DeleteApiProjectsProjectIdDisciplinesDisciplineIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdDisciplinesDisciplineIdMutationKey
  >;

export function deleteApiProjectsProjectIdDisciplinesDisciplineIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdDisciplinesDisciplineIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId404Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"];
      disciplineId: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, disciplineId }) => {
      return deleteApiProjectsProjectIdDisciplinesDisciplineId(
        projectId,
        disciplineId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a discipline
 * {@link /api/projects/:project_id/disciplines/:discipline_id}
 */
export function useDeleteApiProjectsProjectIdDisciplinesDisciplineId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdDisciplinesDisciplineId401Schema
        | DeleteApiProjectsProjectIdDisciplinesDisciplineId403Schema
        | DeleteApiProjectsProjectIdDisciplinesDisciplineId404Schema
        | DeleteApiProjectsProjectIdDisciplinesDisciplineId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"];
        disciplineId: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdDisciplinesDisciplineIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdDisciplinesDisciplineIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdDisciplinesDisciplineId401Schema
        | DeleteApiProjectsProjectIdDisciplinesDisciplineId403Schema
        | DeleteApiProjectsProjectIdDisciplinesDisciplineId404Schema
        | DeleteApiProjectsProjectIdDisciplinesDisciplineId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"];
        disciplineId: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId404Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"];
      disciplineId: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId404Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["project_id"];
      disciplineId: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema["discipline_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdDisciplinesSortMutationKey = () =>
  [{ url: "/api/projects/:project_id/disciplines/sort" }] as const;

export type PostApiProjectsProjectIdDisciplinesSortMutationKey = ReturnType<
  typeof postApiProjectsProjectIdDisciplinesSortMutationKey
>;

export function postApiProjectsProjectIdDisciplinesSortMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdDisciplinesSortMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdDisciplinesSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDisciplinesSort401Schema
      | PostApiProjectsProjectIdDisciplinesSort403Schema
      | PostApiProjectsProjectIdDisciplinesSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDisciplinesSortPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdDisciplinesSort(projectId, data, config);
    },
  });
}

/**
 * @summary Sorts disciplines
 * {@link /api/projects/:project_id/disciplines/sort}
 */
export function usePostApiProjectsProjectIdDisciplinesSort<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdDisciplinesSortMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdDisciplinesSort401Schema
        | PostApiProjectsProjectIdDisciplinesSort403Schema
        | PostApiProjectsProjectIdDisciplinesSort404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdDisciplinesSortPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdDisciplinesSortMutationKey();

  const baseOptions = postApiProjectsProjectIdDisciplinesSortMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdDisciplinesSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDisciplinesSort401Schema
      | PostApiProjectsProjectIdDisciplinesSort403Schema
      | PostApiProjectsProjectIdDisciplinesSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDisciplinesSortPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdDisciplinesSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDisciplinesSort401Schema
      | PostApiProjectsProjectIdDisciplinesSort403Schema
      | PostApiProjectsProjectIdDisciplinesSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDisciplinesSortPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdDisciplinesSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDisciplinesSort401Schema
      | PostApiProjectsProjectIdDisciplinesSort403Schema
      | PostApiProjectsProjectIdDisciplinesSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDisciplinesSortPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdDocumentsMutationKey = () =>
  [{ url: "/api/projects/:project_id/documents" }] as const;

export type PostApiProjectsProjectIdDocumentsMutationKey = ReturnType<
  typeof postApiProjectsProjectIdDocumentsMutationKey
>;

export function postApiProjectsProjectIdDocumentsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdDocumentsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdDocumentsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDocuments400Schema
      | PostApiProjectsProjectIdDocuments401Schema
      | PostApiProjectsProjectIdDocuments403Schema
      | PostApiProjectsProjectIdDocuments404Schema
      | PostApiProjectsProjectIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDocumentsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdDocumentsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdDocuments(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a document
 * {@link /api/projects/:project_id/documents}
 */
export function usePostApiProjectsProjectIdDocuments<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdDocuments400Schema
        | PostApiProjectsProjectIdDocuments401Schema
        | PostApiProjectsProjectIdDocuments403Schema
        | PostApiProjectsProjectIdDocuments404Schema
        | PostApiProjectsProjectIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdDocumentsPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdDocumentsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdDocumentsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdDocumentsMutationKey();

  const baseOptions = postApiProjectsProjectIdDocumentsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDocuments400Schema
      | PostApiProjectsProjectIdDocuments401Schema
      | PostApiProjectsProjectIdDocuments403Schema
      | PostApiProjectsProjectIdDocuments404Schema
      | PostApiProjectsProjectIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDocumentsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdDocumentsMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDocuments400Schema
      | PostApiProjectsProjectIdDocuments401Schema
      | PostApiProjectsProjectIdDocuments403Schema
      | PostApiProjectsProjectIdDocuments404Schema
      | PostApiProjectsProjectIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDocumentsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdDocumentsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDocuments400Schema
      | PostApiProjectsProjectIdDocuments401Schema
      | PostApiProjectsProjectIdDocuments403Schema
      | PostApiProjectsProjectIdDocuments404Schema
      | PostApiProjectsProjectIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdDocumentsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdDocumentsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdDocumentsDocumentIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/documents/:document_id" }] as const;

export type PatchApiProjectsProjectIdDocumentsDocumentIdMutationKey =
  ReturnType<typeof patchApiProjectsProjectIdDocumentsDocumentIdMutationKey>;

export function patchApiProjectsProjectIdDocumentsDocumentIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = patchApiProjectsProjectIdDocumentsDocumentIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdDocumentsDocumentId401Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId403Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId404Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"];
      documentId: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"];
      data?: PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, documentId, data }) => {
      return patchApiProjectsProjectIdDocumentsDocumentId(
        projectId,
        documentId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a document
 * {@link /api/projects/:project_id/documents/:document_id}
 */
export function usePatchApiProjectsProjectIdDocumentsDocumentId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdDocumentsDocumentId401Schema
        | PatchApiProjectsProjectIdDocumentsDocumentId403Schema
        | PatchApiProjectsProjectIdDocumentsDocumentId404Schema
        | PatchApiProjectsProjectIdDocumentsDocumentId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"];
        documentId: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"];
        data?: PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdDocumentsDocumentIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdDocumentsDocumentIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdDocumentsDocumentId401Schema
        | PatchApiProjectsProjectIdDocumentsDocumentId403Schema
        | PatchApiProjectsProjectIdDocumentsDocumentId404Schema
        | PatchApiProjectsProjectIdDocumentsDocumentId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"];
        documentId: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"];
        data?: PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdDocumentsDocumentId401Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId403Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId404Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"];
      documentId: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"];
      data?: PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdDocumentsDocumentId401Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId403Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId404Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"];
      documentId: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"];
      data?: PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdDocumentsDocumentIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/documents/:document_id" }] as const;

export type DeleteApiProjectsProjectIdDocumentsDocumentIdMutationKey =
  ReturnType<typeof deleteApiProjectsProjectIdDocumentsDocumentIdMutationKey>;

export function deleteApiProjectsProjectIdDocumentsDocumentIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdDocumentsDocumentIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdDocumentsDocumentId401Schema
      | DeleteApiProjectsProjectIdDocumentsDocumentId403Schema
      | DeleteApiProjectsProjectIdDocumentsDocumentId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"];
      documentId: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, documentId }) => {
      return deleteApiProjectsProjectIdDocumentsDocumentId(
        projectId,
        documentId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a document
 * {@link /api/projects/:project_id/documents/:document_id}
 */
export function useDeleteApiProjectsProjectIdDocumentsDocumentId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdDocumentsDocumentId401Schema
        | DeleteApiProjectsProjectIdDocumentsDocumentId403Schema
        | DeleteApiProjectsProjectIdDocumentsDocumentId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"];
        documentId: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdDocumentsDocumentIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdDocumentsDocumentIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdDocumentsDocumentId401Schema
        | DeleteApiProjectsProjectIdDocumentsDocumentId403Schema
        | DeleteApiProjectsProjectIdDocumentsDocumentId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"];
        documentId: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdDocumentsDocumentId401Schema
      | DeleteApiProjectsProjectIdDocumentsDocumentId403Schema
      | DeleteApiProjectsProjectIdDocumentsDocumentId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"];
      documentId: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdDocumentsDocumentId401Schema
      | DeleteApiProjectsProjectIdDocumentsDocumentId403Schema
      | DeleteApiProjectsProjectIdDocumentsDocumentId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["project_id"];
      documentId: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema["document_id"];
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/groups/:group_id/channel_configuration",
      },
    ] as const;

export type PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationKey
  >;

export function patchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"];
      groupId: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"];
      data?: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, groupId, data }) => {
      return patchApiProjectsProjectIdGroupsGroupIdChannelConfiguration(
        projectId,
        groupId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates the group channel configuration
 * {@link /api/projects/:project_id/groups/:group_id/channel_configuration}
 */
export function usePatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
        | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
        | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
        | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"];
        groupId: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"];
        data?: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
        | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
        | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
        | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"];
        groupId: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"];
        data?: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"];
      groupId: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"];
      data?: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["project_id"];
      groupId: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema["group_id"];
      data?: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdGroupsMutationKey = () =>
  [{ url: "/api/projects/:project_id/groups" }] as const;

export type PostApiProjectsProjectIdGroupsMutationKey = ReturnType<
  typeof postApiProjectsProjectIdGroupsMutationKey
>;

export function postApiProjectsProjectIdGroupsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdGroupsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdGroupsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdGroupsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdGroups400Schema
      | PostApiProjectsProjectIdGroups401Schema
      | PostApiProjectsProjectIdGroups403Schema
      | PostApiProjectsProjectIdGroups404Schema
      | PostApiProjectsProjectIdGroups422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdGroupsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdGroupsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdGroups(projectId, data, config);
    },
  });
}

/**
 * @description Authenticated user will be added automatically as a group member and admin of the group.
 * @summary Creates a group
 * {@link /api/projects/:project_id/groups}
 */
export function usePostApiProjectsProjectIdGroups<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdGroupsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdGroups400Schema
        | PostApiProjectsProjectIdGroups401Schema
        | PostApiProjectsProjectIdGroups403Schema
        | PostApiProjectsProjectIdGroups404Schema
        | PostApiProjectsProjectIdGroups422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdGroupsPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdGroupsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdGroupsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiProjectsProjectIdGroupsMutationKey();

  const baseOptions = postApiProjectsProjectIdGroupsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdGroupsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdGroups400Schema
      | PostApiProjectsProjectIdGroups401Schema
      | PostApiProjectsProjectIdGroups403Schema
      | PostApiProjectsProjectIdGroups404Schema
      | PostApiProjectsProjectIdGroups422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdGroupsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdGroupsMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdGroupsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdGroups400Schema
      | PostApiProjectsProjectIdGroups401Schema
      | PostApiProjectsProjectIdGroups403Schema
      | PostApiProjectsProjectIdGroups404Schema
      | PostApiProjectsProjectIdGroups422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdGroupsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdGroupsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdGroupsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdGroups400Schema
      | PostApiProjectsProjectIdGroups401Schema
      | PostApiProjectsProjectIdGroups403Schema
      | PostApiProjectsProjectIdGroups404Schema
      | PostApiProjectsProjectIdGroups422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdGroupsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdGroupsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdGroupsGroupIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/groups/:group_id" }] as const;

export type PatchApiProjectsProjectIdGroupsGroupIdMutationKey = ReturnType<
  typeof patchApiProjectsProjectIdGroupsGroupIdMutationKey
>;

export function patchApiProjectsProjectIdGroupsGroupIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = patchApiProjectsProjectIdGroupsGroupIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupId400Schema
      | PatchApiProjectsProjectIdGroupsGroupId401Schema
      | PatchApiProjectsProjectIdGroupsGroupId403Schema
      | PatchApiProjectsProjectIdGroupsGroupId404Schema
      | PatchApiProjectsProjectIdGroupsGroupId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"];
      groupId: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"];
      data?: PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, groupId, data }) => {
      return patchApiProjectsProjectIdGroupsGroupId(
        projectId,
        groupId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a group
 * {@link /api/projects/:project_id/groups/:group_id}
 */
export function usePatchApiProjectsProjectIdGroupsGroupId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdGroupsGroupId400Schema
        | PatchApiProjectsProjectIdGroupsGroupId401Schema
        | PatchApiProjectsProjectIdGroupsGroupId403Schema
        | PatchApiProjectsProjectIdGroupsGroupId404Schema
        | PatchApiProjectsProjectIdGroupsGroupId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"];
        groupId: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"];
        data?: PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdGroupsGroupIdMutationKey();

  const baseOptions = patchApiProjectsProjectIdGroupsGroupIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PatchApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupId400Schema
      | PatchApiProjectsProjectIdGroupsGroupId401Schema
      | PatchApiProjectsProjectIdGroupsGroupId403Schema
      | PatchApiProjectsProjectIdGroupsGroupId404Schema
      | PatchApiProjectsProjectIdGroupsGroupId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"];
      groupId: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"];
      data?: PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PatchApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupId400Schema
      | PatchApiProjectsProjectIdGroupsGroupId401Schema
      | PatchApiProjectsProjectIdGroupsGroupId403Schema
      | PatchApiProjectsProjectIdGroupsGroupId404Schema
      | PatchApiProjectsProjectIdGroupsGroupId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"];
      groupId: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"];
      data?: PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupId400Schema
      | PatchApiProjectsProjectIdGroupsGroupId401Schema
      | PatchApiProjectsProjectIdGroupsGroupId403Schema
      | PatchApiProjectsProjectIdGroupsGroupId404Schema
      | PatchApiProjectsProjectIdGroupsGroupId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"];
      groupId: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"];
      data?: PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdGroupsGroupIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/groups/:group_id" }] as const;

export type DeleteApiProjectsProjectIdGroupsGroupIdMutationKey = ReturnType<
  typeof deleteApiProjectsProjectIdGroupsGroupIdMutationKey
>;

export function deleteApiProjectsProjectIdGroupsGroupIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = deleteApiProjectsProjectIdGroupsGroupIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdGroupsGroupId401Schema
      | DeleteApiProjectsProjectIdGroupsGroupId403Schema
      | DeleteApiProjectsProjectIdGroupsGroupId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"];
      groupId: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, groupId }) => {
      return deleteApiProjectsProjectIdGroupsGroupId(
        projectId,
        groupId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a group
 * {@link /api/projects/:project_id/groups/:group_id}
 */
export function useDeleteApiProjectsProjectIdGroupsGroupId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdGroupsGroupId401Schema
        | DeleteApiProjectsProjectIdGroupsGroupId403Schema
        | DeleteApiProjectsProjectIdGroupsGroupId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"];
        groupId: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdGroupsGroupIdMutationKey();

  const baseOptions = deleteApiProjectsProjectIdGroupsGroupIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdGroupsGroupId401Schema
      | DeleteApiProjectsProjectIdGroupsGroupId403Schema
      | DeleteApiProjectsProjectIdGroupsGroupId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"];
      groupId: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"];
    },
    TContext
  >;

  return useMutation<
    DeleteApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdGroupsGroupId401Schema
      | DeleteApiProjectsProjectIdGroupsGroupId403Schema
      | DeleteApiProjectsProjectIdGroupsGroupId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"];
      groupId: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdGroupsGroupId401Schema
      | DeleteApiProjectsProjectIdGroupsGroupId403Schema
      | DeleteApiProjectsProjectIdGroupsGroupId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema["project_id"];
      groupId: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema["group_id"];
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdGroupsGroupIdMembersMutationKey = () =>
  [{ url: "/api/projects/:project_id/groups/:group_id/members" }] as const;

export type PatchApiProjectsProjectIdGroupsGroupIdMembersMutationKey =
  ReturnType<typeof patchApiProjectsProjectIdGroupsGroupIdMembersMutationKey>;

export function patchApiProjectsProjectIdGroupsGroupIdMembersMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdGroupsGroupIdMembersMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdGroupsGroupIdMembersMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupIdMembers401Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers403Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers404Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema["project_id"];
      groupId: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema["group_id"];
      data?: PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, groupId, data }) => {
      return patchApiProjectsProjectIdGroupsGroupIdMembers(
        projectId,
        groupId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates group members
 * {@link /api/projects/:project_id/groups/:group_id/members}
 */
export function usePatchApiProjectsProjectIdGroupsGroupIdMembers<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdGroupsGroupIdMembersMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdGroupsGroupIdMembers401Schema
        | PatchApiProjectsProjectIdGroupsGroupIdMembers403Schema
        | PatchApiProjectsProjectIdGroupsGroupIdMembers404Schema
        | PatchApiProjectsProjectIdGroupsGroupIdMembers422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema["project_id"];
        groupId: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema["group_id"];
        data?: PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdGroupsGroupIdMembersMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdGroupsGroupIdMembersMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdGroupsGroupIdMembersMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdGroupsGroupIdMembers401Schema
        | PatchApiProjectsProjectIdGroupsGroupIdMembers403Schema
        | PatchApiProjectsProjectIdGroupsGroupIdMembers404Schema
        | PatchApiProjectsProjectIdGroupsGroupIdMembers422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema["project_id"];
        groupId: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema["group_id"];
        data?: PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdGroupsGroupIdMembersMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupIdMembers401Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers403Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers404Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema["project_id"];
      groupId: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema["group_id"];
      data?: PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdGroupsGroupIdMembersMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupIdMembers401Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers403Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers404Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema["project_id"];
      groupId: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema["group_id"];
      data?: PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdAssignmentsMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/assignments" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdIssuesIssueIdAssignmentsMutationKey
  >;

export function postApiProjectsProjectIdIssuesIssueIdAssignmentsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdAssignmentsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignments400Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdAssignments(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates an issue assignment
 * {@link /api/projects/:project_id/issues/:issue_id/assignments}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdAssignments<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdAssignments400Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignments401Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignments403Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignments404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdAssignmentsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdAssignmentsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdAssignments400Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignments401Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignments403Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignments404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignments400Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignments400Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/issues/:issue_id/assignments/:issue_assignment_id/accept",
      },
    ] as const;

export type PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationKey
  >;

export function postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["issue_id"];
      issueAssignmentId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["issue_assignment_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, issueAssignmentId }) => {
      return postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept(
        projectId,
        issueId,
        issueAssignmentId,
        config,
      );
    },
  });
}

/**
 * @summary Accepts issue assignment
 * {@link /api/projects/:project_id/issues/:issue_id/assignments/:issue_assignment_id/accept}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept401Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept403Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["issue_id"];
        issueAssignmentId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["issue_assignment_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept401Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept403Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["issue_id"];
        issueAssignmentId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["issue_assignment_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["issue_id"];
      issueAssignmentId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["issue_assignment_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["issue_id"];
      issueAssignmentId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema["issue_assignment_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/issues/:issue_id/assignments/:issue_assignment_id/reject",
      },
    ] as const;

export type PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationKey
  >;

export function postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["issue_id"];
      issueAssignmentId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["issue_assignment_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, issueAssignmentId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject(
        projectId,
        issueId,
        issueAssignmentId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Rejects issue assignment
 * {@link /api/projects/:project_id/issues/:issue_id/assignments/:issue_assignment_id/reject}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject401Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject403Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["issue_id"];
        issueAssignmentId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["issue_assignment_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject401Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject403Schema
        | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["issue_id"];
        issueAssignmentId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["issue_assignment_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["issue_id"];
      issueAssignmentId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["issue_assignment_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["issue_id"];
      issueAssignmentId: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema["issue_assignment_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/issues/:issue_id/document_references/:document_reference_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationKey
  >;

export function deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["issue_id"];
      documentReferenceId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, documentReferenceId }) => {
      return deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId(
        projectId,
        issueId,
        documentReferenceId,
        config,
      );
    },
  });
}

/**
 * @summary Removes a document from an issue
 * {@link /api/projects/:project_id/issues/:issue_id/document_references/:document_reference_id}
 */
export function useDeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId401Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId403Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["issue_id"];
        documentReferenceId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId401Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId403Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["issue_id"];
        documentReferenceId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["issue_id"];
      documentReferenceId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["issue_id"];
      documentReferenceId: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdDocumentsMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/documents" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationKey =
  ReturnType<typeof postApiProjectsProjectIdIssuesIssueIdDocumentsMutationKey>;

export function postApiProjectsProjectIdIssuesIssueIdDocumentsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdDocumentsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdDocuments400Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments403Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdDocuments(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Adds a document to an issue (from an upload or an existing document)
 * {@link /api/projects/:project_id/issues/:issue_id/documents}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdDocuments<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdDocuments400Schema
        | PostApiProjectsProjectIdIssuesIssueIdDocuments401Schema
        | PostApiProjectsProjectIdIssuesIssueIdDocuments403Schema
        | PostApiProjectsProjectIdIssuesIssueIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdDocumentsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdDocumentsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdDocuments400Schema
        | PostApiProjectsProjectIdIssuesIssueIdDocuments401Schema
        | PostApiProjectsProjectIdIssuesIssueIdDocuments403Schema
        | PostApiProjectsProjectIdIssuesIssueIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdDocuments400Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments403Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdDocuments400Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments403Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdIssueImagesMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/issue_images" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdIssuesIssueIdIssueImagesMutationKey
  >;

export function postApiProjectsProjectIdIssuesIssueIdIssueImagesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdIssueImagesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages400Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdIssueImages(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Deprecated: use /api/projects/{project_id}/issues/{issue_id}/documents
 * @summary Uploads an image (from an upload or an existing document)
 * {@link /api/projects/:project_id/issues/:issue_id/issue_images}
 * @deprecated
 */
export function usePostApiProjectsProjectIdIssuesIssueIdIssueImages<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdIssueImages400Schema
        | PostApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
        | PostApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
        | PostApiProjectsProjectIdIssuesIssueIdIssueImages422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdIssueImagesMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdIssueImagesMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdIssueImages400Schema
        | PostApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
        | PostApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
        | PostApiProjectsProjectIdIssuesIssueIdIssueImages422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages400Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages400Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/issues/:issue_id/issue_images/:issue_image_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationKey
  >;

export function deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_id"];
      issueImageId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_image_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, issueImageId }) => {
      return deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId(
        projectId,
        issueId,
        issueImageId,
        config,
      );
    },
  });
}

/**
 * @description Deprecated: use /api/projects/{project_id}/issues/{issue_id}/document_references/{document_reference_id}
 * @summary Removes an image from an issue
 * {@link /api/projects/:project_id/issues/:issue_id/issue_images/:issue_image_id}
 * @deprecated
 */
export function useDeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_id"];
        issueImageId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_image_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_id"];
        issueImageId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_image_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_id"];
      issueImageId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_image_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_id"];
      issueImageId: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_image_id"];
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/issues/:issue_id/issue_images/:issue_image_id",
      },
    ] as const;

export type PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationKey
  >;

export function patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["project_id"];
      issueId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_id"];
      issueImageId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_image_id"];
      data?: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, issueImageId, data }) => {
      return patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId(
        projectId,
        issueId,
        issueImageId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Deprecated: use /api/projects/{project_id}/documents/{document_id}
 * @summary Updates an image
 * {@link /api/projects/:project_id/issues/:issue_id/issue_images/:issue_image_id}
 * @deprecated
 */
export function usePatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
        | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
        | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["project_id"];
        issueId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_id"];
        issueImageId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_image_id"];
        data?: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
        | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
        | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["project_id"];
        issueId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_id"];
        issueImageId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_image_id"];
        data?: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["project_id"];
      issueId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_id"];
      issueImageId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_image_id"];
      data?: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["project_id"];
      issueId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_id"];
      issueImageId: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema["issue_image_id"];
      data?: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesSmartIssuesMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/smart_issues" }] as const;

export type PostApiProjectsProjectIdIssuesSmartIssuesMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesSmartIssuesMutationKey
>;

export function postApiProjectsProjectIdIssuesSmartIssuesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdIssuesSmartIssuesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesSmartIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesSmartIssues401Schema
      | PostApiProjectsProjectIdIssuesSmartIssues403Schema
      | PostApiProjectsProjectIdIssuesSmartIssues404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesSmartIssuesPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdIssuesSmartIssues(projectId, data, config);
    },
  });
}

/**
 * @summary Request smart issue
 * {@link /api/projects/:project_id/issues/smart_issues}
 */
export function usePostApiProjectsProjectIdIssuesSmartIssues<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesSmartIssuesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesSmartIssues401Schema
        | PostApiProjectsProjectIdIssuesSmartIssues403Schema
        | PostApiProjectsProjectIdIssuesSmartIssues404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesSmartIssuesPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesSmartIssuesMutationKey();

  const baseOptions = postApiProjectsProjectIdIssuesSmartIssuesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdIssuesSmartIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesSmartIssues401Schema
      | PostApiProjectsProjectIdIssuesSmartIssues403Schema
      | PostApiProjectsProjectIdIssuesSmartIssues404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesSmartIssuesPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdIssuesSmartIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesSmartIssues401Schema
      | PostApiProjectsProjectIdIssuesSmartIssues403Schema
      | PostApiProjectsProjectIdIssuesSmartIssues404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesSmartIssuesPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesSmartIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesSmartIssues401Schema
      | PostApiProjectsProjectIdIssuesSmartIssues403Schema
      | PostApiProjectsProjectIdIssuesSmartIssues404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesSmartIssuesPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdApproveMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/approve" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdApproveMutationKey =
  ReturnType<typeof postApiProjectsProjectIdIssuesIssueIdApproveMutationKey>;

export function postApiProjectsProjectIdIssuesIssueIdApproveMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiProjectsProjectIdIssuesIssueIdApproveMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdApproveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdApprove400Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove401Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove403Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return postApiProjectsProjectIdIssuesIssueIdApprove(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Approves an issue
 * {@link /api/projects/:project_id/issues/:issue_id/approve}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdApprove<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdApproveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdApprove400Schema
        | PostApiProjectsProjectIdIssuesIssueIdApprove401Schema
        | PostApiProjectsProjectIdIssuesIssueIdApprove403Schema
        | PostApiProjectsProjectIdIssuesIssueIdApprove404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdApproveMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdApproveMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdApproveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdApprove400Schema
        | PostApiProjectsProjectIdIssuesIssueIdApprove401Schema
        | PostApiProjectsProjectIdIssuesIssueIdApprove403Schema
        | PostApiProjectsProjectIdIssuesIssueIdApprove404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema["issue_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdApproveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdApprove400Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove401Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove403Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdApproveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdApprove400Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove401Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove403Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdCompleteMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/complete" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdCompleteMutationKey =
  ReturnType<typeof postApiProjectsProjectIdIssuesIssueIdCompleteMutationKey>;

export function postApiProjectsProjectIdIssuesIssueIdCompleteMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdCompleteMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdCompleteMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdComplete400Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete401Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete403Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return postApiProjectsProjectIdIssuesIssueIdComplete(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Updates an issue to completed
 * {@link /api/projects/:project_id/issues/:issue_id/complete}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdComplete<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdCompleteMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdComplete400Schema
        | PostApiProjectsProjectIdIssuesIssueIdComplete401Schema
        | PostApiProjectsProjectIdIssuesIssueIdComplete403Schema
        | PostApiProjectsProjectIdIssuesIssueIdComplete404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdCompleteMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdCompleteMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdCompleteMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdComplete400Schema
        | PostApiProjectsProjectIdIssuesIssueIdComplete401Schema
        | PostApiProjectsProjectIdIssuesIssueIdComplete403Schema
        | PostApiProjectsProjectIdIssuesIssueIdComplete404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema["issue_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdCompleteMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdComplete400Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete401Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete403Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdCompleteMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdComplete400Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete401Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete403Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdRejectMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/reject" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdRejectMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesIssueIdRejectMutationKey
>;

export function postApiProjectsProjectIdIssuesIssueIdRejectMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdIssuesIssueIdRejectMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdReject400Schema
      | PostApiProjectsProjectIdIssuesIssueIdReject401Schema
      | PostApiProjectsProjectIdIssuesIssueIdReject404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdReject(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Rejects an issue
 * {@link /api/projects/:project_id/issues/:issue_id/reject}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdReject<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdRejectMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdReject400Schema
        | PostApiProjectsProjectIdIssuesIssueIdReject401Schema
        | PostApiProjectsProjectIdIssuesIssueIdReject404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdRejectMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdRejectMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdRejectMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdReject400Schema
        | PostApiProjectsProjectIdIssuesIssueIdReject401Schema
        | PostApiProjectsProjectIdIssuesIssueIdReject404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdReject400Schema
      | PostApiProjectsProjectIdIssuesIssueIdReject401Schema
      | PostApiProjectsProjectIdIssuesIssueIdReject404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdReject400Schema
      | PostApiProjectsProjectIdIssuesIssueIdReject401Schema
      | PostApiProjectsProjectIdIssuesIssueIdReject404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdReopenMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/reopen" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdReopenMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesIssueIdReopenMutationKey
>;

export function postApiProjectsProjectIdIssuesIssueIdReopenMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiProjectsProjectIdIssuesIssueIdReopenMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdReopenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdReopen400Schema
      | PostApiProjectsProjectIdIssuesIssueIdReopen401Schema
      | PostApiProjectsProjectIdIssuesIssueIdReopen404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return postApiProjectsProjectIdIssuesIssueIdReopen(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Reopens an resolved issue
 * {@link /api/projects/:project_id/issues/:issue_id/reopen}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdReopen<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdReopenMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdReopen400Schema
        | PostApiProjectsProjectIdIssuesIssueIdReopen401Schema
        | PostApiProjectsProjectIdIssuesIssueIdReopen404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdReopenMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdReopenMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdReopenMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdReopen400Schema
        | PostApiProjectsProjectIdIssuesIssueIdReopen401Schema
        | PostApiProjectsProjectIdIssuesIssueIdReopen404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema["issue_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdReopenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdReopen400Schema
      | PostApiProjectsProjectIdIssuesIssueIdReopen401Schema
      | PostApiProjectsProjectIdIssuesIssueIdReopen404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdReopenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdReopen400Schema
      | PostApiProjectsProjectIdIssuesIssueIdReopen401Schema
      | PostApiProjectsProjectIdIssuesIssueIdReopen404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdStartMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/start" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdStartMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesIssueIdStartMutationKey
>;

export function postApiProjectsProjectIdIssuesIssueIdStartMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiProjectsProjectIdIssuesIssueIdStartMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdStartMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStart400Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return postApiProjectsProjectIdIssuesIssueIdStart(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Updates an issue to in_progress
 * {@link /api/projects/:project_id/issues/:issue_id/start}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdStart<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdStartMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdStart400Schema
        | PostApiProjectsProjectIdIssuesIssueIdStart401Schema
        | PostApiProjectsProjectIdIssuesIssueIdStart404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdStartMutationKey();

  const baseOptions = postApiProjectsProjectIdIssuesIssueIdStartMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdStartMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStart400Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema["issue_id"];
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdStartMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStart400Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdStartMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStart400Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdStopMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/stop" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdStopMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesIssueIdStopMutationKey
>;

export function postApiProjectsProjectIdIssuesIssueIdStopMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiProjectsProjectIdIssuesIssueIdStopMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdStopMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStop400Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return postApiProjectsProjectIdIssuesIssueIdStop(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Updates an issue to assigned
 * {@link /api/projects/:project_id/issues/:issue_id/stop}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdStop<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdStopMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdStop400Schema
        | PostApiProjectsProjectIdIssuesIssueIdStop401Schema
        | PostApiProjectsProjectIdIssuesIssueIdStop404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdStopMutationKey();

  const baseOptions = postApiProjectsProjectIdIssuesIssueIdStopMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdStopMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStop400Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema["issue_id"];
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdStopMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStop400Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdStopMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStop400Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdSubmitMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/submit" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdSubmitMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesIssueIdSubmitMutationKey
>;

export function postApiProjectsProjectIdIssuesIssueIdSubmitMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiProjectsProjectIdIssuesIssueIdSubmitMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdSubmitMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdSubmit401Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit403Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit404Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return postApiProjectsProjectIdIssuesIssueIdSubmit(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Submits a draft issue
 * {@link /api/projects/:project_id/issues/:issue_id/submit}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdSubmit<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdSubmitMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdSubmit401Schema
        | PostApiProjectsProjectIdIssuesIssueIdSubmit403Schema
        | PostApiProjectsProjectIdIssuesIssueIdSubmit404Schema
        | PostApiProjectsProjectIdIssuesIssueIdSubmit422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdSubmitMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdSubmitMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdSubmitMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdSubmit401Schema
        | PostApiProjectsProjectIdIssuesIssueIdSubmit403Schema
        | PostApiProjectsProjectIdIssuesIssueIdSubmit404Schema
        | PostApiProjectsProjectIdIssuesIssueIdSubmit422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema["issue_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdSubmitMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdSubmit401Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit403Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit404Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdSubmitMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdSubmit401Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit403Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit404Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/issues/:issue_id/status_statements" },
    ] as const;

export type PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationKey
  >;

export function postApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdStatusStatements(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates an issue status statement
 * {@link /api/projects/:project_id/issues/:issue_id/status_statements}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdStatusStatements<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
        | PostApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
        | PostApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
        | PostApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
        | PostApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/issues/:issue_id/status_statements/:status_statement_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationKey
  >;

export function deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["issue_id"];
      statusStatementId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["status_statement_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, statusStatementId }) => {
      return deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId(
        projectId,
        issueId,
        statusStatementId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes an issue status statement
 * {@link /api/projects/:project_id/issues/:issue_id/status_statements/:status_statement_id}
 */
export function useDeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId401Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId403Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId404Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["issue_id"];
        statusStatementId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["status_statement_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId401Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId403Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId404Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["issue_id"];
        statusStatementId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["status_statement_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["issue_id"];
      statusStatementId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["status_statement_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["issue_id"];
      statusStatementId: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema["status_statement_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssueViewsMutationKey = () =>
  [{ url: "/api/projects/:project_id/issue_views" }] as const;

export type PostApiProjectsProjectIdIssueViewsMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssueViewsMutationKey
>;

export function postApiProjectsProjectIdIssueViewsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssueViewsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdIssueViewsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssueViewsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssueViews401Schema
      | PostApiProjectsProjectIdIssueViews403Schema
      | PostApiProjectsProjectIdIssueViews404Schema
      | PostApiProjectsProjectIdIssueViews422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdIssueViewsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdIssueViews(projectId, data, config);
    },
  });
}

/**
 * @summary Creates issue view
 * {@link /api/projects/:project_id/issue_views}
 */
export function usePostApiProjectsProjectIdIssueViews<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssueViewsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssueViews401Schema
        | PostApiProjectsProjectIdIssueViews403Schema
        | PostApiProjectsProjectIdIssueViews404Schema
        | PostApiProjectsProjectIdIssueViews422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdIssueViewsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssueViewsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssueViewsMutationKey();

  const baseOptions = postApiProjectsProjectIdIssueViewsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdIssueViewsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssueViews401Schema
      | PostApiProjectsProjectIdIssueViews403Schema
      | PostApiProjectsProjectIdIssueViews404Schema
      | PostApiProjectsProjectIdIssueViews422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdIssueViewsMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdIssueViewsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssueViews401Schema
      | PostApiProjectsProjectIdIssueViews403Schema
      | PostApiProjectsProjectIdIssueViews404Schema
      | PostApiProjectsProjectIdIssueViews422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdIssueViewsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssueViewsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssueViews401Schema
      | PostApiProjectsProjectIdIssueViews403Schema
      | PostApiProjectsProjectIdIssueViews404Schema
      | PostApiProjectsProjectIdIssueViews422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssueViewsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdIssueViewsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdIssueViewsIssueViewIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/issue_views/:issue_view_id" }] as const;

export type PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationKey =
  ReturnType<typeof patchApiProjectsProjectIdIssueViewsIssueViewIdMutationKey>;

export function patchApiProjectsProjectIdIssueViewsIssueViewIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdIssueViewsIssueViewIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssueViewsIssueViewId401Schema
      | PatchApiProjectsProjectIdIssueViewsIssueViewId404Schema
      | PatchApiProjectsProjectIdIssueViewsIssueViewId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["project_id"];
      issueViewId: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["issue_view_id"];
      data?: PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueViewId, data }) => {
      return patchApiProjectsProjectIdIssueViewsIssueViewId(
        projectId,
        issueViewId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates issue view
 * {@link /api/projects/:project_id/issue_views/:issue_view_id}
 */
export function usePatchApiProjectsProjectIdIssueViewsIssueViewId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdIssueViewsIssueViewId401Schema
        | PatchApiProjectsProjectIdIssueViewsIssueViewId404Schema
        | PatchApiProjectsProjectIdIssueViewsIssueViewId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["project_id"];
        issueViewId: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["issue_view_id"];
        data?: PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdIssueViewsIssueViewIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdIssueViewsIssueViewIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdIssueViewsIssueViewId401Schema
        | PatchApiProjectsProjectIdIssueViewsIssueViewId404Schema
        | PatchApiProjectsProjectIdIssueViewsIssueViewId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["project_id"];
        issueViewId: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["issue_view_id"];
        data?: PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssueViewsIssueViewId401Schema
      | PatchApiProjectsProjectIdIssueViewsIssueViewId404Schema
      | PatchApiProjectsProjectIdIssueViewsIssueViewId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["project_id"];
      issueViewId: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["issue_view_id"];
      data?: PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssueViewsIssueViewId401Schema
      | PatchApiProjectsProjectIdIssueViewsIssueViewId404Schema
      | PatchApiProjectsProjectIdIssueViewsIssueViewId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["project_id"];
      issueViewId: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["issue_view_id"];
      data?: PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdIssueViewsIssueViewIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/issue_views/:issue_view_id" }] as const;

export type DeleteApiProjectsProjectIdIssueViewsIssueViewIdMutationKey =
  ReturnType<typeof deleteApiProjectsProjectIdIssueViewsIssueViewIdMutationKey>;

export function deleteApiProjectsProjectIdIssueViewsIssueViewIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdIssueViewsIssueViewIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId401Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId403Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId404Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["project_id"];
      issueViewId: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["issue_view_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueViewId }) => {
      return deleteApiProjectsProjectIdIssueViewsIssueViewId(
        projectId,
        issueViewId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes an issue view
 * {@link /api/projects/:project_id/issue_views/:issue_view_id}
 */
export function useDeleteApiProjectsProjectIdIssueViewsIssueViewId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssueViewsIssueViewId401Schema
        | DeleteApiProjectsProjectIdIssueViewsIssueViewId403Schema
        | DeleteApiProjectsProjectIdIssueViewsIssueViewId404Schema
        | DeleteApiProjectsProjectIdIssueViewsIssueViewId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["project_id"];
        issueViewId: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["issue_view_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdIssueViewsIssueViewIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdIssueViewsIssueViewIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssueViewsIssueViewId401Schema
        | DeleteApiProjectsProjectIdIssueViewsIssueViewId403Schema
        | DeleteApiProjectsProjectIdIssueViewsIssueViewId404Schema
        | DeleteApiProjectsProjectIdIssueViewsIssueViewId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["project_id"];
        issueViewId: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["issue_view_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId401Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId403Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId404Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["project_id"];
      issueViewId: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["issue_view_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId401Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId403Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId404Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["project_id"];
      issueViewId: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema["issue_view_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdVisitMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/visit" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdVisitMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesIssueIdVisitMutationKey
>;

export function postApiProjectsProjectIdIssuesIssueIdVisitMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiProjectsProjectIdIssuesIssueIdVisitMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdVisitMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdVisit401Schema
      | PostApiProjectsProjectIdIssuesIssueIdVisit403Schema
      | PostApiProjectsProjectIdIssuesIssueIdVisit404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return postApiProjectsProjectIdIssuesIssueIdVisit(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Saves issue visit
 * {@link /api/projects/:project_id/issues/:issue_id/visit}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdVisit<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdVisitMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdVisit401Schema
        | PostApiProjectsProjectIdIssuesIssueIdVisit403Schema
        | PostApiProjectsProjectIdIssuesIssueIdVisit404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdVisitMutationKey();

  const baseOptions = postApiProjectsProjectIdIssuesIssueIdVisitMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdVisitMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdVisit401Schema
      | PostApiProjectsProjectIdIssuesIssueIdVisit403Schema
      | PostApiProjectsProjectIdIssuesIssueIdVisit404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"];
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdVisitMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdVisit401Schema
      | PostApiProjectsProjectIdIssuesIssueIdVisit403Schema
      | PostApiProjectsProjectIdIssuesIssueIdVisit404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdVisitMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdVisit401Schema
      | PostApiProjectsProjectIdIssuesIssueIdVisit403Schema
      | PostApiProjectsProjectIdIssuesIssueIdVisit404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues" }] as const;

export type PostApiProjectsProjectIdIssuesMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesMutationKey
>;

export function postApiProjectsProjectIdIssuesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdIssuesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssues401Schema
      | PostApiProjectsProjectIdIssues403Schema
      | PostApiProjectsProjectIdIssues404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdIssuesMutationRequestSchema;
      headers?: PostApiProjectsProjectIdIssuesHeaderParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data, headers }) => {
      return postApiProjectsProjectIdIssues(projectId, data, headers, config);
    },
  });
}

/**
 * @summary Creates an issue
 * {@link /api/projects/:project_id/issues}
 */
export function usePostApiProjectsProjectIdIssues<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssues401Schema
        | PostApiProjectsProjectIdIssues403Schema
        | PostApiProjectsProjectIdIssues404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdIssuesMutationRequestSchema;
        headers?: PostApiProjectsProjectIdIssuesHeaderParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiProjectsProjectIdIssuesMutationKey();

  const baseOptions = postApiProjectsProjectIdIssuesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssues401Schema
      | PostApiProjectsProjectIdIssues403Schema
      | PostApiProjectsProjectIdIssues404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdIssuesMutationRequestSchema;
      headers?: PostApiProjectsProjectIdIssuesHeaderParamsSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssues401Schema
      | PostApiProjectsProjectIdIssues403Schema
      | PostApiProjectsProjectIdIssues404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdIssuesMutationRequestSchema;
      headers?: PostApiProjectsProjectIdIssuesHeaderParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssues401Schema
      | PostApiProjectsProjectIdIssues403Schema
      | PostApiProjectsProjectIdIssues404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdIssuesMutationRequestSchema;
      headers?: PostApiProjectsProjectIdIssuesHeaderParamsSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesExportMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/export" }] as const;

export type PostApiProjectsProjectIdIssuesExportMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesExportMutationKey
>;

export function postApiProjectsProjectIdIssuesExportMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiProjectsProjectIdIssuesExportMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesExport400Schema
      | PostApiProjectsProjectIdIssuesExport401Schema
      | PostApiProjectsProjectIdIssuesExport403Schema
      | PostApiProjectsProjectIdIssuesExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesExportPathParamsSchema["project_id"];
      params: PostApiProjectsProjectIdIssuesExportQueryParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, params }) => {
      return postApiProjectsProjectIdIssuesExport(projectId, params, config);
    },
  });
}

/**
 * @description Exporting to PDF is limited to 100 issues
 * @summary Requests issue list export
 * {@link /api/projects/:project_id/issues/export}
 */
export function usePostApiProjectsProjectIdIssuesExport<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesExport400Schema
        | PostApiProjectsProjectIdIssuesExport401Schema
        | PostApiProjectsProjectIdIssuesExport403Schema
        | PostApiProjectsProjectIdIssuesExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesExportPathParamsSchema["project_id"];
        params: PostApiProjectsProjectIdIssuesExportQueryParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesExportMutationKey();

  const baseOptions = postApiProjectsProjectIdIssuesExportMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdIssuesExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesExport400Schema
      | PostApiProjectsProjectIdIssuesExport401Schema
      | PostApiProjectsProjectIdIssuesExport403Schema
      | PostApiProjectsProjectIdIssuesExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesExportPathParamsSchema["project_id"];
      params: PostApiProjectsProjectIdIssuesExportQueryParamsSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdIssuesExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesExport400Schema
      | PostApiProjectsProjectIdIssuesExport401Schema
      | PostApiProjectsProjectIdIssuesExport403Schema
      | PostApiProjectsProjectIdIssuesExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesExportPathParamsSchema["project_id"];
      params: PostApiProjectsProjectIdIssuesExportQueryParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesExport400Schema
      | PostApiProjectsProjectIdIssuesExport401Schema
      | PostApiProjectsProjectIdIssuesExport403Schema
      | PostApiProjectsProjectIdIssuesExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesExportPathParamsSchema["project_id"];
      params: PostApiProjectsProjectIdIssuesExportQueryParamsSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesQuickIssuesMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/quick_issues" }] as const;

export type PostApiProjectsProjectIdIssuesQuickIssuesMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesQuickIssuesMutationKey
>;

export function postApiProjectsProjectIdIssuesQuickIssuesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdIssuesQuickIssuesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesQuickIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesQuickIssues400Schema
      | PostApiProjectsProjectIdIssuesQuickIssues401Schema
      | PostApiProjectsProjectIdIssuesQuickIssues403Schema
      | PostApiProjectsProjectIdIssuesQuickIssues404Schema
      | PostApiProjectsProjectIdIssuesQuickIssues422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesQuickIssuesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema;
      headers?: PostApiProjectsProjectIdIssuesQuickIssuesHeaderParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data, headers }) => {
      return postApiProjectsProjectIdIssuesQuickIssues(
        projectId,
        data,
        headers,
        config,
      );
    },
  });
}

/**
 * @summary Creates an issue and submits it
 * {@link /api/projects/:project_id/issues/quick_issues}
 */
export function usePostApiProjectsProjectIdIssuesQuickIssues<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesQuickIssuesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesQuickIssues400Schema
        | PostApiProjectsProjectIdIssuesQuickIssues401Schema
        | PostApiProjectsProjectIdIssuesQuickIssues403Schema
        | PostApiProjectsProjectIdIssuesQuickIssues404Schema
        | PostApiProjectsProjectIdIssuesQuickIssues422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesQuickIssuesPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema;
        headers?: PostApiProjectsProjectIdIssuesQuickIssuesHeaderParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesQuickIssuesMutationKey();

  const baseOptions = postApiProjectsProjectIdIssuesQuickIssuesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdIssuesQuickIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesQuickIssues400Schema
      | PostApiProjectsProjectIdIssuesQuickIssues401Schema
      | PostApiProjectsProjectIdIssuesQuickIssues403Schema
      | PostApiProjectsProjectIdIssuesQuickIssues404Schema
      | PostApiProjectsProjectIdIssuesQuickIssues422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesQuickIssuesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema;
      headers?: PostApiProjectsProjectIdIssuesQuickIssuesHeaderParamsSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdIssuesQuickIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesQuickIssues400Schema
      | PostApiProjectsProjectIdIssuesQuickIssues401Schema
      | PostApiProjectsProjectIdIssuesQuickIssues403Schema
      | PostApiProjectsProjectIdIssuesQuickIssues404Schema
      | PostApiProjectsProjectIdIssuesQuickIssues422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesQuickIssuesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema;
      headers?: PostApiProjectsProjectIdIssuesQuickIssuesHeaderParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesQuickIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesQuickIssues400Schema
      | PostApiProjectsProjectIdIssuesQuickIssues401Schema
      | PostApiProjectsProjectIdIssuesQuickIssues403Schema
      | PostApiProjectsProjectIdIssuesQuickIssues404Schema
      | PostApiProjectsProjectIdIssuesQuickIssues422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesQuickIssuesPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema;
      headers?: PostApiProjectsProjectIdIssuesQuickIssuesHeaderParamsSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdIssuesIssueIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id" }] as const;

export type PatchApiProjectsProjectIdIssuesIssueIdMutationKey = ReturnType<
  typeof patchApiProjectsProjectIdIssuesIssueIdMutationKey
>;

export function patchApiProjectsProjectIdIssuesIssueIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = patchApiProjectsProjectIdIssuesIssueIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueId401Schema
      | PatchApiProjectsProjectIdIssuesIssueId403Schema
      | PatchApiProjectsProjectIdIssuesIssueId404Schema
      | PatchApiProjectsProjectIdIssuesIssueId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"];
      issueId: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"];
      data?: PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return patchApiProjectsProjectIdIssuesIssueId(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates an issue
 * {@link /api/projects/:project_id/issues/:issue_id}
 */
export function usePatchApiProjectsProjectIdIssuesIssueId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdIssuesIssueId401Schema
        | PatchApiProjectsProjectIdIssuesIssueId403Schema
        | PatchApiProjectsProjectIdIssuesIssueId404Schema
        | PatchApiProjectsProjectIdIssuesIssueId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"];
        issueId: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"];
        data?: PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdIssuesIssueIdMutationKey();

  const baseOptions = patchApiProjectsProjectIdIssuesIssueIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PatchApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueId401Schema
      | PatchApiProjectsProjectIdIssuesIssueId403Schema
      | PatchApiProjectsProjectIdIssuesIssueId404Schema
      | PatchApiProjectsProjectIdIssuesIssueId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"];
      issueId: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"];
      data?: PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PatchApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueId401Schema
      | PatchApiProjectsProjectIdIssuesIssueId403Schema
      | PatchApiProjectsProjectIdIssuesIssueId404Schema
      | PatchApiProjectsProjectIdIssuesIssueId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"];
      issueId: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"];
      data?: PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueId401Schema
      | PatchApiProjectsProjectIdIssuesIssueId403Schema
      | PatchApiProjectsProjectIdIssuesIssueId404Schema
      | PatchApiProjectsProjectIdIssuesIssueId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"];
      issueId: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"];
      data?: PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdIssuesIssueIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id" }] as const;

export type DeleteApiProjectsProjectIdIssuesIssueIdMutationKey = ReturnType<
  typeof deleteApiProjectsProjectIdIssuesIssueIdMutationKey
>;

export function deleteApiProjectsProjectIdIssuesIssueIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = deleteApiProjectsProjectIdIssuesIssueIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueId400Schema
      | DeleteApiProjectsProjectIdIssuesIssueId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return deleteApiProjectsProjectIdIssuesIssueId(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes an issue
 * {@link /api/projects/:project_id/issues/:issue_id}
 */
export function useDeleteApiProjectsProjectIdIssuesIssueId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueId400Schema
        | DeleteApiProjectsProjectIdIssuesIssueId401Schema
        | DeleteApiProjectsProjectIdIssuesIssueId403Schema
        | DeleteApiProjectsProjectIdIssuesIssueId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdIssuesIssueIdMutationKey();

  const baseOptions = deleteApiProjectsProjectIdIssuesIssueIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueId400Schema
      | DeleteApiProjectsProjectIdIssuesIssueId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"];
    },
    TContext
  >;

  return useMutation<
    DeleteApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueId400Schema
      | DeleteApiProjectsProjectIdIssuesIssueId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueId400Schema
      | DeleteApiProjectsProjectIdIssuesIssueId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdArchiveMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/archive" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdArchiveMutationKey =
  ReturnType<typeof postApiProjectsProjectIdIssuesIssueIdArchiveMutationKey>;

export function postApiProjectsProjectIdIssuesIssueIdArchiveMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdIssuesIssueIdArchiveMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdArchive401Schema
      | PostApiProjectsProjectIdIssuesIssueIdArchive403Schema
      | PostApiProjectsProjectIdIssuesIssueIdArchive404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdArchive(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Archives an issue
 * {@link /api/projects/:project_id/issues/:issue_id/archive}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdArchive<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdArchive401Schema
        | PostApiProjectsProjectIdIssuesIssueIdArchive403Schema
        | PostApiProjectsProjectIdIssuesIssueIdArchive404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdArchiveMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdArchiveMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdArchive401Schema
        | PostApiProjectsProjectIdIssuesIssueIdArchive403Schema
        | PostApiProjectsProjectIdIssuesIssueIdArchive404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdArchive401Schema
      | PostApiProjectsProjectIdIssuesIssueIdArchive403Schema
      | PostApiProjectsProjectIdIssuesIssueIdArchive404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdArchive401Schema
      | PostApiProjectsProjectIdIssuesIssueIdArchive403Schema
      | PostApiProjectsProjectIdIssuesIssueIdArchive404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdExportMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/export" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdExportMutationKey = ReturnType<
  typeof postApiProjectsProjectIdIssuesIssueIdExportMutationKey
>;

export function postApiProjectsProjectIdIssuesIssueIdExportMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdIssuesIssueIdExportMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdExport401Schema
      | PostApiProjectsProjectIdIssuesIssueIdExport403Schema
      | PostApiProjectsProjectIdIssuesIssueIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdExport(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Requests issue export
 * {@link /api/projects/:project_id/issues/:issue_id/export}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdExport<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdExport401Schema
        | PostApiProjectsProjectIdIssuesIssueIdExport403Schema
        | PostApiProjectsProjectIdIssuesIssueIdExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdExportMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdExportMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdExport401Schema
        | PostApiProjectsProjectIdIssuesIssueIdExport403Schema
        | PostApiProjectsProjectIdIssuesIssueIdExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdExport401Schema
      | PostApiProjectsProjectIdIssuesIssueIdExport403Schema
      | PostApiProjectsProjectIdIssuesIssueIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdExport401Schema
      | PostApiProjectsProjectIdIssuesIssueIdExport403Schema
      | PostApiProjectsProjectIdIssuesIssueIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdRestoreMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/restore" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdRestoreMutationKey =
  ReturnType<typeof postApiProjectsProjectIdIssuesIssueIdRestoreMutationKey>;

export function postApiProjectsProjectIdIssuesIssueIdRestoreMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiProjectsProjectIdIssuesIssueIdRestoreMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdRestore401Schema
      | PostApiProjectsProjectIdIssuesIssueIdRestore403Schema
      | PostApiProjectsProjectIdIssuesIssueIdRestore404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return postApiProjectsProjectIdIssuesIssueIdRestore(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Restores an archived issue
 * {@link /api/projects/:project_id/issues/:issue_id/restore}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdRestore<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdRestoreMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdRestore401Schema
        | PostApiProjectsProjectIdIssuesIssueIdRestore403Schema
        | PostApiProjectsProjectIdIssuesIssueIdRestore404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdRestoreMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdRestoreMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdRestoreMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdRestore401Schema
        | PostApiProjectsProjectIdIssuesIssueIdRestore403Schema
        | PostApiProjectsProjectIdIssuesIssueIdRestore404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema["issue_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdRestore401Schema
      | PostApiProjectsProjectIdIssuesIssueIdRestore403Schema
      | PostApiProjectsProjectIdIssuesIssueIdRestore404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdRestore401Schema
      | PostApiProjectsProjectIdIssuesIssueIdRestore403Schema
      | PostApiProjectsProjectIdIssuesIssueIdRestore404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/issues/:issue_id/update_impact" },
    ] as const;

export type PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationKey
  >;

export function postApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact401Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact403Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact404Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdUpdateImpact(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates impact
 * {@link /api/projects/:project_id/issues/:issue_id/update_impact}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdUpdateImpact<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact401Schema
        | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact403Schema
        | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact404Schema
        | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact401Schema
        | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact403Schema
        | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact404Schema
        | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema["issue_id"];
        data?: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact401Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact403Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact404Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact401Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact403Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact404Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema["issue_id"];
      data?: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdLocationsMutationKey = () =>
  [{ url: "/api/projects/:project_id/locations" }] as const;

export type PostApiProjectsProjectIdLocationsMutationKey = ReturnType<
  typeof postApiProjectsProjectIdLocationsMutationKey
>;

export function postApiProjectsProjectIdLocationsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdLocationsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdLocationsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdLocationsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdLocations401Schema
      | PostApiProjectsProjectIdLocations403Schema
      | PostApiProjectsProjectIdLocations404Schema
      | PostApiProjectsProjectIdLocations422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdLocationsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdLocationsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdLocations(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a location
 * {@link /api/projects/:project_id/locations}
 */
export function usePostApiProjectsProjectIdLocations<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdLocationsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdLocations401Schema
        | PostApiProjectsProjectIdLocations403Schema
        | PostApiProjectsProjectIdLocations404Schema
        | PostApiProjectsProjectIdLocations422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdLocationsPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdLocationsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdLocationsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdLocationsMutationKey();

  const baseOptions = postApiProjectsProjectIdLocationsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdLocationsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdLocations401Schema
      | PostApiProjectsProjectIdLocations403Schema
      | PostApiProjectsProjectIdLocations404Schema
      | PostApiProjectsProjectIdLocations422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdLocationsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdLocationsMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdLocationsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdLocations401Schema
      | PostApiProjectsProjectIdLocations403Schema
      | PostApiProjectsProjectIdLocations404Schema
      | PostApiProjectsProjectIdLocations422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdLocationsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdLocationsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdLocationsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdLocations401Schema
      | PostApiProjectsProjectIdLocations403Schema
      | PostApiProjectsProjectIdLocations404Schema
      | PostApiProjectsProjectIdLocations422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdLocationsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdLocationsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdLocationsLocationIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/locations/:location_id" }] as const;

export type PatchApiProjectsProjectIdLocationsLocationIdMutationKey =
  ReturnType<typeof patchApiProjectsProjectIdLocationsLocationIdMutationKey>;

export function patchApiProjectsProjectIdLocationsLocationIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = patchApiProjectsProjectIdLocationsLocationIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdLocationsLocationId401Schema
      | PatchApiProjectsProjectIdLocationsLocationId403Schema
      | PatchApiProjectsProjectIdLocationsLocationId404Schema
      | PatchApiProjectsProjectIdLocationsLocationId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"];
      locationId: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"];
      data?: PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, locationId, data }) => {
      return patchApiProjectsProjectIdLocationsLocationId(
        projectId,
        locationId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a location
 * {@link /api/projects/:project_id/locations/:location_id}
 */
export function usePatchApiProjectsProjectIdLocationsLocationId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdLocationsLocationId401Schema
        | PatchApiProjectsProjectIdLocationsLocationId403Schema
        | PatchApiProjectsProjectIdLocationsLocationId404Schema
        | PatchApiProjectsProjectIdLocationsLocationId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"];
        locationId: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"];
        data?: PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdLocationsLocationIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdLocationsLocationIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdLocationsLocationId401Schema
        | PatchApiProjectsProjectIdLocationsLocationId403Schema
        | PatchApiProjectsProjectIdLocationsLocationId404Schema
        | PatchApiProjectsProjectIdLocationsLocationId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"];
        locationId: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"];
        data?: PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdLocationsLocationId401Schema
      | PatchApiProjectsProjectIdLocationsLocationId403Schema
      | PatchApiProjectsProjectIdLocationsLocationId404Schema
      | PatchApiProjectsProjectIdLocationsLocationId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"];
      locationId: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"];
      data?: PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdLocationsLocationId401Schema
      | PatchApiProjectsProjectIdLocationsLocationId403Schema
      | PatchApiProjectsProjectIdLocationsLocationId404Schema
      | PatchApiProjectsProjectIdLocationsLocationId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"];
      locationId: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"];
      data?: PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdLocationsLocationIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/locations/:location_id" }] as const;

export type DeleteApiProjectsProjectIdLocationsLocationIdMutationKey =
  ReturnType<typeof deleteApiProjectsProjectIdLocationsLocationIdMutationKey>;

export function deleteApiProjectsProjectIdLocationsLocationIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdLocationsLocationIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdLocationsLocationId401Schema
      | DeleteApiProjectsProjectIdLocationsLocationId403Schema
      | DeleteApiProjectsProjectIdLocationsLocationId404Schema
      | DeleteApiProjectsProjectIdLocationsLocationId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"];
      locationId: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, locationId }) => {
      return deleteApiProjectsProjectIdLocationsLocationId(
        projectId,
        locationId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a location
 * {@link /api/projects/:project_id/locations/:location_id}
 */
export function useDeleteApiProjectsProjectIdLocationsLocationId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdLocationsLocationId401Schema
        | DeleteApiProjectsProjectIdLocationsLocationId403Schema
        | DeleteApiProjectsProjectIdLocationsLocationId404Schema
        | DeleteApiProjectsProjectIdLocationsLocationId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"];
        locationId: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdLocationsLocationIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdLocationsLocationIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdLocationsLocationId401Schema
        | DeleteApiProjectsProjectIdLocationsLocationId403Schema
        | DeleteApiProjectsProjectIdLocationsLocationId404Schema
        | DeleteApiProjectsProjectIdLocationsLocationId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"];
        locationId: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdLocationsLocationId401Schema
      | DeleteApiProjectsProjectIdLocationsLocationId403Schema
      | DeleteApiProjectsProjectIdLocationsLocationId404Schema
      | DeleteApiProjectsProjectIdLocationsLocationId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"];
      locationId: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdLocationsLocationId401Schema
      | DeleteApiProjectsProjectIdLocationsLocationId403Schema
      | DeleteApiProjectsProjectIdLocationsLocationId404Schema
      | DeleteApiProjectsProjectIdLocationsLocationId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema["project_id"];
      locationId: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema["location_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdLocationsLocationIdSortMutationKey = () =>
  [{ url: "/api/projects/:project_id/locations/:location_id/sort" }] as const;

export type PostApiProjectsProjectIdLocationsLocationIdSortMutationKey =
  ReturnType<typeof postApiProjectsProjectIdLocationsLocationIdSortMutationKey>;

export function postApiProjectsProjectIdLocationsLocationIdSortMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdLocationsLocationIdSortMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdLocationsLocationIdSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdLocationsLocationIdSort401Schema
      | PostApiProjectsProjectIdLocationsLocationIdSort403Schema
      | PostApiProjectsProjectIdLocationsLocationIdSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema["project_id"];
      locationId: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema["location_id"];
      data?: PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, locationId, data }) => {
      return postApiProjectsProjectIdLocationsLocationIdSort(
        projectId,
        locationId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Sorts locations
 * {@link /api/projects/:project_id/locations/:location_id/sort}
 */
export function usePostApiProjectsProjectIdLocationsLocationIdSort<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdLocationsLocationIdSortMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdLocationsLocationIdSort401Schema
        | PostApiProjectsProjectIdLocationsLocationIdSort403Schema
        | PostApiProjectsProjectIdLocationsLocationIdSort404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema["project_id"];
        locationId: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema["location_id"];
        data?: PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdLocationsLocationIdSortMutationKey();

  const baseOptions =
    postApiProjectsProjectIdLocationsLocationIdSortMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdLocationsLocationIdSortMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdLocationsLocationIdSort401Schema
        | PostApiProjectsProjectIdLocationsLocationIdSort403Schema
        | PostApiProjectsProjectIdLocationsLocationIdSort404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema["project_id"];
        locationId: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema["location_id"];
        data?: PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdLocationsLocationIdSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdLocationsLocationIdSort401Schema
      | PostApiProjectsProjectIdLocationsLocationIdSort403Schema
      | PostApiProjectsProjectIdLocationsLocationIdSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema["project_id"];
      locationId: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema["location_id"];
      data?: PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdLocationsLocationIdSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdLocationsLocationIdSort401Schema
      | PostApiProjectsProjectIdLocationsLocationIdSort403Schema
      | PostApiProjectsProjectIdLocationsLocationIdSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema["project_id"];
      locationId: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema["location_id"];
      data?: PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiOrgsMutationKey = () => [{ url: "/api/orgs" }] as const;

export type PostApiOrgsMutationKey = ReturnType<typeof postApiOrgsMutationKey>;

export function postApiOrgsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiOrgsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {},
) {
  const mutationKey = postApiOrgsMutationKey();
  return mutationOptions<
    PostApiOrgsMutationResponseSchema,
    ResponseErrorConfig<
      PostApiOrgs400Schema | PostApiOrgs401Schema | PostApiOrgs422Schema
    >,
    { data?: PostApiOrgsMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiOrgs(data, config);
    },
  });
}

/**
 * @summary Creates an org
 * {@link /api/orgs}
 */
export function usePostApiOrgs<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiOrgsMutationResponseSchema,
      ResponseErrorConfig<
        PostApiOrgs400Schema | PostApiOrgs401Schema | PostApiOrgs422Schema
      >,
      { data?: PostApiOrgsMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiOrgsMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiOrgsMutationKey();

  const baseOptions = postApiOrgsMutationOptions(config) as UseMutationOptions<
    PostApiOrgsMutationResponseSchema,
    ResponseErrorConfig<
      PostApiOrgs400Schema | PostApiOrgs401Schema | PostApiOrgs422Schema
    >,
    { data?: PostApiOrgsMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiOrgsMutationResponseSchema,
    ResponseErrorConfig<
      PostApiOrgs400Schema | PostApiOrgs401Schema | PostApiOrgs422Schema
    >,
    { data?: PostApiOrgsMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiOrgsMutationResponseSchema,
    ResponseErrorConfig<
      PostApiOrgs400Schema | PostApiOrgs401Schema | PostApiOrgs422Schema
    >,
    { data?: PostApiOrgsMutationRequestSchema },
    TContext
  >;
}

export const patchApiOrgsOrgIdMutationKey = () =>
  [{ url: "/api/orgs/:org_id" }] as const;

export type PatchApiOrgsOrgIdMutationKey = ReturnType<
  typeof patchApiOrgsOrgIdMutationKey
>;

export function patchApiOrgsOrgIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PatchApiOrgsOrgIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {},
) {
  const mutationKey = patchApiOrgsOrgIdMutationKey();
  return mutationOptions<
    PatchApiOrgsOrgIdMutationResponseSchema,
    ResponseErrorConfig<PatchApiOrgsOrgId401Schema>,
    {
      orgId: PatchApiOrgsOrgIdPathParamsSchema["org_id"];
      data?: PatchApiOrgsOrgIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ orgId, data }) => {
      return patchApiOrgsOrgId(orgId, data, config);
    },
  });
}

/**
 * @summary Updates an org
 * {@link /api/orgs/:org_id}
 */
export function usePatchApiOrgsOrgId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiOrgsOrgIdMutationResponseSchema,
      ResponseErrorConfig<PatchApiOrgsOrgId401Schema>,
      {
        orgId: PatchApiOrgsOrgIdPathParamsSchema["org_id"];
        data?: PatchApiOrgsOrgIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PatchApiOrgsOrgIdMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? patchApiOrgsOrgIdMutationKey();

  const baseOptions = patchApiOrgsOrgIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PatchApiOrgsOrgIdMutationResponseSchema,
    ResponseErrorConfig<PatchApiOrgsOrgId401Schema>,
    {
      orgId: PatchApiOrgsOrgIdPathParamsSchema["org_id"];
      data?: PatchApiOrgsOrgIdMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PatchApiOrgsOrgIdMutationResponseSchema,
    ResponseErrorConfig<PatchApiOrgsOrgId401Schema>,
    {
      orgId: PatchApiOrgsOrgIdPathParamsSchema["org_id"];
      data?: PatchApiOrgsOrgIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiOrgsOrgIdMutationResponseSchema,
    ResponseErrorConfig<PatchApiOrgsOrgId401Schema>,
    {
      orgId: PatchApiOrgsOrgIdPathParamsSchema["org_id"];
      data?: PatchApiOrgsOrgIdMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiOrgsCheckDomainMutationKey = () =>
  [{ url: "/api/orgs/check_domain" }] as const;

export type PostApiOrgsCheckDomainMutationKey = ReturnType<
  typeof postApiOrgsCheckDomainMutationKey
>;

export function postApiOrgsCheckDomainMutationOptions<TContext = unknown>(
  config: Partial<
    RequestConfig<PostApiOrgsCheckDomainMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiOrgsCheckDomainMutationKey();
  return mutationOptions<
    PostApiOrgsCheckDomainMutationResponseSchema,
    ResponseErrorConfig<PostApiOrgsCheckDomain401Schema>,
    { data?: PostApiOrgsCheckDomainMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiOrgsCheckDomain(data, config);
    },
  });
}

/**
 * @summary Checks org domain
 * {@link /api/orgs/check_domain}
 */
export function usePostApiOrgsCheckDomain<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiOrgsCheckDomainMutationResponseSchema,
      ResponseErrorConfig<PostApiOrgsCheckDomain401Schema>,
      { data?: PostApiOrgsCheckDomainMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiOrgsCheckDomainMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiOrgsCheckDomainMutationKey();

  const baseOptions = postApiOrgsCheckDomainMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiOrgsCheckDomainMutationResponseSchema,
    ResponseErrorConfig<PostApiOrgsCheckDomain401Schema>,
    { data?: PostApiOrgsCheckDomainMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiOrgsCheckDomainMutationResponseSchema,
    ResponseErrorConfig<PostApiOrgsCheckDomain401Schema>,
    { data?: PostApiOrgsCheckDomainMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiOrgsCheckDomainMutationResponseSchema,
    ResponseErrorConfig<PostApiOrgsCheckDomain401Schema>,
    { data?: PostApiOrgsCheckDomainMutationRequestSchema },
    TContext
  >;
}

export const postApiOrgsOrgIdResendVerificationEmailMutationKey = () =>
  [{ url: "/api/orgs/:org_id/resend_verification_email" }] as const;

export type PostApiOrgsOrgIdResendVerificationEmailMutationKey = ReturnType<
  typeof postApiOrgsOrgIdResendVerificationEmailMutationKey
>;

export function postApiOrgsOrgIdResendVerificationEmailMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiOrgsOrgIdResendVerificationEmailMutationKey();
  return mutationOptions<
    PostApiOrgsOrgIdResendVerificationEmailMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiOrgsOrgIdResendVerificationEmail401Schema
      | PostApiOrgsOrgIdResendVerificationEmail403Schema
      | PostApiOrgsOrgIdResendVerificationEmail404Schema
    >,
    {
      orgId: PostApiOrgsOrgIdResendVerificationEmailPathParamsSchema["org_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ orgId }) => {
      return postApiOrgsOrgIdResendVerificationEmail(orgId, config);
    },
  });
}

/**
 * @summary Resends verification email
 * {@link /api/orgs/:org_id/resend_verification_email}
 */
export function usePostApiOrgsOrgIdResendVerificationEmail<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiOrgsOrgIdResendVerificationEmailMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiOrgsOrgIdResendVerificationEmail401Schema
        | PostApiOrgsOrgIdResendVerificationEmail403Schema
        | PostApiOrgsOrgIdResendVerificationEmail404Schema
      >,
      {
        orgId: PostApiOrgsOrgIdResendVerificationEmailPathParamsSchema["org_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiOrgsOrgIdResendVerificationEmailMutationKey();

  const baseOptions = postApiOrgsOrgIdResendVerificationEmailMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiOrgsOrgIdResendVerificationEmailMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiOrgsOrgIdResendVerificationEmail401Schema
      | PostApiOrgsOrgIdResendVerificationEmail403Schema
      | PostApiOrgsOrgIdResendVerificationEmail404Schema
    >,
    {
      orgId: PostApiOrgsOrgIdResendVerificationEmailPathParamsSchema["org_id"];
    },
    TContext
  >;

  return useMutation<
    PostApiOrgsOrgIdResendVerificationEmailMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiOrgsOrgIdResendVerificationEmail401Schema
      | PostApiOrgsOrgIdResendVerificationEmail403Schema
      | PostApiOrgsOrgIdResendVerificationEmail404Schema
    >,
    {
      orgId: PostApiOrgsOrgIdResendVerificationEmailPathParamsSchema["org_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiOrgsOrgIdResendVerificationEmailMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiOrgsOrgIdResendVerificationEmail401Schema
      | PostApiOrgsOrgIdResendVerificationEmail403Schema
      | PostApiOrgsOrgIdResendVerificationEmail404Schema
    >,
    {
      orgId: PostApiOrgsOrgIdResendVerificationEmailPathParamsSchema["org_id"];
    },
    TContext
  >;
}

export const postApiPowerSyncTokenMutationKey = () =>
  [{ url: "/api/power_sync/token" }] as const;

export type PostApiPowerSyncTokenMutationKey = ReturnType<
  typeof postApiPowerSyncTokenMutationKey
>;

export function postApiPowerSyncTokenMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiPowerSyncTokenMutationKey();
  return mutationOptions<
    PostApiPowerSyncTokenMutationResponseSchema,
    ResponseErrorConfig<PostApiPowerSyncToken401Schema>,
    void,
    TContext
  >({
    mutationKey,
    mutationFn: async () => {
      return postApiPowerSyncToken(config);
    },
  });
}

/**
 * @summary Creates a PowerSync authentication token
 * {@link /api/power_sync/token}
 */
export function usePostApiPowerSyncToken<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiPowerSyncTokenMutationResponseSchema,
      ResponseErrorConfig<PostApiPowerSyncToken401Schema>,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiPowerSyncTokenMutationKey();

  const baseOptions = postApiPowerSyncTokenMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiPowerSyncTokenMutationResponseSchema,
    ResponseErrorConfig<PostApiPowerSyncToken401Schema>,
    void,
    TContext
  >;

  return useMutation<
    PostApiPowerSyncTokenMutationResponseSchema,
    ResponseErrorConfig<PostApiPowerSyncToken401Schema>,
    void,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiPowerSyncTokenMutationResponseSchema,
    ResponseErrorConfig<PostApiPowerSyncToken401Schema>,
    void,
    TContext
  >;
}

export const deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/progress_logs/:progress_log_id/document_references/:document_reference_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationKey
  >;

export function deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      progressLogId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["progress_log_id"];
      documentReferenceId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, progressLogId, documentReferenceId }) => {
      return deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId(
        projectId,
        progressLogId,
        documentReferenceId,
        config,
      );
    },
  });
}

/**
 * @summary Removes a document from a progress log
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id/document_references/:document_reference_id}
 */
export function useDeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId401Schema
        | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId403Schema
        | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
        progressLogId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["progress_log_id"];
        documentReferenceId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId401Schema
        | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId403Schema
        | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
        progressLogId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["progress_log_id"];
        documentReferenceId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      progressLogId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["progress_log_id"];
      documentReferenceId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      progressLogId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["progress_log_id"];
      documentReferenceId: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/progress_logs/:progress_log_id/documents",
      },
    ] as const;

export type PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationKey
  >;

export function postApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"];
      progressLogId: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"];
      data?: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, progressLogId, data }) => {
      return postApiProjectsProjectIdProgressLogsProgressLogIdDocuments(
        projectId,
        progressLogId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Adds a document to a progress log (from an upload or an existing document)
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id/documents}
 */
export function usePostApiProjectsProjectIdProgressLogsProgressLogIdDocuments<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
        | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
        | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
        | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"];
        progressLogId: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"];
        data?: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
        | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
        | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
        | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"];
        progressLogId: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"];
        data?: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"];
      progressLogId: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"];
      data?: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["project_id"];
      progressLogId: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema["progress_log_id"];
      data?: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdProgressLogsMutationKey = () =>
  [{ url: "/api/projects/:project_id/progress_logs" }] as const;

export type PostApiProjectsProjectIdProgressLogsMutationKey = ReturnType<
  typeof postApiProjectsProjectIdProgressLogsMutationKey
>;

export function postApiProjectsProjectIdProgressLogsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdProgressLogsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdProgressLogsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdProgressLogsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdProgressLogs401Schema
      | PostApiProjectsProjectIdProgressLogs404Schema
      | PostApiProjectsProjectIdProgressLogs422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdProgressLogsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdProgressLogs(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a progress log
 * {@link /api/projects/:project_id/progress_logs}
 */
export function usePostApiProjectsProjectIdProgressLogs<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdProgressLogsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdProgressLogs401Schema
        | PostApiProjectsProjectIdProgressLogs404Schema
        | PostApiProjectsProjectIdProgressLogs422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdProgressLogsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdProgressLogsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdProgressLogsMutationKey();

  const baseOptions = postApiProjectsProjectIdProgressLogsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdProgressLogsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdProgressLogs401Schema
      | PostApiProjectsProjectIdProgressLogs404Schema
      | PostApiProjectsProjectIdProgressLogs422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdProgressLogsMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdProgressLogsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdProgressLogs401Schema
      | PostApiProjectsProjectIdProgressLogs404Schema
      | PostApiProjectsProjectIdProgressLogs422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdProgressLogsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdProgressLogsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdProgressLogs401Schema
      | PostApiProjectsProjectIdProgressLogs404Schema
      | PostApiProjectsProjectIdProgressLogs422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdProgressLogsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdProgressLogsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdProgressLogsProgressLogIdMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/progress_logs/:progress_log_id" },
    ] as const;

export type PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdProgressLogsProgressLogIdMutationKey
  >;

export function patchApiProjectsProjectIdProgressLogsProgressLogIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdProgressLogsProgressLogIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdProgressLogsProgressLogId401Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId403Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId404Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"];
      progressLogId: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"];
      data?: PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, progressLogId, data }) => {
      return patchApiProjectsProjectIdProgressLogsProgressLogId(
        projectId,
        progressLogId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a progress log
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id}
 */
export function usePatchApiProjectsProjectIdProgressLogsProgressLogId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdProgressLogsProgressLogId401Schema
        | PatchApiProjectsProjectIdProgressLogsProgressLogId403Schema
        | PatchApiProjectsProjectIdProgressLogsProgressLogId404Schema
        | PatchApiProjectsProjectIdProgressLogsProgressLogId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"];
        progressLogId: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"];
        data?: PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdProgressLogsProgressLogIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdProgressLogsProgressLogIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdProgressLogsProgressLogId401Schema
        | PatchApiProjectsProjectIdProgressLogsProgressLogId403Schema
        | PatchApiProjectsProjectIdProgressLogsProgressLogId404Schema
        | PatchApiProjectsProjectIdProgressLogsProgressLogId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"];
        progressLogId: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"];
        data?: PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdProgressLogsProgressLogId401Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId403Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId404Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"];
      progressLogId: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"];
      data?: PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdProgressLogsProgressLogId401Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId403Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId404Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["project_id"];
      progressLogId: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema["progress_log_id"];
      data?: PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdAccessRequestsMutationKey = () =>
  [{ url: "/api/projects/:project_id/access_requests" }] as const;

export type PostApiProjectsProjectIdAccessRequestsMutationKey = ReturnType<
  typeof postApiProjectsProjectIdAccessRequestsMutationKey
>;

export function postApiProjectsProjectIdAccessRequestsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdAccessRequestsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdAccessRequestsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdAccessRequestsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequests400Schema
      | PostApiProjectsProjectIdAccessRequests401Schema
      | PostApiProjectsProjectIdAccessRequests404Schema
      | PostApiProjectsProjectIdAccessRequests422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdAccessRequestsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdAccessRequests(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a project access request
 * {@link /api/projects/:project_id/access_requests}
 */
export function usePostApiProjectsProjectIdAccessRequests<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdAccessRequestsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdAccessRequests400Schema
        | PostApiProjectsProjectIdAccessRequests401Schema
        | PostApiProjectsProjectIdAccessRequests404Schema
        | PostApiProjectsProjectIdAccessRequests422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdAccessRequestsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdAccessRequestsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdAccessRequestsMutationKey();

  const baseOptions = postApiProjectsProjectIdAccessRequestsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdAccessRequestsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequests400Schema
      | PostApiProjectsProjectIdAccessRequests401Schema
      | PostApiProjectsProjectIdAccessRequests404Schema
      | PostApiProjectsProjectIdAccessRequests422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdAccessRequestsMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdAccessRequestsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequests400Schema
      | PostApiProjectsProjectIdAccessRequests401Schema
      | PostApiProjectsProjectIdAccessRequests404Schema
      | PostApiProjectsProjectIdAccessRequests422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdAccessRequestsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdAccessRequestsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequests400Schema
      | PostApiProjectsProjectIdAccessRequests401Schema
      | PostApiProjectsProjectIdAccessRequests404Schema
      | PostApiProjectsProjectIdAccessRequests422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdAccessRequestsMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/access_requests/:project_access_request_id/accept",
      },
    ] as const;

export type PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationKey
  >;

export function postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept404Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema["project_id"];
      projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema["project_access_request_id"];
      data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, projectAccessRequestId, data }) => {
      return postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept(
        projectId,
        projectAccessRequestId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Accepts a project access request
 * {@link /api/projects/:project_id/access_requests/:project_access_request_id/accept}
 */
export function usePostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept401Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept403Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept404Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema["project_id"];
        projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema["project_access_request_id"];
        data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationKey();

  const baseOptions =
    postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept401Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept403Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept404Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema["project_id"];
        projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema["project_access_request_id"];
        data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept404Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema["project_id"];
      projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema["project_access_request_id"];
      data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept404Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema["project_id"];
      projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema["project_access_request_id"];
      data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/access_requests/:project_access_request_id/reject",
      },
    ] as const;

export type PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationKey
  >;

export function postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema["project_id"];
      projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema["project_access_request_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, projectAccessRequestId }) => {
      return postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject(
        projectId,
        projectAccessRequestId,
        config,
      );
    },
  });
}

/**
 * @summary Rejects a project access request
 * {@link /api/projects/:project_id/access_requests/:project_access_request_id/reject}
 */
export function usePostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject401Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject403Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema["project_id"];
        projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema["project_access_request_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationKey();

  const baseOptions =
    postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject401Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject403Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema["project_id"];
        projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema["project_access_request_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema["project_id"];
      projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema["project_access_request_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema["project_id"];
      projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema["project_access_request_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/access_requests/:project_access_request_id/redirect",
      },
    ] as const;

export type PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationKey
  >;

export function postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect400Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema["project_id"];
      projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema["project_access_request_id"];
      data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, projectAccessRequestId, data }) => {
      return postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect(
        projectId,
        projectAccessRequestId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Redirects a project access request to another team
 * {@link /api/projects/:project_id/access_requests/:project_access_request_id/redirect}
 */
export function usePostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect400Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect401Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect403Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema["project_id"];
        projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema["project_access_request_id"];
        data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationKey();

  const baseOptions =
    postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect400Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect401Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect403Schema
        | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema["project_id"];
        projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema["project_access_request_id"];
        data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect400Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema["project_id"];
      projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema["project_access_request_id"];
      data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect400Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema["project_id"];
      projectAccessRequestId: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema["project_access_request_id"];
      data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/notifications/:notification_id/mark_read",
      },
    ] as const;

export type PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationKey
  >;

export function postApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead401Schema
      | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema["project_id"];
      notificationId: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema["notification_id"];
      data?: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, notificationId, data }) => {
      return postApiProjectsProjectIdNotificationsNotificationIdMarkRead(
        projectId,
        notificationId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Marks notification as read
 * {@link /api/projects/:project_id/notifications/:notification_id/mark_read}
 */
export function usePostApiProjectsProjectIdNotificationsNotificationIdMarkRead<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead401Schema
        | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema["project_id"];
        notificationId: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema["notification_id"];
        data?: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationKey();

  const baseOptions =
    postApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead401Schema
        | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema["project_id"];
        notificationId: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema["notification_id"];
        data?: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead401Schema
      | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema["project_id"];
      notificationId: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema["notification_id"];
      data?: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead401Schema
      | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema["project_id"];
      notificationId: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema["notification_id"];
      data?: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdNotificationsMarkAllReadMutationKey = () =>
  [{ url: "/api/projects/:project_id/notifications/mark_all_read" }] as const;

export type PostApiProjectsProjectIdNotificationsMarkAllReadMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdNotificationsMarkAllReadMutationKey
  >;

export function postApiProjectsProjectIdNotificationsMarkAllReadMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdNotificationsMarkAllReadMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdNotificationsMarkAllReadMutationResponseSchema,
    ResponseErrorConfig<PostApiProjectsProjectIdNotificationsMarkAllRead401Schema>,
    {
      projectId: PostApiProjectsProjectIdNotificationsMarkAllReadPathParamsSchema["project_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId }) => {
      return postApiProjectsProjectIdNotificationsMarkAllRead(
        projectId,
        config,
      );
    },
  });
}

/**
 * @summary Marks all notifications as read
 * {@link /api/projects/:project_id/notifications/mark_all_read}
 */
export function usePostApiProjectsProjectIdNotificationsMarkAllRead<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdNotificationsMarkAllReadMutationResponseSchema,
      ResponseErrorConfig<PostApiProjectsProjectIdNotificationsMarkAllRead401Schema>,
      {
        projectId: PostApiProjectsProjectIdNotificationsMarkAllReadPathParamsSchema["project_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdNotificationsMarkAllReadMutationKey();

  const baseOptions =
    postApiProjectsProjectIdNotificationsMarkAllReadMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdNotificationsMarkAllReadMutationResponseSchema,
      ResponseErrorConfig<PostApiProjectsProjectIdNotificationsMarkAllRead401Schema>,
      {
        projectId: PostApiProjectsProjectIdNotificationsMarkAllReadPathParamsSchema["project_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdNotificationsMarkAllReadMutationResponseSchema,
    ResponseErrorConfig<PostApiProjectsProjectIdNotificationsMarkAllRead401Schema>,
    {
      projectId: PostApiProjectsProjectIdNotificationsMarkAllReadPathParamsSchema["project_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdNotificationsMarkAllReadMutationResponseSchema,
    ResponseErrorConfig<PostApiProjectsProjectIdNotificationsMarkAllRead401Schema>,
    {
      projectId: PostApiProjectsProjectIdNotificationsMarkAllReadPathParamsSchema["project_id"];
    },
    TContext
  >;
}

export const postApiProjectsMutationKey = () =>
  [{ url: "/api/projects" }] as const;

export type PostApiProjectsMutationKey = ReturnType<
  typeof postApiProjectsMutationKey
>;

export function postApiProjectsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiProjectsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {},
) {
  const mutationKey = postApiProjectsMutationKey();
  return mutationOptions<
    PostApiProjectsMutationResponseSchema,
    ResponseErrorConfig<PostApiProjects401Schema | PostApiProjects403Schema>,
    { data?: PostApiProjectsMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiProjects(data, config);
    },
  });
}

/**
 * @summary Creates a project
 * {@link /api/projects}
 */
export function usePostApiProjects<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsMutationResponseSchema,
      ResponseErrorConfig<PostApiProjects401Schema | PostApiProjects403Schema>,
      { data?: PostApiProjectsMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiProjectsMutationRequestSchema>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiProjectsMutationKey();

  const baseOptions = postApiProjectsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsMutationResponseSchema,
    ResponseErrorConfig<PostApiProjects401Schema | PostApiProjects403Schema>,
    { data?: PostApiProjectsMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiProjectsMutationResponseSchema,
    ResponseErrorConfig<PostApiProjects401Schema | PostApiProjects403Schema>,
    { data?: PostApiProjectsMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsMutationResponseSchema,
    ResponseErrorConfig<PostApiProjects401Schema | PostApiProjects403Schema>,
    { data?: PostApiProjectsMutationRequestSchema },
    TContext
  >;
}

export const patchApiProjectsProjectIdMutationKey = () =>
  [{ url: "/api/projects/:project_id" }] as const;

export type PatchApiProjectsProjectIdMutationKey = ReturnType<
  typeof patchApiProjectsProjectIdMutationKey
>;

export function patchApiProjectsProjectIdMutationOptions<TContext = unknown>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = patchApiProjectsProjectIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectId401Schema
      | PatchApiProjectsProjectId403Schema
      | PatchApiProjectsProjectId404Schema
      | PatchApiProjectsProjectId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdPathParamsSchema["project_id"];
      data?: PatchApiProjectsProjectIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return patchApiProjectsProjectId(projectId, data, config);
    },
  });
}

/**
 * @summary Updates a project
 * {@link /api/projects/:project_id}
 */
export function usePatchApiProjectsProjectId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectId401Schema
        | PatchApiProjectsProjectId403Schema
        | PatchApiProjectsProjectId404Schema
        | PatchApiProjectsProjectId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdPathParamsSchema["project_id"];
        data?: PatchApiProjectsProjectIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? patchApiProjectsProjectIdMutationKey();

  const baseOptions = patchApiProjectsProjectIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PatchApiProjectsProjectIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectId401Schema
      | PatchApiProjectsProjectId403Schema
      | PatchApiProjectsProjectId404Schema
      | PatchApiProjectsProjectId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdPathParamsSchema["project_id"];
      data?: PatchApiProjectsProjectIdMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PatchApiProjectsProjectIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectId401Schema
      | PatchApiProjectsProjectId403Schema
      | PatchApiProjectsProjectId404Schema
      | PatchApiProjectsProjectId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdPathParamsSchema["project_id"];
      data?: PatchApiProjectsProjectIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectId401Schema
      | PatchApiProjectsProjectId403Schema
      | PatchApiProjectsProjectId404Schema
      | PatchApiProjectsProjectId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdPathParamsSchema["project_id"];
      data?: PatchApiProjectsProjectIdMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdArchiveMutationKey = () =>
  [{ url: "/api/projects/:project_id/archive" }] as const;

export type PostApiProjectsProjectIdArchiveMutationKey = ReturnType<
  typeof postApiProjectsProjectIdArchiveMutationKey
>;

export function postApiProjectsProjectIdArchiveMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = postApiProjectsProjectIdArchiveMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdArchive401Schema
      | PostApiProjectsProjectIdArchive403Schema
      | PostApiProjectsProjectIdArchive404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdArchivePathParamsSchema["project_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId }) => {
      return postApiProjectsProjectIdArchive(projectId, config);
    },
  });
}

/**
 * @summary Archives a project
 * {@link /api/projects/:project_id/archive}
 */
export function usePostApiProjectsProjectIdArchive<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdArchive401Schema
        | PostApiProjectsProjectIdArchive403Schema
        | PostApiProjectsProjectIdArchive404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdArchivePathParamsSchema["project_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiProjectsProjectIdArchiveMutationKey();

  const baseOptions = postApiProjectsProjectIdArchiveMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdArchive401Schema
      | PostApiProjectsProjectIdArchive403Schema
      | PostApiProjectsProjectIdArchive404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdArchivePathParamsSchema["project_id"];
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdArchive401Schema
      | PostApiProjectsProjectIdArchive403Schema
      | PostApiProjectsProjectIdArchive404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdArchivePathParamsSchema["project_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdArchive401Schema
      | PostApiProjectsProjectIdArchive403Schema
      | PostApiProjectsProjectIdArchive404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdArchivePathParamsSchema["project_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftActivitiesMutationKey = () =>
  [{ url: "/api/projects/:project_id/shift_activities" }] as const;

export type PostApiProjectsProjectIdShiftActivitiesMutationKey = ReturnType<
  typeof postApiProjectsProjectIdShiftActivitiesMutationKey
>;

export function postApiProjectsProjectIdShiftActivitiesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdShiftActivitiesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftActivitiesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivities401Schema
      | PostApiProjectsProjectIdShiftActivities403Schema
      | PostApiProjectsProjectIdShiftActivities404Schema
      | PostApiProjectsProjectIdShiftActivities422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdShiftActivities(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a shift activity
 * {@link /api/projects/:project_id/shift_activities}
 */
export function usePostApiProjectsProjectIdShiftActivities<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivities401Schema
        | PostApiProjectsProjectIdShiftActivities403Schema
        | PostApiProjectsProjectIdShiftActivities404Schema
        | PostApiProjectsProjectIdShiftActivities422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftActivitiesMutationKey();

  const baseOptions = postApiProjectsProjectIdShiftActivitiesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdShiftActivitiesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivities401Schema
      | PostApiProjectsProjectIdShiftActivities403Schema
      | PostApiProjectsProjectIdShiftActivities404Schema
      | PostApiProjectsProjectIdShiftActivities422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdShiftActivitiesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivities401Schema
      | PostApiProjectsProjectIdShiftActivities403Schema
      | PostApiProjectsProjectIdShiftActivities404Schema
      | PostApiProjectsProjectIdShiftActivities422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftActivitiesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivities401Schema
      | PostApiProjectsProjectIdShiftActivities403Schema
      | PostApiProjectsProjectIdShiftActivities404Schema
      | PostApiProjectsProjectIdShiftActivities422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/shift_activities/:shift_activity_id" },
    ] as const;

export type PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationKey
  >;

export function patchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"];
      shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"];
      data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId, data }) => {
      return patchApiProjectsProjectIdShiftActivitiesShiftActivityId(
        projectId,
        shiftActivityId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a shift activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id}
 */
export function usePatchApiProjectsProjectIdShiftActivitiesShiftActivityId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId403Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"];
        shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"];
        data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId403Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"];
        shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"];
        data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"];
      shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"];
      data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["project_id"];
      shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema["shift_activity_id"];
      data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/archive",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationKey
  >;

export function postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema["shift_activity_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId }) => {
      return postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Archives a shift activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/archive}
 */
export function usePostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive404Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema["shift_activity_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive404Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema["shift_activity_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema["shift_activity_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema["shift_activity_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/restore",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationKey
  >;

export function postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema["shift_activity_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId }) => {
      return postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore(
        projectId,
        shiftActivityId,
        config,
      );
    },
  });
}

/**
 * @summary Restores a shift activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/restore}
 */
export function usePostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore404Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema["shift_activity_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore404Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema["shift_activity_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema["shift_activity_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema["shift_activity_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/blockers/batch",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationKey
  >;

export function postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch400Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema["shift_activity_id"];
      data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId, data }) => {
      return postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch(
        projectId,
        shiftActivityId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a batch of shift activity blockers
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/blockers/batch}
 */
export function usePostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch400Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema["shift_activity_id"];
        data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch400Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema["shift_activity_id"];
        data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch400Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema["shift_activity_id"];
      data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch400Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema["shift_activity_id"];
      data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/blockers/:shift_activity_blocker_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationKey
  >;

export function deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["project_id"];
      shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["shift_activity_id"];
      shiftActivityBlockerId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["shift_activity_blocker_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({
      projectId,
      shiftActivityId,
      shiftActivityBlockerId,
    }) => {
      return deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId(
        projectId,
        shiftActivityId,
        shiftActivityBlockerId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a shift activity blocker
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/blockers/:shift_activity_blocker_id}
 */
export function useDeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId401Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId403Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["project_id"];
        shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["shift_activity_id"];
        shiftActivityBlockerId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["shift_activity_blocker_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId401Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId403Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["project_id"];
        shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["shift_activity_id"];
        shiftActivityBlockerId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["shift_activity_blocker_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["project_id"];
      shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["shift_activity_id"];
      shiftActivityBlockerId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["shift_activity_blocker_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["project_id"];
      shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["shift_activity_id"];
      shiftActivityBlockerId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema["shift_activity_blocker_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftActivitiesExportMutationKey = () =>
  [{ url: "/api/projects/:project_id/shift_activities/export" }] as const;

export type PostApiProjectsProjectIdShiftActivitiesExportMutationKey =
  ReturnType<typeof postApiProjectsProjectIdShiftActivitiesExportMutationKey>;

export function postApiProjectsProjectIdShiftActivitiesExportMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftActivitiesExportMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftActivitiesExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesExport401Schema
      | PostApiProjectsProjectIdShiftActivitiesExport403Schema
      | PostApiProjectsProjectIdShiftActivitiesExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesExportPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdShiftActivitiesExport(
        projectId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Exports a list of shift activities
 * {@link /api/projects/:project_id/shift_activities/export}
 */
export function usePostApiProjectsProjectIdShiftActivitiesExport<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesExport401Schema
        | PostApiProjectsProjectIdShiftActivitiesExport403Schema
        | PostApiProjectsProjectIdShiftActivitiesExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesExportPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftActivitiesExportMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftActivitiesExportMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesExport401Schema
        | PostApiProjectsProjectIdShiftActivitiesExport403Schema
        | PostApiProjectsProjectIdShiftActivitiesExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesExportPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftActivitiesExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesExport401Schema
      | PostApiProjectsProjectIdShiftActivitiesExport403Schema
      | PostApiProjectsProjectIdShiftActivitiesExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesExportPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftActivitiesExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesExport401Schema
      | PostApiProjectsProjectIdShiftActivitiesExport403Schema
      | PostApiProjectsProjectIdShiftActivitiesExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesExportPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftActivitiesImportsMutationKey = () =>
  [{ url: "/api/projects/:project_id/shift_activities/imports" }] as const;

export type PostApiProjectsProjectIdShiftActivitiesImportsMutationKey =
  ReturnType<typeof postApiProjectsProjectIdShiftActivitiesImportsMutationKey>;

export function postApiProjectsProjectIdShiftActivitiesImportsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftActivitiesImportsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftActivitiesImportsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesImports401Schema
      | PostApiProjectsProjectIdShiftActivitiesImports403Schema
      | PostApiProjectsProjectIdShiftActivitiesImports404Schema
      | PostApiProjectsProjectIdShiftActivitiesImports422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesImportsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdShiftActivitiesImports(
        projectId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a shift activity import
 * {@link /api/projects/:project_id/shift_activities/imports}
 */
export function usePostApiProjectsProjectIdShiftActivitiesImports<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesImportsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesImports401Schema
        | PostApiProjectsProjectIdShiftActivitiesImports403Schema
        | PostApiProjectsProjectIdShiftActivitiesImports404Schema
        | PostApiProjectsProjectIdShiftActivitiesImports422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesImportsPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftActivitiesImportsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftActivitiesImportsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesImportsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesImports401Schema
        | PostApiProjectsProjectIdShiftActivitiesImports403Schema
        | PostApiProjectsProjectIdShiftActivitiesImports404Schema
        | PostApiProjectsProjectIdShiftActivitiesImports422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesImportsPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftActivitiesImportsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesImports401Schema
      | PostApiProjectsProjectIdShiftActivitiesImports403Schema
      | PostApiProjectsProjectIdShiftActivitiesImports404Schema
      | PostApiProjectsProjectIdShiftActivitiesImports422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesImportsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftActivitiesImportsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesImports401Schema
      | PostApiProjectsProjectIdShiftActivitiesImports403Schema
      | PostApiProjectsProjectIdShiftActivitiesImports404Schema
      | PostApiProjectsProjectIdShiftActivitiesImports422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesImportsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/readiness",
      },
    ] as const;

export type PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationKey
  >;

export function patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness400Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema["project_id"];
      shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema["shift_activity_id"];
      data: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId, data }) => {
      return patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness(
        projectId,
        shiftActivityId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates shift activity readiness
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/readiness}
 */
export function usePatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness400Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness401Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness403Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness404Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema["project_id"];
        shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema["shift_activity_id"];
        data: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness400Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness401Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness403Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness404Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema["project_id"];
        shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema["shift_activity_id"];
        data: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness400Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema["project_id"];
      shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema["shift_activity_id"];
      data: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness400Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema["project_id"];
      shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema["shift_activity_id"];
      data: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/requirements",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationKey
  >;

export function postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"];
      data?: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId, data }) => {
      return postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements(
        projectId,
        shiftActivityId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a shift activity requirement
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements}
 */
export function usePostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"];
        data?: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"];
        data?: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"];
      data?: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema["shift_activity_id"];
      data?: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/requirements/sort",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationKey
  >;

export function postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort400Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema["shift_activity_id"];
      data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId, data }) => {
      return postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort(
        projectId,
        shiftActivityId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Sorts shift activity requirements
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements/sort}
 */
export function usePostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort400Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema["shift_activity_id"];
        data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort400Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema["shift_activity_id"];
        data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort400Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema["shift_activity_id"];
      data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort400Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema["shift_activity_id"];
      data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id",
      },
    ] as const;

export type PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationKey
  >;

export function patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["project_id"];
      shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["shift_activity_id"];
      requirementId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["requirement_id"];
      data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId, requirementId, data }) => {
      return patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId(
        projectId,
        shiftActivityId,
        requirementId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a shift activity requirement
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id}
 */
export function usePatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["project_id"];
        shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["shift_activity_id"];
        requirementId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["requirement_id"];
        data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
        | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["project_id"];
        shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["shift_activity_id"];
        requirementId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["requirement_id"];
        data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["project_id"];
      shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["shift_activity_id"];
      requirementId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["requirement_id"];
      data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["project_id"];
      shiftActivityId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["shift_activity_id"];
      requirementId: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["requirement_id"];
      data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationKey
  >;

export function deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["project_id"];
      shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["shift_activity_id"];
      requirementId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["requirement_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId, requirementId }) => {
      return deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId(
        projectId,
        shiftActivityId,
        requirementId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a shift activity requirement
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id}
 */
export function useDeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["project_id"];
        shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["shift_activity_id"];
        requirementId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["requirement_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["project_id"];
        shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["shift_activity_id"];
        requirementId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["requirement_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["project_id"];
      shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["shift_activity_id"];
      requirementId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["requirement_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["project_id"];
      shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["shift_activity_id"];
      requirementId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema["requirement_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id/completion",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationKey
  >;

export function postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["shift_activity_id"];
      requirementId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["requirement_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId, requirementId }) => {
      return postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion(
        projectId,
        shiftActivityId,
        requirementId,
        config,
      );
    },
  });
}

/**
 * @summary Marks shift activity requirement as completed
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id/completion}
 */
export function usePostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["shift_activity_id"];
        requirementId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["requirement_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
        | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["project_id"];
        shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["shift_activity_id"];
        requirementId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["requirement_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["shift_activity_id"];
      requirementId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["requirement_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["project_id"];
      shiftActivityId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["shift_activity_id"];
      requirementId: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["requirement_id"];
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id/completion",
      },
    ] as const;

export type DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationKey
  >;

export function deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["project_id"];
      shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["shift_activity_id"];
      requirementId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["requirement_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftActivityId, requirementId }) => {
      return deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion(
        projectId,
        shiftActivityId,
        requirementId,
        config,
      );
    },
  });
}

/**
 * @summary Marks shift activity requirement as incomplete
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id/completion}
 */
export function useDeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["project_id"];
        shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["shift_activity_id"];
        requirementId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["requirement_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
        | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["project_id"];
        shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["shift_activity_id"];
        requirementId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["requirement_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["project_id"];
      shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["shift_activity_id"];
      requirementId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["requirement_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["project_id"];
      shiftActivityId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["shift_activity_id"];
      requirementId: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema["requirement_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/activities/batch_create",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema["shift_report_id"];
      data: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, data }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate(
        projectId,
        shiftReportId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Batch create shift report activities and people allocations from progress logs
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/activities/batch_create}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema["shift_report_id"];
        data: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema["shift_report_id"];
        data: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema["shift_report_id"];
      data: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema["shift_report_id"];
      data: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/comments/collaborators",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, data }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators(
        projectId,
        shiftReportId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a shift report collaborators comment
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/collaborators}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"];
        data?: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"];
        data?: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema["shift_report_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/comments/public",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"];
      data: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, data }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic(
        projectId,
        shiftReportId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a shift report public comment
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/public}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"];
        data: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"];
        data: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"];
      data: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema["shift_report_id"];
      data: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/comments/:comment_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationKey
  >;

export function deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId404Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["shift_report_id"];
      commentId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["comment_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, commentId }) => {
      return deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId(
        projectId,
        shiftReportId,
        commentId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a shift report comment
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/:comment_id}
 */
export function useDeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId401Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId403Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId404Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["project_id"];
        shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["shift_report_id"];
        commentId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["comment_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId401Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId403Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId404Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["project_id"];
        shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["shift_report_id"];
        commentId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["comment_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId404Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["shift_report_id"];
      commentId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["comment_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId404Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["shift_report_id"];
      commentId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema["comment_id"];
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/document_references/:document_reference_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationKey
  >;

export function deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["shift_report_id"];
      documentReferenceId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, documentReferenceId }) => {
      return deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId(
        projectId,
        shiftReportId,
        documentReferenceId,
        config,
      );
    },
  });
}

/**
 * @summary Removes a document from a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/document_references/:document_reference_id}
 */
export function useDeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId401Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId403Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
        shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["shift_report_id"];
        documentReferenceId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId401Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId403Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
        shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["shift_report_id"];
        documentReferenceId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["shift_report_id"];
      documentReferenceId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["shift_report_id"];
      documentReferenceId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema["document_reference_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/documents",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, data }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdDocuments(
        projectId,
        shiftReportId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Adds a document to a shift report (from an upload or an existing document)
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/documents}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdDocuments<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"];
        data?: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"];
        data?: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema["shift_report_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsExportMutationKey = () =>
  [{ url: "/api/projects/:project_id/shift_reports/export" }] as const;

export type PostApiProjectsProjectIdShiftReportsExportMutationKey = ReturnType<
  typeof postApiProjectsProjectIdShiftReportsExportMutationKey
>;

export function postApiProjectsProjectIdShiftReportsExportMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdShiftReportsExportMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsExport400Schema
      | PostApiProjectsProjectIdShiftReportsExport401Schema
      | PostApiProjectsProjectIdShiftReportsExport403Schema
      | PostApiProjectsProjectIdShiftReportsExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsExportPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdShiftReportsExport(
        projectId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Exports a list of shift reports
 * {@link /api/projects/:project_id/shift_reports/export}
 */
export function usePostApiProjectsProjectIdShiftReportsExport<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsExport400Schema
        | PostApiProjectsProjectIdShiftReportsExport401Schema
        | PostApiProjectsProjectIdShiftReportsExport403Schema
        | PostApiProjectsProjectIdShiftReportsExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsExportPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsExportMutationKey();

  const baseOptions = postApiProjectsProjectIdShiftReportsExportMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdShiftReportsExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsExport400Schema
      | PostApiProjectsProjectIdShiftReportsExport401Schema
      | PostApiProjectsProjectIdShiftReportsExport403Schema
      | PostApiProjectsProjectIdShiftReportsExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsExportPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsExport400Schema
      | PostApiProjectsProjectIdShiftReportsExport401Schema
      | PostApiProjectsProjectIdShiftReportsExport403Schema
      | PostApiProjectsProjectIdShiftReportsExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsExportPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsExport400Schema
      | PostApiProjectsProjectIdShiftReportsExport401Schema
      | PostApiProjectsProjectIdShiftReportsExport403Schema
      | PostApiProjectsProjectIdShiftReportsExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsExportPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdExportMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/export",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdExportMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdExportMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdExportMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdExportMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema["shift_report_id"];
      params: PostApiProjectsProjectIdShiftReportsShiftReportIdExportQueryParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, params }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdExport(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Exports a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/export}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdExport<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdExport400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdExport401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdExport403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema["shift_report_id"];
        params: PostApiProjectsProjectIdShiftReportsShiftReportIdExportQueryParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdExportMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdExportMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdExport400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdExport401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdExport403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema["shift_report_id"];
        params: PostApiProjectsProjectIdShiftReportsShiftReportIdExportQueryParamsSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema["shift_report_id"];
      params: PostApiProjectsProjectIdShiftReportsShiftReportIdExportQueryParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema["shift_report_id"];
      params: PostApiProjectsProjectIdShiftReportsShiftReportIdExportQueryParamsSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdImportMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/import",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdImportMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdImportMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdImportMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema["shift_report_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, data }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdImport(
        projectId,
        shiftReportId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Imports data from an XLSX file to a draft shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/import}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdImport<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdImport400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdImport401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdImport403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdImport404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdImport422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema["shift_report_id"];
        data?: PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdImportMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdImportMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdImport400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdImport401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdImport403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdImport404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdImport422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema["shift_report_id"];
        data?: PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema["shift_report_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema["shift_report_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"];
      resourceType: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"];
      resourceId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({
      projectId,
      shiftReportId,
      resourceType,
      resourceId,
      data,
    }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments(
        projectId,
        shiftReportId,
        resourceType,
        resourceId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Adds a document to a shift report resource (from an upload or an existing document)
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"];
        resourceType: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"];
        resourceId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"];
        data?: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"];
        resourceType: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"];
        resourceId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"];
        data?: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"];
      resourceType: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"];
      resourceId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["shift_report_id"];
      resourceType: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_type"];
      resourceId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema["resource_id"];
      data?: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents/:document_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationKey
  >;

export function deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["shift_report_id"];
      documentId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["document_id"];
      resourceType: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["resource_type"];
      resourceId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["resource_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({
      projectId,
      shiftReportId,
      documentId,
      resourceType,
      resourceId,
    }) => {
      return deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId(
        projectId,
        shiftReportId,
        documentId,
        resourceType,
        resourceId,
        config,
      );
    },
  });
}

/**
 * @summary Removes a document from a shift report resource
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents/:document_id}
 */
export function useDeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId401Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId403Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["project_id"];
        shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["shift_report_id"];
        documentId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["document_id"];
        resourceType: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["resource_type"];
        resourceId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["resource_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId401Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId403Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["project_id"];
        shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["shift_report_id"];
        documentId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["document_id"];
        resourceType: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["resource_type"];
        resourceId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["resource_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["shift_report_id"];
      documentId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["document_id"];
      resourceType: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["resource_type"];
      resourceId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["resource_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["shift_report_id"];
      documentId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["document_id"];
      resourceType: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["resource_type"];
      resourceId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema["resource_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/resources/:kind",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"];
      kind: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"];
      data: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, kind, data }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind(
        projectId,
        shiftReportId,
        kind,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Create resource
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/resources/:kind}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"];
        kind: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"];
        data: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"];
        kind: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"];
        data: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"];
      kind: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"];
      data: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["shift_report_id"];
      kind: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema["kind"];
      data: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsMutationKey = () =>
  [{ url: "/api/projects/:project_id/shift_reports" }] as const;

export type PostApiProjectsProjectIdShiftReportsMutationKey = ReturnType<
  typeof postApiProjectsProjectIdShiftReportsMutationKey
>;

export function postApiProjectsProjectIdShiftReportsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdShiftReportsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReports401Schema
      | PostApiProjectsProjectIdShiftReports403Schema
      | PostApiProjectsProjectIdShiftReports404Schema
      | PostApiProjectsProjectIdShiftReports422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftReportsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdShiftReports(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a shift report
 * {@link /api/projects/:project_id/shift_reports}
 */
export function usePostApiProjectsProjectIdShiftReports<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReports401Schema
        | PostApiProjectsProjectIdShiftReports403Schema
        | PostApiProjectsProjectIdShiftReports404Schema
        | PostApiProjectsProjectIdShiftReports422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdShiftReportsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdShiftReportsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsMutationKey();

  const baseOptions = postApiProjectsProjectIdShiftReportsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdShiftReportsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReports401Schema
      | PostApiProjectsProjectIdShiftReports403Schema
      | PostApiProjectsProjectIdShiftReports404Schema
      | PostApiProjectsProjectIdShiftReports422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftReportsMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReports401Schema
      | PostApiProjectsProjectIdShiftReports403Schema
      | PostApiProjectsProjectIdShiftReports404Schema
      | PostApiProjectsProjectIdShiftReports422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftReportsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReports401Schema
      | PostApiProjectsProjectIdShiftReports403Schema
      | PostApiProjectsProjectIdShiftReports404Schema
      | PostApiProjectsProjectIdShiftReports422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdShiftReportsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdShiftReportsShiftReportIdMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/shift_reports/:shift_report_id" },
    ] as const;

export type PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdShiftReportsShiftReportIdMutationKey
  >;

export function patchApiProjectsProjectIdShiftReportsShiftReportIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdShiftReportsShiftReportIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftReportsShiftReportId400Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId404Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"];
      shiftReportId: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"];
      data?: PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, data }) => {
      return patchApiProjectsProjectIdShiftReportsShiftReportId(
        projectId,
        shiftReportId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a shift report not published
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id}
 */
export function usePatchApiProjectsProjectIdShiftReportsShiftReportId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdShiftReportsShiftReportId400Schema
        | PatchApiProjectsProjectIdShiftReportsShiftReportId401Schema
        | PatchApiProjectsProjectIdShiftReportsShiftReportId403Schema
        | PatchApiProjectsProjectIdShiftReportsShiftReportId404Schema
        | PatchApiProjectsProjectIdShiftReportsShiftReportId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"];
        shiftReportId: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"];
        data?: PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdShiftReportsShiftReportIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdShiftReportsShiftReportIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdShiftReportsShiftReportId400Schema
        | PatchApiProjectsProjectIdShiftReportsShiftReportId401Schema
        | PatchApiProjectsProjectIdShiftReportsShiftReportId403Schema
        | PatchApiProjectsProjectIdShiftReportsShiftReportId404Schema
        | PatchApiProjectsProjectIdShiftReportsShiftReportId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"];
        shiftReportId: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"];
        data?: PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftReportsShiftReportId400Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId404Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"];
      shiftReportId: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"];
      data?: PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftReportsShiftReportId400Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId404Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"];
      shiftReportId: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"];
      data?: PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdShiftReportsShiftReportIdMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/shift_reports/:shift_report_id" },
    ] as const;

export type DeleteApiProjectsProjectIdShiftReportsShiftReportIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdShiftReportsShiftReportIdMutationKey
  >;

export function deleteApiProjectsProjectIdShiftReportsShiftReportIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdShiftReportsShiftReportIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId400Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId }) => {
      return deleteApiProjectsProjectIdShiftReportsShiftReportId(
        projectId,
        shiftReportId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a shift report not published
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id}
 */
export function useDeleteApiProjectsProjectIdShiftReportsShiftReportId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftReportsShiftReportId400Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportId401Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportId403Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"];
        shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdShiftReportsShiftReportIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdShiftReportsShiftReportIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdShiftReportsShiftReportId400Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportId401Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportId403Schema
        | DeleteApiProjectsProjectIdShiftReportsShiftReportId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"];
        shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId400Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId400Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["project_id"];
      shiftReportId: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema["shift_report_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/archive",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema["shift_report_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdArchive(
        projectId,
        shiftReportId,
        config,
      );
    },
  });
}

/**
 * @summary Archives a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/archive}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdArchive<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema["shift_report_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema["shift_report_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema["shift_report_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema["shift_report_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/publish",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema["shift_report_id"];
      params?: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishQueryParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, params }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdPublish(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Publishes a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/publish}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdPublish<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema["shift_report_id"];
        params?: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishQueryParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema["shift_report_id"];
        params?: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishQueryParamsSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema["shift_report_id"];
      params?: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishQueryParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema["shift_report_id"];
      params?: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishQueryParamsSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/reset_section",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection401Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema["shift_report_id"];
      params?: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionQueryParamsSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId, params }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdResetSection(
        projectId,
        shiftReportId,
        params,
        config,
      );
    },
  });
}

/**
 * @summary Deletes all elements from a shift report section
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/reset_section}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdResetSection<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection401Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema["shift_report_id"];
        params?: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionQueryParamsSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection401Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema["shift_report_id"];
        params?: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionQueryParamsSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection401Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema["shift_report_id"];
      params?: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionQueryParamsSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection401Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema["shift_report_id"];
      params?: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionQueryParamsSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/restore",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema["shift_report_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdRestore(
        projectId,
        shiftReportId,
        config,
      );
    },
  });
}

/**
 * @summary Restores a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/restore}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdRestore<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema["shift_report_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore404Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema["shift_report_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema["shift_report_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema["shift_report_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/shift_reports/:shift_report_id/submit_for_review",
      },
    ] as const;

export type PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationKey
  >;

export function postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema["shift_report_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, shiftReportId }) => {
      return postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview(
        projectId,
        shiftReportId,
        config,
      );
    },
  });
}

/**
 * @summary Submits a draft shift report to review
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/submit_for_review}
 */
export function usePostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema["shift_report_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationKey();

  const baseOptions =
    postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview400Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview401Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview403Schema
        | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema["project_id"];
        shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema["shift_report_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema["shift_report_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema["project_id"];
      shiftReportId: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema["shift_report_id"];
    },
    TContext
  >;
}

export const postApiProjectsShowcasesMutationKey = () =>
  [{ url: "/api/projects/showcases" }] as const;

export type PostApiProjectsShowcasesMutationKey = ReturnType<
  typeof postApiProjectsShowcasesMutationKey
>;

export function postApiProjectsShowcasesMutationOptions<TContext = unknown>(
  config: Partial<
    RequestConfig<PostApiProjectsShowcasesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsShowcasesMutationKey();
  return mutationOptions<
    PostApiProjectsShowcasesMutationResponseSchema,
    ResponseErrorConfig<
      PostApiProjectsShowcases401Schema | PostApiProjectsShowcases403Schema
    >,
    { data: PostApiProjectsShowcasesMutationRequestSchema },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiProjectsShowcases(data, config);
    },
  });
}

/**
 * @summary Creates a Showcase project
 * {@link /api/projects/showcases}
 */
export function usePostApiProjectsShowcases<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsShowcasesMutationResponseSchema,
      ResponseErrorConfig<
        PostApiProjectsShowcases401Schema | PostApiProjectsShowcases403Schema
      >,
      { data: PostApiProjectsShowcasesMutationRequestSchema },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsShowcasesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiProjectsShowcasesMutationKey();

  const baseOptions = postApiProjectsShowcasesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsShowcasesMutationResponseSchema,
    ResponseErrorConfig<
      PostApiProjectsShowcases401Schema | PostApiProjectsShowcases403Schema
    >,
    { data: PostApiProjectsShowcasesMutationRequestSchema },
    TContext
  >;

  return useMutation<
    PostApiProjectsShowcasesMutationResponseSchema,
    ResponseErrorConfig<
      PostApiProjectsShowcases401Schema | PostApiProjectsShowcases403Schema
    >,
    { data: PostApiProjectsShowcasesMutationRequestSchema },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsShowcasesMutationResponseSchema,
    ResponseErrorConfig<
      PostApiProjectsShowcases401Schema | PostApiProjectsShowcases403Schema
    >,
    { data: PostApiProjectsShowcasesMutationRequestSchema },
    TContext
  >;
}

export const patchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/teams/:team_id/channel_configuration" },
    ] as const;

export type PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationKey
  >;

export function patchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"];
      teamId: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"];
      data?: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, data }) => {
      return patchApiProjectsProjectIdTeamsTeamIdChannelConfiguration(
        projectId,
        teamId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates the team channel configuration
 * {@link /api/projects/:project_id/teams/:team_id/channel_configuration}
 */
export function usePatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
        | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
        | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
        | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"];
        teamId: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"];
        data?: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
        | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
        | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
        | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"];
        teamId: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"];
        data?: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"];
      teamId: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"];
      data?: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["project_id"];
      teamId: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema["team_id"];
      data?: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdJoinTokenMutationKey = () =>
  [{ url: "/api/projects/:project_id/teams/:team_id/join_token" }] as const;

export type PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationKey =
  ReturnType<typeof postApiProjectsProjectIdTeamsTeamIdJoinTokenMutationKey>;

export function postApiProjectsProjectIdTeamsTeamIdJoinTokenMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdTeamsTeamIdJoinTokenMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"];
      data: PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, data }) => {
      return postApiProjectsProjectIdTeamsTeamIdJoinToken(
        projectId,
        teamId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a new team join token (and expires existing join token)
 * {@link /api/projects/:project_id/teams/:team_id/join_token}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdJoinToken<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
        | PostApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
        | PostApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
        | PostApiProjectsProjectIdTeamsTeamIdJoinToken422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"];
        data: PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdJoinTokenMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamsTeamIdJoinTokenMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
        | PostApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
        | PostApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
        | PostApiProjectsProjectIdTeamsTeamIdJoinToken422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"];
        data: PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"];
      data: PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"];
      data: PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationKey = () =>
  [{ url: "/api/projects/:project_id/teams/:team_id/join_token" }] as const;

export type DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationKey =
  ReturnType<typeof deleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationKey>;

export function deleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"];
      teamId: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId }) => {
      return deleteApiProjectsProjectIdTeamsTeamIdJoinToken(
        projectId,
        teamId,
        config,
      );
    },
  });
}

/**
 * @summary Expires a team join token
 * {@link /api/projects/:project_id/teams/:team_id/join_token}
 */
export function useDeleteApiProjectsProjectIdTeamsTeamIdJoinToken<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
        | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
        | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"];
        teamId: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
        | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
        | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"];
        teamId: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"];
      teamId: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["project_id"];
      teamId: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema["team_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamJoinTokensTokenJoinMutationKey = () =>
  [{ url: "/api/projects/:project_id/team_join_tokens/:token/join" }] as const;

export type PostApiProjectsProjectIdTeamJoinTokensTokenJoinMutationKey =
  ReturnType<typeof postApiProjectsProjectIdTeamJoinTokensTokenJoinMutationKey>;

export function postApiProjectsProjectIdTeamJoinTokensTokenJoinMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdTeamJoinTokensTokenJoinMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamJoinTokensTokenJoinMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin401Schema
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin404Schema
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema["project_id"];
      token: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema["token"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, token }) => {
      return postApiProjectsProjectIdTeamJoinTokensTokenJoin(
        projectId,
        token,
        config,
      );
    },
  });
}

/**
 * @summary Adds a user to a team using a team join token
 * {@link /api/projects/:project_id/team_join_tokens/:token/join}
 */
export function usePostApiProjectsProjectIdTeamJoinTokensTokenJoin<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamJoinTokensTokenJoinMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamJoinTokensTokenJoin401Schema
        | PostApiProjectsProjectIdTeamJoinTokensTokenJoin404Schema
        | PostApiProjectsProjectIdTeamJoinTokensTokenJoin422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema["project_id"];
        token: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema["token"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamJoinTokensTokenJoinMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamJoinTokensTokenJoinMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamJoinTokensTokenJoinMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamJoinTokensTokenJoin401Schema
        | PostApiProjectsProjectIdTeamJoinTokensTokenJoin404Schema
        | PostApiProjectsProjectIdTeamJoinTokensTokenJoin422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema["project_id"];
        token: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema["token"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamJoinTokensTokenJoinMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin401Schema
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin404Schema
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema["project_id"];
      token: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema["token"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamJoinTokensTokenJoinMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin401Schema
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin404Schema
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema["project_id"];
      token: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema["token"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdMembersMutationKey = () =>
  [{ url: "/api/projects/:project_id/teams/:team_id/members" }] as const;

export type PostApiProjectsProjectIdTeamsTeamIdMembersMutationKey = ReturnType<
  typeof postApiProjectsProjectIdTeamsTeamIdMembersMutationKey
>;

export function postApiProjectsProjectIdTeamsTeamIdMembersMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdTeamsTeamIdMembersMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdMembersMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembers401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers404Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema["team_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, data }) => {
      return postApiProjectsProjectIdTeamsTeamIdMembers(
        projectId,
        teamId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Invites a user to the team
 * {@link /api/projects/:project_id/teams/:team_id/members}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdMembers<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdMembersMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdMembers401Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembers403Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembers404Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembers422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema["team_id"];
        data?: PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdMembersMutationKey();

  const baseOptions = postApiProjectsProjectIdTeamsTeamIdMembersMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdMembersMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembers401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers404Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema["team_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdMembersMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembers401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers404Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema["team_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdMembersMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembers401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers404Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema["team_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/members/:team_member_id",
      },
    ] as const;

export type PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationKey
  >;

export function patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["project_id"];
      teamId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_id"];
      teamMemberId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_member_id"];
      data?: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, teamMemberId, data }) => {
      return patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId(
        projectId,
        teamId,
        teamMemberId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a team member
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id}
 */
export function usePatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
        | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
        | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
        | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["project_id"];
        teamId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_id"];
        teamMemberId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_member_id"];
        data?: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
        | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
        | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
        | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["project_id"];
        teamId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_id"];
        teamMemberId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_member_id"];
        data?: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["project_id"];
      teamId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_id"];
      teamMemberId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_member_id"];
      data?: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["project_id"];
      teamId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_id"];
      teamMemberId: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_member_id"];
      data?: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/members/:team_member_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationKey
  >;

export function deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["project_id"];
      teamId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_id"];
      teamMemberId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_member_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, teamMemberId }) => {
      return deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId(
        projectId,
        teamId,
        teamMemberId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes an invited team member
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id}
 */
export function useDeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
        | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
        | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["project_id"];
        teamId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_id"];
        teamMemberId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_member_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
        | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
        | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["project_id"];
        teamId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_id"];
        teamMemberId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_member_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["project_id"];
      teamId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_id"];
      teamMemberId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_member_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["project_id"];
      teamId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_id"];
      teamMemberId: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema["team_member_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/members/:team_member_id/archive",
      },
    ] as const;

export type PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationKey
  >;

export function postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive404Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["team_id"];
      teamMemberId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["team_member_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, teamMemberId, data }) => {
      return postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive(
        projectId,
        teamId,
        teamMemberId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Archives a team member
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id/archive}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive401Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive403Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive404Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["team_id"];
        teamMemberId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["team_member_id"];
        data?: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive401Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive403Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive404Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["team_id"];
        teamMemberId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["team_member_id"];
        data?: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive404Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["team_id"];
      teamMemberId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["team_member_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive404Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["team_id"];
      teamMemberId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema["team_member_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/members/:team_member_id/resend_invite_email",
      },
    ] as const;

export type PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationKey
  >;

export function postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["team_id"];
      teamMemberId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["team_member_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, teamMemberId }) => {
      return postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail(
        projectId,
        teamId,
        teamMemberId,
        config,
      );
    },
  });
}

/**
 * @summary Resends invite email to an invited user
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id/resend_invite_email}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail401Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail403Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["team_id"];
        teamMemberId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["team_member_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail401Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail403Schema
        | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["team_id"];
        teamMemberId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["team_member_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["team_id"];
      teamMemberId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["team_member_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["team_id"];
      teamMemberId: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema["team_member_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/resources/:resource_id/enable",
      },
    ] as const;

export type PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationKey
  >;

export function postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["team_id"];
      resourceId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["resource_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, resourceId }) => {
      return postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable(
        projectId,
        teamId,
        resourceId,
        config,
      );
    },
  });
}

/**
 * @summary Enables a resource
 * {@link /api/projects/:project_id/teams/:team_id/resources/:resource_id/enable}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable401Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable403Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["team_id"];
        resourceId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["resource_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable401Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable403Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["team_id"];
        resourceId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["resource_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["team_id"];
      resourceId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["resource_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["team_id"];
      resourceId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema["resource_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/resources/:resource_id/disable",
      },
    ] as const;

export type PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationKey
  >;

export function postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["team_id"];
      resourceId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["resource_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, resourceId }) => {
      return postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable(
        projectId,
        teamId,
        resourceId,
        config,
      );
    },
  });
}

/**
 * @summary Disables a resource
 * {@link /api/projects/:project_id/teams/:team_id/resources/:resource_id/disable}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable401Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable403Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["team_id"];
        resourceId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["resource_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable401Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable403Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["team_id"];
        resourceId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["resource_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["team_id"];
      resourceId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["resource_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["team_id"];
      resourceId: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema["resource_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdResourcesKindMutationKey = () =>
  [
    { url: "/api/projects/:project_id/teams/:team_id/resources/:kind" },
  ] as const;

export type PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdTeamsTeamIdResourcesKindMutationKey
  >;

export function postApiProjectsProjectIdTeamsTeamIdResourcesKindMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdTeamsTeamIdResourcesKindMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"];
      kind: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"];
      data: PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, kind, data }) => {
      return postApiProjectsProjectIdTeamsTeamIdResourcesKind(
        projectId,
        teamId,
        kind,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Create resource
 * {@link /api/projects/:project_id/teams/:team_id/resources/:kind}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdResourcesKind<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesKind422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"];
        kind: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"];
        data: PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdResourcesKindMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamsTeamIdResourcesKindMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
        | PostApiProjectsProjectIdTeamsTeamIdResourcesKind422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"];
        kind: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"];
        data: PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"];
      kind: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"];
      data: PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["team_id"];
      kind: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema["kind"];
      data: PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdSubscriptionMutationKey = () =>
  [{ url: "/api/projects/:project_id/teams/:team_id/subscription" }] as const;

export type PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationKey =
  ReturnType<typeof postApiProjectsProjectIdTeamsTeamIdSubscriptionMutationKey>;

export function postApiProjectsProjectIdTeamsTeamIdSubscriptionMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdTeamsTeamIdSubscriptionMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscription401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema["team_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, data }) => {
      return postApiProjectsProjectIdTeamsTeamIdSubscription(
        projectId,
        teamId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Start a team subscription update
 * {@link /api/projects/:project_id/teams/:team_id/subscription}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdSubscription<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdSubscription401Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscription403Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscription404Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscription422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema["team_id"];
        data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdSubscriptionMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamsTeamIdSubscriptionMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdSubscription401Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscription403Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscription404Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscription422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema["team_id"];
        data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscription401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema["team_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscription401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema["team_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationKey =
  () =>
    [
      { url: "/api/projects/:project_id/teams/:team_id/subscription/confirm" },
    ] as const;

export type PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationKey
  >;

export function postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema["team_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, data }) => {
      return postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm(
        projectId,
        teamId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Confirm a Stripe Billing subscription
 * {@link /api/projects/:project_id/teams/:team_id/subscription/confirm}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm401Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm403Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm404Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema["team_id"];
        data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm401Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm403Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm404Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema["team_id"];
        data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema["team_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema["team_id"];
      data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/subscription/billing_portal",
      },
    ] as const;

export type PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationKey
  >;

export function postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema["team_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId }) => {
      return postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal(
        projectId,
        teamId,
        config,
      );
    },
  });
}

/**
 * @summary Retrieves an URL for the billing portal
 * {@link /api/projects/:project_id/teams/:team_id/subscription/billing_portal}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal401Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal403Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal404Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema["team_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal401Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal403Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal404Schema
        | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema["team_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema["team_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema["team_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsMutationKey = () =>
  [{ url: "/api/projects/:project_id/teams" }] as const;

export type PostApiProjectsProjectIdTeamsMutationKey = ReturnType<
  typeof postApiProjectsProjectIdTeamsMutationKey
>;

export function postApiProjectsProjectIdTeamsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdTeamsMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdTeamsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeams401Schema
      | PostApiProjectsProjectIdTeams403Schema
      | PostApiProjectsProjectIdTeams404Schema
      | PostApiProjectsProjectIdTeams422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdTeamsMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdTeams(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a team
 * {@link /api/projects/:project_id/teams}
 */
export function usePostApiProjectsProjectIdTeams<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeams401Schema
        | PostApiProjectsProjectIdTeams403Schema
        | PostApiProjectsProjectIdTeams404Schema
        | PostApiProjectsProjectIdTeams422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsPathParamsSchema["project_id"];
        data?: PostApiProjectsProjectIdTeamsMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdTeamsMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiProjectsProjectIdTeamsMutationKey();

  const baseOptions = postApiProjectsProjectIdTeamsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdTeamsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeams401Schema
      | PostApiProjectsProjectIdTeams403Schema
      | PostApiProjectsProjectIdTeams404Schema
      | PostApiProjectsProjectIdTeams422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdTeamsMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdTeamsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeams401Schema
      | PostApiProjectsProjectIdTeams403Schema
      | PostApiProjectsProjectIdTeams404Schema
      | PostApiProjectsProjectIdTeams422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdTeamsMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeams401Schema
      | PostApiProjectsProjectIdTeams403Schema
      | PostApiProjectsProjectIdTeams404Schema
      | PostApiProjectsProjectIdTeams422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsPathParamsSchema["project_id"];
      data?: PostApiProjectsProjectIdTeamsMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdTeamsTeamIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/teams/:team_id" }] as const;

export type PatchApiProjectsProjectIdTeamsTeamIdMutationKey = ReturnType<
  typeof patchApiProjectsProjectIdTeamsTeamIdMutationKey
>;

export function patchApiProjectsProjectIdTeamsTeamIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = patchApiProjectsProjectIdTeamsTeamIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamId401Schema
      | PatchApiProjectsProjectIdTeamsTeamId403Schema
      | PatchApiProjectsProjectIdTeamsTeamId404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"];
      teamId: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"];
      data?: PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId, data }) => {
      return patchApiProjectsProjectIdTeamsTeamId(
        projectId,
        teamId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a team
 * {@link /api/projects/:project_id/teams/:team_id}
 */
export function usePatchApiProjectsProjectIdTeamsTeamId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdTeamsTeamId401Schema
        | PatchApiProjectsProjectIdTeamsTeamId403Schema
        | PatchApiProjectsProjectIdTeamsTeamId404Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"];
        teamId: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"];
        data?: PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdTeamsTeamIdMutationKey();

  const baseOptions = patchApiProjectsProjectIdTeamsTeamIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PatchApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamId401Schema
      | PatchApiProjectsProjectIdTeamsTeamId403Schema
      | PatchApiProjectsProjectIdTeamsTeamId404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"];
      teamId: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"];
      data?: PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PatchApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamId401Schema
      | PatchApiProjectsProjectIdTeamsTeamId403Schema
      | PatchApiProjectsProjectIdTeamsTeamId404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"];
      teamId: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"];
      data?: PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamId401Schema
      | PatchApiProjectsProjectIdTeamsTeamId403Schema
      | PatchApiProjectsProjectIdTeamsTeamId404Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"];
      teamId: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"];
      data?: PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdTeamsTeamIdMutationKey = () =>
  [{ url: "/api/projects/:project_id/teams/:team_id" }] as const;

export type DeleteApiProjectsProjectIdTeamsTeamIdMutationKey = ReturnType<
  typeof deleteApiProjectsProjectIdTeamsTeamIdMutationKey
>;

export function deleteApiProjectsProjectIdTeamsTeamIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey = deleteApiProjectsProjectIdTeamsTeamIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamId401Schema
      | DeleteApiProjectsProjectIdTeamsTeamId403Schema
      | DeleteApiProjectsProjectIdTeamsTeamId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"];
      teamId: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId }) => {
      return deleteApiProjectsProjectIdTeamsTeamId(projectId, teamId, config);
    },
  });
}

/**
 * @summary Deletes a team
 * {@link /api/projects/:project_id/teams/:team_id}
 */
export function useDeleteApiProjectsProjectIdTeamsTeamId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdTeamsTeamId401Schema
        | DeleteApiProjectsProjectIdTeamsTeamId403Schema
        | DeleteApiProjectsProjectIdTeamsTeamId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"];
        teamId: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdTeamsTeamIdMutationKey();

  const baseOptions = deleteApiProjectsProjectIdTeamsTeamIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamId401Schema
      | DeleteApiProjectsProjectIdTeamsTeamId403Schema
      | DeleteApiProjectsProjectIdTeamsTeamId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"];
      teamId: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"];
    },
    TContext
  >;

  return useMutation<
    DeleteApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamId401Schema
      | DeleteApiProjectsProjectIdTeamsTeamId403Schema
      | DeleteApiProjectsProjectIdTeamsTeamId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"];
      teamId: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamId401Schema
      | DeleteApiProjectsProjectIdTeamsTeamId403Schema
      | DeleteApiProjectsProjectIdTeamsTeamId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema["project_id"];
      teamId: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema["team_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/teams/:team_id/resend_members_invites",
      },
    ] as const;

export type PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationKey
  >;

export function postApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema["team_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, teamId }) => {
      return postApiProjectsProjectIdTeamsTeamIdResendMembersInvites(
        projectId,
        teamId,
        config,
      );
    },
  });
}

/**
 * @summary Resends invite email to all invited users on the team
 * {@link /api/projects/:project_id/teams/:team_id/resend_members_invites}
 */
export function usePostApiProjectsProjectIdTeamsTeamIdResendMembersInvites<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites401Schema
        | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema["team_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationKey();

  const baseOptions =
    postApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites401Schema
        | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema["project_id"];
        teamId: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema["team_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema["team_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema["project_id"];
      teamId: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema["team_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdWatchingsMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/watchings" }] as const;

export type PostApiProjectsProjectIdIssuesIssueIdWatchingsMutationKey =
  ReturnType<typeof postApiProjectsProjectIdIssuesIssueIdWatchingsMutationKey>;

export function postApiProjectsProjectIdIssuesIssueIdWatchingsMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdWatchingsMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings403Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings404Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return postApiProjectsProjectIdIssuesIssueIdWatchings(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Watches an issue
 * {@link /api/projects/:project_id/issues/:issue_id/watchings}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdWatchings<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdWatchings401Schema
        | PostApiProjectsProjectIdIssuesIssueIdWatchings403Schema
        | PostApiProjectsProjectIdIssuesIssueIdWatchings404Schema
        | PostApiProjectsProjectIdIssuesIssueIdWatchings422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdWatchingsMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdWatchingsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdWatchings401Schema
        | PostApiProjectsProjectIdIssuesIssueIdWatchings403Schema
        | PostApiProjectsProjectIdIssuesIssueIdWatchings404Schema
        | PostApiProjectsProjectIdIssuesIssueIdWatchings422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings403Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings404Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings403Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings404Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationKey = () =>
  [{ url: "/api/projects/:project_id/issues/:issue_id/watchings" }] as const;

export type DeleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationKey
  >;

export function deleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId }) => {
      return deleteApiProjectsProjectIdIssuesIssueIdWatchings(
        projectId,
        issueId,
        config,
      );
    },
  });
}

/**
 * @summary Unwatches an issue
 * {@link /api/projects/:project_id/issues/:issue_id/watchings}
 */
export function useDeleteApiProjectsProjectIdIssuesIssueIdWatchings<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueIdWatchings401Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdWatchings404Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdWatchings422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdIssuesIssueIdWatchings401Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdWatchings404Schema
        | DeleteApiProjectsProjectIdIssuesIssueIdWatchings422Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"];
        issueId: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings422Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["project_id"];
      issueId: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema["issue_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/issues/:issue_id/watchings/batch_create",
      },
    ] as const;

export type PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationKey
  >;

export function postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate401Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate403Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema["issue_id"];
      data: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, issueId, data }) => {
      return postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate(
        projectId,
        issueId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates issue watchings
 * {@link /api/projects/:project_id/issues/:issue_id/watchings/batch_create}
 */
export function usePostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate401Schema
        | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate403Schema
        | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema["issue_id"];
        data: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationKey();

  const baseOptions =
    postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate401Schema
        | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate403Schema
        | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema["project_id"];
        issueId: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema["issue_id"];
        data: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate401Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate403Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema["issue_id"];
      data: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate401Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate403Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema["project_id"];
      issueId: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema["issue_id"];
      data: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId, data }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities(
        projectId,
        weeklyWorkPlanId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a weekly work plan activity
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities400Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities400Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/batch",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId, data }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch(
        projectId,
        weeklyWorkPlanId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a batch of weekly work plan activities
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/batch}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema["weekly_work_plan_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema["weekly_work_plan_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema;
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id",
      },
    ] as const;

export type PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationKey
  >;

export function patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"];
      weeklyWorkPlanId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"];
      activityId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"];
      data?: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId, activityId, data }) => {
      return patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId(
        projectId,
        weeklyWorkPlanId,
        activityId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a weekly work plan activity
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id}
 */
export function usePatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"];
        weeklyWorkPlanId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"];
        activityId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"];
        data?: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"];
        weeklyWorkPlanId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"];
        activityId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"];
        data?: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"];
      weeklyWorkPlanId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"];
      activityId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"];
      data?: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"];
      weeklyWorkPlanId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"];
      activityId: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"];
      data?: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id",
      },
    ] as const;

export type DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationKey
  >;

export function deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"];
      weeklyWorkPlanId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"];
      activityId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId, activityId }) => {
      return deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId(
        projectId,
        weeklyWorkPlanId,
        activityId,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a weekly work plan activity
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id}
 */
export function useDeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"];
        weeklyWorkPlanId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"];
        activityId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"];
        weeklyWorkPlanId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"];
        activityId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"];
      weeklyWorkPlanId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"];
      activityId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["project_id"];
      weeklyWorkPlanId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["weekly_work_plan_id"];
      activityId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema["activity_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/sort",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId, data }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort(
        projectId,
        weeklyWorkPlanId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Sorts weekly work plan activities
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/sort}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort400Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema["weekly_work_plan_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort400Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema["weekly_work_plan_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id/scheduled_days",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["weekly_work_plan_id"];
      activityId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["activity_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId, activityId, data }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays(
        projectId,
        weeklyWorkPlanId,
        activityId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Creates a weekly work plan activity scheduled day
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id/scheduled_days}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["weekly_work_plan_id"];
        activityId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["activity_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["weekly_work_plan_id"];
        activityId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["activity_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["weekly_work_plan_id"];
      activityId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["activity_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["weekly_work_plan_id"];
      activityId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema["activity_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema;
    },
    TContext
  >;
}

export const deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id/scheduled_days/:date",
      },
    ] as const;

export type DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationKey =
  ReturnType<
    typeof deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationKey
  >;

export function deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationKey();
  return mutationOptions<
    DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate401Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate403Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["project_id"];
      weeklyWorkPlanId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["weekly_work_plan_id"];
      activityId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["activity_id"];
      date: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["date"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId, activityId, date }) => {
      return deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate(
        projectId,
        weeklyWorkPlanId,
        activityId,
        date,
        config,
      );
    },
  });
}

/**
 * @summary Deletes a weekly work plan activity scheduled day
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id/scheduled_days/:date}
 */
export function useDeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate401Schema
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate403Schema
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["project_id"];
        weeklyWorkPlanId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["weekly_work_plan_id"];
        activityId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["activity_id"];
        date: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["date"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationKey();

  const baseOptions =
    deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationResponseSchema,
      ResponseErrorConfig<
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate401Schema
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate403Schema
        | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate404Schema
      >,
      {
        projectId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["project_id"];
        weeklyWorkPlanId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["weekly_work_plan_id"];
        activityId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["activity_id"];
        date: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["date"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate401Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate403Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["project_id"];
      weeklyWorkPlanId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["weekly_work_plan_id"];
      activityId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["activity_id"];
      date: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["date"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate401Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate403Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate404Schema
    >,
    {
      projectId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["project_id"];
      weeklyWorkPlanId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["weekly_work_plan_id"];
      activityId: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["activity_id"];
      date: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema["date"];
    },
    TContext
  >;
}

export const patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/shift_activities_finder",
      },
    ] as const;

export type PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationKey =
  ReturnType<
    typeof patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationKey
  >;

export function patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationKey();
  return mutationOptions<
    PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"];
      data: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder(
        projectId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates shift activities finder options for weekly work plans
 * {@link /api/projects/:project_id/weekly_work_plans/shift_activities_finder}
 */
export function usePatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"];
        data: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationKey();

  const baseOptions =
    patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationResponseSchema,
      ResponseErrorConfig<
        | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
        | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder422Schema
      >,
      {
        projectId: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"];
        data: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"];
      data: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder422Schema
    >,
    {
      projectId: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema["project_id"];
      data: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansMutationKey = () =>
  [{ url: "/api/projects/:project_id/weekly_work_plans" }] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansMutationKey = ReturnType<
  typeof postApiProjectsProjectIdWeeklyWorkPlansMutationKey
>;

export function postApiProjectsProjectIdWeeklyWorkPlansMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey = postApiProjectsProjectIdWeeklyWorkPlansMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlans400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, data }) => {
      return postApiProjectsProjectIdWeeklyWorkPlans(projectId, data, config);
    },
  });
}

/**
 * @summary Creates a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlans<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlans400Schema
        | PostApiProjectsProjectIdWeeklyWorkPlans401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlans403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlans404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlans422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansMutationKey();

  const baseOptions = postApiProjectsProjectIdWeeklyWorkPlansMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlans400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema;
    },
    TContext
  >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlans400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlans400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema["project_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema;
    },
    TContext
  >;
}

export const putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id",
      },
    ] as const;

export type PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationKey =
  ReturnType<
    typeof putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationKey
  >;

export function putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationKey();
  return mutationOptions<
    PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationResponseSchema,
    ResponseErrorConfig<
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId400Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId422Schema
    >,
    {
      projectId: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"];
      weeklyWorkPlanId: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"];
      data?: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId, data }) => {
      return putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId(
        projectId,
        weeklyWorkPlanId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Updates a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id}
 */
export function usePutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationResponseSchema,
      ResponseErrorConfig<
        | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId400Schema
        | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
        | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
        | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
        | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId422Schema
      >,
      {
        projectId: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"];
        weeklyWorkPlanId: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"];
        data?: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationKey();

  const baseOptions =
    putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationOptions(
      config,
    ) as UseMutationOptions<
      PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationResponseSchema,
      ResponseErrorConfig<
        | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId400Schema
        | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
        | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
        | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
        | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId422Schema
      >,
      {
        projectId: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"];
        weeklyWorkPlanId: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"];
        data?: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationResponseSchema,
    ResponseErrorConfig<
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId400Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId422Schema
    >,
    {
      projectId: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"];
      weeklyWorkPlanId: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"];
      data?: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationResponseSchema,
    ResponseErrorConfig<
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId400Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId422Schema
    >,
    {
      projectId: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["project_id"];
      weeklyWorkPlanId: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema["weekly_work_plan_id"];
      data?: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/close",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose(
        projectId,
        weeklyWorkPlanId,
        config,
      );
    },
  });
}

/**
 * @summary Closes a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/close}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/duplicate",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema["weekly_work_plan_id"];
      data?: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId, data }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate(
        projectId,
        weeklyWorkPlanId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Duplicates the weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/duplicate}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate400Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema["weekly_work_plan_id"];
        data?: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate400Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema["weekly_work_plan_id"];
        data?: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema["weekly_work_plan_id"];
      data?: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema["weekly_work_plan_id"];
      data?: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/prefill",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema>
  > & { client?: typeof fetch } = {},
) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId, data }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill(
        projectId,
        weeklyWorkPlanId,
        data,
        config,
      );
    },
  });
}

/**
 * @summary Prefills the weekly work plan (and deletes existing activities)
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/prefill}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill400Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema["weekly_work_plan_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill400Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema["weekly_work_plan_id"];
        data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema;
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema["weekly_work_plan_id"];
      data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema;
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/export",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport(
        projectId,
        weeklyWorkPlanId,
        config,
      );
    },
  });
}

/**
 * @summary Requests a weekly work plan export
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/export}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/lookback/export",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport(
        projectId,
        weeklyWorkPlanId,
        config,
      );
    },
  });
}

/**
 * @summary Requests a weekly work plan lookback export
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/lookback/export}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport404Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport404Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/publish",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish(
        projectId,
        weeklyWorkPlanId,
        config,
      );
    },
  });
}

/**
 * @summary Publishes a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/publish}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/archive",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive(
        projectId,
        weeklyWorkPlanId,
        config,
      );
    },
  });
}

/**
 * @summary Archives a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/archive}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >;
}

export const postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationKey =
  () =>
    [
      {
        url: "/api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/restore",
      },
    ] as const;

export type PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationKey =
  ReturnType<
    typeof postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationKey
  >;

export function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const mutationKey =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationKey();
  return mutationOptions<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ projectId, weeklyWorkPlanId }) => {
      return postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore(
        projectId,
        weeklyWorkPlanId,
        config,
      );
    },
  });
}

/**
 * @summary Restores an archived weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/restore}
 */
export function usePostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationKey();

  const baseOptions =
    postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationResponseSchema,
      ResponseErrorConfig<
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore401Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore403Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore404Schema
        | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore422Schema
      >,
      {
        projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema["project_id"];
        weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema["weekly_work_plan_id"];
      },
      TContext
    >;

  return useMutation<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore422Schema
    >,
    {
      projectId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema["project_id"];
      weeklyWorkPlanId: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema["weekly_work_plan_id"];
    },
    TContext
  >;
}
